import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTimeUtc: { input: any; output: any; }
  Json: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum Activity {
  HospitalFullTime = 'HOSPITAL_FULL_TIME',
  HospitalPartTime = 'HOSPITAL_PART_TIME',
  HospitalUniNotPuph = 'HOSPITAL_UNI_NOT_PUPH',
  Intern = 'INTERN',
  Liberal = 'LIBERAL',
  Puph = 'PUPH',
  Retired = 'RETIRED'
}

export type ActualAdvantage = {
  __typename?: 'ActualAdvantage';
  actualPackage?: Maybe<ActualPackage>;
  advantage_type: AdvantageType;
  area?: Maybe<Scalars['String']['output']>;
  attendee_id?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  excluding_tax_amount?: Maybe<Scalars['Float']['output']>;
  gross_amount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  including_tax_amount?: Maybe<Scalars['Float']['output']>;
  net_amount: Scalars['Float']['output'];
  payment_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  quantity: Scalars['Float']['output'];
};

export type ActualPackage = {
  __typename?: 'ActualPackage';
  advantages: Array<ActualAdvantage>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  id: Scalars['ID']['output'];
  is_distribution?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  netTotalAdvantages?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Ticket>;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

/** A paginated list of ActualPackage items. */
export type ActualPackagePaginator = {
  __typename?: 'ActualPackagePaginator';
  /** A list of ActualPackage items. */
  data: Array<ActualPackage>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type AdditionalCost = {
  __typename?: 'AdditionalCost';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ticket_id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  attendee?: Maybe<Attendee>;
  cedex?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  country?: Maybe<AddressCountry>;
  declaration?: Maybe<Declaration>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Ticket>;
};

export enum AddressCountry {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type AdvantageAmounts = {
  __typename?: 'AdvantageAmounts';
  excluding_tax_amount?: Maybe<Scalars['Float']['output']>;
  gross_amount?: Maybe<Scalars['Float']['output']>;
  including_tax_amount?: Maybe<Scalars['Float']['output']>;
  net_amount: Scalars['Float']['output'];
};

export type AdvantageDynamicAmounts = {
  __typename?: 'AdvantageDynamicAmounts';
  actual?: Maybe<Scalars['Float']['output']>;
  gap?: Maybe<Scalars['Float']['output']>;
  planned?: Maybe<Scalars['Float']['output']>;
};

export type AdvantageInConvention = {
  advantage_type: AdvantageType;
  including_tax_amount: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type AdvantageInPackage = {
  __typename?: 'AdvantageInPackage';
  advantage_type: AdvantageType;
  amounts: AdvantageAmounts;
  quantity: Scalars['Float']['output'];
};

export enum AdvantageType {
  Book = 'BOOK',
  BookDonation = 'BOOK_DONATION',
  ClinicalStudy = 'CLINICAL_STUDY',
  DonationOrLoanForResearch = 'DONATION_OR_LOAN_FOR_RESEARCH',
  DonationOrLoanForTraining = 'DONATION_OR_LOAN_FOR_TRAINING',
  EquipmentLoan = 'EQUIPMENT_LOAN',
  HospitalityDinner = 'HOSPITALITY_DINNER',
  HospitalityLunch = 'HOSPITALITY_LUNCH',
  HospitalityMeal = 'HOSPITALITY_MEAL',
  HospitalityNight = 'HOSPITALITY_NIGHT',
  HospitalitySnack = 'HOSPITALITY_SNACK',
  HospitalityTravel = 'HOSPITALITY_TRAVEL',
  MaterialDonation = 'MATERIAL_DONATION',
  OperatingDonation = 'OPERATING_DONATION',
  Other = 'OTHER',
  OtherProductsAndServices = 'OTHER_PRODUCTS_AND_SERVICES',
  RegistrationFee = 'REGISTRATION_FEE',
  SalaryAgreement = 'SALARY_AGREEMENT',
  SalaryDayIntervention = 'SALARY_DAY_INTERVENTION',
  SalaryDayPreparation = 'SALARY_DAY_PREPARATION',
  SalaryHalfDayIntervention = 'SALARY_HALF_DAY_INTERVENTION',
  SalaryHalfDayPreparation = 'SALARY_HALF_DAY_PREPARATION',
  SalaryHourlyIntervention = 'SALARY_HOURLY_INTERVENTION',
  SalaryHourlyPreparation = 'SALARY_HOURLY_PREPARATION',
  Sample = 'SAMPLE',
  SampleDonation = 'SAMPLE_DONATION',
  StandRental = 'STAND_RENTAL',
  Supply = 'SUPPLY',
  Training = 'TRAINING'
}

export type AgencyExport = {
  __typename?: 'AgencyExport';
  document: Document;
  id: Scalars['ID']['output'];
  ticket: Ticket;
  updated_at: Scalars['DateTimeUtc']['output'];
};

export type AggregatedAdvantageTypeTotal = {
  __typename?: 'AggregatedAdvantageTypeTotal';
  advantage_type: AdvantageType;
  id: Scalars['ID']['output'];
  total_actual_advantages: Scalars['Float']['output'];
  total_gap: Scalars['Float']['output'];
  total_planned_advantages: Scalars['Float']['output'];
};

export type AggregatedAdvantageTypeTotalByAttendee = {
  __typename?: 'AggregatedAdvantageTypeTotalByAttendee';
  address: Address;
  advantage_types: Array<AttendeeAdvantageTypeBreakdown>;
  category: AttendeeCategory;
  civility?: Maybe<AttendeeCivility>;
  firstname?: Maybe<Scalars['String']['output']>;
  healthSpecialties?: Maybe<Array<Maybe<Specialty>>>;
  health_number?: Maybe<Scalars['String']['output']>;
  health_type?: Maybe<AttendeeHealthType>;
  id: Scalars['ID']['output'];
  is_billed?: Maybe<Scalars['Boolean']['output']>;
  is_military?: Maybe<Scalars['Boolean']['output']>;
  is_present?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  legal_title?: Maybe<Scalars['String']['output']>;
  organization_type?: Maybe<AttendeeOrganizationType>;
  total_actual_advantages: Scalars['Float']['output'];
  total_gap: Scalars['Float']['output'];
  total_planned_advantages: Scalars['Float']['output'];
};

export type AggregatedAdvantageTypeTotalByAttendeePaginator = {
  __typename?: 'AggregatedAdvantageTypeTotalByAttendeePaginator';
  data: Array<AggregatedAdvantageTypeTotalByAttendee>;
  paginatorInfo: PaginatorInfo;
};

export enum AggregatedAdvantageTypeTotalOrderByColumn {
  Firstname = 'FIRSTNAME',
  Lastname = 'LASTNAME'
}

export type AggregatedAdvantageTypeTotalOrderByInput = {
  column: AggregatedAdvantageTypeTotalOrderByColumn;
  order: SortOrder;
};

export type AggregatedAdvantageTypeTotalPaginator = {
  __typename?: 'AggregatedAdvantageTypeTotalPaginator';
  data: Array<AggregatedAdvantageTypeTotal>;
  paginatorInfo: PaginatorInfo;
};

export type AllInternalSigners = {
  __typename?: 'AllInternalSigners';
  internal_signers: Array<InternalSigner>;
  users_and_internal_signers: Array<UserAndInternalSigner>;
  validator_signers: Array<UserKeycloakSigner>;
};

export type Allocations = {
  __typename?: 'Allocations';
  identities?: Maybe<Array<Maybe<Identity>>>;
  networks?: Maybe<Array<Maybe<Network>>>;
  products?: Maybe<Array<Maybe<Product>>>;
  regions?: Maybe<Array<Maybe<Region>>>;
  sectors?: Maybe<Array<Maybe<Sector>>>;
  therapeuticAreas?: Maybe<Array<Maybe<TherapeuticArea>>>;
  ugas?: Maybe<Array<Maybe<Uga>>>;
  units?: Maybe<Array<Maybe<Unit>>>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};

export type AllocationsInputs = {
  identities?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  networks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sectors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  therapeuticAreas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ugas?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  units?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  zones?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum AnalyticsType {
  Dqc = 'DQC'
}

export type AnalyticsUrl = {
  __typename?: 'AnalyticsUrl';
  url: Scalars['String']['output'];
};

export type ApiAttendee = {
  __typename?: 'ApiAttendee';
  activity?: Maybe<Activity>;
  address?: Maybe<ApiAttendeeAddress>;
  category?: Maybe<Scalars['String']['output']>;
  civility?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  healthSpecialties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  health_number?: Maybe<Scalars['String']['output']>;
  health_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  legal_title?: Maybe<Scalars['String']['output']>;
  organization_type?: Maybe<AttendeeOrganizationType>;
  pharmacist_type?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  plannedPackages?: Maybe<Array<Maybe<PlannedPackage>>>;
  regime?: Maybe<AttendeeRegime>;
  title?: Maybe<AttendeeTitle>;
  type_number?: Maybe<Scalars['String']['output']>;
};

export type ApiAttendeeAddress = {
  __typename?: 'ApiAttendeeAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of ApiAttendee items. */
export type ApiAttendeePaginator = {
  __typename?: 'ApiAttendeePaginator';
  /** A list of ApiAttendee items. */
  data: Array<ApiAttendee>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ApiCreatePlannedAdvantageInput = {
  advantage_type: AdvantageType;
  area?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  excluding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  gross_amount?: InputMaybe<Scalars['Float']['input']>;
  including_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  net_amount: Scalars['Float']['input'];
  planned_package_id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Float']['input'];
};

export type ApiOperation = {
  __typename?: 'ApiOperation';
  actualPackageIds: Array<Scalars['String']['output']>;
  actualPackages?: Maybe<Array<Maybe<ActualPackage>>>;
  attachmentIds: Array<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  contractTemplateIds: Array<Scalars['String']['output']>;
  contractTemplates?: Maybe<Array<Maybe<ContractTemplate>>>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  donation_type?: Maybe<DonationType>;
  enabled: Scalars['Boolean']['output'];
  eventTypes: Array<OperationEventType>;
  id: Scalars['ID']['output'];
  mandatory_actual_packages?: Maybe<Scalars['Boolean']['output']>;
  mandatory_attachments?: Maybe<Scalars['Boolean']['output']>;
  mandatory_contract_templates?: Maybe<Scalars['Boolean']['output']>;
  mandatory_planned_packages?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  operation_type_eps?: Maybe<OperationTypeEps>;
  operation_type_idahe?: Maybe<OperationTypeIdahe>;
  operation_type_transparency?: Maybe<OperationTypeTransparency>;
  plannedPackageIds: Array<Scalars['String']['output']>;
  plannedPackages?: Maybe<Array<Maybe<PlannedPackage>>>;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

/** A paginated list of ApiOperation items. */
export type ApiOperationPaginator = {
  __typename?: 'ApiOperationPaginator';
  /** A list of ApiOperation items. */
  data: Array<ApiOperation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ApiUpdatePlannedAdvantageInput = {
  advantage_type: AdvantageType;
  area?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  excluding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  gross_amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  including_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  net_amount: Scalars['Float']['input'];
  planned_package_id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Float']['input'];
};

export type AssignActualPackageToAttendeesInput = {
  actualPackageID: Scalars['ID']['input'];
  attendeeIDS?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignActualPackagesToTicketInput = {
  actualPackageIDs: Array<Scalars['ID']['input']>;
  ticketID: Scalars['ID']['input'];
};

export type AssignPlannedPackageToAttendeesInput = {
  attendeeIDS?: InputMaybe<Array<Scalars['ID']['input']>>;
  plannedPackageID: Scalars['ID']['input'];
  ticketID: Scalars['ID']['input'];
};

export type AssignPlannedPackagesToTicketInput = {
  plannedPackageIDs: Array<Scalars['ID']['input']>;
  ticketID: Scalars['ID']['input'];
};

export type AttachDocumentToAttendeeInput = {
  attendee: UpsertAttendeeBelongsTo;
  custom_type_name?: InputMaybe<Scalars['String']['input']>;
  document_id: UpsertDocumentBelongsTo;
  filename?: InputMaybe<Scalars['String']['input']>;
  signed_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  ticket: UpsertTicketBelongsTo;
  type: DocumentAttendeeTypes;
};

export type AttachDocumentToTicketInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  document_id?: InputMaybe<UpsertDocumentBelongsTo>;
  filename?: InputMaybe<Scalars['String']['input']>;
  ticket?: InputMaybe<UpsertTicketBelongsTo>;
  type?: InputMaybe<AttachmentFileType>;
};

export type AttachExpenseReportToTicketInput = {
  document_id: UpsertDocumentBelongsTo;
  filename?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  ticket: UpsertTicketBelongsTo;
};

export type AttachSigningSheetToTicketInput = {
  document_id: UpsertDocumentBelongsTo;
  filename?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ticket: UpsertTicketBelongsTo;
};

export type AttachTicketLinkInput = {
  linked_ticket_id: Scalars['ID']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type Attachment = {
  __typename?: 'Attachment';
  comment?: Maybe<Scalars['String']['output']>;
  document: Document;
  file?: Maybe<Array<Scalars['Upload']['output']>>;
  id: Scalars['ID']['output'];
  is_added_manually?: Maybe<Scalars['Boolean']['output']>;
  ticket?: Maybe<Ticket>;
  type?: Maybe<AttachmentFileType>;
};

export enum AttachmentFileType {
  ContractProject = 'CONTRACT_PROJECT',
  ContractZipFile = 'CONTRACT_ZIP_FILE',
  ConventionLetter = 'CONVENTION_LETTER',
  EventProgram = 'EVENT_PROGRAM',
  InvitationCard = 'INVITATION_CARD',
  Mandate = 'MANDATE',
  ObservationBookletProject = 'OBSERVATION_BOOKLET_PROJECT',
  OrderNotice = 'ORDER_NOTICE',
  Others = 'OTHERS',
  Quotation = 'QUOTATION',
  RegistrationForm = 'REGISTRATION_FORM',
  ScientificProgram = 'SCIENTIFIC_PROGRAM',
  SolicitationLetter = 'SOLICITATION_LETTER',
  Summary = 'SUMMARY'
}

export type AttachmentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AttachmentFileType>;
};

/** A paginated list of Attachment items. */
export type AttachmentPaginator = {
  __typename?: 'AttachmentPaginator';
  /** A list of Attachment items. */
  data: Array<Attachment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type AttachmentResult = {
  __typename?: 'AttachmentResult';
  comment?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  ticket?: Maybe<Ticket>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Attendee = {
  __typename?: 'Attendee';
  acronym?: Maybe<Scalars['String']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  activity?: Maybe<Activity>;
  actualPackages?: Maybe<Array<Maybe<ActualPackage>>>;
  addedBy?: Maybe<User>;
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['String']['output']>;
  assignation?: Maybe<Scalars['String']['output']>;
  attendeeSignature?: Maybe<AttendeeSignature>;
  attendee_link_id?: Maybe<Scalars['String']['output']>;
  base_global_code?: Maybe<Scalars['String']['output']>;
  capital?: Maybe<Scalars['String']['output']>;
  category?: Maybe<AttendeeCategory>;
  civility?: Maybe<AttendeeCivility>;
  company?: Maybe<Scalars['String']['output']>;
  contracts?: Maybe<Array<Maybe<ContractAttendee>>>;
  contractsDepositStatus?: Maybe<DocumentAttendeeStatus>;
  contractsSignatureStatus?: Maybe<DocumentAttendeeStatus>;
  contractual_link?: Maybe<AttendeeContractualLink>;
  createdBy?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  deleted_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<DocumentAttendee>>>;
  email?: Maybe<Scalars['String']['output']>;
  executive_role?: Maybe<AttendeeExecutiveRole>;
  external_id?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  healthSpecialties?: Maybe<Array<Maybe<Specialty>>>;
  health_number?: Maybe<Scalars['String']['output']>;
  health_type?: Maybe<AttendeeHealthType>;
  id: Scalars['ID']['output'];
  is_billed?: Maybe<Scalars['Boolean']['output']>;
  is_military?: Maybe<Scalars['Boolean']['output']>;
  is_present?: Maybe<Scalars['Boolean']['output']>;
  is_public?: Maybe<Scalars['Boolean']['output']>;
  is_signed?: Maybe<Scalars['Boolean']['output']>;
  is_threshold_reached?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  legal_status?: Maybe<Scalars['String']['output']>;
  legal_title?: Maybe<Scalars['String']['output']>;
  official_journal_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  organization_type?: Maybe<AttendeeOrganizationType>;
  parent_organization_name?: Maybe<Scalars['String']['output']>;
  pharmacist_type?: Maybe<PharmacistType>;
  phone_number?: Maybe<Scalars['String']['output']>;
  place_of_registration?: Maybe<Scalars['String']['output']>;
  plannedPackages?: Maybe<Array<Maybe<PlannedPackage>>>;
  prefecture_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  prefecture_name?: Maybe<Scalars['String']['output']>;
  prefecture_number?: Maybe<Scalars['String']['output']>;
  rcs?: Maybe<Scalars['String']['output']>;
  regime?: Maybe<AttendeeRegime>;
  siret?: Maybe<Scalars['String']['output']>;
  social_security_number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<AttendeeStateType>;
  ticketLink?: Maybe<AttendeeTicketLink>;
  ticket_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<AttendeeTitle>;
  type?: Maybe<AttendeeType>;
  type_number?: Maybe<TypeNumber>;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

export type AttendeeAdvantageTypeBreakdown = {
  __typename?: 'AttendeeAdvantageTypeBreakdown';
  advantage_type: AdvantageType;
  total_actual_advantages: Scalars['Float']['output'];
  total_gap: Scalars['Float']['output'];
  total_planned_advantages: Scalars['Float']['output'];
};

export type AttendeeAdvantageTypeTotal = {
  __typename?: 'AttendeeAdvantageTypeTotal';
  actual_package?: Maybe<ActualPackage>;
  advantage_type: AdvantageType;
  attendee?: Maybe<Attendee>;
  id: Scalars['ID']['output'];
  planned_package?: Maybe<PlannedPackage>;
  ticket?: Maybe<Ticket>;
  total_actual_advantages: Scalars['Float']['output'];
  total_gap: Scalars['Float']['output'];
  total_planned_advantages: Scalars['Float']['output'];
};

/** A paginated list of AttendeeAdvantageTypeTotal items. */
export type AttendeeAdvantageTypeTotalPaginator = {
  __typename?: 'AttendeeAdvantageTypeTotalPaginator';
  /** A list of AttendeeAdvantageTypeTotal items. */
  data: Array<AttendeeAdvantageTypeTotal>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum AttendeeCategory {
  Collaborator = 'COLLABORATOR',
  HealthProfessional = 'HEALTH_PROFESSIONAL',
  Influencer = 'INFLUENCER',
  LegalEntity = 'LEGAL_ENTITY',
  Other = 'OTHER',
  Student = 'STUDENT'
}

export enum AttendeeCivility {
  Female = 'FEMALE',
  Male = 'MALE',
  Unknown = 'UNKNOWN'
}

export enum AttendeeContractualLink {
  BeneficialOwnerNonSignatory = 'BENEFICIAL_OWNER_NON_SIGNATORY',
  Contractor = 'CONTRACTOR',
  NonBeneficialOwnerContractor = 'NON_BENEFICIAL_OWNER_CONTRACTOR'
}

export enum AttendeeDepositRegime {
  Authorization = 'AUTHORIZATION',
  Declaration = 'DECLARATION'
}

export enum AttendeeExecutiveRole {
  Director = 'DIRECTOR',
  President = 'PRESIDENT',
  Secretary = 'SECRETARY',
  Treasurer = 'TREASURER'
}

export enum AttendeeHealthType {
  CareGiver = 'CARE_GIVER',
  ChildCareAssistant = 'CHILD_CARE_ASSISTANT',
  Chiropractor = 'CHIROPRACTOR',
  DentalAssistant = 'DENTAL_ASSISTANT',
  Dentist = 'DENTIST',
  Dietitian = 'DIETITIAN',
  Doctor = 'DOCTOR',
  Epithesist = 'EPITHESIST',
  HearAidSpecialist = 'HEAR_AID_SPECIALIST',
  HospitalPharmacyPreparer = 'HOSPITAL_PHARMACY_PREPARER',
  LaboratoryTechnician = 'LABORATORY_TECHNICIAN',
  MassageTherapist = 'MASSAGE_THERAPIST',
  MedicalElectRadioManipulator = 'MEDICAL_ELECT_RADIO_MANIPULATOR',
  MedicalPhysicist = 'MEDICAL_PHYSICIST',
  Midwife = 'MIDWIFE',
  Nurse = 'NURSE',
  OccupationalTherapist = 'OCCUPATIONAL_THERAPIST',
  Ocularist = 'OCULARIST',
  OfficinePharmacyPreparer = 'OFFICINE_PHARMACY_PREPARER',
  OpticianEyeWear = 'OPTICIAN_EYE_WEAR',
  OrthopedistOrthotist = 'ORTHOPEDIST_ORTHOTIST',
  Orthoprosthetist = 'ORTHOPROSTHETIST',
  Orthoptist = 'ORTHOPTIST',
  Osteopath = 'OSTEOPATH',
  Other = 'OTHER',
  Paramedic = 'PARAMEDIC',
  Pharmacist = 'PHARMACIST',
  PharmacyHospitalPreparer = 'PHARMACY_HOSPITAL_PREPARER',
  Podiatrist = 'PODIATRIST',
  PodoOrthotist = 'PODO_ORTHOTIST',
  ProthethistOrthotistDisabled = 'PROTHETHIST_ORTHOTIST_DISABLED',
  Psychomotrician = 'PSYCHOMOTRICIAN',
  Psychotherapist = 'PSYCHOTHERAPIST',
  SpeechTherapist = 'SPEECH_THERAPIST',
  Veterinary = 'VETERINARY'
}

export enum AttendeeImportStatusEnum {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export enum AttendeeMedicalType {
  BiologicalPharmacist = 'BIOLOGICAL_PHARMACIST',
  CommunityPharmacist = 'COMMUNITY_PHARMACIST',
  DentalSurgeon = 'DENTAL_SURGEON',
  Doctor = 'DOCTOR',
  HospitalPharmacist = 'HOSPITAL_PHARMACIST',
  Midwife = 'MIDWIFE',
  MilitaryPersonnel = 'MILITARY_PERSONNEL',
  MineMutualPharmacist = 'MINE_MUTUAL_PHARMACIST',
  Nurse = 'NURSE',
  OverseasPharmacist = 'OVERSEAS_PHARMACIST',
  PhysicalTherapist = 'PHYSICAL_THERAPIST',
  Podiatrist = 'PODIATRIST',
  WholesalePharmacist = 'WHOLESALE_PHARMACIST'
}

export enum AttendeeOrganizationType {
  Academy = 'ACADEMY',
  AdvisoryBody = 'ADVISORY_BODY',
  AgriculturalProfessionalGroup = 'AGRICULTURAL_PROFESSIONAL_GROUP',
  CorporateVeterinary = 'CORPORATE_VETERINARY',
  Foundation = 'FOUNDATION',
  HealthcareEducationInstitution = 'HEALTHCARE_EDUCATION_INSTITUTION',
  HealthcareFacility = 'HEALTHCARE_FACILITY',
  HealthcareProfessionalAssociation = 'HEALTHCARE_PROFESSIONAL_ASSOCIATION',
  HealthcareSystemUserAssociation = 'HEALTHCARE_SYSTEM_USER_ASSOCIATION',
  HealthGroup = 'HEALTH_GROUP',
  LearnedSociety = 'LEARNED_SOCIETY',
  Other = 'OTHER',
  PressAndMedia = 'PRESS_AND_MEDIA',
  SoftwarePublisher = 'SOFTWARE_PUBLISHER',
  StudentAssociation = 'STUDENT_ASSOCIATION'
}

/** A paginated list of Attendee items. */
export type AttendeePaginator = {
  __typename?: 'AttendeePaginator';
  /** A list of Attendee items. */
  data: Array<Attendee>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum AttendeeRegime {
  NonUrssaf = 'NON_URSSAF',
  Urssaf = 'URSSAF'
}

export type AttendeeSignature = {
  __typename?: 'AttendeeSignature';
  attendee_id: Scalars['ID']['output'];
  hospitality: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  signature: Scalars['String']['output'];
  ticket_id: Scalars['ID']['output'];
};

export enum AttendeeStateType {
  Attendee = 'ATTENDEE',
  NotSelected = 'NOT_SELECTED',
  NotSubmitted = 'NOT_SUBMITTED',
  Prospective = 'PROSPECTIVE'
}

export enum AttendeeSubmissionRegime {
  Authorization = 'AUTHORIZATION',
  Declaration = 'DECLARATION'
}

export type AttendeeTicketLink = {
  __typename?: 'AttendeeTicketLink';
  code: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  workflow_step?: Maybe<Scalars['String']['output']>;
};

export type AttendeeTicketRelationResult = {
  __typename?: 'AttendeeTicketRelationResult';
  attendee_id?: Maybe<Scalars['ID']['output']>;
  deleted_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  ticket_id?: Maybe<Scalars['ID']['output']>;
};

export enum AttendeeTitle {
  Doctor = 'DOCTOR',
  Professor = 'PROFESSOR'
}

export type AttendeeTotalFilter = {
  __typename?: 'AttendeeTotalFilter';
  paginatorInfo: PaginatorInfoTotal;
};

export enum AttendeeType {
  Auditor = 'AUDITOR',
  Intern = 'INTERN',
  Other = 'OTHER',
  Speaker = 'SPEAKER',
  SpeakerConsultant = 'SPEAKER_CONSULTANT',
  SpeakerExpert = 'SPEAKER_EXPERT'
}

export type AuthTicketPermissions = {
  __typename?: 'AuthTicketPermissions';
  lifecycle_key: TicketLifecycleKey;
  permissions: Array<TicketPermission>;
};

export type AvailableSteps = {
  __typename?: 'AvailableSteps';
  steps: Array<Scalars['String']['output']>;
};

export type Avatar = {
  __typename?: 'Avatar';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BatchProgress = {
  __typename?: 'BatchProgress';
  message: Scalars['String']['output'];
  params?: Maybe<BatchProgressParams>;
  status: BroadCastsStatusEnum;
};

export type BatchProgressParams = {
  __typename?: 'BatchProgressParams';
  author_id?: Maybe<Scalars['ID']['output']>;
  batch_id?: Maybe<Scalars['ID']['output']>;
  failed_count?: Maybe<Scalars['Int']['output']>;
  processed?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  ticket_code?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum BotDestination {
  Eps = 'EPS',
  Idahe = 'IDAHE',
  Other = 'OTHER'
}

export enum BroadCastsStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Skipped = 'SKIPPED'
}

export type BulkUpdateAttendeesInput = {
  added_by?: InputMaybe<Scalars['ID']['input']>;
  contractual_link?: InputMaybe<AttendeeContractualLink>;
  ids: Array<Scalars['ID']['input']>;
  state?: InputMaybe<AttendeeStateType>;
  type?: InputMaybe<AttendeeType>;
};

export type CancelContractAttendeeSignatureRequestInput = {
  contract_attendee_id: Scalars['ID']['input'];
};

export type ChangeTicketStatusInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Status>;
};

export type CheckContractZipFileBatch = {
  __typename?: 'CheckContractZipFileBatch';
  attachment?: Maybe<Attachment>;
  batch_id: Scalars['ID']['output'];
  has_failed?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckExpensesImportBatch = {
  __typename?: 'CheckExpensesImportBatch';
  batch_id: Scalars['ID']['output'];
  expenses_import?: Maybe<ExpensesImport>;
};

export type CloneContactAsAttendeeError = {
  __typename?: 'CloneContactAsAttendeeError';
  contact_id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type CloneContactAsAttendeeInput = {
  contact_id: Scalars['ID']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type CloneContactsAsAttendeesInput = {
  contact_ids: Array<Scalars['ID']['input']>;
  ticket_id: Scalars['ID']['input'];
};

export type CloneContactsAsAttendeesResult = {
  __typename?: 'CloneContactsAsAttendeesResult';
  created: Array<Attendee>;
  errors: Array<CloneContactAsAttendeeError>;
};

export type ClonePlannedPackagesAsActualPackagesInput = {
  assignClonedPackages: Scalars['Boolean']['input'];
  ticketID: Scalars['ID']['input'];
};

export type CloneTicketBatch = {
  __typename?: 'CloneTicketBatch';
  batch_id: Scalars['String']['output'];
};

export type CloneTicketInput = {
  attachments?: InputMaybe<Scalars['Boolean']['input']>;
  attendees?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  packages?: InputMaybe<Scalars['Boolean']['input']>;
  packages_assignations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CloneTicketProgress = {
  __typename?: 'CloneTicketProgress';
  message: Scalars['String']['output'];
  status: BroadCastsStatusEnum;
  ticket?: Maybe<Ticket>;
};

export type Comment = {
  __typename?: 'Comment';
  content: Scalars['String']['output'];
  created_at: Scalars['DateTimeUtc']['output'];
  created_by: User;
  deleted_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  id: Scalars['ID']['output'];
  ticket_id: Scalars['ID']['output'];
  ticket_step?: Maybe<Step>;
  type?: Maybe<TypeOfReturn>;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

/** A paginated list of Comment items. */
export type CommentPaginator = {
  __typename?: 'CommentPaginator';
  /** A list of Comment items. */
  data: Array<Comment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Contact = {
  __typename?: 'Contact';
  acronym?: Maybe<Scalars['String']['output']>;
  activity?: Maybe<Activity>;
  address?: Maybe<Address>;
  assignation?: Maybe<Scalars['String']['output']>;
  base_global_code?: Maybe<Scalars['String']['output']>;
  capital?: Maybe<Scalars['String']['output']>;
  category?: Maybe<AttendeeCategory>;
  civility?: Maybe<AttendeeCivility>;
  company?: Maybe<Scalars['String']['output']>;
  contractual_link?: Maybe<AttendeeContractualLink>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<DocumentContact>>>;
  email?: Maybe<Scalars['String']['output']>;
  executive_role?: Maybe<AttendeeExecutiveRole>;
  external_id?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  healthSpecialties?: Maybe<Array<Maybe<Specialty>>>;
  health_number?: Maybe<Scalars['String']['output']>;
  health_type?: Maybe<AttendeeHealthType>;
  id: Scalars['ID']['output'];
  is_military?: Maybe<Scalars['Boolean']['output']>;
  is_public?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  legal_status?: Maybe<Scalars['String']['output']>;
  legal_title?: Maybe<Scalars['String']['output']>;
  official_journal_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  organization_type?: Maybe<AttendeeOrganizationType>;
  parent_organization_name?: Maybe<Scalars['String']['output']>;
  pharmacist_type?: Maybe<PharmacistType>;
  phone_number?: Maybe<Scalars['String']['output']>;
  place_of_registration?: Maybe<Scalars['String']['output']>;
  prefecture_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  prefecture_name?: Maybe<Scalars['String']['output']>;
  prefecture_number?: Maybe<Scalars['String']['output']>;
  rcs?: Maybe<Scalars['String']['output']>;
  regime?: Maybe<AttendeeRegime>;
  siret?: Maybe<Scalars['String']['output']>;
  social_security_number?: Maybe<Scalars['String']['output']>;
  title?: Maybe<AttendeeTitle>;
  type?: Maybe<AttendeeType>;
  type_number?: Maybe<TypeNumber>;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

/** A paginated list of Contact items. */
export type ContactPaginator = {
  __typename?: 'ContactPaginator';
  /** A list of Contact items. */
  data: Array<Contact>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ContactTotalFilter = {
  __typename?: 'ContactTotalFilter';
  paginatorInfo: PaginatorInfoTotal;
};

export type ContractAndSigners = {
  __typename?: 'ContractAndSigners';
  contract: ContractAttendee;
  signers: Array<UserAndInternalSigner>;
};

export type ContractAttendee = {
  __typename?: 'ContractAttendee';
  attendee: Attendee;
  contractTemplate?: Maybe<ContractTemplate>;
  created_at: Scalars['DateTimeUtc']['output'];
  deposit_status: DocumentAttendeeStatus;
  document: Document;
  id: Scalars['ID']['output'];
  last_reminder?: Maybe<Scalars['DateTimeUtc']['output']>;
  signature_status: DocumentAttendeeStatus;
  signatures?: Maybe<Array<Maybe<Signature>>>;
  ticket: Ticket;
  updated_at: Scalars['DateTimeUtc']['output'];
};

export type ContractAttendeeBatch = {
  __typename?: 'ContractAttendeeBatch';
  attendee_id: Scalars['String']['output'];
  batch_id: Scalars['String']['output'];
  contract_template_id: Scalars['String']['output'];
};

export type ContractAttendeeForReminder = {
  __typename?: 'ContractAttendeeForReminder';
  contract: ContractAttendee;
  signers: Array<UserAndInternalSigner>;
};

export type ContractAttendeeForReminders = {
  __typename?: 'ContractAttendeeForReminders';
  contractAttendees?: Maybe<Array<Maybe<ContractAttendeeForReminder>>>;
  latestReminder?: Maybe<Scalars['DateTimeUtc']['output']>;
};

export enum ContractAttendeeManagementOrderByColumn {
  AttachmentFilename = 'ATTACHMENT_FILENAME',
  ContractFilename = 'CONTRACT_FILENAME',
  Lastname = 'LASTNAME',
  SignatureRequestType = 'SIGNATURE_REQUEST_TYPE',
  SignatureStatus = 'SIGNATURE_STATUS'
}

export type ContractAttendeeManagementOrderByInput = {
  column: ContractAttendeeManagementOrderByColumn;
  order: SortOrder;
};

export enum ContractAttendeeSignerType {
  Attendee = 'ATTENDEE',
  Internal = 'INTERNAL',
  User = 'USER'
}

export type ContractDepositInformation = {
  __typename?: 'ContractDepositInformation';
  contract_attendee_id: Scalars['ID']['output'];
  deposit_platform?: Maybe<ContractDepositPlatform>;
  deposit_type?: Maybe<ContractDepositType>;
  id: Scalars['ID']['output'];
};

export enum ContractDepositPlatform {
  Eps = 'EPS',
  Idahe2 = 'IDAHE2'
}

export enum ContractDepositStatus {
  Creating = 'CREATING',
  Done = 'DONE',
  Pending = 'PENDING'
}

export enum ContractDepositType {
  Authorization = 'AUTHORIZATION',
  Statement = 'STATEMENT'
}

export type ContractTemplate = {
  __typename?: 'ContractTemplate';
  contractTemplateDocuments: ContractTemplateDocumentPaginator;
  document: Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signature_request_type?: Maybe<SignatureRequestType>;
  ticket?: Maybe<Ticket>;
  ticket_id?: Maybe<Scalars['ID']['output']>;
};


export type ContractTemplateContractTemplateDocumentsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractTemplateDocument = {
  __typename?: 'ContractTemplateDocument';
  contract_template_id: Scalars['ID']['output'];
  created_at: Scalars['DateTimeUtc']['output'];
  created_by?: Maybe<User>;
  document: Document;
  document_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: ContractTemplateDocumentStatus;
  version: Scalars['Float']['output'];
};

/** A paginated list of ContractTemplateDocument items. */
export type ContractTemplateDocumentPaginator = {
  __typename?: 'ContractTemplateDocumentPaginator';
  /** A list of ContractTemplateDocument items. */
  data: Array<ContractTemplateDocument>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ContractTemplateDocumentStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum ContractTemplateOrderByColumn {
  Id = 'ID',
  Name = 'NAME',
  SignatureRequestType = 'SIGNATURE_REQUEST_TYPE'
}

export type ContractTemplateOrderByInput = {
  column: ContractTemplateOrderByColumn;
  order: SortOrder;
};

/** A paginated list of ContractTemplate items. */
export type ContractTemplatePaginator = {
  __typename?: 'ContractTemplatePaginator';
  /** A list of ContractTemplate items. */
  data: Array<ContractTemplate>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ContractTemplateUpload = {
  __typename?: 'ContractTemplateUpload';
  contractTemplateDocuments: Array<ContractTemplateDocument>;
  document: Document;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  signature_request_type: SignatureRequestType;
  ticket_id?: Maybe<Scalars['ID']['output']>;
};

export type ContractZipFileBatchInput = {
  batch_id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};

export type Convention = {
  __typename?: 'Convention';
  advantages?: Maybe<Array<Maybe<PlannedAdvantage>>>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_manual_pack_allowed: Scalars['Boolean']['output'];
  type: ConventionType;
};

/** A paginated list of Convention items. */
export type ConventionPaginator = {
  __typename?: 'ConventionPaginator';
  /** A list of Convention items. */
  data: Array<Convention>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ConventionType {
  IndustrialSiteMeetingOneDay1_2020 = 'INDUSTRIAL_SITE_MEETING_ONE_DAY1_2020',
  IndustrialSiteMeetingOneDay2_2020 = 'INDUSTRIAL_SITE_MEETING_ONE_DAY2_2020',
  IndustrialSiteMeetingOneToTwoDays_2024 = 'INDUSTRIAL_SITE_MEETING_ONE_TO_TWO_DAYS_2024',
  IndustrialSiteMeetingOneToTwoDays_2026 = 'INDUSTRIAL_SITE_MEETING_ONE_TO_TWO_DAYS_2026',
  None = 'NONE',
  OnSiteTrainingHalfToOneDay1_2020 = 'ON_SITE_TRAINING_HALF_TO_ONE_DAY1_2020',
  OnSiteTrainingHalfToOneDay2_2020 = 'ON_SITE_TRAINING_HALF_TO_ONE_DAY2_2020',
  OnSiteTrainingHalfToTwoDays_2024 = 'ON_SITE_TRAINING_HALF_TO_TWO_DAYS_2024',
  OnSiteTrainingHalfToTwoDays_2026 = 'ON_SITE_TRAINING_HALF_TO_TWO_DAYS_2026',
  RecurringProfessionalMeeting1_2020 = 'RECURRING_PROFESSIONAL_MEETING1_2020',
  RecurringProfessionalMeeting2_2020 = 'RECURRING_PROFESSIONAL_MEETING2_2020',
  RecurringProfessionalMeetingOneAndHalfToEightHours_2024 = 'RECURRING_PROFESSIONAL_MEETING_ONE_AND_HALF_TO_EIGHT_HOURS_2024',
  RecurringProfessionalMeetingOneAndHalfToEightHours_2026 = 'RECURRING_PROFESSIONAL_MEETING_ONE_AND_HALF_TO_EIGHT_HOURS_2026',
  StaffMeeting_2020 = 'STAFF_MEETING_2020',
  StaffMeeting_2024 = 'STAFF_MEETING_2024',
  StaffMeeting_2026 = 'STAFF_MEETING_2026',
  WeekendSeminar_2020 = 'WEEKEND_SEMINAR_2020',
  WeekendSeminar_2024 = 'WEEKEND_SEMINAR_2024',
  WeekendSeminar_2026 = 'WEEKEND_SEMINAR_2026'
}

export enum Country {
  France = 'FRANCE',
  Other = 'OTHER'
}

export type CreateActualAdvantageInPackage = {
  advantage_type: AdvantageType;
  area?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  excluding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  gross_amount?: InputMaybe<Scalars['Float']['input']>;
  including_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  net_amount: Scalars['Float']['input'];
  payment_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  quantity: Scalars['Float']['input'];
};

export type CreateActualAdvantageInput = {
  advantage_type: AdvantageType;
  area?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  excluding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  gross_amount?: InputMaybe<Scalars['Float']['input']>;
  including_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  net_amount: Scalars['Float']['input'];
  payment_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  quantity: Scalars['Float']['input'];
};

export type CreateActualAdvantagesInput = {
  advantages?: InputMaybe<Array<InputMaybe<CreateActualAdvantageInput>>>;
};

export type CreateActualPackageInput = {
  advantages: Array<CreateActualAdvantageInPackage>;
  is_distribution?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  source?: InputMaybe<SourceEnum>;
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAdditionalCostInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAddressInput = {
  cedex?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<AddressCountry>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  street_name?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  street_type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAttendeeByApiError = {
  __typename?: 'CreateAttendeeByApiError';
  firstname?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreateAttendeeByApiInput = {
  activity?: InputMaybe<Activity>;
  address: CreateAddressInput;
  category?: InputMaybe<AttendeeCategory>;
  civility?: InputMaybe<AttendeeCivility>;
  company?: InputMaybe<Scalars['String']['input']>;
  contractual_link?: InputMaybe<AttendeeContractualLink>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  executive_role?: InputMaybe<AttendeeExecutiveRole>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  healthSpecialties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  health_type?: InputMaybe<AttendeeHealthType>;
  is_military?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<AttendeeOrganizationType>;
  parent_organization_name?: InputMaybe<Scalars['String']['input']>;
  pharmacist_type?: InputMaybe<PharmacistType>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  regime?: InputMaybe<AttendeeRegime>;
  state?: InputMaybe<AttendeeStateType>;
  ticket_id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<AttendeeTitle>;
  type?: InputMaybe<AttendeeType>;
  type_number?: InputMaybe<TypeNumber>;
};

export type CreateAttendeeByImportInput = {
  file: Scalars['Upload']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type CreateAttendeeInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  activity?: InputMaybe<Activity>;
  address: CreateAddressInput;
  assignation?: InputMaybe<Scalars['String']['input']>;
  attendee_link_id?: InputMaybe<Scalars['String']['input']>;
  base_global_code?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AttendeeCategory>;
  civility?: InputMaybe<AttendeeCivility>;
  company?: InputMaybe<Scalars['String']['input']>;
  contractual_link?: InputMaybe<AttendeeContractualLink>;
  create_contact?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  executive_role?: InputMaybe<AttendeeExecutiveRole>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  healthSpecialties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  health_type?: InputMaybe<AttendeeHealthType>;
  is_billed?: InputMaybe<Scalars['Boolean']['input']>;
  is_military?: InputMaybe<Scalars['Boolean']['input']>;
  is_present?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  legal_status?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  official_journal?: InputMaybe<Scalars['Upload']['input']>;
  official_journal_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  organization_type?: InputMaybe<AttendeeOrganizationType>;
  parent_organization_name?: InputMaybe<Scalars['String']['input']>;
  pharmacist_type?: InputMaybe<PharmacistType>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  place_of_registration?: InputMaybe<Scalars['String']['input']>;
  prefecture_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  prefecture_name?: InputMaybe<Scalars['String']['input']>;
  prefecture_number?: InputMaybe<Scalars['String']['input']>;
  rcs?: InputMaybe<Scalars['String']['input']>;
  receipt?: InputMaybe<Scalars['Upload']['input']>;
  regime?: InputMaybe<AttendeeRegime>;
  rib?: InputMaybe<Scalars['Upload']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
  solicitation_letter?: InputMaybe<Scalars['Upload']['input']>;
  state?: InputMaybe<AttendeeStateType>;
  status?: InputMaybe<Scalars['Upload']['input']>;
  ticket_id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<AttendeeTitle>;
  type?: InputMaybe<AttendeeType>;
  type_number?: InputMaybe<TypeNumber>;
};

export type CreateAttendeesByApiInput = {
  attendees: Array<CreateAttendeeByApiInput>;
  ticket_id: Scalars['String']['input'];
};

export type CreateAttendeesByApiResult = {
  __typename?: 'CreateAttendeesByApiResult';
  created: Array<Attendee>;
  errors: Array<CreateAttendeeByApiError>;
};

export type CreateAttendeesByImportBatch = {
  __typename?: 'CreateAttendeesByImportBatch';
  batch_id: Scalars['String']['output'];
};

export type CreateAttendeesByImportProgress = {
  __typename?: 'CreateAttendeesByImportProgress';
  message: Scalars['String']['output'];
  status: BroadCastsStatusEnum;
  ticketAttendeeImport?: Maybe<TicketAttendeeImport>;
};

export type CreateCommentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  taggedUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
  ticket_step?: InputMaybe<Step>;
  type?: InputMaybe<TypeOfReturn>;
};

export type CreateContactInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  activity?: InputMaybe<Activity>;
  address: CreateAddressInput;
  assignation?: InputMaybe<Scalars['String']['input']>;
  base_global_code?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AttendeeCategory>;
  civility?: InputMaybe<AttendeeCivility>;
  company?: InputMaybe<Scalars['String']['input']>;
  contractual_link?: InputMaybe<AttendeeContractualLink>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  executive_role?: InputMaybe<AttendeeExecutiveRole>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  healthSpecialties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  health_type?: InputMaybe<AttendeeHealthType>;
  is_military?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  legal_status?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  official_journal?: InputMaybe<Scalars['Upload']['input']>;
  official_journal_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  organization_type?: InputMaybe<AttendeeOrganizationType>;
  parent_organization_name?: InputMaybe<Scalars['String']['input']>;
  pharmacist_type?: InputMaybe<PharmacistType>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  place_of_registration?: InputMaybe<Scalars['String']['input']>;
  prefecture_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  prefecture_name?: InputMaybe<Scalars['String']['input']>;
  prefecture_number?: InputMaybe<Scalars['String']['input']>;
  rcs?: InputMaybe<Scalars['String']['input']>;
  receipt?: InputMaybe<Scalars['Upload']['input']>;
  regime?: InputMaybe<AttendeeRegime>;
  rib?: InputMaybe<Scalars['Upload']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
  solicitation_letter?: InputMaybe<Scalars['Upload']['input']>;
  status?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<AttendeeTitle>;
  type?: InputMaybe<AttendeeType>;
  type_number?: InputMaybe<TypeNumber>;
};

export type CreateContractAttendeeInput = {
  attendee_id?: InputMaybe<Scalars['ID']['input']>;
  contract_template_id?: InputMaybe<Scalars['ID']['input']>;
  signers: Array<InputMaybe<SignerInput>>;
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateContractDepositInformationInput = {
  contract_attendee_id: Scalars['ID']['input'];
  deposit_platform?: InputMaybe<ContractDepositPlatform>;
  deposit_type?: InputMaybe<ContractDepositType>;
};

export type CreateContractForAttendeeInput = {
  attendee_id: Scalars['ID']['input'];
  end_at: Scalars['DateTimeUtc']['input'];
  operation_id: Scalars['ID']['input'];
  start_at: Scalars['DateTimeUtc']['input'];
  ticket_id: Scalars['ID']['input'];
  ticket_name: Scalars['String']['input'];
  validator_1: Scalars['ID']['input'];
  validator_2: Scalars['ID']['input'];
  workflow_id: Scalars['ID']['input'];
};

export type CreateConventionInput = {
  advantages: Array<InputMaybe<AdvantageInConvention>>;
  is_manual_pack_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  type: ConventionType;
};

export type CreateDeclarationDocumentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  declaration_id: Scalars['ID']['input'];
  document?: InputMaybe<Scalars['Upload']['input']>;
  type?: InputMaybe<AttachmentFileType>;
};

export type CreateDeclarationExportInput = {
  publication_status: PublicationStatus;
  ticket_ids: Array<Scalars['String']['input']>;
};

export type CreateDeclarationInput = {
  address?: InputMaybe<CreateAddressInput>;
  advantages?: InputMaybe<Array<InputMaybe<UpsertDeclarationAdvantageInDeclaration>>>;
  attendee_medical_types?: InputMaybe<Array<InputMaybe<AttendeeMedicalType>>>;
  attendee_quantity?: InputMaybe<Scalars['Int']['input']>;
  convention_id?: InputMaybe<Scalars['ID']['input']>;
  declaration_count?: InputMaybe<Scalars['Int']['input']>;
  end_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  external_code?: InputMaybe<Scalars['String']['input']>;
  managerCrm?: InputMaybe<UpsertCrmUserBelongsTo>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  specialties?: InputMaybe<Array<InputMaybe<DeclarationSpecialty>>>;
  start_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
};

export type CreateDiagnosticExportInput = {
  ticket_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateManualSubmissionInput = {
  eps_target?: InputMaybe<EpsTargetInput>;
  other_category?: InputMaybe<OtherDepositCategoryEnum>;
  package_id?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regime: Scalars['String']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type CreateNonComplianceInput = {
  internal_code?: InputMaybe<Scalars['String']['input']>;
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNotificationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  date_boundary?: InputMaybe<NotificationDateBoundary>;
  day_type?: InputMaybe<NotificationDayType>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_object?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_types?: InputMaybe<Array<InputMaybe<EventType>>>;
  external_emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internal_emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  operations?: InputMaybe<UpsertOperationsBelongsToMany>;
  period?: InputMaybe<NotificationPeriod>;
  submission_regime?: InputMaybe<NotificationSubmissionRegime>;
  target_state?: InputMaybe<NotificationTargetState>;
  ticket_roles_to_notify?: InputMaybe<Array<InputMaybe<NotificationTicketRolesToNotify>>>;
  type?: InputMaybe<NotificationType>;
};

export type CreateOperationEventTypeInput = {
  event_type: EventType;
  operation?: InputMaybe<UpsertOperationBelongsTo>;
};

export type CreateOperationEventTypesHasMany = {
  create: Array<CreateOperationEventTypeInput>;
};

export type CreateOperationInput = {
  actualPackages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractTemplates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  donation_type?: InputMaybe<DonationType>;
  eventTypes?: InputMaybe<CreateOperationEventTypesHasMany>;
  idahe_convention?: InputMaybe<OperationConventionIdahe>;
  idahe_typology?: InputMaybe<OperationTypologyIdahe>;
  is_publication_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  mandatory_actual_packages?: InputMaybe<Scalars['Boolean']['input']>;
  mandatory_attachments?: InputMaybe<Scalars['Boolean']['input']>;
  mandatory_contract_templates?: InputMaybe<Scalars['Boolean']['input']>;
  mandatory_planned_packages?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  operation_type_eps?: InputMaybe<OperationTypeEps>;
  operation_type_idahe?: InputMaybe<OperationTypeIdahe>;
  operation_type_transparency?: InputMaybe<OperationTypeTransparency>;
  plannedPackages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreatePlannedAdvantageInPackage = {
  advantage_type: AdvantageType;
  area?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  excluding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  gross_amount?: InputMaybe<Scalars['Float']['input']>;
  including_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  net_amount: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type CreatePlannedAdvantageInput = {
  advantage_type: AdvantageType;
  area?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  excluding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  gross_amount?: InputMaybe<Scalars['Float']['input']>;
  including_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  net_amount: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type CreatePlannedAdvantagesInput = {
  advantages?: InputMaybe<Array<InputMaybe<CreatePlannedAdvantageInput>>>;
};

export type CreatePlannedPackageInput = {
  advantages: Array<CreatePlannedAdvantageInPackage>;
  is_distribution?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSigningProcedureResponse = {
  __typename?: 'CreateSigningProcedureResponse';
  batch_id?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  skipped?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

export type CreateWorkflowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  eventTypes?: InputMaybe<Array<EventType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Array<StepInput>>;
};

export enum CrmResponsibility {
  Approver = 'APPROVER',
  Manager = 'MANAGER'
}

export type CrmUser = {
  __typename?: 'CrmUser';
  deleted_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  post_title?: Maybe<Scalars['String']['output']>;
  responsibilities: Array<CrmResponsibility>;
  staff_id?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of CrmUser items. */
export type CrmUserPaginator = {
  __typename?: 'CrmUserPaginator';
  /** A list of CrmUser items. */
  data: Array<CrmUser>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Data = {
  __typename?: 'Data';
  authentication_mode?: Maybe<YouSignAuthenticationMode>;
  custom_experience_id?: Maybe<Scalars['ID']['output']>;
  interval_in_days?: Maybe<IntervalInDays>;
  max_occurrences?: Maybe<Scalars['Int']['output']>;
  operation_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  ticket_deadline_days?: Maybe<Scalars['Int']['output']>;
  ticket_deadline_work_days?: Maybe<Scalars['Int']['output']>;
  workspace_id?: Maybe<Scalars['ID']['output']>;
};

export type Declaration = {
  __typename?: 'Declaration';
  address?: Maybe<Address>;
  advantages?: Maybe<Array<Maybe<DeclarationAdvantage>>>;
  attendee_medical_types?: Maybe<Array<Maybe<AttendeeMedicalType>>>;
  attendee_quantity: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  convention?: Maybe<Convention>;
  created_at: Scalars['DateTimeUtc']['output'];
  created_by: User;
  declaration_count: Scalars['Int']['output'];
  deposit?: Maybe<DeclarationDeposit>;
  end_at: Scalars['DateTimeUtc']['output'];
  external_code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_accepted: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_canceled: Scalars['Boolean']['output'];
  is_refused: Scalars['Boolean']['output'];
  managerCrm?: Maybe<CrmUser>;
  name: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  specialties: Array<DeclarationSpecialty>;
  start_at: Scalars['DateTimeUtc']['output'];
  status?: Maybe<DeclarationStatus>;
  themes?: Maybe<Array<Maybe<DeclarationThemes>>>;
  tickets?: Maybe<Array<Maybe<Ticket>>>;
  workflow_step?: Maybe<DeclarationWorkflowStep>;
};

export type DeclarationAdvantage = {
  __typename?: 'DeclarationAdvantage';
  advantage_type: AdvantageType;
  comment?: Maybe<Scalars['String']['output']>;
  declaration: Declaration;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  including_tax_amount: Scalars['Float']['output'];
  net_amount: Scalars['Float']['output'];
  originalAdvantage: PlannedAdvantage;
  quantity: Scalars['Float']['output'];
};

export enum DeclarationBadge {
  Activated = 'ACTIVATED',
  Creating = 'CREATING',
  FirstValidation = 'FIRST_VALIDATION',
  IsAccepted = 'IS_ACCEPTED',
  IsArchived = 'IS_ARCHIVED',
  IsCanceled = 'IS_CANCELED',
  IsRefused = 'IS_REFUSED',
  SecondValidation = 'SECOND_VALIDATION',
  Sent = 'SENT',
  ToEdit = 'TO_EDIT'
}

export type DeclarationDeposit = {
  __typename?: 'DeclarationDeposit';
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTimeUtc']['output'];
  created_by: User;
  id: Scalars['ID']['output'];
  recommendation_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DeclarationDepositStatus>;
  submission_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum DeclarationDepositStatus {
  Canceled = 'CANCELED',
  Submitted = 'SUBMITTED',
  ToSubmit = 'TO_SUBMIT'
}

export type DeclarationDocument = {
  __typename?: 'DeclarationDocument';
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTimeUtc']['output'];
  created_by: User;
  declaration: Declaration;
  document: Document;
  id: Scalars['ID']['output'];
  type: AttachmentFileType;
};

/** A paginated list of DeclarationDocument items. */
export type DeclarationDocumentPaginator = {
  __typename?: 'DeclarationDocumentPaginator';
  /** A list of DeclarationDocument items. */
  data: Array<DeclarationDocument>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DeclarationExport = {
  __typename?: 'DeclarationExport';
  created_at: Scalars['DateTimeUtc']['output'];
  document: Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publication_status: PublicationStatus;
  ticket_uuids: Array<Scalars['String']['output']>;
};

/** A paginated list of DeclarationExport items. */
export type DeclarationExportPaginator = {
  __typename?: 'DeclarationExportPaginator';
  /** A list of DeclarationExport items. */
  data: Array<DeclarationExport>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum DeclarationFlag {
  IsAccepted = 'IS_ACCEPTED',
  IsArchived = 'IS_ARCHIVED',
  IsCanceled = 'IS_CANCELED',
  IsRefused = 'IS_REFUSED'
}

/** A paginated list of Declaration items. */
export type DeclarationPaginator = {
  __typename?: 'DeclarationPaginator';
  /** A list of Declaration items. */
  data: Array<Declaration>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum DeclarationSpecialty {
  Allergology = 'ALLERGOLOGY',
  AnatomicalPathology = 'ANATOMICAL_PATHOLOGY',
  Anesthesia = 'ANESTHESIA',
  Angiology = 'ANGIOLOGY',
  Cardiology = 'CARDIOLOGY',
  CardiovascularSurg = 'CARDIOVASCULAR_SURG',
  Dermatology = 'DERMATOLOGY',
  EmergencyMedicine = 'EMERGENCY_MEDICINE',
  Endocrinology = 'ENDOCRINOLOGY',
  FaceSurg = 'FACE_SURG',
  Gastroenterology = 'GASTROENTEROLOGY',
  GeneralMedicine = 'GENERAL_MEDICINE',
  Genetics = 'GENETICS',
  Geriatrics = 'GERIATRICS',
  Hematology = 'HEMATOLOGY',
  InfantSurg = 'INFANT_SURG',
  Infectiology = 'INFECTIOLOGY',
  InternMedicine = 'INTERN_MEDICINE',
  LocalTrainingOrg = 'LOCAL_TRAINING_ORG',
  MaxilofacialSurg = 'MAXILOFACIAL_SURG',
  MedicalBiology = 'MEDICAL_BIOLOGY',
  MedicalGynecology = 'MEDICAL_GYNECOLOGY',
  MedicalImagery = 'MEDICAL_IMAGERY',
  MedicalResearch = 'MEDICAL_RESEARCH',
  Multidisciplinary = 'MULTIDISCIPLINARY',
  Nephrology = 'NEPHROLOGY',
  Neurology = 'NEUROLOGY',
  Neurosurgery = 'NEUROSURGERY',
  NuclearMedicine = 'NUCLEAR_MEDICINE',
  ObstetricGynecology = 'OBSTETRIC_GYNECOLOGY',
  Oncology = 'ONCOLOGY',
  Ophtalmology = 'OPHTALMOLOGY',
  Orl = 'ORL',
  OrthopedicSurg = 'ORTHOPEDIC_SURG',
  Pediatrics = 'PEDIATRICS',
  Pharmacology = 'PHARMACOLOGY',
  PlasticSurg = 'PLASTIC_SURG',
  Pneumology = 'PNEUMOLOGY',
  ProfessionalDvpt = 'PROFESSIONAL_DVPT',
  Psychiatry = 'PSYCHIATRY',
  PublicHealth = 'PUBLIC_HEALTH',
  Radiology = 'RADIOLOGY',
  ReadaptMedicine = 'READAPT_MEDICINE',
  Rheumatology = 'RHEUMATOLOGY',
  SportMedicine = 'SPORT_MEDICINE',
  Stomatology = 'STOMATOLOGY',
  Surgery = 'SURGERY',
  ThermalMedicine = 'THERMAL_MEDICINE',
  Transplant = 'TRANSPLANT',
  UrolologicSurg = 'UROLOLOGIC_SURG',
  VascularSurg = 'VASCULAR_SURG',
  VisceralSurg = 'VISCERAL_SURG',
  WorkMedicine = 'WORK_MEDICINE'
}

export enum DeclarationStatus {
  Creating = 'CREATING',
  ToEdit = 'TO_EDIT'
}

export type DeclarationThemes = {
  __typename?: 'DeclarationThemes';
  created_at: Scalars['DateTimeUtc']['output'];
  created_by: User;
  declaration: Declaration;
  duration: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A paginated list of DeclarationThemes items. */
export type DeclarationThemesPaginator = {
  __typename?: 'DeclarationThemesPaginator';
  /** A list of DeclarationThemes items. */
  data: Array<DeclarationThemes>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum DeclarationWorkflowStep {
  Activated = 'ACTIVATED',
  FirstValidation = 'FIRST_VALIDATION',
  SecondValidation = 'SECOND_VALIDATION',
  Sent = 'SENT'
}

export type DeleteActualAdvantageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteActualPackageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteAdditionalCostInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteAttachmentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteAttendeeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteContractAttendeeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteContractsAttendeesInput = {
  ids: Array<Scalars['ID']['input']>;
  ticket_id: Scalars['ID']['input'];
};

export type DeleteContractsAttendeesResponse = {
  __typename?: 'DeleteContractsAttendeesResponse';
  batch_id?: Maybe<Scalars['String']['output']>;
  ticket_code: Scalars['String']['output'];
};

export type DeleteCrmUserInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteDeclarationDocumentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDeclarationExportInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDeclarationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDeclarationThemesInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDiagnosticExportInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDocumentAttendeeContactInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDocumentAttendeeForAttendeeInput = {
  attendee_id: Scalars['ID']['input'];
  document_attendee_id: Scalars['ID']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type DeleteDocumentAttendeeInput = {
  id: Scalars['ID']['input'];
};

export type DeleteExpenseReportForTicketInput = {
  expense_report_id: Scalars['ID']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type DeleteExpenseReportInput = {
  id: Scalars['ID']['input'];
};

export type DeleteInternalSignerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteNonComplianceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeletePlannedAdvantageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeletePlannedPackageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteSigningSheetForTicketInput = {
  signing_sheet_id: Scalars['ID']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type DeleteTemplateContractInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTicketInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteWorkflowInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum Department {
  Ain = 'AIN',
  Aisne = 'AISNE',
  Allier = 'ALLIER',
  AlpesDeHauteProvence = 'ALPES_DE_HAUTE_PROVENCE',
  AlpesMaritimes = 'ALPES_MARITIMES',
  Ardeche = 'ARDECHE',
  Ardennes = 'ARDENNES',
  Ariege = 'ARIEGE',
  Aube = 'AUBE',
  Aude = 'AUDE',
  Aveyron = 'AVEYRON',
  BasRhin = 'BAS_RHIN',
  BouchesDuRhone = 'BOUCHES_DU_RHONE',
  Calvados = 'CALVADOS',
  Cantal = 'CANTAL',
  Charente = 'CHARENTE',
  CharenteMaritime = 'CHARENTE_MARITIME',
  Cher = 'CHER',
  Correze = 'CORREZE',
  CorseDuSud = 'CORSE_DU_SUD',
  CotesDArmor = 'COTES_D_ARMOR',
  CoteDOr = 'COTE_D_OR',
  Creuse = 'CREUSE',
  DeuxSevres = 'DEUX_SEVRES',
  Dordogne = 'DORDOGNE',
  Doubs = 'DOUBS',
  Drome = 'DROME',
  Essonne = 'ESSONNE',
  Eure = 'EURE',
  EureEtLoir = 'EURE_ET_LOIR',
  Finistere = 'FINISTERE',
  Gard = 'GARD',
  Gers = 'GERS',
  Gironde = 'GIRONDE',
  Guadeloupe = 'GUADELOUPE',
  Guyane = 'GUYANE',
  HautesAlpes = 'HAUTES_ALPES',
  HautesPyrenees = 'HAUTES_PYRENEES',
  HauteCorse = 'HAUTE_CORSE',
  HauteGaronne = 'HAUTE_GARONNE',
  HauteLoire = 'HAUTE_LOIRE',
  HauteMarne = 'HAUTE_MARNE',
  HauteSaone = 'HAUTE_SAONE',
  HauteSavoie = 'HAUTE_SAVOIE',
  HauteVienne = 'HAUTE_VIENNE',
  HautsDeSeine = 'HAUTS_DE_SEINE',
  HautRhin = 'HAUT_RHIN',
  Herault = 'HERAULT',
  IlleEtVilaine = 'ILLE_ET_VILAINE',
  Indre = 'INDRE',
  IndreEtLoire = 'INDRE_ET_LOIRE',
  Isere = 'ISERE',
  Jura = 'JURA',
  Landes = 'LANDES',
  LaReunion = 'LA_REUNION',
  Loir = 'LOIR',
  Loiret = 'LOIRET',
  LoireAtlantique = 'LOIRE_ATLANTIQUE',
  LoirEtCher = 'LOIR_ET_CHER',
  Lot = 'LOT',
  LotEtGaronne = 'LOT_ET_GARONNE',
  Lozere = 'LOZERE',
  MaineEtLoire = 'MAINE_ET_LOIRE',
  Manche = 'MANCHE',
  Marne = 'MARNE',
  Martinique = 'MARTINIQUE',
  Mayenne = 'MAYENNE',
  Mayotte = 'MAYOTTE',
  MeurtheEtMoselle = 'MEURTHE_ET_MOSELLE',
  Meuse = 'MEUSE',
  Morbihan = 'MORBIHAN',
  Moselle = 'MOSELLE',
  Nievre = 'NIEVRE',
  Nord = 'NORD',
  Oise = 'OISE',
  Orne = 'ORNE',
  Other = 'OTHER',
  Paris = 'PARIS',
  PasDeCalais = 'PAS_DE_CALAIS',
  PuyDeDome = 'PUY_DE_DOME',
  PyreneesAtlantiques = 'PYRENEES_ATLANTIQUES',
  PyreneesOrientales = 'PYRENEES_ORIENTALES',
  Rhone = 'RHONE',
  SaoneEtLoire = 'SAONE_ET_LOIRE',
  Sarthe = 'SARTHE',
  Savoie = 'SAVOIE',
  SeineEtMarne = 'SEINE_ET_MARNE',
  SeineMaritime = 'SEINE_MARITIME',
  SeineSaintDenis = 'SEINE_SAINT_DENIS',
  Somme = 'SOMME',
  Tarn = 'TARN',
  TarnEtGaronne = 'TARN_ET_GARONNE',
  TerritoireDeBelfort = 'TERRITOIRE_DE_BELFORT',
  ValDeMarne = 'VAL_DE_MARNE',
  ValDOise = 'VAL_D_OISE',
  Var = 'VAR',
  Vaucluse = 'VAUCLUSE',
  Vendee = 'VENDEE',
  Vienne = 'VIENNE',
  Vosges = 'VOSGES',
  Yonne = 'YONNE',
  Yvelines = 'YVELINES'
}

export type Deposit = {
  __typename?: 'Deposit';
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  created_by?: Maybe<User>;
  id: Scalars['ID']['output'];
  json_filters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  other_category?: Maybe<OtherDepositCategoryEnum>;
  packages?: Maybe<Array<Maybe<PlannedPackage>>>;
  platform?: Maybe<BotDestination>;
  reference?: Maybe<Scalars['String']['output']>;
  regime?: Maybe<AttendeeDepositRegime>;
  status?: Maybe<DepositStatus>;
  submissions?: Maybe<Array<Maybe<Submission>>>;
  ticket?: Maybe<Ticket>;
};

export enum DepositDocumentType {
  Contracts = 'CONTRACTS',
  CsvAttendees = 'CSV_ATTENDEES',
  MergedContracts = 'MERGED_CONTRACTS'
}

export type DepositFilterOption = {
  __typename?: 'DepositFilterOption';
  ticket_code: Scalars['String']['output'];
  ticket_id: Scalars['ID']['output'];
  ticket_name: Scalars['String']['output'];
};

export type DepositNotValidatedAndUnsignedContractResponse = {
  __typename?: 'DepositNotValidatedAndUnsignedContractResponse';
  contract_count: Scalars['Int']['output'];
  contract_lines: Array<Scalars['String']['output']>;
  deposit_count: Scalars['Int']['output'];
  deposit_lines: Array<Scalars['String']['output']>;
};

/** A paginated list of Deposit items. */
export type DepositPaginator = {
  __typename?: 'DepositPaginator';
  /** A list of Deposit items. */
  data: Array<Deposit>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum DepositStatus {
  Canceled = 'CANCELED',
  ConventionAuthorized = 'CONVENTION_AUTHORIZED',
  ConventionRefused = 'CONVENTION_REFUSED',
  Creating = 'CREATING',
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RecommendationPending = 'RECOMMENDATION_PENDING',
  SubmissionIncomplete = 'SUBMISSION_INCOMPLETE',
  SubmissionSent = 'SUBMISSION_SENT',
  ValidationPending = 'VALIDATION_PENDING',
  WaitingForNotification = 'WAITING_FOR_NOTIFICATION'
}

export type DepositZipFile = {
  __typename?: 'DepositZipFile';
  document: Document;
  id: Scalars['ID']['output'];
  json_filter?: Maybe<Scalars['String']['output']>;
  planned_package?: Maybe<PlannedPackage>;
  regime: Scalars['String']['output'];
  ticket: Ticket;
  updated_at: Scalars['DateTimeUtc']['output'];
};

export type DetachTicketLinkInput = {
  linked_ticket_id: Scalars['ID']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type DiagnosticExport = {
  __typename?: 'DiagnosticExport';
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  document: Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ticket_uuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A paginated list of DiagnosticExport items. */
export type DiagnosticExportPaginator = {
  __typename?: 'DiagnosticExportPaginator';
  /** A list of DiagnosticExport items. */
  data: Array<DiagnosticExport>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum DoctorListStatus {
  Canceled = 'CANCELED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type Document = {
  __typename?: 'Document';
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  temporary_url: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DocumentAttendee = {
  __typename?: 'DocumentAttendee';
  attendee: Ticket;
  custom_type_name?: Maybe<Scalars['String']['output']>;
  deposit_status?: Maybe<DocumentAttendeeStatus>;
  document: Document;
  id: Scalars['ID']['output'];
  signature_status?: Maybe<DocumentAttendeeStatus>;
  signed_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  step?: Maybe<DocumentAttendeeStep>;
  ticket: Ticket;
  type: DocumentAttendeeTypes;
};

export enum DocumentAttendeeStatus {
  Canceled = 'CANCELED',
  Creating = 'CREATING',
  Done = 'DONE',
  NotSent = 'NOT_SENT',
  NotSigned = 'NOT_SIGNED',
  Pending = 'PENDING',
  Signing = 'SIGNING'
}

export enum DocumentAttendeeStep {
  Archived = 'ARCHIVED',
  Canceled = 'CANCELED',
  ContractManagement = 'CONTRACT_MANAGEMENT',
  Creating = 'CREATING',
  Declared = 'DECLARED',
  EventInProgress = 'EVENT_IN_PROGRESS',
  EventIsFinished = 'EVENT_IS_FINISHED',
  EventValidating = 'EVENT_VALIDATING',
  FirstValidation = 'FIRST_VALIDATION',
  SecondValidation = 'SECOND_VALIDATION',
  ToEdit = 'TO_EDIT'
}

export enum DocumentAttendeeTypes {
  ActivityAuthorization = 'ACTIVITY_AUTHORIZATION',
  AmendmentContract = 'AMENDMENT_CONTRACT',
  Contract = 'CONTRACT',
  DeanAuthorization = 'DEAN_AUTHORIZATION',
  DirectorAuthorization = 'DIRECTOR_AUTHORIZATION',
  OfficialJournal = 'OFFICIAL_JOURNAL',
  OrderResponse = 'ORDER_RESPONSE',
  Other = 'OTHER',
  Receipt = 'RECEIPT',
  Rib = 'RIB',
  SignedContract = 'SIGNED_CONTRACT',
  SolicitationLetter = 'SOLICITATION_LETTER',
  Status = 'STATUS',
  WorkCertificate = 'WORK_CERTIFICATE'
}

export type DocumentAttendeeUpload = {
  __typename?: 'DocumentAttendeeUpload';
  attendee: Ticket;
  deposit_status?: Maybe<DocumentAttendeeStatus>;
  document: Document;
  id: Scalars['ID']['output'];
  signature_status?: Maybe<DocumentAttendeeStatus>;
  signed_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  step?: Maybe<DocumentAttendeeStep>;
  ticket: Ticket;
  type: DocumentAttendeeTypes;
};

export type DocumentContact = {
  __typename?: 'DocumentContact';
  contact?: Maybe<Contact>;
  document: Document;
  id: Scalars['ID']['output'];
  type: DocumentAttendeeTypes;
};

export type DocumentSubmission = {
  __typename?: 'DocumentSubmission';
  additional_information?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  document_submission_type?: Maybe<DocumentSubmissionTypes>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_from_bot?: Maybe<Scalars['Boolean']['output']>;
  path: Scalars['String']['output'];
  temporary_url: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum DocumentSubmissionTypes {
  AttendeeList = 'ATTENDEE_LIST',
  Contracts = 'CONTRACTS',
  NoticeFromOrder = 'NOTICE_FROM_ORDER',
  Other = 'OTHER',
  PsLetterCancel = 'PS_LETTER_CANCEL',
  PsLetterMaintain = 'PS_LETTER_MAINTAIN',
  SignedConvention = 'SIGNED_CONVENTION',
  SubmissionLetter = 'SUBMISSION_LETTER',
  SubmissionLetterComplement = 'SUBMISSION_LETTER_COMPLEMENT',
  SubmissionLetterModification = 'SUBMISSION_LETTER_MODIFICATION',
  SupplementInfoRequest = 'SUPPLEMENT_INFO_REQUEST',
  UnsignedConvention = 'UNSIGNED_CONVENTION',
  Zip = 'ZIP'
}

export enum DonationType {
  DonationsForHealthRelatedActivities = 'DONATIONS_FOR_HEALTH_RELATED_ACTIVITIES',
  DonationAndGenerosityForResearchActivities = 'DONATION_AND_GENEROSITY_FOR_RESEARCH_ACTIVITIES',
  DonationForPublicUtility = 'DONATION_FOR_PUBLIC_UTILITY'
}

export type DownloadSigningSheetInput = {
  id: Scalars['ID']['input'];
};

export type DownloadedFile = {
  __typename?: 'DownloadedFile';
  content: Scalars['String']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EditContractAttendeeInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EpsTargetInput = {
  health_type?: InputMaybe<AttendeeHealthType>;
  pharmacist_type?: InputMaybe<PharmacistType>;
  regional_health_agency?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum EventType {
  Contract = 'CONTRACT',
  Donation = 'DONATION',
  Event = 'EVENT',
  SimpleDeclaration = 'SIMPLE_DECLARATION',
  SimpleEvent = 'SIMPLE_EVENT',
  UndeclaredEvent = 'UNDECLARED_EVENT'
}

export type ExpenseReport = {
  __typename?: 'ExpenseReport';
  document: Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  ticket: Ticket;
};

export type ExpenseReportResult = {
  __typename?: 'ExpenseReportResult';
  document: Document;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  ticket: Ticket;
};

export type ExpensesImport = {
  __typename?: 'ExpensesImport';
  created_at: Scalars['DateTimeUtc']['output'];
  document: Document;
  id: Scalars['ID']['output'];
  state: ExpensesImportStatus;
  ticket: Ticket;
  type: ExpensesImportType;
};

export type ExpensesImportBatch = {
  __typename?: 'ExpensesImportBatch';
  batch_id: Scalars['String']['output'];
};

export type ExpensesImportBatchInput = {
  batch_id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};

export type ExpensesImportInput = {
  code: Scalars['String']['input'];
  document: Scalars['Upload']['input'];
  import_type: ExpensesType;
};

/** A paginated list of ExpensesImport items. */
export type ExpensesImportPaginator = {
  __typename?: 'ExpensesImportPaginator';
  /** A list of ExpensesImport items. */
  data: Array<ExpensesImport>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ExpensesImportStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type ExpensesImportTemplate = {
  __typename?: 'ExpensesImportTemplate';
  document: Document;
  id: Scalars['ID']['output'];
  ticket: Ticket;
  updated_at: Scalars['DateTimeUtc']['output'];
};

export type ExpensesImportTemplateBatch = {
  __typename?: 'ExpensesImportTemplateBatch';
  batch_id: Scalars['String']['output'];
};

export enum ExpensesImportType {
  Crm = 'CRM',
  Manual = 'MANUAL',
  Specific = 'SPECIFIC'
}

export enum ExpensesType {
  Actual = 'ACTUAL',
  Crm = 'CRM',
  Planned = 'PLANNED',
  Specific = 'SPECIFIC'
}

export enum FilterAvailable {
  Admin = 'admin',
  Dashboard = 'dashboard',
  Library = 'library',
  Transparency = 'transparency'
}

export enum Format {
  Digital = 'DIGITAL',
  Hybrid = 'HYBRID',
  Onsite = 'ONSITE'
}

export enum FormatZipFiles {
  SignedPdf = 'SIGNED_PDF',
  UnsignedDocx = 'UNSIGNED_DOCX',
  UnsignedPdf = 'UNSIGNED_PDF'
}

export type GenerateAgencyExportBatch = {
  __typename?: 'GenerateAgencyExportBatch';
  batch_id: Scalars['String']['output'];
};

export type GenerateAgencyExportInput = {
  code: Scalars['String']['input'];
};

export type GenerateAgencyExportProgress = {
  __typename?: 'GenerateAgencyExportProgress';
  agencyExport?: Maybe<AgencyExport>;
  message: Scalars['String']['output'];
  status: BroadCastsStatusEnum;
};

export type GenerateContractZipFileBatch = {
  __typename?: 'GenerateContractZipFileBatch';
  batch_id: Scalars['String']['output'];
};

export type GenerateContractZipFileInput = {
  code: Scalars['String']['input'];
  formatZipFiles: FormatZipFiles;
};

export type GenerateContractZipFileProgress = {
  __typename?: 'GenerateContractZipFileProgress';
  attachment?: Maybe<Attachment>;
  message: Scalars['String']['output'];
  status: BroadCastsStatusEnum;
};

export type GenerateDepositZipFileBatch = {
  __typename?: 'GenerateDepositZipFileBatch';
  batch_id: Scalars['String']['output'];
};

export type GenerateDepositZipFileInput = {
  json_filter?: InputMaybe<Scalars['String']['input']>;
  package_id?: InputMaybe<Scalars['ID']['input']>;
  regime: AttendeeDepositRegime;
  ticket_id: Scalars['ID']['input'];
  types: Array<DepositDocumentType>;
};

export type GenerateDepositZipFileParams = {
  __typename?: 'GenerateDepositZipFileParams';
  json_filter?: Maybe<Scalars['String']['output']>;
  planned_package_id?: Maybe<Scalars['ID']['output']>;
  regime: AttendeeDepositRegime;
  ticket_id: Scalars['ID']['output'];
};

export type GenerateDepositZipFileProgress = {
  __typename?: 'GenerateDepositZipFileProgress';
  depositZipFile?: Maybe<DepositZipFile>;
  message: Scalars['String']['output'];
  params?: Maybe<GenerateDepositZipFileParams>;
  status: BroadCastsStatusEnum;
};

export type GenerateExpensesImportInput = {
  advantages?: InputMaybe<Array<AdvantageType>>;
  code: Scalars['String']['input'];
  import_type?: InputMaybe<ExpensesType>;
};

export type GenerateExpensesImportTemplateProgress = {
  __typename?: 'GenerateExpensesImportTemplateProgress';
  expensesImportTemplate?: Maybe<ExpensesImportTemplate>;
  message: Scalars['String']['output'];
  status: BroadCastsStatusEnum;
};

export type GenerateManualAttachmentsInput = {
  deposit_id: Scalars['ID']['input'];
  types: Array<DepositDocumentType>;
};

export type GenerateManualAttachmentsParams = {
  __typename?: 'GenerateManualAttachmentsParams';
  deposit_id: Scalars['ID']['output'];
};

export type GenerateManualAttachmentsProgress = {
  __typename?: 'GenerateManualAttachmentsProgress';
  message: Scalars['String']['output'];
  params?: Maybe<GenerateManualAttachmentsParams>;
  status: BroadCastsStatusEnum;
  submission?: Maybe<Submission>;
};

export type GroupPaginationInput = {
  first?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type HealthDepositResponses = {
  __typename?: 'HealthDepositResponses';
  healthTypes?: Maybe<HealthTypesDepositResponse>;
  pharmacistTypes?: Maybe<PharmacistTypesDepositResponse>;
  regionalHealthAgency?: Maybe<OtherAttendeesDepositResponse>;
};

export type HealthTypesDepositResponse = {
  __typename?: 'HealthTypesDepositResponse';
  authorization?: Maybe<Array<Maybe<AttendeeHealthType>>>;
  declaration?: Maybe<Array<Maybe<AttendeeHealthType>>>;
};

export type History = {
  __typename?: 'History';
  created_at: Scalars['DateTimeUtc']['output'];
  formatted_message: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: LogType;
};

/** A paginated list of History items. */
export type HistoryPaginator = {
  __typename?: 'HistoryPaginator';
  /** A list of History items. */
  data: Array<History>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Identity = RestrictedArea & {
  __typename?: 'Identity';
  address?: Maybe<Scalars['String']['output']>;
  capital?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company_form?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  department?: Maybe<Department>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  eps_login?: Maybe<Scalars['String']['output']>;
  gdpr_contact?: Maybe<Scalars['String']['output']>;
  has_eps_password?: Maybe<Scalars['Boolean']['output']>;
  has_idahe_password?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  idahe_login?: Maybe<Scalars['String']['output']>;
  legal_notice?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo_file?: Maybe<Avatar>;
  logo_file_id?: Maybe<Scalars['String']['output']>;
  mail_gdpr_contact?: Maybe<Scalars['String']['output']>;
  main?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  no_urssaf_rate?: Maybe<Scalars['Float']['output']>;
  place_of_registration?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  rcs?: Maybe<Scalars['String']['output']>;
  representative_name?: Maybe<Scalars['String']['output']>;
  representative_title?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Identity items. */
export type IdentityPaginator = {
  __typename?: 'IdentityPaginator';
  /** A list of Identity items. */
  data: Array<Identity>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type InternalSigner = {
  __typename?: 'InternalSigner';
  civility?: Maybe<AttendeeCivility>;
  email: Scalars['String']['output'];
  executive_role?: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  staff_id?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of InternalSigner items. */
export type InternalSignerPaginator = {
  __typename?: 'InternalSignerPaginator';
  /** A list of InternalSigner items. */
  data: Array<InternalSigner>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum IntervalInDays {
  EveryDay = 'EVERY_DAY',
  EveryTwoDay = 'EVERY_TWO_DAY',
  EveryTwoWeek = 'EVERY_TWO_WEEK',
  EveryWeek = 'EVERY_WEEK'
}

export enum LogType {
  AddCommentToSubmission = 'ADD_COMMENT_TO_SUBMISSION',
  ApproverCrmChange = 'APPROVER_CRM_CHANGE',
  Archive = 'ARCHIVE',
  BackToFirstValidation = 'BACK_TO_FIRST_VALIDATION',
  Canceled = 'CANCELED',
  CloneTicket = 'CLONE_TICKET',
  ContractAttendeeSignature = 'CONTRACT_ATTENDEE_SIGNATURE',
  CreateActualPackage = 'CREATE_ACTUAL_PACKAGE',
  CreateAdditionalCost = 'CREATE_ADDITIONAL_COST',
  CreateAdvantage = 'CREATE_ADVANTAGE',
  CreateAdvantageCompleted = 'CREATE_ADVANTAGE_COMPLETED',
  CreateAdvantageNotCompleted = 'CREATE_ADVANTAGE_NOT_COMPLETED',
  CreateAttachment = 'CREATE_ATTACHMENT',
  CreateAttendee = 'CREATE_ATTENDEE',
  CreateAttendeeActualPackage = 'CREATE_ATTENDEE_ACTUAL_PACKAGE',
  CreateAttendeePlannedPackage = 'CREATE_ATTENDEE_PLANNED_PACKAGE',
  CreateAttendeeSignature = 'CREATE_ATTENDEE_SIGNATURE',
  CreateContractAttendee = 'CREATE_CONTRACT_ATTENDEE',
  CreateContractDepositInformation = 'CREATE_CONTRACT_DEPOSIT_INFORMATION',
  CreateContractTemplate = 'CREATE_CONTRACT_TEMPLATE',
  CreateDescription = 'CREATE_DESCRIPTION',
  CreateDocumentAttendee = 'CREATE_DOCUMENT_ATTENDEE',
  CreateExpenseReport = 'CREATE_EXPENSE_REPORT',
  CreateNonCompliance = 'CREATE_NON_COMPLIANCE',
  CreateOnSigningSheet = 'CREATE_ON_SIGNING_SHEET',
  CreatePlannedPackage = 'CREATE_PLANNED_PACKAGE',
  CreateSigningProcedure = 'CREATE_SIGNING_PROCEDURE',
  CreateSigningSheet = 'CREATE_SIGNING_SHEET',
  CreateTicket = 'CREATE_TICKET',
  CreateTripartiteContractAttendee = 'CREATE_TRIPARTITE_CONTRACT_ATTENDEE',
  Declaration = 'DECLARATION',
  DeleteActualPackage = 'DELETE_ACTUAL_PACKAGE',
  DeleteAttendeeActualPackage = 'DELETE_ATTENDEE_ACTUAL_PACKAGE',
  DeleteAttendeePlannedPackage = 'DELETE_ATTENDEE_PLANNED_PACKAGE',
  DeleteDescription = 'DELETE_DESCRIPTION',
  DeletePlannedPackage = 'DELETE_PLANNED_PACKAGE',
  DeleteSigningSheet = 'DELETE_SIGNING_SHEET',
  DoctorListStatusChange = 'DOCTOR_LIST_STATUS_CHANGE',
  DownloadHistory = 'DOWNLOAD_HISTORY',
  DownloadSigningSheet = 'DOWNLOAD_SIGNING_SHEET',
  EndFailedImportExpenses = 'END_FAILED_IMPORT_EXPENSES',
  EndImportExpenses = 'END_IMPORT_EXPENSES',
  GenerateEmptySigningSheet = 'GENERATE_EMPTY_SIGNING_SHEET',
  GenerateSignedSigningSheet = 'GENERATE_SIGNED_SIGNING_SHEET',
  InitiatorChange = 'INITIATOR_CHANGE',
  LinkedDeclarationAdded = 'LINKED_DECLARATION_ADDED',
  LinkedTicketAdded = 'LINKED_TICKET_ADDED',
  ManagerCrmChange = 'MANAGER_CRM_CHANGE',
  MigrationHistory = 'MIGRATION_HISTORY',
  OperationChange = 'OPERATION_CHANGE',
  RemoveAdditionalCost = 'REMOVE_ADDITIONAL_COST',
  RemoveAdvantage = 'REMOVE_ADVANTAGE',
  RemoveAttachment = 'REMOVE_ATTACHMENT',
  RemoveAttendee = 'REMOVE_ATTENDEE',
  RemoveContractAttendee = 'REMOVE_CONTRACT_ATTENDEE',
  RemoveContractAttendeeSignEmailSent = 'REMOVE_CONTRACT_ATTENDEE_SIGN_EMAIL_SENT',
  RemoveContractTemplate = 'REMOVE_CONTRACT_TEMPLATE',
  RemoveDocumentAttendee = 'REMOVE_DOCUMENT_ATTENDEE',
  RemoveExpenseReport = 'REMOVE_EXPENSE_REPORT',
  RemoveNonCompliance = 'REMOVE_NON_COMPLIANCE',
  RemoveTicket = 'REMOVE_TICKET',
  RemoveTripartiteContractAttendee = 'REMOVE_TRIPARTITE_CONTRACT_ATTENDEE',
  StartImportExpenses = 'START_IMPORT_EXPENSES',
  Status = 'STATUS',
  UpdateActualPackage = 'UPDATE_ACTUAL_PACKAGE',
  UpdateAttendee = 'UPDATE_ATTENDEE',
  UpdateDescription = 'UPDATE_DESCRIPTION',
  UpdatePlannedPackage = 'UPDATE_PLANNED_PACKAGE',
  UpdateSubmissionStatus = 'UPDATE_SUBMISSION_STATUS',
  Validator_1Change = 'VALIDATOR_1_CHANGE',
  Validator_2Change = 'VALIDATOR_2_CHANGE',
  WorkflowStepChange = 'WORKFLOW_STEP_CHANGE'
}

export enum MeetingType {
  Local = 'LOCAL',
  National = 'NATIONAL',
  Regional = 'REGIONAL'
}

export type Mutation = {
  __typename?: 'Mutation';
  addClientLevelRoleMappingToUser: UserRole;
  apiCreatePlannedAdvantage: PlannedAdvantage;
  apiUpdatePlannedAdvantage: PlannedAdvantage;
  apiUpsertUser: UserKeycloak;
  assignActualPackageToAttendees: Scalars['Boolean']['output'];
  assignActualPackagesToTicket?: Maybe<Array<Maybe<ActualPackage>>>;
  assignPlannedPackageToAttendees: Scalars['Boolean']['output'];
  assignPlannedPackagesToTicket?: Maybe<Array<Maybe<PlannedPackage>>>;
  attachDocumentToAttendee: DocumentAttendeeUpload;
  attachDocumentToTicket: AttachmentResult;
  attachExpenseReportToTicket: ExpenseReportResult;
  attachSigningSheetToTicket: SigningSheetResult;
  attachTicketLink: TicketLinkPayload;
  bulkUpdateAttendees: Array<Attendee>;
  cancelContractAttendeeSignatureRequest: Scalars['Boolean']['output'];
  changeTicketStatus: Ticket;
  cloneContactAsAttendee: Attendee;
  cloneContactsAsAttendees: CloneContactsAsAttendeesResult;
  cloneOperation: Operation;
  clonePlannedPackagesAsActualPackages?: Maybe<Array<Maybe<ActualPackage>>>;
  cloneTicket: CloneTicketBatch;
  createActualAdvantage: ActualAdvantage;
  createActualAdvantages?: Maybe<Scalars['Boolean']['output']>;
  createActualPackage: ActualPackage;
  createAdditionalCost: AdditionalCost;
  createAddress: Address;
  createAttachmentTemplates: Array<Maybe<Attachment>>;
  createAttachments: Array<Maybe<Attachment>>;
  createAttendee: Attendee;
  createAttendeeByApi: Attendee;
  createAttendeeByImport: CreateAttendeesByImportBatch;
  createAttendeesByApi: CreateAttendeesByApiResult;
  createComment: Comment;
  createContact: Contact;
  createContractAttendee: ContractAttendeeBatch;
  createContractDepositInformation: ContractDepositInformation;
  createContractForAttendee: Ticket;
  createConvention: Convention;
  createDeclaration: Declaration;
  createDeclarationDocument: DeclarationDocument;
  createDeclarationExport: ContractAttendeeBatch;
  createDiagnosticExport: ContractAttendeeBatch;
  createManualSubmission?: Maybe<Deposit>;
  createNonCompliance: NonCompliance;
  createNotification: Notification;
  createOperation: Operation;
  createOperationEventType: OperationEventType;
  createPlannedAdvantage: PlannedAdvantage;
  createPlannedAdvantages?: Maybe<Scalars['Boolean']['output']>;
  createPlannedPackage: PlannedPackage;
  createSigningProcedure: CreateSigningProcedureResponse;
  createUser: UserKeycloak;
  createWorkflow: Workflow;
  deleteActualAdvantage?: Maybe<ActualAdvantage>;
  deleteActualPackage?: Maybe<ActualPackage>;
  deleteAdditionalCost: AdditionalCost;
  deleteAttachment: Attachment;
  deleteAttendee?: Maybe<Attendee>;
  deleteAttendeeSignature: AttendeeSignature;
  deleteContractAttendee?: Maybe<Scalars['String']['output']>;
  deleteContractTemplate: ContractTemplate;
  deleteContractsAttendees: DeleteContractsAttendeesResponse;
  deleteCrmUser?: Maybe<CrmUser>;
  deleteDeclaration?: Maybe<Declaration>;
  deleteDeclarationDocument: DeclarationDocument;
  deleteDeclarationExport: DeclarationExport;
  deleteDeclarationTheme?: Maybe<DeclarationThemes>;
  deleteDocumentAttendee: DocumentAttendee;
  deleteDocumentAttendeeContact?: Maybe<Scalars['Boolean']['output']>;
  deleteDocumentAttendeeForAttendee: DocumentAttendeeUpload;
  deleteExpenseReport: ExpenseReport;
  deleteExpenseReportForTicket: ExpenseReportResult;
  deleteInternalSigner?: Maybe<InternalSigner>;
  deleteNonCompliance: NonCompliance;
  deletePlannedAdvantage?: Maybe<PlannedAdvantage>;
  deletePlannedPackage?: Maybe<PlannedPackage>;
  deleteSigningSheet: SigningSheet;
  deleteSigningSheetForTicket: SigningSheetResult;
  deleteSpecialty?: Maybe<Specialty>;
  deleteTicket?: Maybe<Ticket>;
  deleteWorkflow?: Maybe<Workflow>;
  detachTicketLink: TicketLinkPayload;
  downloadAttendeeTemplate: DownloadedFile;
  downloadSigningSheet?: Maybe<DownloadedFile>;
  editContractAttendee?: Maybe<Scalars['Boolean']['output']>;
  expenseImportByCrm?: Maybe<Scalars['Boolean']['output']>;
  expensesImport: ExpensesImportTemplateBatch;
  expensesImportTemplate: ExpensesImportTemplateBatch;
  generateAgencyExport: GenerateAgencyExportBatch;
  generateContractZipFile: GenerateContractZipFileBatch;
  generateDepositZipFile: GenerateDepositZipFileBatch;
  generateManualAttachments?: Maybe<GenerateDepositZipFileBatch>;
  removeClientLevelRoleMappingFromUser: UserRole;
  restoreActualAdvantage?: Maybe<ActualAdvantage>;
  restoreAttendee?: Maybe<Attendee>;
  restoreComment?: Maybe<Comment>;
  restoreInternalSigner?: Maybe<InternalSigner>;
  restoreNonCompliance?: Maybe<NonCompliance>;
  restorePlannedAdvantage?: Maybe<PlannedAdvantage>;
  restoreTicket?: Maybe<Ticket>;
  restoreWorkflow?: Maybe<Workflow>;
  sendEPSToBot: SendEpsToBotBatch;
  sendIDAHEToBot: Scalars['Boolean']['output'];
  sendReminder?: Maybe<Scalars['Boolean']['output']>;
  softDeleteUser: UserKeycloak;
  toggleActiveStateConventions: Scalars['Boolean']['output'];
  toggleActiveStateOperations: Scalars['Boolean']['output'];
  toggleNotifications: Array<Notification>;
  trashActualAdvantage?: Maybe<ActualAdvantage>;
  trashActualPackage?: Maybe<ActualPackage>;
  trashAttendee?: Maybe<Attendee>;
  trashAttendeeTicketRelation: AttendeeTicketRelationResult;
  trashAttendees?: Maybe<Scalars['Boolean']['output']>;
  trashComment?: Maybe<Comment>;
  trashContact?: Maybe<Contact>;
  trashCrmUser?: Maybe<CrmUser>;
  trashInternalSigner?: Maybe<InternalSigner>;
  trashNonCompliance: NonCompliance;
  trashPlannedAdvantage?: Maybe<PlannedAdvantage>;
  trashPlannedPackage?: Maybe<PlannedPackage>;
  trashWorkflow?: Maybe<Workflow>;
  unassignActualPackageToAttendee: Scalars['Boolean']['output'];
  unassignPlannedPackageToAttendee: Scalars['Boolean']['output'];
  unassignPlannedPackagesToAttendees: Scalars['Boolean']['output'];
  updateActualAdvantage: ActualAdvantage;
  updateActualPackage?: Maybe<ActualPackage>;
  updateAdditionalCost: AdditionalCost;
  updateAddress: Address;
  updateAttendee: Attendee;
  updateAttendeeFacturation: Attendee;
  updateAttendeesBilling?: Maybe<Scalars['Boolean']['output']>;
  updateComment: Comment;
  updateContact: Contact;
  updateConvention: Convention;
  updateCoreTicket: Ticket;
  updateDeclaration: Declaration;
  updateDeclarationAndNextStep: Declaration;
  updateDeclarationAndSendBackToInitiator: Declaration;
  updateDeclarationFlag: Declaration;
  updateManagedTickets: Array<Ticket>;
  updateNonCompliance: NonCompliance;
  updateNotification: Notification;
  updateOperation: Operation;
  updatePlannedAdvantage: PlannedAdvantage;
  updatePlannedPackage?: Maybe<PlannedPackage>;
  updateSetting: Settings;
  updateSettings: Array<Settings>;
  updateSimpleEventsInBulk: Array<Ticket>;
  updateSubmission?: Maybe<Submission>;
  updateTicket: Ticket;
  updateTicketLifeCycle: UpdateTicketLifeCycleResponse;
  updateUser: UserKeycloak;
  updateUserNotifications: User;
  updateUserValidators: UserKeycloak;
  updateWorkflow: Workflow;
  uploadAttachments: Array<NewAttachment>;
  uploadContractTemplate: ContractTemplateUpload;
  uploadDocumentAttendee: DocumentAttendeeUpload;
  uploadExpenseReport: UploadExpenseReport;
  uploadFile: Document;
  uploadLogo: Document;
  uploadSigningSheet: UploadSigningSheet;
  upsertAttendeeSignature: AttendeeSignature;
  upsertCrmUser: CrmUser;
  upsertDeclarationDeposit: DeclarationDeposit;
  upsertDeclarationTheme: DeclarationThemes;
  upsertIdentity: Identity;
  upsertInternalSigner: InternalSigner;
  upsertNetwork: Network;
  upsertProduct: Product;
  upsertRegion: Region;
  upsertSector: Sector;
  upsertSpecialty: Specialty;
  upsertTherapeuticArea: TherapeuticArea;
  upsertTicket: Ticket;
  upsertUga: Uga;
  upsertUnit: Unit;
  upsertZone: Zone;
};


export type MutationAddClientLevelRoleMappingToUserArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<Array<UserRoleInput>>;
};


export type MutationApiCreatePlannedAdvantageArgs = {
  input: ApiCreatePlannedAdvantageInput;
};


export type MutationApiUpdatePlannedAdvantageArgs = {
  input: ApiUpdatePlannedAdvantageInput;
};


export type MutationApiUpsertUserArgs = {
  id: Scalars['ID']['input'];
  input: UserKeycloakInput;
};


export type MutationAssignActualPackageToAttendeesArgs = {
  input?: InputMaybe<AssignActualPackageToAttendeesInput>;
};


export type MutationAssignActualPackagesToTicketArgs = {
  input?: InputMaybe<AssignActualPackagesToTicketInput>;
};


export type MutationAssignPlannedPackageToAttendeesArgs = {
  input?: InputMaybe<AssignPlannedPackageToAttendeesInput>;
};


export type MutationAssignPlannedPackagesToTicketArgs = {
  input?: InputMaybe<AssignPlannedPackagesToTicketInput>;
};


export type MutationAttachDocumentToAttendeeArgs = {
  input: AttachDocumentToAttendeeInput;
};


export type MutationAttachDocumentToTicketArgs = {
  input: AttachDocumentToTicketInput;
};


export type MutationAttachExpenseReportToTicketArgs = {
  input: AttachExpenseReportToTicketInput;
};


export type MutationAttachSigningSheetToTicketArgs = {
  input: AttachSigningSheetToTicketInput;
};


export type MutationAttachTicketLinkArgs = {
  input: AttachTicketLinkInput;
};


export type MutationBulkUpdateAttendeesArgs = {
  input: BulkUpdateAttendeesInput;
};


export type MutationCancelContractAttendeeSignatureRequestArgs = {
  input: CancelContractAttendeeSignatureRequestInput;
};


export type MutationChangeTicketStatusArgs = {
  input: ChangeTicketStatusInput;
};


export type MutationCloneContactAsAttendeeArgs = {
  input: CloneContactAsAttendeeInput;
};


export type MutationCloneContactsAsAttendeesArgs = {
  input: CloneContactsAsAttendeesInput;
};


export type MutationCloneOperationArgs = {
  input: UpdateOperationInput;
};


export type MutationClonePlannedPackagesAsActualPackagesArgs = {
  input?: InputMaybe<ClonePlannedPackagesAsActualPackagesInput>;
};


export type MutationCloneTicketArgs = {
  input: CloneTicketInput;
};


export type MutationCreateActualAdvantageArgs = {
  input: CreateActualAdvantageInput;
};


export type MutationCreateActualAdvantagesArgs = {
  input: Array<CreateActualAdvantageInput>;
  packageID: Scalars['ID']['input'];
};


export type MutationCreateActualPackageArgs = {
  input: CreateActualPackageInput;
};


export type MutationCreateAdditionalCostArgs = {
  input: CreateAdditionalCostInput;
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateAttachmentTemplatesArgs = {
  input?: InputMaybe<AttachmentInput>;
};


export type MutationCreateAttachmentsArgs = {
  input?: InputMaybe<AttachmentInput>;
};


export type MutationCreateAttendeeArgs = {
  input: CreateAttendeeInput;
};


export type MutationCreateAttendeeByApiArgs = {
  input: CreateAttendeeByApiInput;
};


export type MutationCreateAttendeeByImportArgs = {
  input: CreateAttendeeByImportInput;
};


export type MutationCreateAttendeesByApiArgs = {
  input: CreateAttendeesByApiInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateContractAttendeeArgs = {
  input: CreateContractAttendeeInput;
};


export type MutationCreateContractDepositInformationArgs = {
  input: CreateContractDepositInformationInput;
};


export type MutationCreateContractForAttendeeArgs = {
  input: CreateContractForAttendeeInput;
};


export type MutationCreateConventionArgs = {
  input: CreateConventionInput;
};


export type MutationCreateDeclarationArgs = {
  input: CreateDeclarationInput;
};


export type MutationCreateDeclarationDocumentArgs = {
  input: CreateDeclarationDocumentInput;
};


export type MutationCreateDeclarationExportArgs = {
  input: CreateDeclarationExportInput;
};


export type MutationCreateDiagnosticExportArgs = {
  input: CreateDiagnosticExportInput;
};


export type MutationCreateManualSubmissionArgs = {
  input?: InputMaybe<CreateManualSubmissionInput>;
};


export type MutationCreateNonComplianceArgs = {
  input: CreateNonComplianceInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateOperationArgs = {
  input: CreateOperationInput;
};


export type MutationCreateOperationEventTypeArgs = {
  input: CreateOperationEventTypeInput;
};


export type MutationCreatePlannedAdvantageArgs = {
  input: CreatePlannedAdvantageInput;
};


export type MutationCreatePlannedAdvantagesArgs = {
  input: Array<CreatePlannedAdvantageInput>;
  packageID: Scalars['ID']['input'];
};


export type MutationCreatePlannedPackageArgs = {
  input: CreatePlannedPackageInput;
};


export type MutationCreateSigningProcedureArgs = {
  input: CreateSigningProcedureInput;
};


export type MutationCreateUserArgs = {
  input: UserKeycloakInput;
};


export type MutationCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};


export type MutationDeleteActualAdvantageArgs = {
  input: DeleteActualAdvantageInput;
};


export type MutationDeleteActualPackageArgs = {
  input: DeleteActualPackageInput;
};


export type MutationDeleteAdditionalCostArgs = {
  input: DeleteAdditionalCostInput;
};


export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteAttendeeArgs = {
  input: DeleteAttendeeInput;
};


export type MutationDeleteAttendeeSignatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractAttendeeArgs = {
  input: DeleteContractAttendeeInput;
};


export type MutationDeleteContractTemplateArgs = {
  input: DeleteTemplateContractInput;
};


export type MutationDeleteContractsAttendeesArgs = {
  input: DeleteContractsAttendeesInput;
};


export type MutationDeleteCrmUserArgs = {
  input: DeleteCrmUserInput;
};


export type MutationDeleteDeclarationArgs = {
  input: DeleteDeclarationInput;
};


export type MutationDeleteDeclarationDocumentArgs = {
  input: DeleteDeclarationDocumentInput;
};


export type MutationDeleteDeclarationExportArgs = {
  input: DeleteDeclarationExportInput;
};


export type MutationDeleteDeclarationThemeArgs = {
  input: DeleteDeclarationThemesInput;
};


export type MutationDeleteDocumentAttendeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentAttendeeContactArgs = {
  input: DeleteDocumentAttendeeContactInput;
};


export type MutationDeleteDocumentAttendeeForAttendeeArgs = {
  input: DeleteDocumentAttendeeForAttendeeInput;
};


export type MutationDeleteExpenseReportArgs = {
  input: DeleteExpenseReportInput;
};


export type MutationDeleteExpenseReportForTicketArgs = {
  input: DeleteExpenseReportForTicketInput;
};


export type MutationDeleteInternalSignerArgs = {
  input: DeleteInternalSignerInput;
};


export type MutationDeleteNonComplianceArgs = {
  input: DeleteNonComplianceInput;
};


export type MutationDeletePlannedAdvantageArgs = {
  input: DeletePlannedAdvantageInput;
};


export type MutationDeletePlannedPackageArgs = {
  input: DeletePlannedPackageInput;
};


export type MutationDeleteSigningSheetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSigningSheetForTicketArgs = {
  input: DeleteSigningSheetForTicketInput;
};


export type MutationDeleteSpecialtyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTicketArgs = {
  input: DeleteTicketInput;
};


export type MutationDeleteWorkflowArgs = {
  input: DeleteWorkflowInput;
};


export type MutationDetachTicketLinkArgs = {
  input: DetachTicketLinkInput;
};


export type MutationDownloadSigningSheetArgs = {
  input?: InputMaybe<DownloadSigningSheetInput>;
};


export type MutationEditContractAttendeeArgs = {
  input: EditContractAttendeeInput;
};


export type MutationExpenseImportByCrmArgs = {
  input?: InputMaybe<ExpensesImportInput>;
};


export type MutationExpensesImportArgs = {
  input: ExpensesImportInput;
};


export type MutationExpensesImportTemplateArgs = {
  input: GenerateExpensesImportInput;
};


export type MutationGenerateAgencyExportArgs = {
  input: GenerateAgencyExportInput;
};


export type MutationGenerateContractZipFileArgs = {
  input: GenerateContractZipFileInput;
};


export type MutationGenerateDepositZipFileArgs = {
  input: GenerateDepositZipFileInput;
};


export type MutationGenerateManualAttachmentsArgs = {
  input?: InputMaybe<GenerateManualAttachmentsInput>;
};


export type MutationRemoveClientLevelRoleMappingFromUserArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<Array<UserRoleInput>>;
};


export type MutationRestoreActualAdvantageArgs = {
  input: RestoreActualAdvantageInput;
};


export type MutationRestoreAttendeeArgs = {
  input: RestoreAttendeeInput;
};


export type MutationRestoreCommentArgs = {
  input: RestoreCommentInput;
};


export type MutationRestoreInternalSignerArgs = {
  input: RestoreInternalSignerInput;
};


export type MutationRestoreNonComplianceArgs = {
  input: RestoreNonComplianceInput;
};


export type MutationRestorePlannedAdvantageArgs = {
  input: RestorePlannedAdvantageInput;
};


export type MutationRestoreTicketArgs = {
  input: RestoreTicketInput;
};


export type MutationRestoreWorkflowArgs = {
  input: RestoreWorkflowInput;
};


export type MutationSendEpsToBotArgs = {
  input?: InputMaybe<SendEpsToBotInput>;
};


export type MutationSendIdaheToBotArgs = {
  input?: InputMaybe<SendToBotInput>;
};


export type MutationSendReminderArgs = {
  input: SendReminderInput;
};


export type MutationSoftDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleActiveStateConventionsArgs = {
  input: ToggleActiveStateConventionsInput;
};


export type MutationToggleActiveStateOperationsArgs = {
  input: ToggleActiveStateOperationsInput;
};


export type MutationToggleNotificationsArgs = {
  input: Array<ToggleNotificationInput>;
};


export type MutationTrashActualAdvantageArgs = {
  input: TrashActualAdvantageInput;
};


export type MutationTrashActualPackageArgs = {
  input: TrashActualPackageInput;
};


export type MutationTrashAttendeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTrashAttendeeTicketRelationArgs = {
  input: TrashAttendeeTicketRelationInput;
};


export type MutationTrashAttendeesArgs = {
  ids: Array<Scalars['ID']['input']>;
  ticket_id: Scalars['ID']['input'];
};


export type MutationTrashCommentArgs = {
  input: TrashCommentInput;
};


export type MutationTrashContactArgs = {
  input: TrashContactInput;
};


export type MutationTrashCrmUserArgs = {
  input: TrashCrmUserInput;
};


export type MutationTrashInternalSignerArgs = {
  input: TrashInternalSignerInput;
};


export type MutationTrashNonComplianceArgs = {
  input: TrashNonComplianceInput;
};


export type MutationTrashPlannedAdvantageArgs = {
  input: TrashPlannedAdvantageInput;
};


export type MutationTrashPlannedPackageArgs = {
  input: TrashPlannedPackageInput;
};


export type MutationTrashWorkflowArgs = {
  input: TrashWorkflowInput;
};


export type MutationUnassignActualPackageToAttendeeArgs = {
  input?: InputMaybe<UnassignActualPackageToAttendeeInput>;
};


export type MutationUnassignPlannedPackageToAttendeeArgs = {
  input?: InputMaybe<UnassignPlannedPackageToAttendeeInput>;
};


export type MutationUnassignPlannedPackagesToAttendeesArgs = {
  input?: InputMaybe<UnassignPlannedPackagesToAttendeesInput>;
};


export type MutationUpdateActualAdvantageArgs = {
  input: UpdateActualAdvantageInput;
};


export type MutationUpdateActualPackageArgs = {
  input: UpdateActualPackageInput;
};


export type MutationUpdateAdditionalCostArgs = {
  input: UpdateAdditionalCostInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAttendeeArgs = {
  input: UpdateAttendeeInput;
};


export type MutationUpdateAttendeeFacturationArgs = {
  input: UpdateAttendeeFacturationInput;
};


export type MutationUpdateAttendeesBillingArgs = {
  input: UpdateAttendeesBillingInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateConventionArgs = {
  input: UpdateConventionInput;
};


export type MutationUpdateCoreTicketArgs = {
  input: UpdateCoreTicketInput;
};


export type MutationUpdateDeclarationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeclarationInput;
};


export type MutationUpdateDeclarationAndNextStepArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeclarationInput;
};


export type MutationUpdateDeclarationAndSendBackToInitiatorArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeclarationInput;
};


export type MutationUpdateDeclarationFlagArgs = {
  input: UpdateDeclarationFlagInput;
};


export type MutationUpdateManagedTicketsArgs = {
  input: UpdateFromManagementTickets;
};


export type MutationUpdateNonComplianceArgs = {
  input: UpdateNonComplianceInput;
};


export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};


export type MutationUpdateOperationArgs = {
  input: UpdateOperationInput;
};


export type MutationUpdatePlannedAdvantageArgs = {
  input: UpdatePlannedAdvantageInput;
};


export type MutationUpdatePlannedPackageArgs = {
  input: UpdatePlannedPackageInput;
};


export type MutationUpdateSettingArgs = {
  input: SettingsInput;
};


export type MutationUpdateSettingsArgs = {
  input: Array<SettingsInput>;
};


export type MutationUpdateSimpleEventsInBulkArgs = {
  input: UpdateSimpleEventsInBulkInput;
};


export type MutationUpdateSubmissionArgs = {
  input?: InputMaybe<UpdateSubmissionInput>;
};


export type MutationUpdateTicketArgs = {
  input: UpdateTicketInput;
};


export type MutationUpdateTicketLifeCycleArgs = {
  input: UpdateTicketLifeCycleInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UserKeycloakInput;
};


export type MutationUpdateUserNotificationsArgs = {
  input: UpdateUserNotificationsInput;
};


export type MutationUpdateUserValidatorsArgs = {
  id: Scalars['ID']['input'];
  input: UserValidatorsInput;
};


export type MutationUpdateWorkflowArgs = {
  input: UpdateWorkflowInput;
};


export type MutationUploadAttachmentsArgs = {
  input: UploadAttachmentsInput;
};


export type MutationUploadContractTemplateArgs = {
  input: UploadContractTemplateInput;
};


export type MutationUploadDocumentAttendeeArgs = {
  input: UploadDocumentAttendeeInput;
};


export type MutationUploadExpenseReportArgs = {
  input: UploadExpenseReportInput;
};


export type MutationUploadFileArgs = {
  input: UploadFileInput;
};


export type MutationUploadLogoArgs = {
  input: UploadLogoInput;
};


export type MutationUploadSigningSheetArgs = {
  input: UploadSigningSheetInput;
};


export type MutationUpsertAttendeeSignatureArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertAttendeeSignatureInput;
};


export type MutationUpsertCrmUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertCrmUserInput;
};


export type MutationUpsertDeclarationDepositArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertDeclarationDepositInput;
};


export type MutationUpsertDeclarationThemeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertDeclarationThemesInput;
};


export type MutationUpsertIdentityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertIdentityInput;
};


export type MutationUpsertInternalSignerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertInternalSignerInput;
};


export type MutationUpsertNetworkArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertNetworkInput;
};


export type MutationUpsertProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertProductInput;
};


export type MutationUpsertRegionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertRegionInput;
};


export type MutationUpsertSectorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertSectorInput;
};


export type MutationUpsertSpecialtyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertSpecialtyInput;
};


export type MutationUpsertTherapeuticAreaArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertTherapeuticAreaInput;
};


export type MutationUpsertTicketArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertTicketInput;
};


export type MutationUpsertUgaArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertUgaInput;
};


export type MutationUpsertUnitArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertUnitInput;
};


export type MutationUpsertZoneArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertZoneInput;
};

export type Network = RestrictedArea & {
  __typename?: 'Network';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Network items. */
export type NetworkPaginator = {
  __typename?: 'NetworkPaginator';
  /** A list of Network items. */
  data: Array<Network>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type NonCompliance = {
  __typename?: 'NonCompliance';
  id: Scalars['ID']['output'];
  internal_code: Scalars['String']['output'];
  ticket_id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  created_by?: Maybe<User>;
  date_boundary?: Maybe<NotificationDateBoundary>;
  day_type?: Maybe<NotificationDayType>;
  delay?: Maybe<Scalars['Int']['output']>;
  email_body: Scalars['String']['output'];
  email_object: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  event_types: Array<EventType>;
  external_emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  internal_emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  operations?: Maybe<Array<Maybe<Operation>>>;
  period?: Maybe<NotificationPeriod>;
  submission_regime?: Maybe<NotificationSubmissionRegime>;
  target_state?: Maybe<NotificationTargetState>;
  ticket_roles_to_notify?: Maybe<Array<Maybe<NotificationTicketRolesToNotify>>>;
  type: NotificationType;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

export enum NotificationDateBoundary {
  EndAt = 'END_AT',
  StartAt = 'START_AT'
}

export enum NotificationDayType {
  Business = 'BUSINESS',
  Calendar = 'CALENDAR',
  Working = 'WORKING'
}

/** A paginated list of Notification items. */
export type NotificationPaginator = {
  __typename?: 'NotificationPaginator';
  /** A list of Notification items. */
  data: Array<Notification>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum NotificationPeriod {
  After = 'AFTER',
  Before = 'BEFORE'
}

export enum NotificationSubmissionRegime {
  All = 'ALL',
  Authorization = 'AUTHORIZATION',
  Declaration = 'DECLARATION'
}

export enum NotificationTargetState {
  Canceled = 'CANCELED',
  ContractManagement = 'CONTRACT_MANAGEMENT',
  Creating = 'CREATING',
  EventInProgress = 'EVENT_IN_PROGRESS',
  EventIsFinished = 'EVENT_IS_FINISHED',
  EventValidating = 'EVENT_VALIDATING',
  FirstValidation = 'FIRST_VALIDATION',
  IsArchived = 'IS_ARCHIVED',
  IsDeclared = 'IS_DECLARED',
  IsPublished = 'IS_PUBLISHED',
  SecondValidation = 'SECOND_VALIDATION',
  ToEdit = 'TO_EDIT'
}

export enum NotificationTicketRolesToNotify {
  ApproverCrm = 'APPROVER_CRM',
  Initiator = 'INITIATOR',
  ManagerCrm = 'MANAGER_CRM',
  Validator_1 = 'VALIDATOR_1',
  Validator_2 = 'VALIDATOR_2'
}

export enum NotificationType {
  ChangingState = 'CHANGING_STATE',
  DelayAlert = 'DELAY_ALERT'
}

export type Operation = {
  __typename?: 'Operation';
  actualPackageIds: Array<Scalars['String']['output']>;
  actualPackages?: Maybe<Array<Maybe<ActualPackage>>>;
  attachmentIds: Array<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  contractTemplateIds: Array<Scalars['String']['output']>;
  contractTemplates?: Maybe<Array<Maybe<ContractTemplate>>>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  donation_type?: Maybe<DonationType>;
  enabled: Scalars['Boolean']['output'];
  eventTypes: Array<OperationEventType>;
  id: Scalars['ID']['output'];
  idahe_convention?: Maybe<OperationConventionIdahe>;
  idahe_typology?: Maybe<OperationTypologyIdahe>;
  is_publication_allowed: Scalars['Boolean']['output'];
  mandatory_actual_packages?: Maybe<Scalars['Boolean']['output']>;
  mandatory_attachments?: Maybe<Scalars['Boolean']['output']>;
  mandatory_contract_templates?: Maybe<Scalars['Boolean']['output']>;
  mandatory_planned_packages?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  operation_type_eps?: Maybe<OperationTypeEps>;
  operation_type_idahe?: Maybe<OperationTypeIdahe>;
  operation_type_transparency?: Maybe<OperationTypeTransparency>;
  plannedPackageIds: Array<Scalars['String']['output']>;
  plannedPackages?: Maybe<Array<Maybe<PlannedPackage>>>;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

export enum OperationConventionIdahe {
  Financial = 'FINANCIAL',
  Manifestation = 'MANIFESTATION',
  Research = 'RESEARCH'
}

export type OperationEventType = {
  __typename?: 'OperationEventType';
  event_type: EventType;
  id: Scalars['ID']['output'];
  operation: Operation;
};

/** A paginated list of Operation items. */
export type OperationPaginator = {
  __typename?: 'OperationPaginator';
  /** A list of Operation items. */
  data: Array<Operation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum OperationTypeEps {
  AdvertisingSpacePurchaseOrRentalContract = 'ADVERTISING_SPACE_PURCHASE_OR_RENTAL_CONTRACT',
  AwardContract = 'AWARD_CONTRACT',
  ConferenceRegistrationContract = 'CONFERENCE_REGISTRATION_CONTRACT',
  ConsultingOrExpertiseContractOtherThanScientificSurveyStudyMarketStudy = 'CONSULTING_OR_EXPERTISE_CONTRACT_OTHER_THAN_SCIENTIFIC_SURVEY_STUDY_MARKET_STUDY',
  ContractForThePurchaseOrRentalOfSpacesAsPartOfScientificEvents = 'CONTRACT_FOR_THE_PURCHASE_OR_RENTAL_OF_SPACES_AS_PART_OF_SCIENTIFIC_EVENTS',
  EventSpeakerContract = 'EVENT_SPEAKER_CONTRACT',
  Other = 'OTHER',
  Partnership = 'PARTNERSHIP',
  Patronage = 'PATRONAGE',
  ResearchGrantAwardContract = 'RESEARCH_GRANT_AWARD_CONTRACT',
  ScientificEvaluationContract = 'SCIENTIFIC_EVALUATION_CONTRACT',
  ScientificResearchContractExpertiseConsultant = 'SCIENTIFIC_RESEARCH_CONTRACT_EXPERTISE_CONSULTANT',
  Sponsorship = 'SPONSORSHIP'
}

export enum OperationTypeIdahe {
  Agreement_2020_02 = 'AGREEMENT_2020_02',
  Agreement_2020_05 = 'AGREEMENT_2020_05',
  Agreement_2020_0101 = 'AGREEMENT_2020_0101',
  Agreement_2020_0102 = 'AGREEMENT_2020_0102',
  Agreement_2020_0301 = 'AGREEMENT_2020_0301',
  Agreement_2020_0302 = 'AGREEMENT_2020_0302',
  Agreement_2020_0401 = 'AGREEMENT_2020_0401',
  Agreement_2020_0402 = 'AGREEMENT_2020_0402',
  Agreement_2024_01 = 'AGREEMENT_2024_01',
  Agreement_2024_02 = 'AGREEMENT_2024_02',
  Agreement_2024_03 = 'AGREEMENT_2024_03',
  Agreement_2024_04 = 'AGREEMENT_2024_04',
  Agreement_2024_05 = 'AGREEMENT_2024_05',
  Congress = 'CONGRESS',
  FactoryVisit = 'FACTORY_VISIT',
  GraduateEducation = 'GRADUATE_EDUCATION',
  InvestigatorMeeting = 'INVESTIGATOR_MEETING',
  LaboratorySymposium = 'LABORATORY_SYMPOSIUM',
  Other = 'OTHER',
  ProfessionalMeeting = 'PROFESSIONAL_MEETING',
  TrainingCourse = 'TRAINING_COURSE',
  WeekendSeminar = 'WEEKEND_SEMINAR'
}

export enum OperationTypeTransparency {
  AdvertisementSpacePurchaseLease = 'ADVERTISEMENT_SPACE_PURCHASE_LEASE',
  AwardContract = 'AWARD_CONTRACT',
  CosmeticProductEvaluation = 'COSMETIC_PRODUCT_EVALUATION',
  CosmeticProductVigilance = 'COSMETIC_PRODUCT_VIGILANCE',
  DocumentationPurchase = 'DOCUMENTATION_PURCHASE',
  EventSpeakerContract = 'EVENT_SPEAKER_CONTRACT',
  ExpertiseConsultingContractOtherThanScientific = 'EXPERTISE_CONSULTING_CONTRACT_OTHER_THAN_SCIENTIFIC',
  InquiryMarketStudyExcludingResearch = 'INQUIRY_MARKET_STUDY_EXCLUDING_RESEARCH',
  InterviewContract = 'INTERVIEW_CONTRACT',
  NotApplicable = 'NOT_APPLICABLE',
  Other = 'OTHER',
  ParticipationContractInAnEvent = 'PARTICIPATION_CONTRACT_IN_AN_EVENT',
  Partnership = 'PARTNERSHIP',
  Patronage = 'PATRONAGE',
  PublishingContract = 'PUBLISHING_CONTRACT',
  ResearchGrantContract = 'RESEARCH_GRANT_CONTRACT',
  RightsTransferLicense = 'RIGHTS_TRANSFER_LICENSE',
  ScientificEvaluationContract = 'SCIENTIFIC_EVALUATION_CONTRACT',
  ScientificExpertContract = 'SCIENTIFIC_EXPERT_CONTRACT',
  ScientificManifestationSpacePurchaseLease = 'SCIENTIFIC_MANIFESTATION_SPACE_PURCHASE_LEASE',
  ScientificResearchContract = 'SCIENTIFIC_RESEARCH_CONTRACT',
  Sponsorship = 'SPONSORSHIP',
  TrainingContract = 'TRAINING_CONTRACT'
}

export enum OperationTypologyIdahe {
  AwardContract = 'AWARD_CONTRACT',
  CongressRegistrationContract = 'CONGRESS_REGISTRATION_CONTRACT',
  ConsultingNonScientificContract = 'CONSULTING_NON_SCIENTIFIC_CONTRACT',
  EventSpeakerContract = 'EVENT_SPEAKER_CONTRACT',
  ExpertScientificContract = 'EXPERT_SCIENTIFIC_CONTRACT',
  GrantAwardContract = 'GRANT_AWARD_CONTRACT',
  MarketStudy = 'MARKET_STUDY',
  Partnership = 'PARTNERSHIP',
  Patronage = 'PATRONAGE',
  PurchaseRentalAdvertisingSpaceContract = 'PURCHASE_RENTAL_ADVERTISING_SPACE_CONTRACT',
  PurchaseRentalScientificEventSpaceContract = 'PURCHASE_RENTAL_SCIENTIFIC_EVENT_SPACE_CONTRACT',
  ResearchContract = 'RESEARCH_CONTRACT',
  ScientificEvaluationContract = 'SCIENTIFIC_EVALUATION_CONTRACT',
  Sponsorship = 'SPONSORSHIP',
  Training = 'TRAINING'
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type OriginalTicketInfo = {
  __typename?: 'OriginalTicketInfo';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OtherAttendeesDepositResponse = {
  __typename?: 'OtherAttendeesDepositResponse';
  authorizationExist: Scalars['Boolean']['output'];
  declarationExist: Scalars['Boolean']['output'];
};

export type OtherDepositCategoriesAvailableResponse = {
  __typename?: 'OtherDepositCategoriesAvailableResponse';
  authorization: Array<OtherDepositCategoryEnum>;
  declaration: Array<OtherDepositCategoryEnum>;
};

export enum OtherDepositCategoryEnum {
  MilitaryService = 'MILITARY_SERVICE',
  MonacoMedicalCouncil = 'MONACO_MEDICAL_COUNCIL',
  MonacoPharmacyCouncil = 'MONACO_PHARMACY_COUNCIL'
}

export type PackagesDepositsResponse = {
  __typename?: 'PackagesDepositsResponse';
  authorization: Array<PlannedPackage>;
  declaration: Array<PlannedPackage>;
};

export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  count: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  firstItem?: Maybe<Scalars['Int']['output']>;
  hasMorePages: Scalars['Boolean']['output'];
  lastItem?: Maybe<Scalars['Int']['output']>;
  lastPage: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatorInfoTotal = {
  __typename?: 'PaginatorInfoTotal';
  total: Scalars['Int']['output'];
};

export enum PharmacistType {
  PharmacistsAssistantAndOthers = 'PHARMACISTS_ASSISTANT_AND_OTHERS',
  PharmacistsCommunity = 'PHARMACISTS_COMMUNITY',
  PharmacistsHealthcareInstitutions = 'PHARMACISTS_HEALTHCARE_INSTITUTIONS',
  PharmacistsIndustry = 'PHARMACISTS_INDUSTRY',
  PharmacistsLiberalAndHospitalBiologist = 'PHARMACISTS_LIBERAL_AND_HOSPITAL_BIOLOGIST',
  PharmacistsOverseasDepartmentsAndTerritories = 'PHARMACISTS_OVERSEAS_DEPARTMENTS_AND_TERRITORIES',
  PharmacistsWholesaler = 'PHARMACISTS_WHOLESALER'
}

export type PharmacistTypesDepositResponse = {
  __typename?: 'PharmacistTypesDepositResponse';
  authorization?: Maybe<Array<Maybe<PharmacistType>>>;
  declaration?: Maybe<Array<Maybe<PharmacistType>>>;
};

export type PlannedAdvantage = {
  __typename?: 'PlannedAdvantage';
  advantage_type: AdvantageType;
  area?: Maybe<Scalars['String']['output']>;
  attendee_id?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  excluding_tax_amount?: Maybe<Scalars['Float']['output']>;
  gross_amount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  including_tax_amount?: Maybe<Scalars['Float']['output']>;
  net_amount: Scalars['Float']['output'];
  plannedPackage?: Maybe<PlannedPackage>;
  quantity: Scalars['Float']['output'];
};

export type PlannedPackage = {
  __typename?: 'PlannedPackage';
  advantages: Array<PlannedAdvantage>;
  area?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_distribution?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  netTotalAdvantages?: Maybe<Scalars['Float']['output']>;
  ticket?: Maybe<Ticket>;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

export type PlannedPackageApiPaginator = {
  __typename?: 'PlannedPackageApiPaginator';
  data: Array<PlannedPackage>;
  paginatorInfo: PaginatorInfo;
};

/** A paginated list of PlannedPackage items. */
export type PlannedPackagePaginator = {
  __typename?: 'PlannedPackagePaginator';
  /** A list of PlannedPackage items. */
  data: Array<PlannedPackage>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProcessExpensesImportProgress = {
  __typename?: 'ProcessExpensesImportProgress';
  expensesImportTemplate?: Maybe<ExpensesImportTemplate>;
  message: Scalars['String']['output'];
  status: BroadCastsStatusEnum;
};

export type Product = RestrictedArea & {
  __typename?: 'Product';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Product items. */
export type ProductPaginator = {
  __typename?: 'ProductPaginator';
  /** A list of Product items. */
  data: Array<Product>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum PublicationStatus {
  Real = 'REAL',
  Test = 'TEST'
}

export type Query = {
  __typename?: 'Query';
  UserRolesListAll: Array<UserRole>;
  UsersValidatorList: ValidatorsList;
  actualAdvantage?: Maybe<ActualAdvantage>;
  actualAdvantageByAttendeeId: ActualAdvantage;
  actualAdvantages: Array<ActualAdvantage>;
  actualPackage?: Maybe<ActualPackage>;
  actualPackages: ActualPackagePaginator;
  actualPackagesByTicket: Array<ActualPackage>;
  additionalCost?: Maybe<AdditionalCost>;
  additionalCostsByTicket: Array<AdditionalCost>;
  address?: Maybe<Address>;
  advantagesAmountsByTicketCode: AdvantageDynamicAmounts;
  agencyExport?: Maybe<AgencyExport>;
  aggregatedAdvantageTypeTotalByTicket: AggregatedAdvantageTypeTotalPaginator;
  aggregatedAdvantageTypeTotalByTicketThenByAttendee: AggregatedAdvantageTypeTotalByAttendeePaginator;
  allActualPackages?: Maybe<Array<ActualPackage>>;
  allAttachmentsWhereTicketNull?: Maybe<Array<Maybe<Attachment>>>;
  allInternalSigners: AllInternalSigners;
  allPlannedPackages?: Maybe<Array<PlannedPackage>>;
  ansAttendees: Array<Maybe<ApiAttendee>>;
  apiActualPackageByTicketAndId?: Maybe<ActualPackage>;
  apiAttendeesByTicket: AttendeePaginator;
  apiAttendeesPlannedPackagesByTicket: AttendeePaginator;
  apiCrmUserFindOne?: Maybe<CrmUser>;
  apiCrmUsersListAll: CrmUserPaginator;
  apiFilteredPlannedPackagesByTicket: Array<PlannedPackage>;
  apiIdentities: IdentityPaginator;
  apiOperation?: Maybe<ApiOperation>;
  apiOperations: ApiOperationPaginator;
  apiPlannedPackage?: Maybe<PlannedPackage>;
  apiPlannedPackageByTicketAndId?: Maybe<PlannedPackage>;
  apiSearchPlannedPackages: PlannedPackageApiPaginator;
  apiTicketsManagement: TicketPaginator;
  apiUserFindOne?: Maybe<User>;
  apiUsersListAll: UserPaginator;
  assignedPlannedPackagesByTicket?: Maybe<Array<PlannedPackage>>;
  attachmentsWhereTicketNullPaginate: AttachmentPaginator;
  attendee: Attendee;
  attendeeAdvantageTypeTotal: AttendeeAdvantageTypeTotalPaginator;
  attendeeByOtherCategoryAndTicket: AttendeePaginator;
  attendeeIdByTicket?: Maybe<Attendee>;
  attendeePlannedPackages: Array<PlannedPackage>;
  attendees: Array<Attendee>;
  attendeesByTicket: AttendeePaginator;
  attendeesByTicketWithSignatures: Array<Attendee>;
  attendeesByTicketWithSignaturesPagination: AttendeePaginator;
  attendeesDepositsByHealthTypeAndTicket: AttendeePaginator;
  attendeesForContractManagement: AttendeePaginator;
  attendeesTotalByTicket: AttendeePaginator;
  availableConventions: Array<ConventionType>;
  availableWorkflows: AvailableSteps;
  checkBatches: Array<CheckBatches>;
  checkContractZipFileBatch: CheckContractZipFileBatch;
  checkExpensesImportBatch: CheckExpensesImportBatch;
  comment?: Maybe<Comment>;
  comments: Array<Comment>;
  commentsByTicketCode: CommentPaginator;
  contact?: Maybe<Contact>;
  contacts: ContactPaginator;
  contractAndSignersByTicketCode: Array<ContractAndSigners>;
  contractAttendee?: Maybe<ContractAttendee>;
  contractAttendees: Array<ContractAttendee>;
  contractAttendeesForReminder: ContractAttendeeForReminders;
  contractDepositInformation: ContractDepositInformation;
  contractTemplate: ContractTemplate;
  contractTemplatesAllByTicket?: Maybe<Array<Maybe<ContractTemplate>>>;
  contractTemplatesAllWhereTicketNull: ContractTemplatePaginator;
  contractTemplatesByTicket?: Maybe<Array<Maybe<ContractTemplate>>>;
  convention?: Maybe<Convention>;
  conventions: Array<Convention>;
  conventionsPaginator: ConventionPaginator;
  crmUser?: Maybe<CrmUser>;
  crmUsers: Array<CrmUser>;
  crmUsersPaginator: CrmUserPaginator;
  declaration?: Maybe<Declaration>;
  declarationByCode: Declaration;
  declarationDocument: DeclarationDocument;
  declarationDocumentsById: DeclarationDocumentPaginator;
  declarationExport: DeclarationExport;
  declarationExportsPaginator: DeclarationExportPaginator;
  declarationTheme: DeclarationThemes;
  declarationThemesById: DeclarationThemesPaginator;
  declarations: DeclarationPaginator;
  declarationsForLinks: Array<Declaration>;
  deposit: Deposit;
  depositById: Deposit;
  depositNotValidated: DepositNotValidatedAndUnsignedContractResponse;
  depositZipFile?: Maybe<DepositZipFile>;
  deposits: DepositPaginator;
  depositsByTicket?: Maybe<Array<Maybe<Deposit>>>;
  diagnosticExport: DiagnosticExport;
  diagnosticExportsPaginator: DiagnosticExportPaginator;
  doctorsDepositsByTicket: AttendeePaginator;
  documentAttendee: DocumentAttendee;
  documentAttendeeByTicket?: Maybe<Array<Maybe<DocumentAttendee>>>;
  documentAttendeesByAttendee: Array<DocumentAttendee>;
  expenseReport: ExpenseReport;
  expenseReportsByTicket: Array<ExpenseReport>;
  expensesImport: ExpensesImportPaginator;
  expensesImportTemplate?: Maybe<ExpensesImportTemplate>;
  filterAllRestrictedAreasOptions?: Maybe<RestrictedAreasResult>;
  filterContractorOptions: Array<Attendee>;
  filterCrmManagerOptions: Array<CrmUser>;
  filterDepositOptions?: Maybe<Array<DepositFilterOption>>;
  filterRestrictedAreaOptions: Array<RestrictedArea>;
  filterTicket: Array<Ticket>;
  filterTicketCodeOptions: Array<Ticket>;
  filterTicketExternalCodeOptions: Array<Ticket>;
  filterTicketsOptions: Array<Ticket>;
  filteredActualPackagesByTicket: Array<ActualPackage>;
  filteredPlannedPackagesById: Array<PlannedPackage>;
  filteredPlannedPackagesByTicket: Array<PlannedPackage>;
  getAllAllocations?: Maybe<Allocations>;
  getAllContractTemplatesWhereTicketNull?: Maybe<Array<Maybe<ContractTemplate>>>;
  getAllSpecialties: Array<Specialty>;
  getClientRoleFromUser: Array<UserRole>;
  getDynamicUsersByRoleList: UsersByRoleList;
  getEnabledAllocations?: Maybe<Allocations>;
  getUserCreatorByTicketCode: Array<User>;
  getUserInviterByTicketCode: Array<User>;
  getValidatorsFromUser?: Maybe<UserValidators>;
  hasValidEmails: Scalars['Boolean']['output'];
  healthTypesDepositByTicket?: Maybe<HealthDepositResponses>;
  historiesByTicket: HistoryPaginator;
  identity?: Maybe<Identity>;
  identityById?: Maybe<Identity>;
  identityLogo?: Maybe<Document>;
  identityPaginator: IdentityPaginator;
  internalSigner?: Maybe<InternalSigner>;
  internalSigners: Array<InternalSigner>;
  internalSignersPaginator: InternalSignerPaginator;
  me?: Maybe<User>;
  myTicketPermissions: Array<AuthTicketPermissions>;
  network?: Maybe<Network>;
  networks: NetworkPaginator;
  nonCompliance: NonCompliance;
  nonCompliancesByTicket?: Maybe<Array<Maybe<NonCompliance>>>;
  notification?: Maybe<Notification>;
  notifications: NotificationPaginator;
  oneKeysAttendees: ApiAttendeePaginator;
  operation?: Maybe<Operation>;
  operations: OperationPaginator;
  operationsByEventTypes: Array<Operation>;
  otherDepositCategoriesAvailableByTicket?: Maybe<OtherDepositCategoriesAvailableResponse>;
  packageDepositsByTicket: PackagesDepositsResponse;
  plannedAdvantage?: Maybe<PlannedAdvantage>;
  plannedAdvantageByAttendeeId: PlannedAdvantage;
  plannedAdvantages: Array<PlannedAdvantage>;
  plannedPackage?: Maybe<PlannedPackage>;
  plannedPackages: PlannedPackagePaginator;
  plannedPackagesByTicket: Array<PlannedPackage>;
  product?: Maybe<Product>;
  products: ProductPaginator;
  region?: Maybe<Region>;
  regions: RegionPaginator;
  sector?: Maybe<Sector>;
  sectors: SectorPaginator;
  settingByType?: Maybe<Settings>;
  settingsByType: Array<Settings>;
  signatureByAttendee?: Maybe<AttendeeSignature>;
  signaturesByTicket?: Maybe<AttendeeSignature>;
  signedOmniUrl?: Maybe<AnalyticsUrl>;
  signingSheet: SigningSheet;
  signingSheetsByTicket?: Maybe<Array<Maybe<SigningSheet>>>;
  specialties: SpecialtyPaginator;
  specialty?: Maybe<Specialty>;
  submission: Submission;
  therapeuticArea?: Maybe<TherapeuticArea>;
  therapeuticAreas: TherapeuticAreaPaginator;
  ticket: Ticket;
  ticketAttendeeImports: TicketAttendeeImportPaginator;
  ticketByCode: Ticket;
  tickets: Array<Ticket>;
  ticketsByDeclarationCode: TicketPaginator;
  ticketsDashboard: Array<Ticket>;
  ticketsForLinks?: Maybe<TicketsForLinks>;
  ticketsGroupedByStepOrStatus: TicketsGroupedByStepOrStatusPaginator;
  ticketsLibrary: Array<Ticket>;
  ticketsManagement: TicketPaginator;
  ticketsPaginator: TicketPaginator;
  totalContacts: Scalars['Int']['output'];
  transparencyExportPaginator?: Maybe<TransparencyExportPaginator>;
  uga?: Maybe<Uga>;
  ugas: UgaPaginator;
  unit?: Maybe<Unit>;
  units: UnitPaginator;
  userAvatar?: Maybe<Document>;
  userFindOne: UserKeycloak;
  usersForTags: Array<User>;
  usersListAll: UsersListAllPaginator;
  veevaAttendees: ApiAttendeePaginator;
  watchdogMessages?: Maybe<Array<WatchdogMessage>>;
  workflow?: Maybe<Workflow>;
  workflows: Array<Workflow>;
  workflowsByEventType: Array<Workflow>;
  workflowsPaginator: WorkflowPaginator;
  zipFile?: Maybe<Attachment>;
  zone?: Maybe<Zone>;
  zones: ZonePaginator;
};


export type QueryActualAdvantageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryActualAdvantageByAttendeeIdArgs = {
  attendee_id: Scalars['String']['input'];
};


export type QueryActualAdvantagesArgs = {
  orderBy?: InputMaybe<Array<QueryActualAdvantagesOrderByOrderByClause>>;
};


export type QueryActualPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActualPackagesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryActualPackagesByTicketArgs = {
  source?: InputMaybe<SourceEnum>;
  ticketCode: Scalars['String']['input'];
};


export type QueryAdditionalCostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdditionalCostsByTicketArgs = {
  code: Scalars['String']['input'];
};


export type QueryAddressArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdvantagesAmountsByTicketCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryAgencyExportArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type QueryAggregatedAdvantageTypeTotalByTicketArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  ticket_code: Scalars['String']['input'];
};


export type QueryAggregatedAdvantageTypeTotalByTicketThenByAttendeeArgs = {
  attendee_name?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AggregatedAdvantageTypeTotalOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  ticket_code: Scalars['String']['input'];
};


export type QueryAllActualPackagesArgs = {
  ticket_code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllInternalSignersArgs = {
  orderBy?: InputMaybe<Array<QueryAllInternalSignersOrderByOrderByClause>>;
};


export type QueryAllPlannedPackagesArgs = {
  ticket_code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnsAttendeesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApiActualPackageByTicketAndIdArgs = {
  actualPackageId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


export type QueryApiAttendeesByTicketArgs = {
  category?: InputMaybe<AttendeeCategory>;
  created_after?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  created_before?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']>>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>>>;
  type?: InputMaybe<AttendeeType>;
  updated_date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']>>;
};


export type QueryApiAttendeesPlannedPackagesByTicketArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  ticketID: Scalars['ID']['input'];
};


export type QueryApiCrmUserFindOneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiCrmUsersListAllArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  responsibilities?: InputMaybe<Array<CrmResponsibility>>;
  staff_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApiFilteredPlannedPackagesByTicketArgs = {
  is_distribution?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ticketID: Scalars['ID']['input'];
};


export type QueryApiIdentitiesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApiOperationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiOperationsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Array<InputMaybe<EventType>>>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApiPlannedPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiPlannedPackageByTicketAndIdArgs = {
  plannedPackageId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


export type QueryApiSearchPlannedPackagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  is_distribution?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApiTicketsManagementArgs = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']>>;
  event_type?: InputMaybe<Array<EventType>>;
  external_code?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']>>;
  workflow_step?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryApiUserFindOneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiUsersListAllArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  staff_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssignedPlannedPackagesByTicketArgs = {
  ticket_code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttachmentsWhereTicketNullPaginateArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAttendeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAttendeeAdvantageTypeTotalArgs = {
  advantage_type?: InputMaybe<AdvantageType>;
  attendee_id?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  ticket_code: Scalars['String']['input'];
};


export type QueryAttendeeByOtherCategoryAndTicketArgs = {
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<QueryAttendeeByOtherCategoryAndTicketOrderByRelationOrderByClause>>;
  other_deposit_category: OtherDepositCategoryEnum;
  page?: InputMaybe<Scalars['Int']['input']>;
  regime: AttendeeDepositRegime;
  ticket_id: Scalars['ID']['input'];
};


export type QueryAttendeeIdByTicketArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAttendeePlannedPackagesArgs = {
  attendeeId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


export type QueryAttendeesArgs = {
  orderBy?: InputMaybe<Array<QueryAttendeesOrderByOrderByClause>>;
};


export type QueryAttendeesByTicketArgs = {
  added_by?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<AttendeeCategory>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  health_type?: InputMaybe<AttendeeHealthType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<QueryAttendeesByTicketOrderByRelationOrderByClause>>;
  pack?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>>>;
  submission_regime?: InputMaybe<AttendeeSubmissionRegime>;
  type?: InputMaybe<AttendeeType>;
};


export type QueryAttendeesByTicketWithSignaturesArgs = {
  code: Scalars['String']['input'];
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>>>;
};


export type QueryAttendeesByTicketWithSignaturesPaginationArgs = {
  code: Scalars['String']['input'];
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<QueryAttendeesByTicketWithSignaturesPaginationOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>>>;
};


export type QueryAttendeesDepositsByHealthTypeAndTicketArgs = {
  first?: Scalars['Int']['input'];
  health_type?: InputMaybe<AttendeeHealthType>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<QueryAttendeesDepositsByHealthTypeAndTicketOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pharmacist_type?: InputMaybe<PharmacistType>;
  regime: AttendeeDepositRegime;
  regional_health_agency?: InputMaybe<Scalars['Boolean']['input']>;
  ticket_id: Scalars['ID']['input'];
};


export type QueryAttendeesForContractManagementArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ContractAttendeeManagementOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>>>;
  ticket_code: Scalars['String']['input'];
};


export type QueryAttendeesTotalByTicketArgs = {
  added_by?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<AttendeeCategory>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  health_type?: InputMaybe<AttendeeHealthType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<QueryAttendeesTotalByTicketOrderByRelationOrderByClause>>;
  pack?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>>>;
  submission_regime?: InputMaybe<AttendeeSubmissionRegime>;
  type?: InputMaybe<AttendeeType>;
};


export type QueryCheckBatchesArgs = {
  input: Array<InputMaybe<CheckBatchesInput>>;
};


export type QueryCheckContractZipFileBatchArgs = {
  input: ContractZipFileBatchInput;
};


export type QueryCheckExpensesImportBatchArgs = {
  input: ExpensesImportBatchInput;
};


export type QueryCommentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCommentsArgs = {
  orderBy?: InputMaybe<Array<QueryCommentsOrderByOrderByClause>>;
};


export type QueryCommentsByTicketCodeArgs = {
  code: Scalars['String']['input'];
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContactsArgs = {
  category?: InputMaybe<AttendeeCategory>;
  company?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  health_type?: InputMaybe<AttendeeHealthType>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<AttendeeOrganizationType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AttendeeType>;
};


export type QueryContractAndSignersByTicketCodeArgs = {
  attendeeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code: Scalars['String']['input'];
};


export type QueryContractAttendeeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContractAttendeesArgs = {
  orderBy?: InputMaybe<Array<QueryContractAttendeesOrderByOrderByClause>>;
};


export type QueryContractAttendeesForReminderArgs = {
  code: Scalars['String']['input'];
};


export type QueryContractDepositInformationArgs = {
  contract_attendee_id: Scalars['ID']['input'];
};


export type QueryContractTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractTemplatesAllByTicketArgs = {
  ticket_code: Scalars['String']['input'];
};


export type QueryContractTemplatesAllWhereTicketNullArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ContractTemplateOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  ticket_code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractTemplatesByTicketArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type QueryConventionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryConventionsArgs = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConventionsPaginatorArgs = {
  first?: Scalars['Int']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ConventionType>;
};


export type QueryCrmUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCrmUsersArgs = {
  orderBy?: InputMaybe<Array<QueryCrmUsersOrderByOrderByClause>>;
  responsibilities?: InputMaybe<Array<CrmResponsibility>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmUsersPaginatorArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryCrmUsersPaginatorOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  responsibilities?: InputMaybe<Array<CrmResponsibility>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeclarationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeclarationByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryDeclarationDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeclarationDocumentsByIdArgs = {
  declaration_id: Scalars['ID']['input'];
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDeclarationExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeclarationExportsPaginatorArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDeclarationThemeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeclarationThemesByIdArgs = {
  declaration_id: Scalars['ID']['input'];
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDeclarationsArgs = {
  badge?: InputMaybe<DeclarationBadge>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_after?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  created_before?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<DeclarationStatus>>;
  workflow_step?: InputMaybe<Array<DeclarationWorkflowStep>>;
};


export type QueryDeclarationsForLinksArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDepositArgs = {
  deposit_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDepositByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDepositNotValidatedArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type QueryDepositZipFileArgs = {
  json_filter?: InputMaybe<Scalars['String']['input']>;
  planned_package_id?: InputMaybe<Scalars['ID']['input']>;
  regime?: InputMaybe<Scalars['String']['input']>;
  ticket_id: Scalars['ID']['input'];
};


export type QueryDepositsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  submission_reference?: InputMaybe<Scalars['String']['input']>;
  ticket_code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket_end_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  ticket_event_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket_initiator_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticket_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket_operation_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket_start_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  ticket_submission_regime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket_workflow_step_or_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDepositsByTicketArgs = {
  status?: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  ticket_id: Scalars['ID']['input'];
};


export type QueryDiagnosticExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiagnosticExportsPaginatorArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDoctorsDepositsByTicketArgs = {
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<QueryDoctorsDepositsByTicketOrderByRelationOrderByClause>>;
  package_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  regime: AttendeeDepositRegime;
  ticket_id: Scalars['ID']['input'];
};


export type QueryDocumentAttendeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentAttendeeByTicketArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type QueryDocumentAttendeesByAttendeeArgs = {
  attendee_id: Scalars['ID']['input'];
  ticket_id: Scalars['ID']['input'];
};


export type QueryExpenseReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpenseReportsByTicketArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type QueryExpensesImportArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  ticket_code: Scalars['String']['input'];
};


export type QueryExpensesImportTemplateArgs = {
  ticket_code: Scalars['String']['input'];
};


export type QueryFilterContractorOptionsArgs = {
  filter_type: FilterAvailable;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilterCrmManagerOptionsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilterDepositOptionsArgs = {
  ticket_code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticket_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFilterRestrictedAreaOptionsArgs = {
  area: RestrictedAreas;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilterTicketArgs = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  created_by_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  crm_manager?: InputMaybe<Array<Scalars['ID']['input']>>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']>>;
  event_type?: InputMaybe<Array<EventType>>;
  filter_type: FilterAvailable;
  initiator_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  operation_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  validator_1_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  validator_2_id?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryFilterTicketCodeOptionsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  filter_type: FilterAvailable;
};


export type QueryFilterTicketExternalCodeOptionsArgs = {
  external_code?: InputMaybe<Scalars['String']['input']>;
  filter_type: FilterAvailable;
};


export type QueryFilterTicketsOptionsArgs = {
  filter_type: FilterAvailable;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilteredActualPackagesByTicketArgs = {
  is_distribution?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ticketID: Scalars['ID']['input'];
};


export type QueryFilteredPlannedPackagesByIdArgs = {
  plannedPackageId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


export type QueryFilteredPlannedPackagesByTicketArgs = {
  is_distribution?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ticketID: Scalars['ID']['input'];
};


export type QueryGetClientRoleFromUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDynamicUsersByRoleListArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<UserRoles>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserCreatorByTicketCodeArgs = {
  ticket_code: Scalars['String']['input'];
};


export type QueryGetUserInviterByTicketCodeArgs = {
  ticket_code: Scalars['String']['input'];
};


export type QueryGetValidatorsFromUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHasValidEmailsArgs = {
  ticket_code: Scalars['String']['input'];
};


export type QueryHealthTypesDepositByTicketArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type QueryHistoriesByTicketArgs = {
  code: Scalars['String']['input'];
  first?: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIdentityByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIdentityLogoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIdentityPaginatorArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInternalSignerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInternalSignersArgs = {
  orderBy?: InputMaybe<Array<QueryInternalSignersOrderByOrderByClause>>;
};


export type QueryInternalSignersPaginatorArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNetworkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNetworksArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNonComplianceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNonCompliancesByTicketArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOneKeysAttendeesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOperationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOperationsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOperationsByEventTypesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type: Array<EventType>;
};


export type QueryOtherDepositCategoriesAvailableByTicketArgs = {
  ticket_code: Scalars['String']['input'];
};


export type QueryPackageDepositsByTicketArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type QueryPlannedAdvantageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlannedAdvantageByAttendeeIdArgs = {
  attendee_id: Scalars['String']['input'];
};


export type QueryPlannedAdvantagesArgs = {
  orderBy?: InputMaybe<Array<QueryPlannedAdvantagesOrderByOrderByClause>>;
};


export type QueryPlannedPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlannedPackagesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlannedPackagesByTicketArgs = {
  ticketID: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRegionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRegionsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySectorArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySectorsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySettingByTypeArgs = {
  type: SettingsType;
};


export type QuerySettingsByTypeArgs = {
  type: Array<SettingsType>;
};


export type QuerySignatureByAttendeeArgs = {
  attendee_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySignaturesByTicketArgs = {
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySignedOmniUrlArgs = {
  dashboard?: InputMaybe<AnalyticsType>;
};


export type QuerySigningSheetArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySigningSheetsByTicketArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type QuerySpecialtiesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpecialtyArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubmissionArgs = {
  deposit_id?: InputMaybe<Scalars['ID']['input']>;
  submission_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTherapeuticAreaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTherapeuticAreasArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketAttendeeImportsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  ticket_code: Scalars['String']['input'];
};


export type QueryTicketByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryTicketsArgs = {
  status?: InputMaybe<Array<Status>>;
};


export type QueryTicketsByDeclarationCodeArgs = {
  declaration_code: Scalars['String']['input'];
  event_type?: InputMaybe<EventType>;
  first?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<TicketByDeclarationCodeOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  ticket_badge?: InputMaybe<TicketBadge>;
};


export type QueryTicketsDashboardArgs = {
  is_archived: Scalars['Boolean']['input'];
  is_declared: Scalars['Boolean']['input'];
  orderBy?: InputMaybe<Array<QueryTicketsDashboardOrderByOrderByClause>>;
};


export type QueryTicketsForLinksArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTicketsGroupedByStepOrStatusArgs = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  contractor?: InputMaybe<Array<Scalars['String']['input']>>;
  created_by_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  crm_manager?: InputMaybe<Array<Scalars['ID']['input']>>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']>>;
  event_type?: InputMaybe<Array<EventType>>;
  external_code?: InputMaybe<Array<Scalars['String']['input']>>;
  filter_type: FilterAvailable;
  identities?: InputMaybe<Array<Scalars['ID']['input']>>;
  initiator_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  networks?: InputMaybe<Array<Scalars['ID']['input']>>;
  operation_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: TicketsGroupedByStepOrStatusPaginationInput;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  regions?: InputMaybe<Array<Scalars['ID']['input']>>;
  sectors?: InputMaybe<Array<Scalars['ID']['input']>>;
  submission_regime?: InputMaybe<Array<TicketSubmissionRegime>>;
  therapeuticAreas?: InputMaybe<Array<Scalars['ID']['input']>>;
  units?: InputMaybe<Array<Scalars['ID']['input']>>;
  validator_1_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  validator_2_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  zones?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryTicketsLibraryArgs = {
  is_archived: Scalars['Boolean']['input'];
  is_declared: Scalars['Boolean']['input'];
  orderBy?: InputMaybe<Array<QueryTicketsLibraryOrderByOrderByClause>>;
  workflow_step?: InputMaybe<Array<Step>>;
};


export type QueryTicketsManagementArgs = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  contractor?: InputMaybe<Array<Scalars['String']['input']>>;
  created_by_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  crm_manager?: InputMaybe<Array<Scalars['ID']['input']>>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']>>;
  event_type?: InputMaybe<Array<EventType>>;
  external_code?: InputMaybe<Array<Scalars['String']['input']>>;
  filter_type: FilterAvailable;
  first?: Scalars['Int']['input'];
  identities?: InputMaybe<Array<Scalars['ID']['input']>>;
  initiator_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  networks?: InputMaybe<Array<Scalars['ID']['input']>>;
  operation_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<Array<TicketManagementOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  regions?: InputMaybe<Array<Scalars['ID']['input']>>;
  sectors?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<Status>>;
  statusFilterLibrary?: InputMaybe<Array<StatusFilterLibrary>>;
  submission_regime?: InputMaybe<Array<TicketSubmissionRegime>>;
  therapeuticAreas?: InputMaybe<Array<Scalars['ID']['input']>>;
  units?: InputMaybe<Array<Scalars['ID']['input']>>;
  validator_1_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  validator_2_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  workflow_step?: InputMaybe<Array<Step>>;
  zones?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryTicketsPaginatorArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTotalContactsArgs = {
  category?: InputMaybe<AttendeeCategory>;
  company?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  health_type?: InputMaybe<AttendeeHealthType>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<AttendeeOrganizationType>;
  type?: InputMaybe<AttendeeType>;
};


export type QueryTransparencyExportPaginatorArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransparencyExportOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUgaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUgasArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUnitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUnitsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAvatarArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserFindOneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersListAllArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVeevaAttendeesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWatchdogMessagesArgs = {
  code: Scalars['String']['input'];
};


export type QueryWorkflowArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkflowsArgs = {
  orderBy?: InputMaybe<Array<QueryWorkflowsOrderByOrderByClause>>;
};


export type QueryWorkflowsByEventTypeArgs = {
  eventType: EventType;
};


export type QueryWorkflowsPaginatorArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryZipFileArgs = {
  ticket_code: Scalars['String']['input'];
};


export type QueryZoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZonesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Allowed column names for Query.actualAdvantages.orderBy. */
export enum QueryActualAdvantagesOrderByColumn {
  AttendeeId = 'ATTENDEE_ID'
}

/** Order by clause for Query.actualAdvantages.orderBy. */
export type QueryActualAdvantagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryActualAdvantagesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.allInternalSigners.orderBy. */
export enum QueryAllInternalSignersOrderByColumn {
  Id = 'ID'
}

/** Order by clause for Query.allInternalSigners.orderBy. */
export type QueryAllInternalSignersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryAllInternalSignersOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate specification for Query.attendeeByOtherCategoryAndTicket.orderBy.address. */
export type QueryAttendeeByOtherCategoryAndTicketOrderByAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeeByOtherCategoryAndTicketOrderByAddressColumn>;
};

/** Allowed column names for Query.attendeeByOtherCategoryAndTicket.orderBy. */
export enum QueryAttendeeByOtherCategoryAndTicketOrderByAddressColumn {
  Postcode = 'POSTCODE'
}

/** Allowed column names for Query.attendeeByOtherCategoryAndTicket.orderBy. */
export enum QueryAttendeeByOtherCategoryAndTicketOrderByColumn {
  Firstname = 'FIRSTNAME',
  Lastname = 'LASTNAME',
  Regime = 'REGIME'
}

/** Aggregate specification for Query.attendeeByOtherCategoryAndTicket.orderBy.createdBy. */
export type QueryAttendeeByOtherCategoryAndTicketOrderByCreatedBy = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeeByOtherCategoryAndTicketOrderByCreatedByColumn>;
};

/** Allowed column names for Query.attendeeByOtherCategoryAndTicket.orderBy. */
export enum QueryAttendeeByOtherCategoryAndTicketOrderByCreatedByColumn {
  LastName = 'LAST_NAME'
}

/** Order by clause for Query.attendeeByOtherCategoryAndTicket.orderBy. */
export type QueryAttendeeByOtherCategoryAndTicketOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  address?: InputMaybe<QueryAttendeeByOtherCategoryAndTicketOrderByAddress>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryAttendeeByOtherCategoryAndTicketOrderByColumn>;
  /** Aggregate specification. */
  createdBy?: InputMaybe<QueryAttendeeByOtherCategoryAndTicketOrderByCreatedBy>;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate specification for Query.attendeesByTicket.orderBy.actualPackages. */
export type QueryAttendeesByTicketOrderByActualPackages = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesByTicketOrderByActualPackagesColumn>;
};

/** Allowed column names for Query.attendeesByTicket.orderBy. */
export enum QueryAttendeesByTicketOrderByActualPackagesColumn {
  Name = 'NAME'
}

/** Aggregate specification for Query.attendeesByTicket.orderBy.addedBy. */
export type QueryAttendeesByTicketOrderByAddedBy = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesByTicketOrderByAddedByColumn>;
};

/** Allowed column names for Query.attendeesByTicket.orderBy. */
export enum QueryAttendeesByTicketOrderByAddedByColumn {
  LastName = 'LAST_NAME'
}

/** Aggregate specification for Query.attendeesByTicket.orderBy.address. */
export type QueryAttendeesByTicketOrderByAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesByTicketOrderByAddressColumn>;
};

/** Allowed column names for Query.attendeesByTicket.orderBy. */
export enum QueryAttendeesByTicketOrderByAddressColumn {
  Postcode = 'POSTCODE'
}

/** Allowed column names for Query.attendeesByTicket.orderBy. */
export enum QueryAttendeesByTicketOrderByColumn {
  Category = 'CATEGORY',
  ContractualLink = 'CONTRACTUAL_LINK',
  Firstname = 'FIRSTNAME',
  IsBilled = 'IS_BILLED',
  IsPresent = 'IS_PRESENT',
  Lastname = 'LASTNAME',
  Regime = 'REGIME',
  State = 'STATE',
  Type = 'TYPE'
}

/** Aggregate specification for Query.attendeesByTicket.orderBy.contractTemplates. */
export type QueryAttendeesByTicketOrderByContractTemplates = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesByTicketOrderByContractTemplatesColumn>;
};

/** Allowed column names for Query.attendeesByTicket.orderBy. */
export enum QueryAttendeesByTicketOrderByContractTemplatesColumn {
  Name = 'NAME',
  SignatureRequestType = 'SIGNATURE_REQUEST_TYPE'
}

/** Aggregate specification for Query.attendeesByTicket.orderBy.contracts. */
export type QueryAttendeesByTicketOrderByContracts = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesByTicketOrderByContractsColumn>;
};

/** Allowed column names for Query.attendeesByTicket.orderBy. */
export enum QueryAttendeesByTicketOrderByContractsColumn {
  SignatureStatus = 'SIGNATURE_STATUS'
}

/** Aggregate specification for Query.attendeesByTicket.orderBy.plannedPackages. */
export type QueryAttendeesByTicketOrderByPlannedPackages = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesByTicketOrderByPlannedPackagesColumn>;
};

/** Allowed column names for Query.attendeesByTicket.orderBy. */
export enum QueryAttendeesByTicketOrderByPlannedPackagesColumn {
  Name = 'NAME'
}

/** Order by clause for Query.attendeesByTicket.orderBy. */
export type QueryAttendeesByTicketOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  actualPackages?: InputMaybe<QueryAttendeesByTicketOrderByActualPackages>;
  /** Aggregate specification. */
  addedBy?: InputMaybe<QueryAttendeesByTicketOrderByAddedBy>;
  /** Aggregate specification. */
  address?: InputMaybe<QueryAttendeesByTicketOrderByAddress>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryAttendeesByTicketOrderByColumn>;
  /** Aggregate specification. */
  contractTemplates?: InputMaybe<QueryAttendeesByTicketOrderByContractTemplates>;
  /** Aggregate specification. */
  contracts?: InputMaybe<QueryAttendeesByTicketOrderByContracts>;
  /** The direction that is used for ordering. */
  order: SortOrder;
  /** Aggregate specification. */
  plannedPackages?: InputMaybe<QueryAttendeesByTicketOrderByPlannedPackages>;
};

/** Aggregate specification for Query.attendeesByTicketWithSignaturesPagination.orderBy.addedBy. */
export type QueryAttendeesByTicketWithSignaturesPaginationOrderByAddedBy = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesByTicketWithSignaturesPaginationOrderByAddedByColumn>;
};

/** Allowed column names for Query.attendeesByTicketWithSignaturesPagination.orderBy. */
export enum QueryAttendeesByTicketWithSignaturesPaginationOrderByAddedByColumn {
  LastName = 'LAST_NAME'
}

/** Aggregate specification for Query.attendeesByTicketWithSignaturesPagination.orderBy.address. */
export type QueryAttendeesByTicketWithSignaturesPaginationOrderByAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesByTicketWithSignaturesPaginationOrderByAddressColumn>;
};

/** Allowed column names for Query.attendeesByTicketWithSignaturesPagination.orderBy. */
export enum QueryAttendeesByTicketWithSignaturesPaginationOrderByAddressColumn {
  Postcode = 'POSTCODE'
}

/** Allowed column names for Query.attendeesByTicketWithSignaturesPagination.orderBy. */
export enum QueryAttendeesByTicketWithSignaturesPaginationOrderByColumn {
  IsBilled = 'IS_BILLED',
  IsPresent = 'IS_PRESENT',
  IsSigned = 'IS_SIGNED',
  Lastname = 'LASTNAME',
  Regime = 'REGIME',
  State = 'STATE'
}

/** Order by clause for Query.attendeesByTicketWithSignaturesPagination.orderBy. */
export type QueryAttendeesByTicketWithSignaturesPaginationOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  addedBy?: InputMaybe<QueryAttendeesByTicketWithSignaturesPaginationOrderByAddedBy>;
  /** Aggregate specification. */
  address?: InputMaybe<QueryAttendeesByTicketWithSignaturesPaginationOrderByAddress>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryAttendeesByTicketWithSignaturesPaginationOrderByColumn>;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate specification for Query.attendeesDepositsByHealthTypeAndTicket.orderBy.address. */
export type QueryAttendeesDepositsByHealthTypeAndTicketOrderByAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesDepositsByHealthTypeAndTicketOrderByAddressColumn>;
};

/** Allowed column names for Query.attendeesDepositsByHealthTypeAndTicket.orderBy. */
export enum QueryAttendeesDepositsByHealthTypeAndTicketOrderByAddressColumn {
  Postcode = 'POSTCODE'
}

/** Allowed column names for Query.attendeesDepositsByHealthTypeAndTicket.orderBy. */
export enum QueryAttendeesDepositsByHealthTypeAndTicketOrderByColumn {
  Firstname = 'FIRSTNAME',
  Lastname = 'LASTNAME',
  Regime = 'REGIME'
}

/** Aggregate specification for Query.attendeesDepositsByHealthTypeAndTicket.orderBy.createdBy. */
export type QueryAttendeesDepositsByHealthTypeAndTicketOrderByCreatedBy = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesDepositsByHealthTypeAndTicketOrderByCreatedByColumn>;
};

/** Allowed column names for Query.attendeesDepositsByHealthTypeAndTicket.orderBy. */
export enum QueryAttendeesDepositsByHealthTypeAndTicketOrderByCreatedByColumn {
  LastName = 'LAST_NAME'
}

/** Order by clause for Query.attendeesDepositsByHealthTypeAndTicket.orderBy. */
export type QueryAttendeesDepositsByHealthTypeAndTicketOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  address?: InputMaybe<QueryAttendeesDepositsByHealthTypeAndTicketOrderByAddress>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryAttendeesDepositsByHealthTypeAndTicketOrderByColumn>;
  /** Aggregate specification. */
  createdBy?: InputMaybe<QueryAttendeesDepositsByHealthTypeAndTicketOrderByCreatedBy>;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.attendees.orderBy. */
export enum QueryAttendeesOrderByColumn {
  Name = 'NAME'
}

/** Order by clause for Query.attendees.orderBy. */
export type QueryAttendeesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryAttendeesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate specification for Query.attendeesTotalByTicket.orderBy.actualPackages. */
export type QueryAttendeesTotalByTicketOrderByActualPackages = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesTotalByTicketOrderByActualPackagesColumn>;
};

/** Allowed column names for Query.attendeesTotalByTicket.orderBy. */
export enum QueryAttendeesTotalByTicketOrderByActualPackagesColumn {
  Name = 'NAME'
}

/** Aggregate specification for Query.attendeesTotalByTicket.orderBy.addedBy. */
export type QueryAttendeesTotalByTicketOrderByAddedBy = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesTotalByTicketOrderByAddedByColumn>;
};

/** Allowed column names for Query.attendeesTotalByTicket.orderBy. */
export enum QueryAttendeesTotalByTicketOrderByAddedByColumn {
  LastName = 'LAST_NAME'
}

/** Aggregate specification for Query.attendeesTotalByTicket.orderBy.address. */
export type QueryAttendeesTotalByTicketOrderByAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesTotalByTicketOrderByAddressColumn>;
};

/** Allowed column names for Query.attendeesTotalByTicket.orderBy. */
export enum QueryAttendeesTotalByTicketOrderByAddressColumn {
  Postcode = 'POSTCODE'
}

/** Allowed column names for Query.attendeesTotalByTicket.orderBy. */
export enum QueryAttendeesTotalByTicketOrderByColumn {
  Category = 'CATEGORY',
  ContractualLink = 'CONTRACTUAL_LINK',
  Firstname = 'FIRSTNAME',
  IsBilled = 'IS_BILLED',
  IsPresent = 'IS_PRESENT',
  Lastname = 'LASTNAME',
  Regime = 'REGIME',
  State = 'STATE',
  Type = 'TYPE'
}

/** Aggregate specification for Query.attendeesTotalByTicket.orderBy.contractTemplates. */
export type QueryAttendeesTotalByTicketOrderByContractTemplates = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesTotalByTicketOrderByContractTemplatesColumn>;
};

/** Allowed column names for Query.attendeesTotalByTicket.orderBy. */
export enum QueryAttendeesTotalByTicketOrderByContractTemplatesColumn {
  Name = 'NAME',
  SignatureRequestType = 'SIGNATURE_REQUEST_TYPE'
}

/** Aggregate specification for Query.attendeesTotalByTicket.orderBy.contracts. */
export type QueryAttendeesTotalByTicketOrderByContracts = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesTotalByTicketOrderByContractsColumn>;
};

/** Allowed column names for Query.attendeesTotalByTicket.orderBy. */
export enum QueryAttendeesTotalByTicketOrderByContractsColumn {
  SignatureStatus = 'SIGNATURE_STATUS'
}

/** Aggregate specification for Query.attendeesTotalByTicket.orderBy.plannedPackages. */
export type QueryAttendeesTotalByTicketOrderByPlannedPackages = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryAttendeesTotalByTicketOrderByPlannedPackagesColumn>;
};

/** Allowed column names for Query.attendeesTotalByTicket.orderBy. */
export enum QueryAttendeesTotalByTicketOrderByPlannedPackagesColumn {
  Name = 'NAME'
}

/** Order by clause for Query.attendeesTotalByTicket.orderBy. */
export type QueryAttendeesTotalByTicketOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  actualPackages?: InputMaybe<QueryAttendeesTotalByTicketOrderByActualPackages>;
  /** Aggregate specification. */
  addedBy?: InputMaybe<QueryAttendeesTotalByTicketOrderByAddedBy>;
  /** Aggregate specification. */
  address?: InputMaybe<QueryAttendeesTotalByTicketOrderByAddress>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryAttendeesTotalByTicketOrderByColumn>;
  /** Aggregate specification. */
  contractTemplates?: InputMaybe<QueryAttendeesTotalByTicketOrderByContractTemplates>;
  /** Aggregate specification. */
  contracts?: InputMaybe<QueryAttendeesTotalByTicketOrderByContracts>;
  /** The direction that is used for ordering. */
  order: SortOrder;
  /** Aggregate specification. */
  plannedPackages?: InputMaybe<QueryAttendeesTotalByTicketOrderByPlannedPackages>;
};

/** Allowed column names for Query.comments.orderBy. */
export enum QueryCommentsOrderByColumn {
  Name = 'NAME'
}

/** Order by clause for Query.comments.orderBy. */
export type QueryCommentsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryCommentsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.contractAttendees.orderBy. */
export enum QueryContractAttendeesOrderByColumn {
  Name = 'NAME'
}

/** Order by clause for Query.contractAttendees.orderBy. */
export type QueryContractAttendeesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryContractAttendeesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.crmUsers.orderBy. */
export enum QueryCrmUsersOrderByColumn {
  Lastname = 'LASTNAME'
}

/** Order by clause for Query.crmUsers.orderBy. */
export type QueryCrmUsersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryCrmUsersOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.crmUsersPaginator.orderBy. */
export enum QueryCrmUsersPaginatorOrderByColumn {
  Lastname = 'LASTNAME'
}

/** Order by clause for Query.crmUsersPaginator.orderBy. */
export type QueryCrmUsersPaginatorOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryCrmUsersPaginatorOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate specification for Query.doctorsDepositsByTicket.orderBy.address. */
export type QueryDoctorsDepositsByTicketOrderByAddress = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryDoctorsDepositsByTicketOrderByAddressColumn>;
};

/** Allowed column names for Query.doctorsDepositsByTicket.orderBy. */
export enum QueryDoctorsDepositsByTicketOrderByAddressColumn {
  Postcode = 'POSTCODE'
}

/** Allowed column names for Query.doctorsDepositsByTicket.orderBy. */
export enum QueryDoctorsDepositsByTicketOrderByColumn {
  Firstname = 'FIRSTNAME',
  Lastname = 'LASTNAME',
  Regime = 'REGIME'
}

/** Aggregate specification for Query.doctorsDepositsByTicket.orderBy.createdBy. */
export type QueryDoctorsDepositsByTicketOrderByCreatedBy = {
  /** The aggregate function to apply to the column. */
  aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  column?: InputMaybe<QueryDoctorsDepositsByTicketOrderByCreatedByColumn>;
};

/** Allowed column names for Query.doctorsDepositsByTicket.orderBy. */
export enum QueryDoctorsDepositsByTicketOrderByCreatedByColumn {
  LastName = 'LAST_NAME'
}

/** Order by clause for Query.doctorsDepositsByTicket.orderBy. */
export type QueryDoctorsDepositsByTicketOrderByRelationOrderByClause = {
  /** Aggregate specification. */
  address?: InputMaybe<QueryDoctorsDepositsByTicketOrderByAddress>;
  /** The column that is used for ordering. */
  column?: InputMaybe<QueryDoctorsDepositsByTicketOrderByColumn>;
  /** Aggregate specification. */
  createdBy?: InputMaybe<QueryDoctorsDepositsByTicketOrderByCreatedBy>;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.internalSigners.orderBy. */
export enum QueryInternalSignersOrderByColumn {
  Id = 'ID'
}

/** Order by clause for Query.internalSigners.orderBy. */
export type QueryInternalSignersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryInternalSignersOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.plannedAdvantages.orderBy. */
export enum QueryPlannedAdvantagesOrderByColumn {
  AttendeeId = 'ATTENDEE_ID'
}

/** Order by clause for Query.plannedAdvantages.orderBy. */
export type QueryPlannedAdvantagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryPlannedAdvantagesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.ticketsDashboard.orderBy. */
export enum QueryTicketsDashboardOrderByColumn {
  StartAt = 'START_AT'
}

/** Order by clause for Query.ticketsDashboard.orderBy. */
export type QueryTicketsDashboardOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryTicketsDashboardOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.ticketsLibrary.orderBy. */
export enum QueryTicketsLibraryOrderByColumn {
  StartAt = 'START_AT'
}

/** Order by clause for Query.ticketsLibrary.orderBy. */
export type QueryTicketsLibraryOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryTicketsLibraryOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.workflows.orderBy. */
export enum QueryWorkflowsOrderByColumn {
  Name = 'NAME'
}

/** Order by clause for Query.workflows.orderBy. */
export type QueryWorkflowsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryWorkflowsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export type RealtimePublication = {
  __typename?: 'RealtimePublication';
  channel: Scalars['String']['output'];
  event: Scalars['String']['output'];
};

export type Region = RestrictedArea & {
  __typename?: 'Region';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Region items. */
export type RegionPaginator = {
  __typename?: 'RegionPaginator';
  /** A list of Region items. */
  data: Array<Region>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RestoreActualAdvantageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RestoreAttendeeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RestoreCommentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RestoreInternalSignerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RestoreNonComplianceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RestorePlannedAdvantageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RestoreTicketInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RestoreWorkflowInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RestrictedArea = {
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum RestrictedAreas {
  Identities = 'identities',
  Networks = 'networks',
  Products = 'products',
  Regions = 'regions',
  Sectors = 'sectors',
  TherapeuticAreas = 'therapeuticAreas',
  Ugas = 'ugas',
  Units = 'units',
  Zones = 'zones'
}

export type RestrictedAreasResult = {
  __typename?: 'RestrictedAreasResult';
  identities: Array<Identity>;
  networks: Array<Network>;
  products: Array<Product>;
  regions: Array<Region>;
  sectors: Array<Sector>;
  therapeuticAreas: Array<TherapeuticArea>;
  units: Array<Unit>;
  zones: Array<Zone>;
};

export type Role = {
  __typename?: 'Role';
  READ?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  REVIEW?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  WRITE?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RoleInput = {
  READ?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  REVIEW?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  WRITE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Sector = RestrictedArea & {
  __typename?: 'Sector';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Sector items. */
export type SectorPaginator = {
  __typename?: 'SectorPaginator';
  /** A list of Sector items. */
  data: Array<Sector>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SendEpsToBotBatch = {
  __typename?: 'SendEPSToBotBatch';
  batch_id: Scalars['String']['output'];
  realtime: RealtimePublication;
};

export type SendEpsToBotInput = {
  health_types?: InputMaybe<Array<InputMaybe<AttendeeHealthType>>>;
  pharmacist_types?: InputMaybe<Array<InputMaybe<PharmacistType>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regime: Scalars['String']['input'];
  regional_health_agency?: InputMaybe<Scalars['Boolean']['input']>;
  ticket_id: Scalars['ID']['input'];
};

export type SendToBotInput = {
  pack_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regime: Scalars['String']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type SettingDataInput = {
  authentication_mode?: InputMaybe<YouSignAuthenticationMode>;
  custom_experience_id?: InputMaybe<Scalars['ID']['input']>;
  interval_in_days?: InputMaybe<IntervalInDays>;
  max_occurrences?: InputMaybe<Scalars['Int']['input']>;
  operation_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ticket_deadline_days?: InputMaybe<Scalars['Int']['input']>;
  ticket_deadline_work_days?: InputMaybe<Scalars['Int']['input']>;
  workspace_id?: InputMaybe<Scalars['ID']['input']>;
};

export type Settings = {
  __typename?: 'Settings';
  data?: Maybe<Data>;
  is_active: Scalars['Boolean']['output'];
  type: SettingsType;
};

export type SettingsInput = {
  data?: InputMaybe<SettingDataInput>;
  is_active: Scalars['Boolean']['input'];
  type: SettingsType;
};

export enum SettingsType {
  CustomPermissions = 'CUSTOM_PERMISSIONS',
  UpsellAns = 'UPSELL_ANS',
  UpsellCrm = 'UPSELL_CRM',
  UpsellDqc = 'UPSELL_DQC',
  UpsellNotificationsCenter = 'UPSELL_NOTIFICATIONS_CENTER',
  WatchdogAttendeeAddedPostSubmission = 'WATCHDOG_ATTENDEE_ADDED_POST_SUBMISSION',
  WatchdogAttendeeSpecialtyDifferentFromDeclaration = 'WATCHDOG_ATTENDEE_SPECIALTY_DIFFERENT_FROM_DECLARATION',
  WatchdogHospitality = 'WATCHDOG_HOSPITALITY',
  WatchdogSignedContract = 'WATCHDOG_SIGNED_CONTRACT',
  WatchdogSimpleEventsByDeclaration = 'WATCHDOG_SIMPLE_EVENTS_BY_DECLARATION',
  WatchdogTicketDeadline = 'WATCHDOG_TICKET_DEADLINE',
  WatchdogUnannounced = 'WATCHDOG_UNANNOUNCED',
  YousignAuthentication = 'YOUSIGN_AUTHENTICATION',
  YousignReminders = 'YOUSIGN_REMINDERS',
  YousignWorkspace = 'YOUSIGN_WORKSPACE'
}

export type Signature = {
  __typename?: 'Signature';
  coordinates?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTimeUtc']['output'];
  finished: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type SignatureRequest = {
  __typename?: 'SignatureRequest';
  contract_attendee_id?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  skipped?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

export enum SignatureRequestType {
  Ordered = 'ORDERED',
  TripartiteOrdered = 'TRIPARTITE_ORDERED',
  TripartiteUnordered = 'TRIPARTITE_UNORDERED',
  Unordered = 'UNORDERED'
}

export type SignerInput = {
  attendee_id?: InputMaybe<Scalars['ID']['input']>;
  internal_signer_id?: InputMaybe<Scalars['ID']['input']>;
  is_signer_follower?: InputMaybe<Scalars['Boolean']['input']>;
  signer_order?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type SigningSheet = {
  __typename?: 'SigningSheet';
  document: Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ticket: Ticket;
};

export type SigningSheetResult = {
  __typename?: 'SigningSheetResult';
  document: Document;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
  ticket: Ticket;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export enum SourceEnum {
  Import = 'IMPORT',
  Manual = 'MANUAL'
}

export type Specialty = {
  __typename?: 'Specialty';
  id: Scalars['ID']['output'];
  is_attribued?: Maybe<Scalars['Boolean']['output']>;
  is_editable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  technical_key: Scalars['String']['output'];
};

/** A paginated list of Specialty items. */
export type SpecialtyPaginator = {
  __typename?: 'SpecialtyPaginator';
  /** A list of Specialty items. */
  data: Array<Specialty>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum Status {
  Canceled = 'CANCELED',
  Creating = 'CREATING',
  ToEdit = 'TO_EDIT'
}

export enum StatusFilterLibrary {
  Archived = 'ARCHIVED',
  Canceled = 'CANCELED',
  Published = 'PUBLISHED'
}

export enum Step {
  ContractManagement = 'CONTRACT_MANAGEMENT',
  EventInProgress = 'EVENT_IN_PROGRESS',
  EventIsFinished = 'EVENT_IS_FINISHED',
  EventValidating = 'EVENT_VALIDATING',
  FirstValidation = 'FIRST_VALIDATION',
  SecondValidation = 'SECOND_VALIDATION'
}

export type StepInput = {
  roles?: InputMaybe<RoleInput>;
  step: Scalars['String']['input'];
};

export type Submission = {
  __typename?: 'Submission';
  acceptation_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  attendees: Array<Attendee>;
  authorization_refusal_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  complete_submission_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  created_by?: Maybe<User>;
  documents?: Maybe<Array<Maybe<DocumentSubmission>>>;
  id: Scalars['ID']['output'];
  incomplete_submission_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  json?: Maybe<Document>;
  logs?: Maybe<Document>;
  recommendation_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SubmissionStatus>;
  submission_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  type?: Maybe<SubmissionType>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum SubmissionStatus {
  Canceled = 'CANCELED',
  ConventionAuthorized = 'CONVENTION_AUTHORIZED',
  ConventionRefused = 'CONVENTION_REFUSED',
  Creating = 'CREATING',
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RecommendationPending = 'RECOMMENDATION_PENDING',
  SubmissionIncomplete = 'SUBMISSION_INCOMPLETE',
  SubmissionSent = 'SUBMISSION_SENT',
  ValidationPending = 'VALIDATION_PENDING',
  WaitingForNotification = 'WAITING_FOR_NOTIFICATION'
}

export enum SubmissionType {
  Bot = 'BOT',
  Manual = 'MANUAL'
}

export type Subscription = {
  __typename?: 'Subscription';
  cancelSigningProcedureProgress?: Maybe<BatchProgress>;
  cloneTicketProgress?: Maybe<CloneTicketProgress>;
  createAttendeesByImportProgress?: Maybe<CreateAttendeesByImportProgress>;
  createSigningProcedureProgress?: Maybe<BatchProgress>;
  epsDepositProgress?: Maybe<BatchProgress>;
  generateAgencyExportProgress?: Maybe<GenerateAgencyExportProgress>;
  generateContractZipFileProgress?: Maybe<GenerateContractZipFileProgress>;
  generateDepositZipFileProgress?: Maybe<GenerateDepositZipFileProgress>;
  generateExpensesImportTemplateProgress?: Maybe<GenerateExpensesImportTemplateProgress>;
  generateManualAttachmentsProgress?: Maybe<GenerateManualAttachmentsProgress>;
  processExpensesImportProgress?: Maybe<ProcessExpensesImportProgress>;
};

export type TherapeuticArea = RestrictedArea & {
  __typename?: 'TherapeuticArea';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of TherapeuticArea items. */
export type TherapeuticAreaPaginator = {
  __typename?: 'TherapeuticAreaPaginator';
  /** A list of TherapeuticArea items. */
  data: Array<TherapeuticArea>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Ticket = {
  __typename?: 'Ticket';
  address: Address;
  advantages_completed: Scalars['Boolean']['output'];
  advantages_validated: Scalars['Boolean']['output'];
  agency_name?: Maybe<Scalars['String']['output']>;
  allocations?: Maybe<Allocations>;
  approverCrm?: Maybe<CrmUser>;
  attachment?: Maybe<Attachment>;
  attachments?: Maybe<Array<Attachment>>;
  attendees: AttendeePaginator;
  code: Scalars['String']['output'];
  comments: Array<Comment>;
  contractor?: Maybe<Scalars['String']['output']>;
  contracts?: Maybe<TicketContractsStats>;
  contractsFilteredByTemplate?: Maybe<Array<ContractAttendee>>;
  createdBy: User;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  declaration?: Maybe<Declaration>;
  deposits?: Maybe<TicketDepositsStats>;
  description?: Maybe<Scalars['String']['output']>;
  doctor_list_status?: Maybe<DoctorListStatus>;
  doctors_count?: Maybe<Scalars['Int']['output']>;
  end_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  event_specialty?: Maybe<TicketSpecialty>;
  event_type: EventType;
  expenseReports: Array<ExpenseReport>;
  external_code?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Format>;
  id: Scalars['ID']['output'];
  initiator?: Maybe<User>;
  isTicketInitiatedByUser: Scalars['Boolean']['output'];
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_declared?: Maybe<Scalars['Boolean']['output']>;
  is_doctor_list_status_editable?: Maybe<Scalars['Boolean']['output']>;
  is_package_creation_allowed: Scalars['Boolean']['output'];
  is_published?: Maybe<Scalars['Boolean']['output']>;
  linkedTickets?: Maybe<Array<Maybe<Ticket>>>;
  managerCrm?: Maybe<CrmUser>;
  meeting_type?: Maybe<MeetingType>;
  name: Scalars['String']['output'];
  nonCompliances: Array<NonCompliance>;
  operation?: Maybe<Operation>;
  originalTicketInfo?: Maybe<OriginalTicketInfo>;
  place?: Maybe<Scalars['String']['output']>;
  present_doctors_count?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  remainingDays?: Maybe<Scalars['Int']['output']>;
  signingSheets?: Maybe<Array<Maybe<SigningSheet>>>;
  start_at: Scalars['DateTimeUtc']['output'];
  status?: Maybe<Status>;
  submission_regime: TicketSubmissionRegime;
  ticketBadge?: Maybe<TicketBadge>;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  validator_1?: Maybe<User>;
  validator_2?: Maybe<User>;
  with_agency?: Maybe<Scalars['Boolean']['output']>;
  workflow?: Maybe<Workflow>;
  workflow_step?: Maybe<Step>;
};


export type TicketAttendeesArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type TicketExpenseReportsArgs = {
  orderBy?: InputMaybe<Array<TicketExpenseReportsOrderByOrderByClause>>;
};

export type TicketAllocationsInputs = {
  identities?: InputMaybe<Scalars['ID']['input']>;
  networks?: InputMaybe<Scalars['ID']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  regions?: InputMaybe<Scalars['ID']['input']>;
  sectors?: InputMaybe<Scalars['ID']['input']>;
  therapeuticAreas?: InputMaybe<Scalars['ID']['input']>;
  ugas?: InputMaybe<Scalars['ID']['input']>;
  units?: InputMaybe<Scalars['ID']['input']>;
  zones?: InputMaybe<Scalars['ID']['input']>;
};

export type TicketAttendeeImport = {
  __typename?: 'TicketAttendeeImport';
  created_at: Scalars['DateTimeUtc']['output'];
  document: Document;
  id: Scalars['ID']['output'];
  status?: Maybe<AttendeeImportStatusEnum>;
  ticket: Ticket;
};

/** A paginated list of TicketAttendeeImport items. */
export type TicketAttendeeImportPaginator = {
  __typename?: 'TicketAttendeeImportPaginator';
  /** A list of TicketAttendeeImport items. */
  data: Array<TicketAttendeeImport>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum TicketBadge {
  Archived = 'ARCHIVED',
  Canceled = 'CANCELED',
  ContractManagement = 'CONTRACT_MANAGEMENT',
  Creating = 'CREATING',
  Declared = 'DECLARED',
  EventInProgress = 'EVENT_IN_PROGRESS',
  EventIsFinished = 'EVENT_IS_FINISHED',
  EventValidating = 'EVENT_VALIDATING',
  FirstValidation = 'FIRST_VALIDATION',
  Published = 'PUBLISHED',
  SecondValidation = 'SECOND_VALIDATION',
  ToEdit = 'TO_EDIT'
}

export enum TicketByDeclarationCodeOrderByColumn {
  Code = 'CODE',
  DoctorListStatus = 'DOCTOR_LIST_STATUS',
  EndAt = 'END_AT',
  Name = 'NAME',
  PresentDoctorsCount = 'PRESENT_DOCTORS_COUNT',
  StartAt = 'START_AT'
}

export type TicketByDeclarationCodeOrderByInput = {
  column: TicketByDeclarationCodeOrderByColumn;
  order: SortOrder;
};

export type TicketContractsStats = {
  __typename?: 'TicketContractsStats';
  eligible_attendees_count: Scalars['Int']['output'];
  generated_contracts: Scalars['Int']['output'];
  signed_contracts: Scalars['Int']['output'];
};

export type TicketDepositsStats = {
  __typename?: 'TicketDepositsStats';
  deposit_sent: Scalars['Int']['output'];
  eligible_deposits_count: Scalars['Int']['output'];
};

/** Allowed column names for Ticket.expenseReports.orderBy. */
export enum TicketExpenseReportsOrderByColumn {
  Name = 'NAME',
  Reference = 'REFERENCE'
}

/** Order by clause for Ticket.expenseReports.orderBy. */
export type TicketExpenseReportsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: TicketExpenseReportsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export type TicketGroupedByStepOrStatus = {
  __typename?: 'TicketGroupedByStepOrStatus';
  paginatorInfo: PaginatorInfo;
  tickets: Array<Maybe<Ticket>>;
};

export enum TicketLifecycleKey {
  Canceled = 'CANCELED',
  ContractManagement = 'CONTRACT_MANAGEMENT',
  Creating = 'CREATING',
  EventInProgress = 'EVENT_IN_PROGRESS',
  EventIsFinished = 'EVENT_IS_FINISHED',
  EventValidating = 'EVENT_VALIDATING',
  FirstValidation = 'FIRST_VALIDATION',
  SecondValidation = 'SECOND_VALIDATION',
  ToEdit = 'TO_EDIT'
}

export type TicketLinkPayload = {
  __typename?: 'TicketLinkPayload';
  linked_ticket_id: Scalars['ID']['output'];
  ticket_id: Scalars['ID']['output'];
};

export enum TicketManagementOrderByColumn {
  Code = 'CODE',
  Contractor = 'CONTRACTOR',
  CreatedAt = 'CREATED_AT',
  EventType = 'EVENT_TYPE',
  Name = 'NAME',
  OperationName = 'OPERATION_NAME',
  RemainingDays = 'REMAINING_DAYS',
  StartAt = 'START_AT',
  SubmissionRegime = 'SUBMISSION_REGIME'
}

export type TicketManagementOrderByInput = {
  column: TicketManagementOrderByColumn;
  order: SortOrder;
};

/** A paginated list of Ticket items. */
export type TicketPaginator = {
  __typename?: 'TicketPaginator';
  /** A list of Ticket items. */
  data: Array<Ticket>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum TicketPermission {
  ArchiveTicket = 'ARCHIVE_TICKET',
  CompleteAdvantages = 'COMPLETE_ADVANTAGES',
  DenySpending = 'DENY_SPENDING',
  EditActualAdvantages = 'EDIT_ACTUAL_ADVANTAGES',
  EditAttendees = 'EDIT_ATTENDEES',
  EditContractManagement = 'EDIT_CONTRACT_MANAGEMENT',
  EditDeposit = 'EDIT_DEPOSIT',
  EditInformation = 'EDIT_INFORMATION',
  EditPlannedAdvantages = 'EDIT_PLANNED_ADVANTAGES',
  EditSigning = 'EDIT_SIGNING',
  EditSigningSheet = 'EDIT_SIGNING_SHEET',
  SendBackToInitiator = 'SEND_BACK_TO_INITIATOR',
  SendBackToValidator = 'SEND_BACK_TO_VALIDATOR',
  SendToEventInProgress = 'SEND_TO_EVENT_IN_PROGRESS',
  SendToTransparency = 'SEND_TO_TRANSPARENCY',
  SubmitTicket = 'SUBMIT_TICKET'
}

export enum TicketSpecialty {
  Allergology = 'ALLERGOLOGY',
  AnatomicalPathology = 'ANATOMICAL_PATHOLOGY',
  Anesthesia = 'ANESTHESIA',
  Angiology = 'ANGIOLOGY',
  Cardiology = 'CARDIOLOGY',
  CardiovascularSurg = 'CARDIOVASCULAR_SURG',
  Dermatology = 'DERMATOLOGY',
  EmergencyMedicine = 'EMERGENCY_MEDICINE',
  Endocrinology = 'ENDOCRINOLOGY',
  FaceSurg = 'FACE_SURG',
  Gastroenterology = 'GASTROENTEROLOGY',
  GeneralMedicine = 'GENERAL_MEDICINE',
  Genetics = 'GENETICS',
  Geriatrics = 'GERIATRICS',
  Hematology = 'HEMATOLOGY',
  InfantSurg = 'INFANT_SURG',
  Infectiology = 'INFECTIOLOGY',
  InternMedicine = 'INTERN_MEDICINE',
  LocalTrainingOrg = 'LOCAL_TRAINING_ORG',
  MaxilofacialSurg = 'MAXILOFACIAL_SURG',
  MedicalBiology = 'MEDICAL_BIOLOGY',
  MedicalGynecology = 'MEDICAL_GYNECOLOGY',
  MedicalImagery = 'MEDICAL_IMAGERY',
  MedicalResearch = 'MEDICAL_RESEARCH',
  Multidisciplinary = 'MULTIDISCIPLINARY',
  Nephrology = 'NEPHROLOGY',
  Neurology = 'NEUROLOGY',
  Neurosurgery = 'NEUROSURGERY',
  None = 'NONE',
  NuclearMedicine = 'NUCLEAR_MEDICINE',
  ObstetricGynecology = 'OBSTETRIC_GYNECOLOGY',
  Oncology = 'ONCOLOGY',
  Ophtalmology = 'OPHTALMOLOGY',
  Orl = 'ORL',
  OrthopedicSurg = 'ORTHOPEDIC_SURG',
  Pediatrics = 'PEDIATRICS',
  Pharmacology = 'PHARMACOLOGY',
  PlasticSurg = 'PLASTIC_SURG',
  Pneumology = 'PNEUMOLOGY',
  ProfessionalDvpt = 'PROFESSIONAL_DVPT',
  Psychiatry = 'PSYCHIATRY',
  PublicHealth = 'PUBLIC_HEALTH',
  Radiology = 'RADIOLOGY',
  ReadaptMedicine = 'READAPT_MEDICINE',
  Rheumatology = 'RHEUMATOLOGY',
  SportMedicine = 'SPORT_MEDICINE',
  Stomatology = 'STOMATOLOGY',
  Surgery = 'SURGERY',
  ThermalMedicine = 'THERMAL_MEDICINE',
  Transplant = 'TRANSPLANT',
  UrolologicSurg = 'UROLOLOGIC_SURG',
  VascularSurg = 'VASCULAR_SURG',
  VisceralSurg = 'VISCERAL_SURG',
  WorkMedicine = 'WORK_MEDICINE'
}

export enum TicketSubmissionRegime {
  Authorization = 'AUTHORIZATION',
  Declaration = 'DECLARATION',
  Mixed = 'MIXED',
  None = 'NONE'
}

export type TicketsForLinks = {
  __typename?: 'TicketsForLinks';
  contracts?: Maybe<Array<Maybe<Ticket>>>;
  events?: Maybe<Array<Maybe<Ticket>>>;
  simple_events?: Maybe<Array<Maybe<Ticket>>>;
  undeclared_events?: Maybe<Array<Maybe<Ticket>>>;
};

export type TicketsGroupedByStepOrStatus = {
  __typename?: 'TicketsGroupedByStepOrStatus';
  CONTRACT_MANAGEMENT: TicketGroupedByStepOrStatus;
  CREATING: TicketGroupedByStepOrStatus;
  EVENT_IN_PROGRESS: TicketGroupedByStepOrStatus;
  EVENT_IS_FINISHED: TicketGroupedByStepOrStatus;
  EVENT_VALIDATING: TicketGroupedByStepOrStatus;
  FIRST_VALIDATION: TicketGroupedByStepOrStatus;
  LIBRARY?: Maybe<TicketGroupedByStepOrStatus>;
  SECOND_VALIDATION: TicketGroupedByStepOrStatus;
  TO_EDIT: TicketGroupedByStepOrStatus;
  TRANSPARENCY?: Maybe<TicketGroupedByStepOrStatus>;
};

export type TicketsGroupedByStepOrStatusPaginationInput = {
  CONTRACT_MANAGEMENT: GroupPaginationInput;
  CREATING: GroupPaginationInput;
  EVENT_IN_PROGRESS: GroupPaginationInput;
  EVENT_IS_FINISHED: GroupPaginationInput;
  EVENT_VALIDATING: GroupPaginationInput;
  FIRST_VALIDATION: GroupPaginationInput;
  LIBRARY?: InputMaybe<GroupPaginationInput>;
  SECOND_VALIDATION: GroupPaginationInput;
  TO_EDIT: GroupPaginationInput;
  TRANSPARENCY?: InputMaybe<GroupPaginationInput>;
};

export type TicketsGroupedByStepOrStatusPaginator = {
  __typename?: 'TicketsGroupedByStepOrStatusPaginator';
  data: TicketsGroupedByStepOrStatus;
  paginatorInfo: PaginatorInfo;
};

export enum ToastType {
  Error = 'ERROR',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type ToggleActiveStateConventionsInput = {
  conventionIDs: Array<Scalars['ID']['input']>;
  is_active: Scalars['Boolean']['input'];
};

export type ToggleActiveStateOperationsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  operationIDs: Array<Scalars['ID']['input']>;
};

export type ToggleNotificationInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type TransparencyExport = {
  __typename?: 'TransparencyExport';
  created_at: Scalars['DateTimeUtc']['output'];
  filename: Scalars['String']['output'];
  from_date: Scalars['DateTimeUtc']['output'];
  id: Scalars['ID']['output'];
  publication_status?: Maybe<PublicationStatus>;
  to_date: Scalars['DateTimeUtc']['output'];
  url: Scalars['String']['output'];
};

export enum TransparencyExportOrderByColumn {
  CreatedAt = 'CREATED_AT',
  PublicationStatus = 'PUBLICATION_STATUS'
}

export type TransparencyExportOrderByInput = {
  column: TransparencyExportOrderByColumn;
  order: SortOrder;
};

export type TransparencyExportPaginator = {
  __typename?: 'TransparencyExportPaginator';
  data: Array<TransparencyExport>;
  paginatorInfo: PaginatorInfo;
};

export type TrashActualAdvantageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashActualPackageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ticketID?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashAttendeeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashAttendeeTicketRelationInput = {
  attendee_id: Scalars['ID']['input'];
  ticket_id: Scalars['ID']['input'];
};

export type TrashCommentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashContactInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashCrmUserInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashInternalSignerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashNonComplianceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashPlannedAdvantageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashPlannedPackageInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ticketID?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashTicketInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrashTicketResponse = {
  __typename?: 'TrashTicketResponse';
  batch_id?: Maybe<Scalars['String']['output']>;
  ticket: Ticket;
};

export type TrashWorkflowInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export enum TypeNumber {
  Adeli = 'ADELI',
  Ine = 'INE',
  Other = 'OTHER',
  Rna = 'RNA',
  Rpps = 'RPPS'
}

export enum TypeOfReturn {
  Classic = 'CLASSIC',
  Expenses = 'EXPENSES',
  Feedback = 'FEEDBACK'
}

export type Uga = RestrictedArea & {
  __typename?: 'Uga';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Uga items. */
export type UgaPaginator = {
  __typename?: 'UgaPaginator';
  /** A list of Uga items. */
  data: Array<Uga>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UnassignActualPackageToAttendeeInput = {
  actualPackageID: Scalars['ID']['input'];
  attendeeID: Scalars['ID']['input'];
};

export type UnassignPlannedPackageToAttendeeInput = {
  attendeeID: Scalars['ID']['input'];
  plannedPackageID: Scalars['ID']['input'];
  ticketID: Scalars['ID']['input'];
};

export type UnassignPlannedPackagesToAttendeesInput = {
  attendeeIDS?: InputMaybe<Array<Scalars['ID']['input']>>;
  ticketID: Scalars['ID']['input'];
};

export type Unit = RestrictedArea & {
  __typename?: 'Unit';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Unit items. */
export type UnitPaginator = {
  __typename?: 'UnitPaginator';
  /** A list of Unit items. */
  data: Array<Unit>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UpdateActualAdvantageInput = {
  advantage_type: AdvantageType;
  area?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  excluding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  gross_amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  including_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  net_amount: Scalars['Float']['input'];
  payment_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  quantity: Scalars['Float']['input'];
};

export type UpdateActualPackageInput = {
  advantages: Array<CreateActualAdvantageInPackage>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdditionalCostInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAddressHasOne = {
  create?: InputMaybe<CreateAddressInput>;
  update?: InputMaybe<UpdateAddressInput>;
};

export type UpdateAddressInput = {
  cedex?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<AddressCountry>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  street_name?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  street_type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAttendeeFacturationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  is_billed?: InputMaybe<Scalars['Boolean']['input']>;
  is_present?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAttendeeInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  activity?: InputMaybe<Activity>;
  added_by?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<UpdateAddressHasOne>;
  assignation?: InputMaybe<Scalars['String']['input']>;
  attendee_link_id?: InputMaybe<Scalars['String']['input']>;
  base_global_code?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AttendeeCategory>;
  civility?: InputMaybe<AttendeeCivility>;
  company?: InputMaybe<Scalars['String']['input']>;
  contractual_link?: InputMaybe<AttendeeContractualLink>;
  create_contact?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  executive_role?: InputMaybe<AttendeeExecutiveRole>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  healthSpecialties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  health_type?: InputMaybe<AttendeeHealthType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_billed?: InputMaybe<Scalars['Boolean']['input']>;
  is_military?: InputMaybe<Scalars['Boolean']['input']>;
  is_present?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  legal_status?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  official_journal?: InputMaybe<Scalars['Upload']['input']>;
  official_journal_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  organization_type?: InputMaybe<AttendeeOrganizationType>;
  parent_organization_name?: InputMaybe<Scalars['String']['input']>;
  pharmacist_type?: InputMaybe<PharmacistType>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  place_of_registration?: InputMaybe<Scalars['String']['input']>;
  prefecture_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  prefecture_name?: InputMaybe<Scalars['String']['input']>;
  prefecture_number?: InputMaybe<Scalars['String']['input']>;
  rcs?: InputMaybe<Scalars['String']['input']>;
  receipt?: InputMaybe<Scalars['Upload']['input']>;
  regime?: InputMaybe<AttendeeRegime>;
  rib?: InputMaybe<Scalars['Upload']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
  solicitation_letter?: InputMaybe<Scalars['Upload']['input']>;
  state?: InputMaybe<AttendeeStateType>;
  status?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<AttendeeTitle>;
  type?: InputMaybe<AttendeeType>;
  type_number?: InputMaybe<TypeNumber>;
};

export type UpdateAttendeesBillingInput = {
  ids: Array<Scalars['ID']['input']>;
  is_billed?: InputMaybe<Scalars['Boolean']['input']>;
  is_present?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCommentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TypeOfReturn>;
};

export type UpdateContactInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  activity?: InputMaybe<Activity>;
  address?: InputMaybe<UpdateAddressHasOne>;
  assignation?: InputMaybe<Scalars['String']['input']>;
  base_global_code?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AttendeeCategory>;
  civility?: InputMaybe<AttendeeCivility>;
  company?: InputMaybe<Scalars['String']['input']>;
  contractual_link?: InputMaybe<AttendeeContractualLink>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  executive_role?: InputMaybe<AttendeeExecutiveRole>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  healthSpecialties?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  health_type?: InputMaybe<AttendeeHealthType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_military?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  legal_status?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  official_journal?: InputMaybe<Scalars['Upload']['input']>;
  official_journal_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  organization_type?: InputMaybe<AttendeeOrganizationType>;
  parent_organization_name?: InputMaybe<Scalars['String']['input']>;
  pharmacist_type?: InputMaybe<PharmacistType>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  place_of_registration?: InputMaybe<Scalars['String']['input']>;
  prefecture_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  prefecture_name?: InputMaybe<Scalars['String']['input']>;
  prefecture_number?: InputMaybe<Scalars['String']['input']>;
  rcs?: InputMaybe<Scalars['String']['input']>;
  receipt?: InputMaybe<Scalars['Upload']['input']>;
  regime?: InputMaybe<AttendeeRegime>;
  rib?: InputMaybe<Scalars['Upload']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
  solicitation_letter?: InputMaybe<Scalars['Upload']['input']>;
  status?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<AttendeeTitle>;
  type?: InputMaybe<AttendeeType>;
  type_number?: InputMaybe<TypeNumber>;
};

export type UpdateConventionInput = {
  advantages: Array<InputMaybe<AdvantageInConvention>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_manual_pack_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  type: ConventionType;
};

export type UpdateCoreTicketInput = {
  address?: InputMaybe<UpdateAddressHasOne>;
  agency_name?: InputMaybe<Scalars['String']['input']>;
  allocations?: InputMaybe<TicketAllocationsInputs>;
  approverCrm?: InputMaybe<UpsertCrmUserBelongsTo>;
  attendees?: InputMaybe<UpsertAttendeesBelongsToMany>;
  comments?: InputMaybe<UpsertCommentsBelongsToMany>;
  declaration?: InputMaybe<UpsertDeclarationBelongsTo>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  event_specialty?: InputMaybe<TicketSpecialty>;
  event_type?: InputMaybe<EventType>;
  external_code?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Format>;
  id: Scalars['ID']['input'];
  initiator?: InputMaybe<UpsertInitiatorBelongsTo>;
  linkedTickets?: InputMaybe<UpsertLinkedTicketsBelongsToMany>;
  managerCrm?: InputMaybe<UpsertCrmUserBelongsTo>;
  meeting_type?: InputMaybe<MeetingType>;
  name?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<UpsertOperationBelongsTo>;
  place?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  start_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  validator_1?: InputMaybe<UpsertValidator1BelongsTo>;
  validator_2?: InputMaybe<UpsertValidator2BelongsTo>;
  with_agency?: InputMaybe<Scalars['Boolean']['input']>;
  workflow?: InputMaybe<UpsertWorkflowBelongsTo>;
};

export type UpdateDeclarationFlagInput = {
  flag?: InputMaybe<DeclarationFlag>;
  id: Scalars['ID']['input'];
};

export type UpdateDeclarationInput = {
  address?: InputMaybe<CreateAddressInput>;
  advantages?: InputMaybe<Array<InputMaybe<UpsertDeclarationAdvantageInDeclaration>>>;
  attendee_medical_types?: InputMaybe<Array<InputMaybe<AttendeeMedicalType>>>;
  attendee_quantity?: InputMaybe<Scalars['Int']['input']>;
  convention_id?: InputMaybe<Scalars['ID']['input']>;
  declaration_count?: InputMaybe<Scalars['Int']['input']>;
  end_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  external_code?: InputMaybe<Scalars['String']['input']>;
  managerCrm?: InputMaybe<UpsertCrmUserBelongsTo>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  specialties?: InputMaybe<Array<InputMaybe<DeclarationSpecialty>>>;
  start_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
};

export type UpdateFromManagementTickets = {
  ids: Array<Scalars['ID']['input']>;
  is_archived: Scalars['Boolean']['input'];
  is_declared: Scalars['Boolean']['input'];
};

export type UpdateNonComplianceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  internal_code?: InputMaybe<Scalars['String']['input']>;
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  date_boundary?: InputMaybe<NotificationDateBoundary>;
  day_type?: InputMaybe<NotificationDayType>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_object?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_types?: InputMaybe<Array<InputMaybe<EventType>>>;
  external_emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internal_emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  operations?: InputMaybe<UpsertOperationsBelongsToMany>;
  period?: InputMaybe<NotificationPeriod>;
  submission_regime?: InputMaybe<NotificationSubmissionRegime>;
  target_state?: InputMaybe<NotificationTargetState>;
  ticket_roles_to_notify?: InputMaybe<Array<InputMaybe<NotificationTicketRolesToNotify>>>;
  type?: InputMaybe<NotificationType>;
};

export type UpdateOperationInput = {
  actualPackages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractTemplates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  donation_type?: InputMaybe<DonationType>;
  eventTypes: Array<EventType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idahe_convention?: InputMaybe<OperationConventionIdahe>;
  idahe_typology?: InputMaybe<OperationTypologyIdahe>;
  is_publication_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  mandatory_actual_packages?: InputMaybe<Scalars['Boolean']['input']>;
  mandatory_attachments?: InputMaybe<Scalars['Boolean']['input']>;
  mandatory_contract_templates?: InputMaybe<Scalars['Boolean']['input']>;
  mandatory_planned_packages?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  operation_type_eps?: InputMaybe<OperationTypeEps>;
  operation_type_idahe?: InputMaybe<OperationTypeIdahe>;
  operation_type_transparency?: InputMaybe<OperationTypeTransparency>;
  plannedPackages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdatePlannedAdvantageInput = {
  advantage_type: AdvantageType;
  area?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  excluding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  gross_amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  including_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  net_amount: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type UpdatePlannedPackageInput = {
  advantages: Array<CreatePlannedAdvantageInPackage>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ticketID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSimpleEventsInBulkInput = {
  doctor_list_status?: InputMaybe<DoctorListStatus>;
  ids: Array<Scalars['ID']['input']>;
};

export type UpdateSubmissionInput = {
  acceptation_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  additional_information?: InputMaybe<Scalars['String']['input']>;
  authorization_refusal_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  complete_submission_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  file_type?: InputMaybe<DocumentSubmissionTypes>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id: Scalars['ID']['input'];
  incomplete_submission_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  recommendation_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubmissionStatus>;
  submission_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTicketInput = {
  address?: InputMaybe<UpdateAddressHasOne>;
  agency_name?: InputMaybe<Scalars['String']['input']>;
  allocations?: InputMaybe<TicketAllocationsInputs>;
  approverCrm?: InputMaybe<UpsertCrmUserBelongsTo>;
  attendees?: InputMaybe<UpsertAttendeesBelongsToMany>;
  comments?: InputMaybe<UpsertCommentsBelongsToMany>;
  declaration?: InputMaybe<UpsertDeclarationBelongsTo>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  event_specialty?: InputMaybe<TicketSpecialty>;
  event_type?: InputMaybe<EventType>;
  external_code?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Format>;
  id: Scalars['ID']['input'];
  initiator?: InputMaybe<UpsertInitiatorBelongsTo>;
  linkedTickets?: InputMaybe<UpsertLinkedTicketsBelongsToMany>;
  managerCrm?: InputMaybe<UpsertCrmUserBelongsTo>;
  meeting_type?: InputMaybe<MeetingType>;
  name?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<UpsertOperationBelongsTo>;
  place?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  start_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  validator_1?: InputMaybe<UpsertValidator1BelongsTo>;
  validator_2?: InputMaybe<UpsertValidator2BelongsTo>;
  with_agency?: InputMaybe<Scalars['Boolean']['input']>;
  workflow?: InputMaybe<UpsertWorkflowBelongsTo>;
};

export type UpdateTicketLifeCycleInput = {
  advantages_completed?: InputMaybe<Scalars['Boolean']['input']>;
  advantages_validated?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_declared?: InputMaybe<Scalars['Boolean']['input']>;
  next_step?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Status>;
  step?: InputMaybe<Step>;
};

export type UpdateTicketLifeCycleResponse = {
  __typename?: 'UpdateTicketLifeCycleResponse';
  batch_id?: Maybe<Scalars['String']['output']>;
  ticket: Ticket;
};

export type UpdateUserNotificationsInput = {
  email_notifications?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkflowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  eventTypes: Array<EventType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  steps: Array<StepInput>;
};

export type UploadAttachmentsInput = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadContractTemplateInput = {
  contractTemplate: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  signature_request_type: SignatureRequestType;
  template_id?: InputMaybe<Scalars['ID']['input']>;
  ticket_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadDocumentAttendeeInput = {
  attendee_id: Scalars['ID']['input'];
  custom_type_name?: InputMaybe<Scalars['String']['input']>;
  deposit_status?: InputMaybe<DocumentAttendeeStatus>;
  document?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  signature_status?: InputMaybe<DocumentAttendeeStatus>;
  signed_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  type?: InputMaybe<DocumentAttendeeTypes>;
};

export type UploadExpenseReport = {
  __typename?: 'UploadExpenseReport';
  document: Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
};

export type UploadExpenseReportInput = {
  expenseReport?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  ticket_code?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFileInput = {
  content?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadLogoInput = {
  content?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadSigningSheet = {
  __typename?: 'UploadSigningSheet';
  document: Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UploadSigningSheetInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  signingSheet: Scalars['Upload']['input'];
};

export type UpsertAttendeeBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertAttendeeSignatureInput = {
  attendee_id: Scalars['ID']['input'];
  hospitality: Scalars['Boolean']['input'];
  signature: Scalars['String']['input'];
  ticket_code: Scalars['String']['input'];
};

export type UpsertAttendeesBelongsToMany = {
  connect?: InputMaybe<Array<Scalars['ID']['input']>>;
  create?: InputMaybe<Array<CreateAttendeeInput>>;
  sync?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpsertCommentsBelongsToMany = {
  connect?: InputMaybe<Array<Scalars['ID']['input']>>;
  create?: InputMaybe<Array<CreateCommentInput>>;
  sync?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpsertCrmUserBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertCrmUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  post_title?: InputMaybe<Scalars['String']['input']>;
  responsibilities?: InputMaybe<Array<CrmResponsibility>>;
  staff_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDeclarationAdvantageInDeclaration = {
  advantage_type?: InputMaybe<AdvantageType>;
  comment?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  including_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  originalAdvantageId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertDeclarationBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertDeclarationDepositInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  declaration_id: Scalars['ID']['input'];
  recommendation_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DeclarationDepositStatus>;
  submission_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDeclarationThemesInput = {
  declaration_id: Scalars['ID']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDocumentBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertEventTypeBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertIdentityInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company_form?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  department?: InputMaybe<Department>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eps_login?: InputMaybe<Scalars['String']['input']>;
  eps_password?: InputMaybe<Scalars['String']['input']>;
  gdpr_contact?: InputMaybe<Scalars['String']['input']>;
  idahe_login?: InputMaybe<Scalars['String']['input']>;
  idahe_password?: InputMaybe<Scalars['String']['input']>;
  legal_notice?: InputMaybe<Scalars['String']['input']>;
  mail_gdpr_contact?: InputMaybe<Scalars['String']['input']>;
  main?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  no_urssaf_rate?: InputMaybe<Scalars['Float']['input']>;
  place_of_registration?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  rcs?: InputMaybe<Scalars['String']['input']>;
  representative_name?: InputMaybe<Scalars['String']['input']>;
  representative_title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertInitiatorBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertInternalSignerInput = {
  civility?: InputMaybe<AttendeeCivility>;
  email?: InputMaybe<Scalars['String']['input']>;
  executive_role?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  staff_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertLinkedTicketsBelongsToMany = {
  connect?: InputMaybe<Array<Scalars['ID']['input']>>;
  sync?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpsertNetworkInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertOperationBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateOperationInput>;
  update?: InputMaybe<UpdateOperationInput>;
};

export type UpsertOperationsBelongsToMany = {
  sync?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpsertProductInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertRegionInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertSectorInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertSpecialtyInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  technical_key: Scalars['String']['input'];
};

export type UpsertTherapeuticAreaInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertTicketBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertTicketInput = {
  address?: InputMaybe<CreateAddressInput>;
  agency_name?: InputMaybe<Scalars['String']['input']>;
  allocations?: InputMaybe<TicketAllocationsInputs>;
  approverCrm?: InputMaybe<UpsertCrmUserBelongsTo>;
  attendees?: InputMaybe<UpsertAttendeesBelongsToMany>;
  comments?: InputMaybe<UpsertCommentsBelongsToMany>;
  declaration?: InputMaybe<UpsertDeclarationBelongsTo>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  event_specialty?: InputMaybe<TicketSpecialty>;
  event_type?: InputMaybe<EventType>;
  external_code?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Format>;
  initiator?: InputMaybe<UpsertInitiatorBelongsTo>;
  linkedTickets?: InputMaybe<UpsertLinkedTicketsBelongsToMany>;
  managerCrm?: InputMaybe<UpsertCrmUserBelongsTo>;
  meeting_type?: InputMaybe<MeetingType>;
  name?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<UpsertOperationBelongsTo>;
  place?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  start_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  userIdForAllocations?: InputMaybe<UpsertUserBelongsTo>;
  validator_1?: InputMaybe<UpsertValidator1BelongsTo>;
  validator_2?: InputMaybe<UpsertValidator2BelongsTo>;
  with_agency?: InputMaybe<Scalars['Boolean']['input']>;
  workflow?: InputMaybe<UpsertWorkflowBelongsTo>;
};

export type UpsertUgaInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertUnitInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertValidator1BelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertValidator2BelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertWorkflowBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertZoneInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  allocations?: Maybe<Allocations>;
  avatar?: Maybe<Scalars['String']['output']>;
  avatar_file?: Maybe<Avatar>;
  avatar_file_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTimeUtc']['output']>;
  email: Scalars['String']['output'];
  email_notifications: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  first_name: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  keycloak_id: Scalars['ID']['output'];
  last_name: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  resource_access: Array<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  scopes: Array<Scalars['String']['output']>;
  staff_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTimeUtc']['output']>;
};

export type UserAndInternalSigner = {
  __typename?: 'UserAndInternalSigner';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  type: ContractAttendeeSignerType;
};

export type UserAttributesKeycloak = {
  __typename?: 'UserAttributesKeycloak';
  avatar?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  eps_login?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  eps_password?: Maybe<Scalars['Boolean']['output']>;
  idahe_login?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  idahe_password?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  promo_delegation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserAttributesKeycloakInput = {
  avatar?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eps_login?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eps_password?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  idahe_login?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  idahe_password?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promo_delegation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserKeycloak = {
  __typename?: 'UserKeycloak';
  allocations?: Maybe<Allocations>;
  attributes?: Maybe<UserAttributesKeycloak>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  staff_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserKeycloakInput = {
  allocations?: InputMaybe<AllocationsInputs>;
  attributes?: InputMaybe<UserAttributesKeycloakInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  staff_id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserKeycloakSigner = {
  __typename?: 'UserKeycloakSigner';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserRole = {
  __typename?: 'UserRole';
  clientRole?: Maybe<Scalars['String']['output']>;
  composite?: Maybe<Scalars['String']['output']>;
  containerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserRoleInput = {
  clientRole?: InputMaybe<Scalars['String']['input']>;
  composite?: InputMaybe<Scalars['String']['input']>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum UserRoles {
  Initiators = 'INITIATORS',
  Validators_1 = 'VALIDATORS_1',
  Validators_2 = 'VALIDATORS_2'
}

export type UserValidators = {
  __typename?: 'UserValidators';
  first_validators?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  second_validators?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type UserValidatorsInput = {
  first_validators?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  second_validators?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersByRoleList = {
  __typename?: 'UsersByRoleList';
  initiators?: Maybe<Array<User>>;
  validators_1?: Maybe<Array<User>>;
  validators_2?: Maybe<Array<User>>;
};

export type UsersListAllPaginator = {
  __typename?: 'UsersListAllPaginator';
  data: Array<UserKeycloak>;
  paginatorInfo: PaginatorInfo;
};

export type ValidatorsList = {
  __typename?: 'ValidatorsList';
  validators_1: Array<User>;
  validators_2: Array<User>;
};

export type WatchdogMessage = {
  __typename?: 'WatchdogMessage';
  count?: Maybe<Scalars['Int']['output']>;
  list?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  type: ToastType;
};

export enum WatchdogsSettings {
  WatchdogAttendeeAddedPostSubmission = 'WATCHDOG_ATTENDEE_ADDED_POST_SUBMISSION',
  WatchdogAttendeeSpecialtyDifferentFromDeclaration = 'WATCHDOG_ATTENDEE_SPECIALTY_DIFFERENT_FROM_DECLARATION',
  WatchdogHospitality = 'WATCHDOG_HOSPITALITY',
  WatchdogSimpleEventsByDeclaration = 'WATCHDOG_SIMPLE_EVENTS_BY_DECLARATION',
  WatchdogTicketDeadline = 'WATCHDOG_TICKET_DEADLINE',
  WatchdogUnannounced = 'WATCHDOG_UNANNOUNCED'
}

export type Workflow = {
  __typename?: 'Workflow';
  description?: Maybe<Scalars['String']['output']>;
  eventTypes: Array<WorkflowEventType>;
  id: Scalars['ID']['output'];
  is_used?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  steps: Array<WorkflowStep>;
};

export type WorkflowEventType = {
  __typename?: 'WorkflowEventType';
  event_type: EventType;
};

/** A paginated list of Workflow items. */
export type WorkflowPaginator = {
  __typename?: 'WorkflowPaginator';
  /** A list of Workflow items. */
  data: Array<Workflow>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type WorkflowStep = {
  __typename?: 'WorkflowStep';
  roles: Role;
  step: Step;
};

export enum YouSignAuthenticationMode {
  Email = 'EMAIL',
  None = 'NONE',
  Sms = 'SMS'
}

export type Zone = RestrictedArea & {
  __typename?: 'Zone';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Zone items. */
export type ZonePaginator = {
  __typename?: 'ZonePaginator';
  /** A list of Zone items. */
  data: Array<Zone>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CheckBatches = {
  __typename?: 'checkBatches';
  attendee_id: Scalars['ID']['output'];
  batch_id: Scalars['ID']['output'];
  contract_attendee?: Maybe<ContractAttendee>;
  contract_template_id: Scalars['ID']['output'];
};

export type CheckBatchesInput = {
  attendee_id?: InputMaybe<Scalars['String']['input']>;
  batch_id?: InputMaybe<Scalars['String']['input']>;
  contract_template_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSigningProcedureContractAttendeeInput = {
  contract_attendee_id: Scalars['ID']['input'];
};

export type CreateSigningProcedureInput = {
  contract_attendees?: InputMaybe<Array<InputMaybe<CreateSigningProcedureContractAttendeeInput>>>;
  signature_request_types?: InputMaybe<Array<InputMaybe<CreateSigningProcedureSignatureRequestTypeInput>>>;
};

export type CreateSigningProcedureSignatureRequestTypeInput = {
  signature_request_type: SignatureRequestType;
};

export type NewAttachment = {
  __typename?: 'newAttachment';
  comment?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Array<Scalars['Upload']['output']>>;
  ticket_id: Scalars['Int']['output'];
  type?: Maybe<AttachmentFileType>;
};

export type SendReminderInput = {
  contract_attendees?: InputMaybe<Array<InputMaybe<CreateSigningProcedureContractAttendeeInput>>>;
};

export type CreateAdditionalCostMutationVariables = Exact<{
  input: CreateAdditionalCostInput;
}>;


export type CreateAdditionalCostMutation = { __typename?: 'Mutation', createAdditionalCost: { __typename?: 'AdditionalCost', type: string, amount: number, description?: string | null, ticket_id: string } };

export type UpdateAdditionalCostMutationVariables = Exact<{
  input: UpdateAdditionalCostInput;
}>;


export type UpdateAdditionalCostMutation = { __typename?: 'Mutation', updateAdditionalCost: { __typename?: 'AdditionalCost', id: string, type: string, description?: string | null, amount: number, ticket_id: string } };

export type DeleteAdditionalCostMutationVariables = Exact<{
  input: DeleteAdditionalCostInput;
}>;


export type DeleteAdditionalCostMutation = { __typename?: 'Mutation', deleteAdditionalCost: { __typename?: 'AdditionalCost', id: string } };

export type DownloadAttendeeTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type DownloadAttendeeTemplateMutation = { __typename?: 'Mutation', downloadAttendeeTemplate: { __typename?: 'DownloadedFile', content: string, filename?: string | null } };

export type CreateContractDepositInformationMutationVariables = Exact<{
  input: CreateContractDepositInformationInput;
}>;


export type CreateContractDepositInformationMutation = { __typename?: 'Mutation', createContractDepositInformation: { __typename?: 'ContractDepositInformation', id: string, deposit_platform?: ContractDepositPlatform | null, deposit_type?: ContractDepositType | null } };

export type UploadAttachmentsMutationVariables = Exact<{
  input: UploadAttachmentsInput;
}>;


export type UploadAttachmentsMutation = { __typename?: 'Mutation', uploadAttachments: Array<{ __typename?: 'newAttachment', comment?: string | null, file?: Array<any> | null, type?: AttachmentFileType | null }> };

export type DeleteAttachmentMutationVariables = Exact<{
  input: DeleteAttachmentInput;
}>;


export type DeleteAttachmentMutation = { __typename?: 'Mutation', deleteAttachment: { __typename?: 'Attachment', id: string } };

export type UploadSigningSheetMutationVariables = Exact<{
  input: UploadSigningSheetInput;
}>;


export type UploadSigningSheetMutation = { __typename?: 'Mutation', uploadSigningSheet: { __typename?: 'UploadSigningSheet', id: string, name: string, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } };

export type CreateContractAttendeeMutationVariables = Exact<{
  input: CreateContractAttendeeInput;
}>;


export type CreateContractAttendeeMutation = { __typename?: 'Mutation', createContractAttendee: { __typename?: 'ContractAttendeeBatch', batch_id: string, attendee_id: string, contract_template_id: string } };

export type EditContractAttendeeInputMutationVariables = Exact<{
  input: EditContractAttendeeInput;
}>;


export type EditContractAttendeeInputMutation = { __typename?: 'Mutation', editContractAttendee?: boolean | null };

export type UpsertIdentityMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertIdentityInput;
}>;


export type UpsertIdentityMutation = { __typename?: 'Mutation', upsertIdentity: { __typename?: 'Identity', id: string, name?: string | null, company_form?: string | null, capital?: string | null, place_of_registration?: string | null, rcs?: string | null, gdpr_contact?: string | null, mail_gdpr_contact?: string | null, legal_notice?: string | null, address?: string | null, postal_code?: string | null, city?: string | null, department?: Department | null, country?: Country | null, representative_name?: string | null, representative_title?: string | null, enabled?: boolean | null, main?: boolean | null, eps_login?: string | null, idahe_login?: string | null, has_eps_password?: boolean | null, has_idahe_password?: boolean | null, no_urssaf_rate?: number | null, logo_file?: { __typename?: 'Avatar', id?: string | null, type?: string | null, url?: string | null } | null } };

export type UploadLogoMutationVariables = Exact<{
  input: UploadLogoInput;
}>;


export type UploadLogoMutation = { __typename?: 'Mutation', uploadLogo: { __typename?: 'Document', id: string, filename: string, type: string, url: string } };

export type CreateOperationMutationVariables = Exact<{
  input: CreateOperationInput;
}>;


export type CreateOperationMutation = { __typename?: 'Mutation', createOperation: { __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } };

export type UpdateOperationMutationVariables = Exact<{
  input: UpdateOperationInput;
}>;


export type UpdateOperationMutation = { __typename?: 'Mutation', updateOperation: { __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } };

export type UpsertTicketMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertTicketInput;
}>;


export type UpsertTicketMutation = { __typename?: 'Mutation', upsertTicket: { __typename?: 'Ticket', id: string, name: string, description?: string | null, place?: string | null, code: string, external_code?: string | null, status?: Status | null, workflow_step?: Step | null, event_type: EventType, event_specialty?: TicketSpecialty | null, quantity: number, start_at: any, end_at?: any | null, created_at?: any | null, is_declared?: boolean | null, is_archived?: boolean | null, is_published?: boolean | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, with_agency?: boolean | null, agency_name?: string | null, format?: Format | null, meeting_type?: MeetingType | null, is_package_creation_allowed: boolean, address: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null }, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, attendees: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }> }, createdBy: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, validator_1?: { __typename?: 'User', id: string, full_name: string } | null, validator_2?: { __typename?: 'User', id: string, full_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, enabled: boolean, is_publication_allowed: boolean } | null, nonCompliances: Array<{ __typename?: 'NonCompliance', id: string, ticket_id: string }>, linkedTickets?: Array<{ __typename?: 'Ticket', id: string, name: string, event_type: EventType } | null> | null, declaration?: { __typename?: 'Declaration', id: string, name: string } | null, allocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, approverCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null } };

export type UpdateTicketMutationVariables = Exact<{
  input: UpdateTicketInput;
}>;


export type UpdateTicketMutation = { __typename?: 'Mutation', updateTicket: { __typename?: 'Ticket', id: string, name: string, description?: string | null, place?: string | null, code: string, external_code?: string | null, status?: Status | null, workflow_step?: Step | null, event_type: EventType, event_specialty?: TicketSpecialty | null, quantity: number, start_at: any, end_at?: any | null, created_at?: any | null, is_declared?: boolean | null, is_archived?: boolean | null, is_published?: boolean | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, with_agency?: boolean | null, agency_name?: string | null, format?: Format | null, meeting_type?: MeetingType | null, is_package_creation_allowed: boolean, address: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null }, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, attendees: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }> }, createdBy: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, validator_1?: { __typename?: 'User', id: string, full_name: string } | null, validator_2?: { __typename?: 'User', id: string, full_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, enabled: boolean, is_publication_allowed: boolean } | null, nonCompliances: Array<{ __typename?: 'NonCompliance', id: string, ticket_id: string }>, linkedTickets?: Array<{ __typename?: 'Ticket', id: string, name: string, event_type: EventType } | null> | null, declaration?: { __typename?: 'Declaration', id: string, name: string } | null, allocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, approverCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null } };

export type UpdateUserNotificationsMutationVariables = Exact<{
  input: UpdateUserNotificationsInput;
}>;


export type UpdateUserNotificationsMutation = { __typename?: 'Mutation', updateUserNotifications: { __typename?: 'User', id: string, email_notifications: number } };

export type CreateUserMutationVariables = Exact<{
  input: UserKeycloakInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserKeycloak', firstName?: string | null } };

export type SoftDeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SoftDeleteUserMutation = { __typename?: 'Mutation', softDeleteUser: { __typename?: 'UserKeycloak', id?: string | null } };

export type AddClientLevelRoleMappingToUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<Array<UserRoleInput> | UserRoleInput>;
}>;


export type AddClientLevelRoleMappingToUserMutation = { __typename?: 'Mutation', addClientLevelRoleMappingToUser: { __typename?: 'UserRole', id?: string | null } };

export type RemoveClientLevelRoleMappingFromUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<Array<UserRoleInput> | UserRoleInput>;
}>;


export type RemoveClientLevelRoleMappingFromUserMutation = { __typename?: 'Mutation', removeClientLevelRoleMappingFromUser: { __typename?: 'UserRole', id?: string | null } };

export type UploadFileMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'Document', id: string, url: string, type: string } };

export type AdditionalCostQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdditionalCostQuery = { __typename?: 'Query', additionalCost?: { __typename?: 'AdditionalCost', id: string, type: string, description?: string | null, amount: number, ticket_id: string } | null };

export type AdditionalCostsByTicketQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type AdditionalCostsByTicketQuery = { __typename?: 'Query', additionalCostsByTicket: Array<{ __typename?: 'AdditionalCost', id: string, type: string, description?: string | null, amount: number, ticket_id: string }> };

export type AttendeesTotalByTicketQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AttendeeType>;
  category?: InputMaybe<AttendeeCategory>;
  health_type?: InputMaybe<AttendeeHealthType>;
  pack?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AttendeesTotalByTicketQuery = { __typename?: 'Query', attendeesTotalByTicket: { __typename?: 'AttendeePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } } };

export type CreateAttendeeMutationVariables = Exact<{
  input: CreateAttendeeInput;
}>;


export type CreateAttendeeMutation = { __typename?: 'Mutation', createAttendee: { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null } };

export type UpdateAttendeeMutationVariables = Exact<{
  input: UpdateAttendeeInput;
}>;


export type UpdateAttendeeMutation = { __typename?: 'Mutation', updateAttendee: { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null } };

export type TrashAttendeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TrashAttendeeMutation = { __typename?: 'Mutation', trashAttendee?: { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null } | null };

export type DeleteAttendeeMutationVariables = Exact<{
  input: DeleteAttendeeInput;
}>;


export type DeleteAttendeeMutation = { __typename?: 'Mutation', deleteAttendee?: { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null } | null };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', id: string, content: string, type?: TypeOfReturn | null, ticket_id: string, ticket_step?: Step | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string } } };

export type UpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'Comment', id: string, content: string, type?: TypeOfReturn | null } };

export type TrashCommentMutationVariables = Exact<{
  input: TrashCommentInput;
}>;


export type TrashCommentMutation = { __typename?: 'Mutation', trashComment?: { __typename?: 'Comment', id: string, content: string, type?: TypeOfReturn | null, ticket_id: string, ticket_step?: Step | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string } } | null };

export type ContractDepositInformationQueryVariables = Exact<{
  input: Scalars['ID']['input'];
}>;


export type ContractDepositInformationQuery = { __typename?: 'Query', contractDepositInformation: { __typename?: 'ContractDepositInformation', contract_attendee_id: string } };

export type SigningSheetsByTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
}>;


export type SigningSheetsByTicketQuery = { __typename?: 'Query', signingSheetsByTicket?: Array<{ __typename?: 'SigningSheet', id: string, name: string } | null> | null };

export type IdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityQuery = { __typename?: 'Query', identity?: { __typename?: 'Identity', id: string, name?: string | null, company_form?: string | null, capital?: string | null, place_of_registration?: string | null, rcs?: string | null, gdpr_contact?: string | null, mail_gdpr_contact?: string | null, legal_notice?: string | null, address?: string | null, postal_code?: string | null, city?: string | null, department?: Department | null, country?: Country | null, representative_name?: string | null, representative_title?: string | null, enabled?: boolean | null, main?: boolean | null, eps_login?: string | null, idahe_login?: string | null, has_eps_password?: boolean | null, has_idahe_password?: boolean | null, no_urssaf_rate?: number | null, logo_file?: { __typename?: 'Avatar', id?: string | null, type?: string | null, url?: string | null } | null } | null };

export type IdentityLogoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IdentityLogoQuery = { __typename?: 'Query', identityLogo?: { __typename?: 'Document', id: string, url: string, filename: string, type: string } | null };

export type OperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OperationQuery = { __typename?: 'Query', operation?: { __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } | null };

export type TicketByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TicketByCodeQuery = { __typename?: 'Query', ticketByCode: { __typename?: 'Ticket', id: string, name: string, description?: string | null, place?: string | null, code: string, external_code?: string | null, status?: Status | null, workflow_step?: Step | null, event_type: EventType, event_specialty?: TicketSpecialty | null, quantity: number, start_at: any, end_at?: any | null, created_at?: any | null, is_declared?: boolean | null, is_archived?: boolean | null, is_published?: boolean | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, with_agency?: boolean | null, agency_name?: string | null, format?: Format | null, meeting_type?: MeetingType | null, is_package_creation_allowed: boolean, address: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null }, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, attendees: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }> }, createdBy: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, validator_1?: { __typename?: 'User', id: string, full_name: string } | null, validator_2?: { __typename?: 'User', id: string, full_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, enabled: boolean, is_publication_allowed: boolean } | null, nonCompliances: Array<{ __typename?: 'NonCompliance', id: string, ticket_id: string }>, linkedTickets?: Array<{ __typename?: 'Ticket', id: string, name: string, event_type: EventType } | null> | null, declaration?: { __typename?: 'Declaration', id: string, name: string } | null, allocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, approverCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, comment?: string | null, type?: AttachmentFileType | null, is_added_manually?: boolean | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } }> | null } };

export type NonCompliancesByTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
}>;


export type NonCompliancesByTicketQuery = { __typename?: 'Query', nonCompliancesByTicket?: Array<{ __typename?: 'NonCompliance', id: string, ticket_id: string, type: string, internal_code: string } | null> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, name?: string | null, first_name: string, last_name: string, full_name: string, email: string, keycloak_id: string, phone?: string | null, email_notifications: number, allocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null } | null };

export type UserAssignableRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserAssignableRoleQuery = { __typename?: 'Query', getClientRoleFromUser: Array<{ __typename?: 'UserRole', id?: string | null, name?: string | null, composite?: string | null, clientRole?: string | null, containerId?: string | null }>, UserRolesListAll: Array<{ __typename?: 'UserRole', id?: string | null, name?: string | null, composite?: string | null, clientRole?: string | null, containerId?: string | null }> };

export type UserClientRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserClientRoleQuery = { __typename?: 'Query', getClientRoleFromUser: Array<{ __typename?: 'UserRole', id?: string | null, name?: string | null }> };

export type UserRolesListAllQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRolesListAllQuery = { __typename?: 'Query', UserRolesListAll: Array<{ __typename?: 'UserRole', id?: string | null, name?: string | null, composite?: string | null, clientRole?: string | null, containerId?: string | null }> };

export type UserAvatarQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserAvatarQuery = { __typename?: 'Query', userAvatar?: { __typename?: 'Document', id: string, url: string, filename: string, type: string } | null };

export type UsersValidatorListQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersValidatorListQuery = { __typename?: 'Query', UsersValidatorList: { __typename?: 'ValidatorsList', validators_1: Array<{ __typename?: 'User', id: string, keycloak_id: string, first_name: string, last_name: string, email: string }>, validators_2: Array<{ __typename?: 'User', id: string, keycloak_id: string, first_name: string, last_name: string, email: string }> } };

export type GetAllWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllWorkflowsQuery = { __typename?: 'Query', workflows: Array<{ __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> }> };

export type FetchWorkflowByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchWorkflowByIdQuery = { __typename?: 'Query', workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null };

export type CreateWorkflowMutationVariables = Exact<{
  input: CreateWorkflowInput;
}>;


export type CreateWorkflowMutation = { __typename?: 'Mutation', createWorkflow: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } };

export type UpdateWorkflowMutationVariables = Exact<{
  input: UpdateWorkflowInput;
}>;


export type UpdateWorkflowMutation = { __typename?: 'Mutation', updateWorkflow: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } };

export type WorkflowsPaginatorQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WorkflowsPaginatorQuery = { __typename?: 'Query', workflowsPaginator: { __typename?: 'WorkflowPaginator', data: Array<{ __typename?: 'Workflow', is_used?: boolean | null, id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type TrashWorkflowMutationVariables = Exact<{
  input: TrashWorkflowInput;
}>;


export type TrashWorkflowMutation = { __typename?: 'Mutation', trashWorkflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null };

export type CoreAdditionalCostFieldsFragment = { __typename?: 'AdditionalCost', id: string, type: string, description?: string | null, amount: number, ticket_id: string };

export type CoreAddressFieldsFragment = { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null };

export type CorePlannedAdvantageFieldsFragment = { __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null };

export type CoreActualAdvantageFieldsFragment = { __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null };

export type CoreAllocationsFieldsFragment = { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null };

export type CoreNetworkFieldsFragment = { __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null };

export type CoreUgaFieldsFragment = { __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null };

export type CoreZoneFieldsFragment = { __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null };

export type CoreAttendeeByImportFieldsFragment = { __typename?: 'Attendee', ticket_id?: string | null };

export type CoreAttendeeTicketFieldsFragment = { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null };

export type CoreUpdateAttendeeFieldsFragment = { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null };

export type CoreAttendeeOnPostEventFieldsFragment = { __typename?: 'Attendee', id: string, firstname?: string | null, lastname?: string | null, type?: AttendeeType | null, civility?: AttendeeCivility | null, health_type?: AttendeeHealthType | null, type_number?: TypeNumber | null, health_number?: string | null, organization_type?: AttendeeOrganizationType | null, email?: string | null, regime?: AttendeeRegime | null, phone_number?: string | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, is_present?: boolean | null, is_billed?: boolean | null, is_signed?: boolean | null, is_military?: boolean | null, state?: AttendeeStateType | null, legal_title?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, postcode?: string | null, street_name?: string | null, city?: string | null } | null, attendeeSignature?: { __typename?: 'AttendeeSignature', id: string, signature: string, hospitality: boolean } | null, createdBy?: { __typename?: 'User', id: string, full_name: string } | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null };

export type CoreAttendeeByApiFieldsFragment = { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null };

export type CoreAttendeeSignatureFieldsFragment = { __typename?: 'AttendeeSignature', id: string, ticket_id: string, attendee_id: string, signature: string, hospitality: boolean };

export type CoreCommentFieldsFragment = { __typename?: 'Comment', id: string, content: string, type?: TypeOfReturn | null, ticket_id: string, ticket_step?: Step | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string } };

export type CoreContactFieldsFragment = { __typename?: 'Contact', id: string, category?: AttendeeCategory | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone_number?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, civility?: AttendeeCivility | null, type?: AttendeeType | null, title?: AttendeeTitle | null, regime?: AttendeeRegime | null, description?: string | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, created_at?: any | null, updated_at?: any | null, assignation?: string | null, external_id?: string | null, address?: { __typename?: 'Address', id: string, name?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, city?: string | null, country?: AddressCountry | null } | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, documents?: Array<{ __typename?: 'DocumentContact', id: string, type: DocumentAttendeeTypes, contact?: { __typename?: 'Contact', id: string } | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null };

export type CoreUserAndInternalSignerFieldsFragment = { __typename?: 'UserAndInternalSigner', id: string, firstname: string, lastname: string, phone?: string | null, email: string, type: ContractAttendeeSignerType };

export type CoreInternalSignerFieldsFragment = { __typename?: 'InternalSigner', id: string, firstname: string, lastname: string, executive_role?: string | null, phone?: string | null, email: string, civility?: AttendeeCivility | null, staff_id?: string | null };

export type CoreUserKeycloakSignerFieldsFragment = { __typename?: 'UserKeycloakSigner', id?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null };

export type CoreContractAttendeeFragment = { __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } };

export type CoreAdvantagesConventionFragment = { __typename?: 'Convention', id: string, type: ConventionType, is_active: boolean, is_manual_pack_allowed: boolean, advantages?: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null } | null> | null };

export type CoreCrmUserFieldsFragment = { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null };

export type CoreDeclarationFragment = { __typename?: 'Declaration', id: string, name: string, code: string, status?: DeclarationStatus | null, workflow_step?: DeclarationWorkflowStep | null, is_accepted: boolean, is_refused: boolean, is_archived: boolean, is_canceled: boolean, declaration_count: number, attendee_quantity: number, attendee_medical_types?: Array<AttendeeMedicalType | null> | null, specialties: Array<DeclarationSpecialty>, start_at: any, end_at: any, created_at: any, reference?: string | null, external_code?: string | null, advantages?: Array<{ __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, including_tax_amount: number, quantity: number, comment?: string | null, enabled: boolean, originalAdvantage: { __typename?: 'PlannedAdvantage', id: string, net_amount: number, including_tax_amount?: number | null, quantity: number, advantage_type: AdvantageType } } | null> | null, convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_manual_pack_allowed: boolean } | null, themes?: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string } | null> | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string }, address?: { __typename?: 'Address', id: string, city?: string | null, country?: AddressCountry | null } | null, tickets?: Array<{ __typename?: 'Ticket', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, deposit?: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } | null };

export type CoreDeclarationDepositFragment = { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null };

export type CoreDeclarationAdvantageFragment = { __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, quantity: number, comment?: string | null, enabled: boolean, declaration: { __typename?: 'Declaration', id: string } };

export type CoreDeclarationThemeFragment = { __typename?: 'DeclarationThemes', id: string, name: string, duration: string, declaration: { __typename?: 'Declaration', id: string } };

export type CoreDeclarationDocumentFragment = { __typename?: 'DeclarationDocument', id: string, type: AttachmentFileType, comment?: string | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, declaration: { __typename?: 'Declaration', id: string } };

export type CoreDocumentFieldsFragment = { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null };

export type CoreDocumentAttendeeFieldsFragment = { __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } };

export type CoreDocumentContactFieldsFragment = { __typename?: 'DocumentContact', id: string, type: DocumentAttendeeTypes, contact?: { __typename?: 'Contact', id: string } | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } };

export type CoreIdentityFieldsFragment = { __typename?: 'Identity', id: string, name?: string | null, company_form?: string | null, capital?: string | null, place_of_registration?: string | null, rcs?: string | null, gdpr_contact?: string | null, mail_gdpr_contact?: string | null, legal_notice?: string | null, address?: string | null, postal_code?: string | null, city?: string | null, department?: Department | null, country?: Country | null, representative_name?: string | null, representative_title?: string | null, enabled?: boolean | null, main?: boolean | null, eps_login?: string | null, idahe_login?: string | null, has_eps_password?: boolean | null, has_idahe_password?: boolean | null, no_urssaf_rate?: number | null, logo_file?: { __typename?: 'Avatar', id?: string | null, type?: string | null, url?: string | null } | null };

export type CoreNotificationFieldsFragment = { __typename?: 'Notification', id: string, type: NotificationType, name: string, event_types: Array<EventType>, target_state?: NotificationTargetState | null, submission_regime?: NotificationSubmissionRegime | null, date_boundary?: NotificationDateBoundary | null, day_type?: NotificationDayType | null, period?: NotificationPeriod | null, delay?: number | null, enabled: boolean, external_emails?: Array<string | null> | null, internal_emails?: Array<string | null> | null, ticket_roles_to_notify?: Array<NotificationTicketRolesToNotify | null> | null, email_object: string, email_body: string, comment?: string | null, created_by?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, operations?: Array<{ __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } | null> | null };

export type CoreOperationFieldsFragment = { __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> };

export type CorePlannedPackageFieldsFragment = { __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> };

export type CoreActualPackageFieldsFragment = { __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> };

export type CorePaginationFieldsFragment = { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number };

export type CoreProductFieldsFragment = { __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null };

export type CoreRegionFieldsFragment = { __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null };

export type CoreSectorFieldsFragment = { __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null };

export type CoreSettingsFieldsFragment = { __typename?: 'Settings', is_active: boolean, type: SettingsType, data?: { __typename?: 'Data', max_occurrences?: number | null, interval_in_days?: IntervalInDays | null, authentication_mode?: YouSignAuthenticationMode | null, operation_ids?: Array<string | null> | null, ticket_deadline_days?: number | null, ticket_deadline_work_days?: number | null, workspace_id?: string | null, custom_experience_id?: string | null } | null };

export type GlobalSettingsFieldsFragment = { __typename?: 'Settings', is_active: boolean, type: SettingsType };

export type CoreWatchdogsSettingsFieldsFragment = { __typename?: 'Settings', is_active: boolean, type: SettingsType, data?: { __typename?: 'Data', operation_ids?: Array<string | null> | null, ticket_deadline_days?: number | null, ticket_deadline_work_days?: number | null } | null };

export type CoreSpecialtyFieldsFragment = { __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null };

export type CoreSubmissionFieldsFragment = { __typename?: 'Submission', id: string, reference?: string | null, status?: SubmissionStatus | null, url?: string | null, type?: SubmissionType | null, created_at?: any | null, incomplete_submission_date?: any | null, authorization_refusal_date?: any | null, recommendation_date?: any | null, acceptation_date?: any | null, complete_submission_date?: any | null, submission_date?: any | null, comment?: string | null, attendees: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }>, documents?: Array<{ __typename?: 'DocumentSubmission', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null, document_submission_type?: DocumentSubmissionTypes | null, is_from_bot?: boolean | null, additional_information?: string | null } | null> | null, json?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null, logs?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null };

export type CoreBatchProgressFieldsFragment = { __typename?: 'BatchProgress', status: BroadCastsStatusEnum, message: string, params?: { __typename?: 'BatchProgressParams', batch_id?: string | null, progress?: number | null, total?: number | null, processed?: number | null, failed_count?: number | null, ticket_code?: string | null } | null };

export type CoreTherapeuticAreaFieldsFragment = { __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null };

export type CoreTicketFieldsFragment = { __typename?: 'Ticket', id: string, name: string, description?: string | null, place?: string | null, code: string, external_code?: string | null, status?: Status | null, workflow_step?: Step | null, event_type: EventType, event_specialty?: TicketSpecialty | null, quantity: number, start_at: any, end_at?: any | null, created_at?: any | null, is_declared?: boolean | null, is_archived?: boolean | null, is_published?: boolean | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, with_agency?: boolean | null, agency_name?: string | null, format?: Format | null, meeting_type?: MeetingType | null, is_package_creation_allowed: boolean, address: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null }, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, attendees: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }> }, createdBy: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, validator_1?: { __typename?: 'User', id: string, full_name: string } | null, validator_2?: { __typename?: 'User', id: string, full_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, enabled: boolean, is_publication_allowed: boolean } | null, nonCompliances: Array<{ __typename?: 'NonCompliance', id: string, ticket_id: string }>, linkedTickets?: Array<{ __typename?: 'Ticket', id: string, name: string, event_type: EventType } | null> | null, declaration?: { __typename?: 'Declaration', id: string, name: string } | null, allocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, approverCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null };

export type CoreDashboardTicketFieldsFragment = { __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null };

export type CoreAdminDashboardTicketFieldsFragment = { __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null };

export type TicketAttachmentsFragment = { __typename?: 'Ticket', attachments?: Array<{ __typename?: 'Attachment', id: string, comment?: string | null, type?: AttachmentFileType | null, is_added_manually?: boolean | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } }> | null };

export type TicketByStepAndStatusFieldsFragment = { __typename?: 'TicketsGroupedByStepOrStatus', CREATING: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, FIRST_VALIDATION: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, SECOND_VALIDATION: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, TO_EDIT: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, CONTRACT_MANAGEMENT: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_IN_PROGRESS: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_VALIDATING: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_IS_FINISHED: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type TicketByStepAndStatusAdminFieldsFragment = { __typename?: 'TicketsGroupedByStepOrStatus', CREATING: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, FIRST_VALIDATION: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, SECOND_VALIDATION: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, TO_EDIT: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, CONTRACT_MANAGEMENT: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_IN_PROGRESS: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_VALIDATING: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_IS_FINISHED: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, LIBRARY?: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null, TRANSPARENCY?: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type CoreTicketStatusAndStepFieldsFragment = { __typename?: 'Ticket', id: string, code: string, status?: Status | null, workflow_step?: Step | null, is_declared?: boolean | null, is_archived?: boolean | null, is_published?: boolean | null, advantages_completed: boolean, advantages_validated: boolean, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null };

export type CoreUnitFieldsFragment = { __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null };

export type CoreUserKeycloakFieldsFragment = { __typename?: 'UserKeycloak', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, enabled?: boolean | null, attributes?: { __typename?: 'UserAttributesKeycloak', phone?: Array<string | null> | null } | null };

export type CoreAddedByFieldsFragment = { __typename?: 'User', id: string, full_name: string };

export type CoreWorkflowFieldsFragment = { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> };

export type CreateActualAdvantageMutationVariables = Exact<{
  input: CreateActualAdvantageInput;
}>;


export type CreateActualAdvantageMutation = { __typename?: 'Mutation', createActualAdvantage: { __typename?: 'ActualAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, attendee_id?: string | null, quantity: number, payment_date?: any | null } };

export type UpdateActualAdvantageMutationVariables = Exact<{
  input: UpdateActualAdvantageInput;
}>;


export type UpdateActualAdvantageMutation = { __typename?: 'Mutation', updateActualAdvantage: { __typename?: 'ActualAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, attendee_id?: string | null, quantity: number, detail?: string | null, comment?: string | null, area?: string | null, payment_date?: any | null } };

export type TrashActualAdvantageMutationVariables = Exact<{
  input: TrashActualAdvantageInput;
}>;


export type TrashActualAdvantageMutation = { __typename?: 'Mutation', trashActualAdvantage?: { __typename?: 'ActualAdvantage', id: string } | null };

export type CreateActualAdvantagesMutationVariables = Exact<{
  packageID: Scalars['ID']['input'];
  input: Array<CreateActualAdvantageInput> | CreateActualAdvantageInput;
}>;


export type CreateActualAdvantagesMutation = { __typename?: 'Mutation', createActualAdvantages?: boolean | null };

export type CreateActualPackageMutationVariables = Exact<{
  input: CreateActualPackageInput;
}>;


export type CreateActualPackageMutation = { __typename?: 'Mutation', createActualPackage: { __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }>, ticket?: { __typename?: 'Ticket', id: string } | null } };

export type UpdateActualPackageMutationVariables = Exact<{
  input: UpdateActualPackageInput;
}>;


export type UpdateActualPackageMutation = { __typename?: 'Mutation', updateActualPackage?: { __typename?: 'ActualPackage', id: string, name: string, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }>, ticket?: { __typename?: 'Ticket', id: string } | null } | null };

export type TrashActualPackageMutationVariables = Exact<{
  input: TrashActualPackageInput;
}>;


export type TrashActualPackageMutation = { __typename?: 'Mutation', trashActualPackage?: { __typename?: 'ActualPackage', id: string } | null };

export type DeleteActualPackageMutationVariables = Exact<{
  input: DeleteActualPackageInput;
}>;


export type DeleteActualPackageMutation = { __typename?: 'Mutation', deleteActualPackage?: { __typename?: 'ActualPackage', id: string } | null };

export type AssignActualPackagesToTicketMutationVariables = Exact<{
  input?: InputMaybe<AssignActualPackagesToTicketInput>;
}>;


export type AssignActualPackagesToTicketMutation = { __typename?: 'Mutation', assignActualPackagesToTicket?: Array<{ __typename?: 'ActualPackage', id: string, name: string, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }>, ticket?: { __typename?: 'Ticket', id: string } | null } | null> | null };

export type AssignActualPackageToAttendeesMutationVariables = Exact<{
  input?: InputMaybe<AssignActualPackageToAttendeesInput>;
}>;


export type AssignActualPackageToAttendeesMutation = { __typename?: 'Mutation', assignActualPackageToAttendees: boolean };

export type UnassignActualPackageToAttendeeMutationVariables = Exact<{
  input?: InputMaybe<UnassignActualPackageToAttendeeInput>;
}>;


export type UnassignActualPackageToAttendeeMutation = { __typename?: 'Mutation', unassignActualPackageToAttendee: boolean };

export type ClonePlannedPackagesAsActualPackagesMutationVariables = Exact<{
  input?: InputMaybe<ClonePlannedPackagesAsActualPackagesInput>;
}>;


export type ClonePlannedPackagesAsActualPackagesMutation = { __typename?: 'Mutation', clonePlannedPackagesAsActualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }>, ticket?: { __typename?: 'Ticket', id: string } | null } | null> | null };

export type GenerateAgencyExportMutationVariables = Exact<{
  input: GenerateAgencyExportInput;
}>;


export type GenerateAgencyExportMutation = { __typename?: 'Mutation', generateAgencyExport: { __typename?: 'GenerateAgencyExportBatch', batch_id: string } };

export type UpsertAllocationsNetworkMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertNetworkInput;
}>;


export type UpsertAllocationsNetworkMutation = { __typename?: 'Mutation', upsertNetwork: { __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } };

export type UpsertAllocationsUgaMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertUgaInput;
}>;


export type UpsertAllocationsUgaMutation = { __typename?: 'Mutation', upsertUga: { __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } };

export type UpsertAllocationsZoneMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertZoneInput;
}>;


export type UpsertAllocationsZoneMutation = { __typename?: 'Mutation', upsertZone: { __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } };

export type CreateAttachmentTemplatesMutationVariables = Exact<{
  input: AttachmentInput;
}>;


export type CreateAttachmentTemplatesMutation = { __typename?: 'Mutation', createAttachmentTemplates: Array<{ __typename?: 'Attachment', id: string, comment?: string | null, type?: AttachmentFileType | null } | null> };

export type GenerateContractZipFileMutationVariables = Exact<{
  input: GenerateContractZipFileInput;
}>;


export type GenerateContractZipFileMutation = { __typename?: 'Mutation', generateContractZipFile: { __typename?: 'GenerateContractZipFileBatch', batch_id: string } };

export type CreateAttachmentsMutationVariables = Exact<{
  input: AttachmentInput;
}>;


export type CreateAttachmentsMutation = { __typename?: 'Mutation', createAttachments: Array<{ __typename?: 'Attachment', id: string, comment?: string | null, type?: AttachmentFileType | null } | null> };

export type CreateAttendeeByImportMutationVariables = Exact<{
  input: CreateAttendeeByImportInput;
}>;


export type CreateAttendeeByImportMutation = { __typename?: 'Mutation', createAttendeeByImport: { __typename?: 'CreateAttendeesByImportBatch', batch_id: string } };

export type CreateAttendeeByApiMutationVariables = Exact<{
  input: CreateAttendeeByApiInput;
}>;


export type CreateAttendeeByApiMutation = { __typename?: 'Mutation', createAttendeeByApi: { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null } };

export type CreateAttendeesByApiMutationVariables = Exact<{
  input: CreateAttendeesByApiInput;
}>;


export type CreateAttendeesByApiMutation = { __typename?: 'Mutation', createAttendeesByApi: { __typename?: 'CreateAttendeesByApiResult', created: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null }>, errors: Array<{ __typename?: 'CreateAttendeeByApiError', index: number, firstname?: string | null, lastname?: string | null, message: string }> } };

export type UpdateAttendeeFacturationMutationVariables = Exact<{
  input: UpdateAttendeeFacturationInput;
}>;


export type UpdateAttendeeFacturationMutation = { __typename?: 'Mutation', updateAttendeeFacturation: { __typename?: 'Attendee', id: string, is_present?: boolean | null, is_billed?: boolean | null } };

export type UpdateAttendeesBillingMutationVariables = Exact<{
  input: UpdateAttendeesBillingInput;
}>;


export type UpdateAttendeesBillingMutation = { __typename?: 'Mutation', updateAttendeesBilling?: boolean | null };

export type BulkUpdateAttendeesMutationVariables = Exact<{
  input: BulkUpdateAttendeesInput;
}>;


export type BulkUpdateAttendeesMutation = { __typename?: 'Mutation', bulkUpdateAttendees: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }> };

export type CloneContactAsAttendeeMutationVariables = Exact<{
  input: CloneContactAsAttendeeInput;
}>;


export type CloneContactAsAttendeeMutation = { __typename?: 'Mutation', cloneContactAsAttendee: { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null } };

export type CloneContactsAsAttendeesMutationVariables = Exact<{
  input: CloneContactsAsAttendeesInput;
}>;


export type CloneContactsAsAttendeesMutation = { __typename?: 'Mutation', cloneContactsAsAttendees: { __typename?: 'CloneContactsAsAttendeesResult', created: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null }>, errors: Array<{ __typename?: 'CloneContactAsAttendeeError', index: number, contact_id: string, message: string }> } };

export type TrashAttendeesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  ticket_id: Scalars['ID']['input'];
}>;


export type TrashAttendeesMutation = { __typename?: 'Mutation', trashAttendees?: boolean | null };

export type UpsertAttendeeSignatureMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertAttendeeSignatureInput;
}>;


export type UpsertAttendeeSignatureMutation = { __typename?: 'Mutation', upsertAttendeeSignature: { __typename?: 'AttendeeSignature', id: string, ticket_id: string, attendee_id: string, signature: string, hospitality: boolean } };

export type DeleteAttendeeSignatureMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAttendeeSignatureMutation = { __typename?: 'Mutation', deleteAttendeeSignature: { __typename?: 'AttendeeSignature', id: string, ticket_id: string, attendee_id: string, signature: string, hospitality: boolean } };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', id: string, category?: AttendeeCategory | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone_number?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, civility?: AttendeeCivility | null, type?: AttendeeType | null, title?: AttendeeTitle | null, regime?: AttendeeRegime | null, description?: string | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, created_at?: any | null, updated_at?: any | null, assignation?: string | null, external_id?: string | null, address?: { __typename?: 'Address', id: string, name?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, city?: string | null, country?: AddressCountry | null } | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, documents?: Array<{ __typename?: 'DocumentContact', id: string, type: DocumentAttendeeTypes, contact?: { __typename?: 'Contact', id: string } | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null } };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'Contact', id: string, category?: AttendeeCategory | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone_number?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, civility?: AttendeeCivility | null, type?: AttendeeType | null, title?: AttendeeTitle | null, regime?: AttendeeRegime | null, description?: string | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, created_at?: any | null, updated_at?: any | null, assignation?: string | null, external_id?: string | null, address?: { __typename?: 'Address', id: string, name?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, city?: string | null, country?: AddressCountry | null } | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, documents?: Array<{ __typename?: 'DocumentContact', id: string, type: DocumentAttendeeTypes, contact?: { __typename?: 'Contact', id: string } | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null } };

export type TrashContactMutationVariables = Exact<{
  input: TrashContactInput;
}>;


export type TrashContactMutation = { __typename?: 'Mutation', trashContact?: { __typename?: 'Contact', id: string } | null };

export type ContractAttendeeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractAttendeeQuery = { __typename?: 'Query', contractAttendee?: { __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null };

export type UploadContractTemplateMutationVariables = Exact<{
  input: UploadContractTemplateInput;
}>;


export type UploadContractTemplateMutation = { __typename?: 'Mutation', uploadContractTemplate: { __typename?: 'ContractTemplateUpload', id?: string | null, ticket_id?: string | null, name: string, signature_request_type: SignatureRequestType, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } };

export type DeleteContractTemplateMutationVariables = Exact<{
  input: DeleteTemplateContractInput;
}>;


export type DeleteContractTemplateMutation = { __typename?: 'Mutation', deleteContractTemplate: { __typename?: 'ContractTemplate', id: string } };

export type ToggleActiveStateConventionsMutationVariables = Exact<{
  input: ToggleActiveStateConventionsInput;
}>;


export type ToggleActiveStateConventionsMutation = { __typename?: 'Mutation', toggleActiveStateConventions: boolean };

export type CreateConventionMutationVariables = Exact<{
  input: CreateConventionInput;
}>;


export type CreateConventionMutation = { __typename?: 'Mutation', createConvention: { __typename?: 'Convention', id: string, type: ConventionType, is_active: boolean, is_manual_pack_allowed: boolean, advantages?: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null } | null> | null } };

export type UpdateConventionMutationVariables = Exact<{
  input: UpdateConventionInput;
}>;


export type UpdateConventionMutation = { __typename?: 'Mutation', updateConvention: { __typename?: 'Convention', id: string, type: ConventionType, is_active: boolean, is_manual_pack_allowed: boolean, advantages?: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null } | null> | null } };

export type UpsertCrmUserMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertCrmUserInput;
}>;


export type UpsertCrmUserMutation = { __typename?: 'Mutation', upsertCrmUser: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } };

export type TrashCrmUserMutationVariables = Exact<{
  input: TrashCrmUserInput;
}>;


export type TrashCrmUserMutation = { __typename?: 'Mutation', trashCrmUser?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null };

export type CreateDeclarationMutationVariables = Exact<{
  input: CreateDeclarationInput;
}>;


export type CreateDeclarationMutation = { __typename?: 'Mutation', createDeclaration: { __typename?: 'Declaration', id: string, name: string, code: string, status?: DeclarationStatus | null, workflow_step?: DeclarationWorkflowStep | null, is_accepted: boolean, is_refused: boolean, is_archived: boolean, is_canceled: boolean, declaration_count: number, attendee_quantity: number, attendee_medical_types?: Array<AttendeeMedicalType | null> | null, specialties: Array<DeclarationSpecialty>, start_at: any, end_at: any, created_at: any, reference?: string | null, external_code?: string | null, advantages?: Array<{ __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, including_tax_amount: number, quantity: number, comment?: string | null, enabled: boolean, originalAdvantage: { __typename?: 'PlannedAdvantage', id: string, net_amount: number, including_tax_amount?: number | null, quantity: number, advantage_type: AdvantageType } } | null> | null, convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_manual_pack_allowed: boolean } | null, themes?: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string } | null> | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string }, address?: { __typename?: 'Address', id: string, city?: string | null, country?: AddressCountry | null } | null, tickets?: Array<{ __typename?: 'Ticket', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, deposit?: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } | null } };

export type UpdateDeclarationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDeclarationInput;
}>;


export type UpdateDeclarationMutation = { __typename?: 'Mutation', updateDeclaration: { __typename?: 'Declaration', id: string, name: string, code: string, status?: DeclarationStatus | null, workflow_step?: DeclarationWorkflowStep | null, is_accepted: boolean, is_refused: boolean, is_archived: boolean, is_canceled: boolean, declaration_count: number, attendee_quantity: number, attendee_medical_types?: Array<AttendeeMedicalType | null> | null, specialties: Array<DeclarationSpecialty>, start_at: any, end_at: any, created_at: any, reference?: string | null, external_code?: string | null, advantages?: Array<{ __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, including_tax_amount: number, quantity: number, comment?: string | null, enabled: boolean, originalAdvantage: { __typename?: 'PlannedAdvantage', id: string, net_amount: number, including_tax_amount?: number | null, quantity: number, advantage_type: AdvantageType } } | null> | null, convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_manual_pack_allowed: boolean } | null, themes?: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string } | null> | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string }, address?: { __typename?: 'Address', id: string, city?: string | null, country?: AddressCountry | null } | null, tickets?: Array<{ __typename?: 'Ticket', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, deposit?: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } | null } };

export type UpdateDeclarationAndNextStepMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDeclarationInput;
}>;


export type UpdateDeclarationAndNextStepMutation = { __typename?: 'Mutation', updateDeclarationAndNextStep: { __typename?: 'Declaration', id: string, name: string, code: string, status?: DeclarationStatus | null, workflow_step?: DeclarationWorkflowStep | null, is_accepted: boolean, is_refused: boolean, is_archived: boolean, is_canceled: boolean, declaration_count: number, attendee_quantity: number, attendee_medical_types?: Array<AttendeeMedicalType | null> | null, specialties: Array<DeclarationSpecialty>, start_at: any, end_at: any, created_at: any, reference?: string | null, external_code?: string | null, advantages?: Array<{ __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, including_tax_amount: number, quantity: number, comment?: string | null, enabled: boolean, originalAdvantage: { __typename?: 'PlannedAdvantage', id: string, net_amount: number, including_tax_amount?: number | null, quantity: number, advantage_type: AdvantageType } } | null> | null, convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_manual_pack_allowed: boolean } | null, themes?: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string } | null> | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string }, address?: { __typename?: 'Address', id: string, city?: string | null, country?: AddressCountry | null } | null, tickets?: Array<{ __typename?: 'Ticket', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, deposit?: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } | null } };

export type UpdateDeclarationAndSendBackToInitiatorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDeclarationInput;
}>;


export type UpdateDeclarationAndSendBackToInitiatorMutation = { __typename?: 'Mutation', updateDeclarationAndSendBackToInitiator: { __typename?: 'Declaration', id: string, name: string, code: string, status?: DeclarationStatus | null, workflow_step?: DeclarationWorkflowStep | null, is_accepted: boolean, is_refused: boolean, is_archived: boolean, is_canceled: boolean, declaration_count: number, attendee_quantity: number, attendee_medical_types?: Array<AttendeeMedicalType | null> | null, specialties: Array<DeclarationSpecialty>, start_at: any, end_at: any, created_at: any, reference?: string | null, external_code?: string | null, advantages?: Array<{ __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, including_tax_amount: number, quantity: number, comment?: string | null, enabled: boolean, originalAdvantage: { __typename?: 'PlannedAdvantage', id: string, net_amount: number, including_tax_amount?: number | null, quantity: number, advantage_type: AdvantageType } } | null> | null, convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_manual_pack_allowed: boolean } | null, themes?: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string } | null> | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string }, address?: { __typename?: 'Address', id: string, city?: string | null, country?: AddressCountry | null } | null, tickets?: Array<{ __typename?: 'Ticket', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, deposit?: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } | null } };

export type UpdateDeclarationFlagMutationVariables = Exact<{
  input: UpdateDeclarationFlagInput;
}>;


export type UpdateDeclarationFlagMutation = { __typename?: 'Mutation', updateDeclarationFlag: { __typename?: 'Declaration', id: string, name: string, code: string, status?: DeclarationStatus | null, workflow_step?: DeclarationWorkflowStep | null, is_accepted: boolean, is_refused: boolean, is_archived: boolean, is_canceled: boolean, declaration_count: number, attendee_quantity: number, attendee_medical_types?: Array<AttendeeMedicalType | null> | null, specialties: Array<DeclarationSpecialty>, start_at: any, end_at: any, created_at: any, reference?: string | null, external_code?: string | null, advantages?: Array<{ __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, including_tax_amount: number, quantity: number, comment?: string | null, enabled: boolean, originalAdvantage: { __typename?: 'PlannedAdvantage', id: string, net_amount: number, including_tax_amount?: number | null, quantity: number, advantage_type: AdvantageType } } | null> | null, convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_manual_pack_allowed: boolean } | null, themes?: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string } | null> | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string }, address?: { __typename?: 'Address', id: string, city?: string | null, country?: AddressCountry | null } | null, tickets?: Array<{ __typename?: 'Ticket', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, deposit?: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } | null } };

export type DeleteDeclarationMutationVariables = Exact<{
  input: DeleteDeclarationInput;
}>;


export type DeleteDeclarationMutation = { __typename?: 'Mutation', deleteDeclaration?: { __typename?: 'Declaration', id: string, name: string, code: string, status?: DeclarationStatus | null, workflow_step?: DeclarationWorkflowStep | null, is_accepted: boolean, is_refused: boolean, is_archived: boolean, is_canceled: boolean, declaration_count: number, attendee_quantity: number, attendee_medical_types?: Array<AttendeeMedicalType | null> | null, specialties: Array<DeclarationSpecialty>, start_at: any, end_at: any, created_at: any, reference?: string | null, external_code?: string | null, advantages?: Array<{ __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, including_tax_amount: number, quantity: number, comment?: string | null, enabled: boolean, originalAdvantage: { __typename?: 'PlannedAdvantage', id: string, net_amount: number, including_tax_amount?: number | null, quantity: number, advantage_type: AdvantageType } } | null> | null, convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_manual_pack_allowed: boolean } | null, themes?: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string } | null> | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string }, address?: { __typename?: 'Address', id: string, city?: string | null, country?: AddressCountry | null } | null, tickets?: Array<{ __typename?: 'Ticket', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, deposit?: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } | null } | null };

export type UpsertDeclarationThemeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertDeclarationThemesInput;
}>;


export type UpsertDeclarationThemeMutation = { __typename?: 'Mutation', upsertDeclarationTheme: { __typename?: 'DeclarationThemes', id: string, name: string, duration: string, declaration: { __typename?: 'Declaration', id: string } } };

export type DeleteDeclarationThemeMutationVariables = Exact<{
  input: DeleteDeclarationThemesInput;
}>;


export type DeleteDeclarationThemeMutation = { __typename?: 'Mutation', deleteDeclarationTheme?: { __typename?: 'DeclarationThemes', id: string, name: string, duration: string, declaration: { __typename?: 'Declaration', id: string } } | null };

export type CreateDeclarationDocumentMutationVariables = Exact<{
  input: CreateDeclarationDocumentInput;
}>;


export type CreateDeclarationDocumentMutation = { __typename?: 'Mutation', createDeclarationDocument: { __typename?: 'DeclarationDocument', id: string, type: AttachmentFileType, comment?: string | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, declaration: { __typename?: 'Declaration', id: string } } };

export type DeleteDeclarationDocumentMutationVariables = Exact<{
  input: DeleteDeclarationDocumentInput;
}>;


export type DeleteDeclarationDocumentMutation = { __typename?: 'Mutation', deleteDeclarationDocument: { __typename?: 'DeclarationDocument', id: string, type: AttachmentFileType, comment?: string | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, declaration: { __typename?: 'Declaration', id: string } } };

export type UpsertDeclarationDepositMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertDeclarationDepositInput;
}>;


export type UpsertDeclarationDepositMutation = { __typename?: 'Mutation', upsertDeclarationDeposit: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } };

export type SendIdaheToBotMutationVariables = Exact<{
  input: SendToBotInput;
}>;


export type SendIdaheToBotMutation = { __typename?: 'Mutation', sendIDAHEToBot: boolean };

export type SendEpsToBotMutationVariables = Exact<{
  input: SendEpsToBotInput;
}>;


export type SendEpsToBotMutation = { __typename?: 'Mutation', sendEPSToBot: { __typename?: 'SendEPSToBotBatch', batch_id: string, realtime: { __typename?: 'RealtimePublication', channel: string, event: string } } };

export type CreateManualSubmissionMutationVariables = Exact<{
  input: CreateManualSubmissionInput;
}>;


export type CreateManualSubmissionMutation = { __typename?: 'Mutation', createManualSubmission?: { __typename?: 'Deposit', id: string, reference?: string | null, regime?: AttendeeDepositRegime | null, platform?: BotDestination | null, status?: DepositStatus | null, json_filters?: Array<string | null> | null, created_at?: any | null, ticket?: { __typename?: 'Ticket', id: string, code: string, name: string } | null, packages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string } | null> | null, submissions?: Array<{ __typename?: 'Submission', id: string, status?: SubmissionStatus | null, url?: string | null, incomplete_submission_date?: any | null, authorization_refusal_date?: any | null, recommendation_date?: any | null, acceptation_date?: any | null, complete_submission_date?: any | null, comment?: string | null, created_at?: any | null, documents?: Array<{ __typename?: 'DocumentSubmission', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null> | null } | null> | null, created_by?: { __typename?: 'User', first_name: string, last_name: string } | null } | null };

export type UpdateSubmissionMutationVariables = Exact<{
  input?: InputMaybe<UpdateSubmissionInput>;
}>;


export type UpdateSubmissionMutation = { __typename?: 'Mutation', updateSubmission?: { __typename?: 'Submission', id: string, reference?: string | null, status?: SubmissionStatus | null, url?: string | null, created_at?: any | null, attendees: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }>, documents?: Array<{ __typename?: 'DocumentSubmission', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null> | null, json?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null, logs?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null } | null };

export type GenerateManualAttachmentsMutationVariables = Exact<{
  input: GenerateManualAttachmentsInput;
}>;


export type GenerateManualAttachmentsMutation = { __typename?: 'Mutation', generateManualAttachments?: { __typename?: 'GenerateDepositZipFileBatch', batch_id: string } | null };

export type GenerateDepositZipFileMutationVariables = Exact<{
  input: GenerateDepositZipFileInput;
}>;


export type GenerateDepositZipFileMutation = { __typename?: 'Mutation', generateDepositZipFile: { __typename?: 'GenerateDepositZipFileBatch', batch_id: string } };

export type DeleteDocumentAttendeeContactMutationVariables = Exact<{
  input: DeleteDocumentAttendeeContactInput;
}>;


export type DeleteDocumentAttendeeContactMutation = { __typename?: 'Mutation', deleteDocumentAttendeeContact?: boolean | null };

export type DeleteSigningSheetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSigningSheetMutation = { __typename?: 'Mutation', deleteSigningSheet: { __typename?: 'SigningSheet', id: string } };

export type UploadDocumentAttendeeMutationVariables = Exact<{
  input: UploadDocumentAttendeeInput;
}>;


export type UploadDocumentAttendeeMutation = { __typename?: 'Mutation', uploadDocumentAttendee: { __typename?: 'DocumentAttendeeUpload', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } };

export type DeleteDocumentAttendeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDocumentAttendeeMutation = { __typename?: 'Mutation', deleteDocumentAttendee: { __typename?: 'DocumentAttendee', id: string } };

export type DeleteContractAttendeeMutationVariables = Exact<{
  input: DeleteContractAttendeeInput;
}>;


export type DeleteContractAttendeeMutation = { __typename?: 'Mutation', deleteContractAttendee?: string | null };

export type DeleteContractsAttendeesMutationVariables = Exact<{
  input: DeleteContractsAttendeesInput;
}>;


export type DeleteContractsAttendeesMutation = { __typename?: 'Mutation', deleteContractsAttendees: { __typename?: 'DeleteContractsAttendeesResponse', ticket_code: string, batch_id?: string | null } };

export type UploadExpenseReportMutationVariables = Exact<{
  input: UploadExpenseReportInput;
}>;


export type UploadExpenseReportMutation = { __typename?: 'Mutation', uploadExpenseReport: { __typename?: 'UploadExpenseReport', id: string, name: string, reference?: string | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } };

export type DeleteExpenseReportMutationVariables = Exact<{
  input: DeleteExpenseReportInput;
}>;


export type DeleteExpenseReportMutation = { __typename?: 'Mutation', deleteExpenseReport: { __typename?: 'ExpenseReport', id: string } };

export type UploadExpensesImportMutationVariables = Exact<{
  input: ExpensesImportInput;
}>;


export type UploadExpensesImportMutation = { __typename?: 'Mutation', expensesImport: { __typename?: 'ExpensesImportTemplateBatch', batch_id: string } };

export type ExpenseImportByCrmMutationVariables = Exact<{
  input: ExpensesImportInput;
}>;


export type ExpenseImportByCrmMutation = { __typename?: 'Mutation', expenseImportByCrm?: boolean | null };

export type GenerateExpensesImportTemplateMutationVariables = Exact<{
  input: GenerateExpensesImportInput;
}>;


export type GenerateExpensesImportTemplateMutation = { __typename?: 'Mutation', expensesImportTemplate: { __typename?: 'ExpensesImportTemplateBatch', batch_id: string } };

export type UpsertInternalSignerMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertInternalSignerInput;
}>;


export type UpsertInternalSignerMutation = { __typename?: 'Mutation', upsertInternalSigner: { __typename?: 'InternalSigner', id: string, firstname: string, lastname: string, executive_role?: string | null, phone?: string | null, email: string, civility?: AttendeeCivility | null, staff_id?: string | null } };

export type TrashInternalSignerMutationVariables = Exact<{
  input: TrashInternalSignerInput;
}>;


export type TrashInternalSignerMutation = { __typename?: 'Mutation', trashInternalSigner?: { __typename?: 'InternalSigner', id: string, firstname: string, lastname: string, executive_role?: string | null, phone?: string | null, email: string, civility?: AttendeeCivility | null, staff_id?: string | null } | null };

export type CreateNotificationMutationVariables = Exact<{
  input: CreateNotificationInput;
}>;


export type CreateNotificationMutation = { __typename?: 'Mutation', createNotification: { __typename?: 'Notification', id: string, type: NotificationType, name: string, event_types: Array<EventType>, target_state?: NotificationTargetState | null, submission_regime?: NotificationSubmissionRegime | null, date_boundary?: NotificationDateBoundary | null, day_type?: NotificationDayType | null, period?: NotificationPeriod | null, delay?: number | null, enabled: boolean, external_emails?: Array<string | null> | null, internal_emails?: Array<string | null> | null, ticket_roles_to_notify?: Array<NotificationTicketRolesToNotify | null> | null, email_object: string, email_body: string, comment?: string | null, created_by?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, operations?: Array<{ __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } | null> | null } };

export type UpdateNotificationMutationVariables = Exact<{
  input: UpdateNotificationInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: { __typename?: 'Notification', id: string, type: NotificationType, name: string, event_types: Array<EventType>, target_state?: NotificationTargetState | null, submission_regime?: NotificationSubmissionRegime | null, date_boundary?: NotificationDateBoundary | null, day_type?: NotificationDayType | null, period?: NotificationPeriod | null, delay?: number | null, enabled: boolean, external_emails?: Array<string | null> | null, internal_emails?: Array<string | null> | null, ticket_roles_to_notify?: Array<NotificationTicketRolesToNotify | null> | null, email_object: string, email_body: string, comment?: string | null, created_by?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, operations?: Array<{ __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } | null> | null } };

export type ToggleNotificationsMutationVariables = Exact<{
  input: Array<ToggleNotificationInput> | ToggleNotificationInput;
}>;


export type ToggleNotificationsMutation = { __typename?: 'Mutation', toggleNotifications: Array<{ __typename?: 'Notification', id: string, type: NotificationType, name: string, event_types: Array<EventType>, target_state?: NotificationTargetState | null, submission_regime?: NotificationSubmissionRegime | null, date_boundary?: NotificationDateBoundary | null, day_type?: NotificationDayType | null, period?: NotificationPeriod | null, delay?: number | null, enabled: boolean, external_emails?: Array<string | null> | null, internal_emails?: Array<string | null> | null, ticket_roles_to_notify?: Array<NotificationTicketRolesToNotify | null> | null, email_object: string, email_body: string, comment?: string | null, created_by?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, operations?: Array<{ __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } | null> | null }> };

export type CloneOperationMutationVariables = Exact<{
  input: UpdateOperationInput;
}>;


export type CloneOperationMutation = { __typename?: 'Mutation', cloneOperation: { __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } };

export type ToggleActiveStateOperationsMutationVariables = Exact<{
  input: ToggleActiveStateOperationsInput;
}>;


export type ToggleActiveStateOperationsMutation = { __typename?: 'Mutation', toggleActiveStateOperations: boolean };

export type CreatePlannedAdvantageMutationVariables = Exact<{
  input: CreatePlannedAdvantageInput;
}>;


export type CreatePlannedAdvantageMutation = { __typename?: 'Mutation', createPlannedAdvantage: { __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, attendee_id?: string | null, quantity: number, detail?: string | null, comment?: string | null, area?: string | null } };

export type UpdatePlannedAdvantageMutationVariables = Exact<{
  input: UpdatePlannedAdvantageInput;
}>;


export type UpdatePlannedAdvantageMutation = { __typename?: 'Mutation', updatePlannedAdvantage: { __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, attendee_id?: string | null, quantity: number, detail?: string | null, comment?: string | null, area?: string | null } };

export type TrashPlannedAdvantageMutationVariables = Exact<{
  input: TrashPlannedAdvantageInput;
}>;


export type TrashPlannedAdvantageMutation = { __typename?: 'Mutation', trashPlannedAdvantage?: { __typename?: 'PlannedAdvantage', id: string } | null };

export type CreatePlannedAdvantagesMutationVariables = Exact<{
  packageID: Scalars['ID']['input'];
  input: Array<CreatePlannedAdvantageInput> | CreatePlannedAdvantageInput;
}>;


export type CreatePlannedAdvantagesMutation = { __typename?: 'Mutation', createPlannedAdvantages?: boolean | null };

export type CreatePlannedPackageMutationVariables = Exact<{
  input: CreatePlannedPackageInput;
}>;


export type CreatePlannedPackageMutation = { __typename?: 'Mutation', createPlannedPackage: { __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, comment?: string | null, area?: string | null }>, ticket?: { __typename?: 'Ticket', id: string } | null } };

export type UpdatePlannedPackageMutationVariables = Exact<{
  input: UpdatePlannedPackageInput;
}>;


export type UpdatePlannedPackageMutation = { __typename?: 'Mutation', updatePlannedPackage?: { __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, comment?: string | null, area?: string | null }>, ticket?: { __typename?: 'Ticket', id: string } | null } | null };

export type TrashPlannedPackageMutationVariables = Exact<{
  input: TrashPlannedPackageInput;
}>;


export type TrashPlannedPackageMutation = { __typename?: 'Mutation', trashPlannedPackage?: { __typename?: 'PlannedPackage', id: string } | null };

export type DeletePlannedPackageMutationVariables = Exact<{
  input: DeletePlannedPackageInput;
}>;


export type DeletePlannedPackageMutation = { __typename?: 'Mutation', deletePlannedPackage?: { __typename?: 'PlannedPackage', id: string } | null };

export type AssignPlannedPackagesToTicketMutationVariables = Exact<{
  input?: InputMaybe<AssignPlannedPackagesToTicketInput>;
}>;


export type AssignPlannedPackagesToTicketMutation = { __typename?: 'Mutation', assignPlannedPackagesToTicket?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, comment?: string | null, area?: string | null }>, ticket?: { __typename?: 'Ticket', id: string } | null } | null> | null };

export type AssignPlannedPackageToAttendeesMutationVariables = Exact<{
  input?: InputMaybe<AssignPlannedPackageToAttendeesInput>;
}>;


export type AssignPlannedPackageToAttendeesMutation = { __typename?: 'Mutation', assignPlannedPackageToAttendees: boolean };

export type UnassignPlannedPackageToAttendeeMutationVariables = Exact<{
  input?: InputMaybe<UnassignPlannedPackageToAttendeeInput>;
}>;


export type UnassignPlannedPackageToAttendeeMutation = { __typename?: 'Mutation', unassignPlannedPackageToAttendee: boolean };

export type UnassignPlannedPackagesToAttendeesMutationVariables = Exact<{
  input?: InputMaybe<UnassignPlannedPackagesToAttendeesInput>;
}>;


export type UnassignPlannedPackagesToAttendeesMutation = { __typename?: 'Mutation', unassignPlannedPackagesToAttendees: boolean };

export type UpsertProductMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertProductInput;
}>;


export type UpsertProductMutation = { __typename?: 'Mutation', upsertProduct: { __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } };

export type UpsertRegionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertRegionInput;
}>;


export type UpsertRegionMutation = { __typename?: 'Mutation', upsertRegion: { __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } };

export type UpsertSectorMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertSectorInput;
}>;


export type UpsertSectorMutation = { __typename?: 'Mutation', upsertSector: { __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } };

export type UpdateSettingsMutationVariables = Exact<{
  input: Array<SettingsInput> | SettingsInput;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', updateSettings: Array<{ __typename?: 'Settings', is_active: boolean, type: SettingsType, data?: { __typename?: 'Data', max_occurrences?: number | null, interval_in_days?: IntervalInDays | null, authentication_mode?: YouSignAuthenticationMode | null, operation_ids?: Array<string | null> | null, ticket_deadline_days?: number | null, ticket_deadline_work_days?: number | null, workspace_id?: string | null, custom_experience_id?: string | null } | null }> };

export type UpdateSettingMutationVariables = Exact<{
  input: SettingsInput;
}>;


export type UpdateSettingMutation = { __typename?: 'Mutation', updateSetting: { __typename?: 'Settings', is_active: boolean, type: SettingsType, data?: { __typename?: 'Data', max_occurrences?: number | null, interval_in_days?: IntervalInDays | null, authentication_mode?: YouSignAuthenticationMode | null, operation_ids?: Array<string | null> | null, ticket_deadline_days?: number | null, ticket_deadline_work_days?: number | null, workspace_id?: string | null, custom_experience_id?: string | null } | null } };

export type SendReminderMutationVariables = Exact<{
  input: SendReminderInput;
}>;


export type SendReminderMutation = { __typename?: 'Mutation', sendReminder?: boolean | null };

export type CancelContractAttendeeSignatureRequestMutationVariables = Exact<{
  input: CancelContractAttendeeSignatureRequestInput;
}>;


export type CancelContractAttendeeSignatureRequestMutation = { __typename?: 'Mutation', cancelContractAttendeeSignatureRequest: boolean };

export type CreateSigningProcedureMutationVariables = Exact<{
  input: CreateSigningProcedureInput;
}>;


export type CreateSigningProcedureMutation = { __typename?: 'Mutation', createSigningProcedure: { __typename?: 'CreateSigningProcedureResponse', success: boolean, skipped?: Array<string | null> | null, error?: string | null, batch_id?: string | null } };

export type DownloadSigningSheetMutationVariables = Exact<{
  input: DownloadSigningSheetInput;
}>;


export type DownloadSigningSheetMutation = { __typename?: 'Mutation', downloadSigningSheet?: { __typename?: 'DownloadedFile', content: string, filename?: string | null, type?: string | null } | null };

export type UpsertSpecialtyMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertSpecialtyInput;
}>;


export type UpsertSpecialtyMutation = { __typename?: 'Mutation', upsertSpecialty: { __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } };

export type DeleteSpecialtyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSpecialtyMutation = { __typename?: 'Mutation', deleteSpecialty?: { __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null };

export type UpsertTherapeuticAreaMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertTherapeuticAreaInput;
}>;


export type UpsertTherapeuticAreaMutation = { __typename?: 'Mutation', upsertTherapeuticArea: { __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } };

export type UpdateTicketLifeCycleMutationVariables = Exact<{
  input: UpdateTicketLifeCycleInput;
}>;


export type UpdateTicketLifeCycleMutation = { __typename?: 'Mutation', updateTicketLifeCycle: { __typename?: 'UpdateTicketLifeCycleResponse', batch_id?: string | null, ticket: { __typename?: 'Ticket', id: string, code: string, status?: Status | null, workflow_step?: Step | null, is_declared?: boolean | null, is_archived?: boolean | null, is_published?: boolean | null, advantages_completed: boolean, advantages_validated: boolean, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } } };

export type UpdateTicketFromDashboardMutationVariables = Exact<{
  input: UpdateTicketInput;
}>;


export type UpdateTicketFromDashboardMutation = { __typename?: 'Mutation', updateTicket: { __typename?: 'Ticket', id: string, code: string, name: string, is_archived?: boolean | null } };

export type UpdateCoreTicketMutationVariables = Exact<{
  input: UpdateCoreTicketInput;
}>;


export type UpdateCoreTicketMutation = { __typename?: 'Mutation', updateCoreTicket: { __typename?: 'Ticket', id: string, name: string, description?: string | null, place?: string | null, code: string, external_code?: string | null, status?: Status | null, workflow_step?: Step | null, event_type: EventType, event_specialty?: TicketSpecialty | null, quantity: number, start_at: any, end_at?: any | null, created_at?: any | null, is_declared?: boolean | null, is_archived?: boolean | null, advantages_completed: boolean, advantages_validated: boolean, with_agency?: boolean | null, agency_name?: string | null, format?: Format | null, meeting_type?: MeetingType | null, address: { __typename?: 'Address', id: string, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null }, workflow?: { __typename?: 'Workflow', id: string, name: string, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }> } | null, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, attendees: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, firstname?: string | null, lastname?: string | null, title?: AttendeeTitle | null, health_number?: string | null, health_type?: AttendeeHealthType | null }> }, createdBy: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, avatar?: string | null, avatar_file_id?: string | null, avatar_file?: { __typename?: 'Avatar', id?: string | null, type?: string | null, url?: string | null } | null }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, full_name: string } | null, validator_2?: { __typename?: 'User', id: string, full_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string } | null, nonCompliances: Array<{ __typename?: 'NonCompliance', id: string, ticket_id: string }>, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, approverCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null } };

export type UpdateTicketsFromTicketsManagementMutationVariables = Exact<{
  input: UpdateFromManagementTickets;
}>;


export type UpdateTicketsFromTicketsManagementMutation = { __typename?: 'Mutation', updateManagedTickets: Array<{ __typename?: 'Ticket', id: string, is_archived?: boolean | null, is_declared?: boolean | null }> };

export type CreateDeclarationExportFromTicketsManagementMutationVariables = Exact<{
  input: CreateDeclarationExportInput;
}>;


export type CreateDeclarationExportFromTicketsManagementMutation = { __typename?: 'Mutation', createDeclarationExport: { __typename?: 'ContractAttendeeBatch', batch_id: string } };

export type CreateDiagnosticExportFromTicketsManagementMutationVariables = Exact<{
  input: CreateDiagnosticExportInput;
}>;


export type CreateDiagnosticExportFromTicketsManagementMutation = { __typename?: 'Mutation', createDiagnosticExport: { __typename?: 'ContractAttendeeBatch', batch_id: string } };

export type CloneTicketMutationVariables = Exact<{
  input: CloneTicketInput;
}>;


export type CloneTicketMutation = { __typename?: 'Mutation', cloneTicket: { __typename?: 'CloneTicketBatch', batch_id: string } };

export type CreateContractForAttendeeMutationVariables = Exact<{
  input: CreateContractForAttendeeInput;
}>;


export type CreateContractForAttendeeMutation = { __typename?: 'Mutation', createContractForAttendee: { __typename?: 'Ticket', id: string, code: string } };

export type UpdateSimpleEventsInBulkMutationVariables = Exact<{
  input: UpdateSimpleEventsInBulkInput;
}>;


export type UpdateSimpleEventsInBulkMutation = { __typename?: 'Mutation', updateSimpleEventsInBulk: Array<{ __typename?: 'Ticket', id: string, doctor_list_status?: DoctorListStatus | null }> };

export type UpsertUnitMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertUnitInput;
}>;


export type UpsertUnitMutation = { __typename?: 'Mutation', upsertUnit: { __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UserKeycloakInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserKeycloak', id?: string | null, firstName?: string | null } };

export type UpdateUserValidatorsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UserValidatorsInput;
}>;


export type UpdateUserValidatorsMutation = { __typename?: 'Mutation', updateUserValidators: { __typename?: 'UserKeycloak', id?: string | null, firstName?: string | null } };

export type ActualPackagesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ActualPackagesQuery = { __typename?: 'Query', actualPackages: { __typename?: 'ActualPackagePaginator', data: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, source?: string | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }>, ticket?: { __typename?: 'Ticket', id: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ActualPackageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActualPackageQuery = { __typename?: 'Query', actualPackage?: { __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, source?: string | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }>, ticket?: { __typename?: 'Ticket', id: string } | null } | null };

export type AllActualPackagesQueryVariables = Exact<{
  ticket_code?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllActualPackagesQuery = { __typename?: 'Query', allActualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, source?: string | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }>, ticket?: { __typename?: 'Ticket', id: string } | null }> | null };

export type ExpensesImportQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExpensesImportQuery = { __typename?: 'Query', expensesImport: { __typename?: 'ExpensesImportPaginator', data: Array<{ __typename?: 'ExpensesImport', id: string, state: ExpensesImportStatus, type: ExpensesImportType, created_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ExpensesImportTemplateQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
}>;


export type ExpensesImportTemplateQuery = { __typename?: 'Query', expensesImportTemplate?: { __typename?: 'ExpensesImportTemplate', id: string, updated_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null };

export type AgencyExportQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
}>;


export type AgencyExportQuery = { __typename?: 'Query', agencyExport?: { __typename?: 'AgencyExport', id: string, updated_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null };

export type GetEnabledAllocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnabledAllocationsQuery = { __typename?: 'Query', getEnabledAllocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null };

export type GetAllAllocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAllocationsQuery = { __typename?: 'Query', getAllAllocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null };

export type AllocationsIdentitiesQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllocationsIdentitiesQuery = { __typename?: 'Query', identityPaginator: { __typename?: 'IdentityPaginator', data: Array<{ __typename?: 'Identity', id: string, name?: string | null, company_form?: string | null, capital?: string | null, place_of_registration?: string | null, rcs?: string | null, gdpr_contact?: string | null, mail_gdpr_contact?: string | null, legal_notice?: string | null, address?: string | null, postal_code?: string | null, city?: string | null, department?: Department | null, country?: Country | null, representative_name?: string | null, representative_title?: string | null, enabled?: boolean | null, main?: boolean | null, eps_login?: string | null, idahe_login?: string | null, has_eps_password?: boolean | null, has_idahe_password?: boolean | null, no_urssaf_rate?: number | null, logo_file?: { __typename?: 'Avatar', id?: string | null, type?: string | null, url?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AllocationsIdentityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AllocationsIdentityQuery = { __typename?: 'Query', identityById?: { __typename?: 'Identity', id: string, name?: string | null, company_form?: string | null, capital?: string | null, place_of_registration?: string | null, rcs?: string | null, gdpr_contact?: string | null, mail_gdpr_contact?: string | null, legal_notice?: string | null, address?: string | null, postal_code?: string | null, city?: string | null, department?: Department | null, country?: Country | null, representative_name?: string | null, representative_title?: string | null, enabled?: boolean | null, main?: boolean | null, eps_login?: string | null, idahe_login?: string | null, has_eps_password?: boolean | null, has_idahe_password?: boolean | null, no_urssaf_rate?: number | null, logo_file?: { __typename?: 'Avatar', id?: string | null, type?: string | null, url?: string | null } | null } | null };

export type AllocationsNetworksQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllocationsNetworksQuery = { __typename?: 'Query', networks: { __typename?: 'NetworkPaginator', data: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AllocationsNetworkQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AllocationsNetworkQuery = { __typename?: 'Query', network?: { __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null };

export type AllocationsUgasQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllocationsUgasQuery = { __typename?: 'Query', ugas: { __typename?: 'UgaPaginator', data: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AllocationsUgaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AllocationsUgaQuery = { __typename?: 'Query', uga?: { __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null };

export type AllocationsZonesQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllocationsZonesQuery = { __typename?: 'Query', zones: { __typename?: 'ZonePaginator', data: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AllocationsZoneQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AllocationsZoneQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null };

export type SignedOmniUrlQueryVariables = Exact<{
  dashboard: AnalyticsType;
}>;


export type SignedOmniUrlQuery = { __typename?: 'Query', signedOmniUrl?: { __typename?: 'AnalyticsUrl', url: string } | null };

export type GetAnsAttendeesQueryVariables = Exact<{
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  health_number?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnsAttendeesQuery = { __typename?: 'Query', ansAttendees: Array<{ __typename?: 'ApiAttendee', id?: string | null, title?: AttendeeTitle | null, civility?: string | null, firstname?: string | null, lastname?: string | null, category?: string | null, type_number?: string | null, health_number?: string | null, health_type?: string | null, healthSpecialties?: Array<string | null> | null, pharmacist_type?: string | null, external_id?: string | null, email?: string | null, phone_number?: string | null, address?: { __typename?: 'ApiAttendeeAddress', name?: string | null, street_name?: string | null, postcode?: string | null, city?: string | null, country?: string | null } | null } | null> };

export type AttachmentsWhereTicketNullPaginateQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AttachmentsWhereTicketNullPaginateQuery = { __typename?: 'Query', attachmentsWhereTicketNullPaginate: { __typename?: 'AttachmentPaginator', data: Array<{ __typename?: 'Attachment', id: string, comment?: string | null, type?: AttachmentFileType | null, document: { __typename?: 'Document', url: string, filename: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AllAttachmentsWhereTicketNullQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAttachmentsWhereTicketNullQuery = { __typename?: 'Query', allAttachmentsWhereTicketNull?: Array<{ __typename?: 'Attachment', id: string, comment?: string | null, type?: AttachmentFileType | null, document: { __typename?: 'Document', url: string, filename: string } } | null> | null };

export type ZipFileQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
}>;


export type ZipFileQuery = { __typename?: 'Query', zipFile?: { __typename?: 'Attachment', id: string, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null };

export type AttendeesByTicketQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AttendeeType>;
  category?: InputMaybe<AttendeeCategory>;
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>> | InputMaybe<AttendeeStateType>>;
  health_type?: InputMaybe<AttendeeHealthType>;
  submission_regime?: InputMaybe<AttendeeSubmissionRegime>;
  added_by?: InputMaybe<Scalars['ID']['input']>;
  pack?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<QueryAttendeesByTicketOrderByRelationOrderByClause> | QueryAttendeesByTicketOrderByRelationOrderByClause>;
}>;


export type AttendeesByTicketQuery = { __typename?: 'Query', attendeesByTicket: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } } | null } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, step?: DocumentAttendeeStep | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetAttendeeTotalByTicketQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AttendeeType>;
  category?: InputMaybe<AttendeeCategory>;
  health_type?: InputMaybe<AttendeeHealthType>;
  added_by?: InputMaybe<Scalars['ID']['input']>;
  submission_regime?: InputMaybe<AttendeeSubmissionRegime>;
  pack?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAttendeeTotalByTicketQuery = { __typename?: 'Query', total: { __typename?: 'AttendeePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } } };

export type GetAttendeeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAttendeeQuery = { __typename?: 'Query', attendee: { __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null } };

export type AttendeeAdvantageTypeTotalQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
  attendee_id?: InputMaybe<Scalars['ID']['input']>;
  advantage_type?: InputMaybe<AdvantageType>;
}>;


export type AttendeeAdvantageTypeTotalQuery = { __typename?: 'Query', attendeeAdvantageTypeTotal: { __typename?: 'AttendeeAdvantageTypeTotalPaginator', data: Array<{ __typename?: 'AttendeeAdvantageTypeTotal', id: string, advantage_type: AdvantageType, total_actual_advantages: number, total_planned_advantages: number, total_gap: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AggregatedAdvantageTypeTotalByTicketQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AggregatedAdvantageTypeTotalByTicketQuery = { __typename?: 'Query', aggregatedAdvantageTypeTotalByTicket: { __typename?: 'AggregatedAdvantageTypeTotalPaginator', data: Array<{ __typename?: 'AggregatedAdvantageTypeTotal', id: string, advantage_type: AdvantageType, total_actual_advantages: number, total_planned_advantages: number, total_gap: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
  attendee_name?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AggregatedAdvantageTypeTotalOrderByInput> | AggregatedAdvantageTypeTotalOrderByInput>;
}>;


export type AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery = { __typename?: 'Query', aggregatedAdvantageTypeTotalByTicketThenByAttendee: { __typename?: 'AggregatedAdvantageTypeTotalByAttendeePaginator', data: Array<{ __typename?: 'AggregatedAdvantageTypeTotalByAttendee', id: string, firstname?: string | null, lastname?: string | null, civility?: AttendeeCivility | null, category: AttendeeCategory, health_type?: AttendeeHealthType | null, health_number?: string | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, is_military?: boolean | null, is_present?: boolean | null, is_billed?: boolean | null, total_planned_advantages: number, total_actual_advantages: number, total_gap: number, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null }, advantage_types: Array<{ __typename?: 'AttendeeAdvantageTypeBreakdown', advantage_type: AdvantageType, total_planned_advantages: number, total_actual_advantages: number, total_gap: number }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AttendeesOnSigningSheetQueryVariables = Exact<{
  code: Scalars['String']['input'];
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>> | InputMaybe<AttendeeStateType>>;
}>;


export type AttendeesOnSigningSheetQuery = { __typename?: 'Query', attendeesByTicketWithSignatures: Array<{ __typename?: 'Attendee', id: string, ticket_id?: string | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, is_signed?: boolean | null, category?: AttendeeCategory | null, legal_title?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, attendeeSignature?: { __typename?: 'AttendeeSignature', id: string, signature: string, hospitality: boolean } | null }> };

export type AttendeesOnPostEventQueryVariables = Exact<{
  code: Scalars['String']['input'];
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>> | InputMaybe<AttendeeStateType>>;
}>;


export type AttendeesOnPostEventQuery = { __typename?: 'Query', attendeesByTicketWithSignatures: Array<{ __typename?: 'Attendee', id: string, firstname?: string | null, lastname?: string | null, type?: AttendeeType | null, civility?: AttendeeCivility | null, health_type?: AttendeeHealthType | null, type_number?: TypeNumber | null, health_number?: string | null, organization_type?: AttendeeOrganizationType | null, email?: string | null, regime?: AttendeeRegime | null, phone_number?: string | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, is_present?: boolean | null, is_billed?: boolean | null, is_signed?: boolean | null, is_military?: boolean | null, state?: AttendeeStateType | null, legal_title?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, postcode?: string | null, street_name?: string | null, city?: string | null } | null, attendeeSignature?: { __typename?: 'AttendeeSignature', id: string, signature: string, hospitality: boolean } | null, createdBy?: { __typename?: 'User', id: string, full_name: string } | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }> };

export type AttendeesOnPostEventPaginationQueryVariables = Exact<{
  code: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<InputMaybe<AttendeeStateType>> | InputMaybe<AttendeeStateType>>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryAttendeesByTicketWithSignaturesPaginationOrderByRelationOrderByClause> | QueryAttendeesByTicketWithSignaturesPaginationOrderByRelationOrderByClause>;
}>;


export type AttendeesOnPostEventPaginationQuery = { __typename?: 'Query', attendeesByTicketWithSignaturesPagination: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, firstname?: string | null, lastname?: string | null, type?: AttendeeType | null, civility?: AttendeeCivility | null, health_type?: AttendeeHealthType | null, type_number?: TypeNumber | null, health_number?: string | null, organization_type?: AttendeeOrganizationType | null, email?: string | null, regime?: AttendeeRegime | null, phone_number?: string | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, is_present?: boolean | null, is_billed?: boolean | null, is_signed?: boolean | null, is_military?: boolean | null, state?: AttendeeStateType | null, legal_title?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, postcode?: string | null, street_name?: string | null, city?: string | null } | null, attendeeSignature?: { __typename?: 'AttendeeSignature', id: string, signature: string, hospitality: boolean } | null, createdBy?: { __typename?: 'User', id: string, full_name: string } | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CheckExpensesImportBatchQueryVariables = Exact<{
  input: ExpensesImportBatchInput;
}>;


export type CheckExpensesImportBatchQuery = { __typename?: 'Query', checkExpensesImportBatch: { __typename?: 'CheckExpensesImportBatch', batch_id: string, expenses_import?: { __typename?: 'ExpensesImport', id: string, state: ExpensesImportStatus, created_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null } };

export type CheckContractZipFileBatchQueryVariables = Exact<{
  input: ContractZipFileBatchInput;
}>;


export type CheckContractZipFileBatchQuery = { __typename?: 'Query', checkContractZipFileBatch: { __typename?: 'CheckContractZipFileBatch', batch_id: string, has_failed?: boolean | null, attachment?: { __typename?: 'Attachment', id: string, comment?: string | null, type?: AttachmentFileType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null } };

export type CheckContractTemplateBatchesQueryVariables = Exact<{
  input: Array<InputMaybe<CheckBatchesInput>> | InputMaybe<CheckBatchesInput>;
}>;


export type CheckContractTemplateBatchesQuery = { __typename?: 'Query', checkBatches: Array<{ __typename?: 'checkBatches', batch_id: string, attendee_id: string, contract_template_id: string, contract_attendee?: { __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null }> };

export type CommentsByTicketCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommentsByTicketCodeQuery = { __typename?: 'Query', commentsByTicketCode: { __typename?: 'CommentPaginator', data: Array<{ __typename?: 'Comment', id: string, content: string, type?: TypeOfReturn | null, ticket_id: string, ticket_step?: Step | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ContactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactQuery = { __typename?: 'Query', contact?: { __typename?: 'Contact', id: string, category?: AttendeeCategory | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone_number?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, civility?: AttendeeCivility | null, type?: AttendeeType | null, title?: AttendeeTitle | null, regime?: AttendeeRegime | null, description?: string | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, created_at?: any | null, updated_at?: any | null, assignation?: string | null, external_id?: string | null, address?: { __typename?: 'Address', id: string, name?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, city?: string | null, country?: AddressCountry | null } | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, documents?: Array<{ __typename?: 'DocumentContact', id: string, type: DocumentAttendeeTypes, contact?: { __typename?: 'Contact', id: string } | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null } | null };

export type GetContactsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AttendeeType>;
  category?: InputMaybe<AttendeeCategory>;
  health_type?: InputMaybe<AttendeeHealthType>;
  organization_type?: InputMaybe<AttendeeOrganizationType>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactPaginator', data: Array<{ __typename?: 'Contact', id: string, category?: AttendeeCategory | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone_number?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, civility?: AttendeeCivility | null, type?: AttendeeType | null, title?: AttendeeTitle | null, regime?: AttendeeRegime | null, description?: string | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, created_at?: any | null, updated_at?: any | null, assignation?: string | null, external_id?: string | null, address?: { __typename?: 'Address', id: string, name?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, city?: string | null, country?: AddressCountry | null } | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, documents?: Array<{ __typename?: 'DocumentContact', id: string, type: DocumentAttendeeTypes, contact?: { __typename?: 'Contact', id: string } | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetContactsTotalQueryVariables = Exact<{
  type?: InputMaybe<AttendeeType>;
  category?: InputMaybe<AttendeeCategory>;
  health_type?: InputMaybe<AttendeeHealthType>;
  organization_type?: InputMaybe<AttendeeOrganizationType>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContactsTotalQuery = { __typename?: 'Query', totalContacts: number };

export type ContractAndSignersQueryVariables = Exact<{
  code: Scalars['String']['input'];
  attendeeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type ContractAndSignersQuery = { __typename?: 'Query', contractAndSignersByTicketCode: Array<{ __typename?: 'ContractAndSigners', contract: { __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } }, signers: Array<{ __typename?: 'UserAndInternalSigner', id: string, email: string }> }> };

export type ContractAttendeesForReminderQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ContractAttendeesForReminderQuery = { __typename?: 'Query', contractAttendeesForReminder: { __typename?: 'ContractAttendeeForReminders', latestReminder?: any | null, contractAttendees?: Array<{ __typename?: 'ContractAttendeeForReminder', contract: { __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } }, signers: Array<{ __typename?: 'UserAndInternalSigner', id: string, email: string }> } | null> | null } };

export type AllInternalSignersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllInternalSignersQuery = { __typename?: 'Query', allInternalSigners: { __typename?: 'AllInternalSigners', validator_signers: Array<{ __typename?: 'UserKeycloakSigner', id?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }>, internal_signers: Array<{ __typename?: 'InternalSigner', id: string, firstname: string, lastname: string, executive_role?: string | null, phone?: string | null, email: string, civility?: AttendeeCivility | null, staff_id?: string | null }>, users_and_internal_signers: Array<{ __typename?: 'UserAndInternalSigner', id: string, firstname: string, lastname: string, phone?: string | null, email: string, type: ContractAttendeeSignerType }> } };

export type ContractTemplatesByTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
}>;


export type ContractTemplatesByTicketQuery = { __typename?: 'Query', contractTemplatesByTicket?: Array<{ __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null } | null> | null };

export type ContractTemplatesAllByTicketQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
}>;


export type ContractTemplatesAllByTicketQuery = { __typename?: 'Query', contractTemplatesAllByTicket?: Array<{ __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, ticket_id?: string | null } | null> | null };

export type ContractTemplatesAllWhereTicketNullQueryVariables = Exact<{
  ticket_code?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContractTemplateOrderByInput> | ContractTemplateOrderByInput>;
}>;


export type ContractTemplatesAllWhereTicketNullQuery = { __typename?: 'Query', contractTemplatesAllWhereTicketNull: { __typename?: 'ContractTemplatePaginator', data: Array<{ __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetAllContractTemplatesWhereTicketNullQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllContractTemplatesWhereTicketNullQuery = { __typename?: 'Query', getAllContractTemplatesWhereTicketNull?: Array<{ __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null } | null> | null };

export type ContractTemplateByIdQueryVariables = Exact<{
  contract_template_id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContractTemplateByIdQuery = { __typename?: 'Query', contractTemplate: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, contractTemplateDocuments: { __typename?: 'ContractTemplateDocumentPaginator', data: Array<{ __typename?: 'ContractTemplateDocument', id: string, name: string, version: number, status: ContractTemplateDocumentStatus, created_at: any, created_by?: { __typename?: 'User', id: string, full_name: string } | null, document: { __typename?: 'Document', url: string, filename: string, size: number } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } } };

export type GetConventionsQueryVariables = Exact<{
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetConventionsQuery = { __typename?: 'Query', conventionsPaginator: { __typename?: 'ConventionPaginator', data: Array<{ __typename?: 'Convention', id: string, type: ConventionType, is_active: boolean, is_manual_pack_allowed: boolean, advantages?: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null } | null> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetConventionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConventionQuery = { __typename?: 'Query', convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_active: boolean, is_manual_pack_allowed: boolean, advantages?: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null } | null> | null } | null };

export type GetAvailableConventionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableConventionsQuery = { __typename?: 'Query', availableConventions: Array<ConventionType> };

export type GetConventionsForSelectQueryVariables = Exact<{
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetConventionsForSelectQuery = { __typename?: 'Query', conventions: Array<{ __typename?: 'Convention', id: string, type: ConventionType }> };

export type CrmUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CrmUserQuery = { __typename?: 'Query', crmUser?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null };

export type CrmUsersPaginatorQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  responsibilities?: InputMaybe<Array<CrmResponsibility> | CrmResponsibility>;
}>;


export type CrmUsersPaginatorQuery = { __typename?: 'Query', crmUsersPaginator: { __typename?: 'CrmUserPaginator', data: Array<{ __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CrmUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  responsibilities?: InputMaybe<Array<CrmResponsibility> | CrmResponsibility>;
}>;


export type CrmUsersQuery = { __typename?: 'Query', crmUsers: Array<{ __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null }> };

export type CrmUserByResponsibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type CrmUserByResponsibilityQuery = { __typename?: 'Query', approvers: Array<{ __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null }>, managers: Array<{ __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null }> };

export type DeclarationsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  badge?: InputMaybe<DeclarationBadge>;
}>;


export type DeclarationsQuery = { __typename?: 'Query', declarations: { __typename?: 'DeclarationPaginator', data: Array<{ __typename?: 'Declaration', id: string, name: string, code: string, status?: DeclarationStatus | null, workflow_step?: DeclarationWorkflowStep | null, is_accepted: boolean, is_refused: boolean, is_archived: boolean, is_canceled: boolean, declaration_count: number, attendee_quantity: number, attendee_medical_types?: Array<AttendeeMedicalType | null> | null, specialties: Array<DeclarationSpecialty>, start_at: any, end_at: any, created_at: any, reference?: string | null, external_code?: string | null, advantages?: Array<{ __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, including_tax_amount: number, quantity: number, comment?: string | null, enabled: boolean, originalAdvantage: { __typename?: 'PlannedAdvantage', id: string, net_amount: number, including_tax_amount?: number | null, quantity: number, advantage_type: AdvantageType } } | null> | null, convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_manual_pack_allowed: boolean } | null, themes?: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string } | null> | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string }, address?: { __typename?: 'Address', id: string, city?: string | null, country?: AddressCountry | null } | null, tickets?: Array<{ __typename?: 'Ticket', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, deposit?: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type DeclarationsForLinksQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeclarationsForLinksQuery = { __typename?: 'Query', declarationsForLinks: Array<{ __typename?: 'Declaration', id: string, name: string, code: string }> };

export type DeclarationByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type DeclarationByCodeQuery = { __typename?: 'Query', declarationByCode: { __typename?: 'Declaration', id: string, name: string, code: string, status?: DeclarationStatus | null, workflow_step?: DeclarationWorkflowStep | null, is_accepted: boolean, is_refused: boolean, is_archived: boolean, is_canceled: boolean, declaration_count: number, attendee_quantity: number, attendee_medical_types?: Array<AttendeeMedicalType | null> | null, specialties: Array<DeclarationSpecialty>, start_at: any, end_at: any, created_at: any, reference?: string | null, external_code?: string | null, advantages?: Array<{ __typename?: 'DeclarationAdvantage', id: string, advantage_type: AdvantageType, net_amount: number, including_tax_amount: number, quantity: number, comment?: string | null, enabled: boolean, originalAdvantage: { __typename?: 'PlannedAdvantage', id: string, net_amount: number, including_tax_amount?: number | null, quantity: number, advantage_type: AdvantageType } } | null> | null, convention?: { __typename?: 'Convention', id: string, type: ConventionType, is_manual_pack_allowed: boolean } | null, themes?: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string } | null> | null, created_by: { __typename?: 'User', id: string, first_name: string, last_name: string }, address?: { __typename?: 'Address', id: string, city?: string | null, country?: AddressCountry | null } | null, tickets?: Array<{ __typename?: 'Ticket', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, deposit?: { __typename?: 'DeclarationDeposit', id: string, reference?: string | null, status?: DeclarationDepositStatus | null, url?: string | null, submission_date?: any | null, recommendation_date?: any | null, comment?: string | null } | null } };

export type DeclarationThemeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeclarationThemeQuery = { __typename?: 'Query', declarationTheme: { __typename?: 'DeclarationThemes', id: string, name: string, duration: string, declaration: { __typename?: 'Declaration', id: string } } };

export type DeclarationThemesByIdQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  declaration_id: Scalars['ID']['input'];
}>;


export type DeclarationThemesByIdQuery = { __typename?: 'Query', declarationThemesById: { __typename?: 'DeclarationThemesPaginator', data: Array<{ __typename?: 'DeclarationThemes', id: string, name: string, duration: string, declaration: { __typename?: 'Declaration', id: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type DeclarationDocumentsByIdQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  declaration_id: Scalars['ID']['input'];
}>;


export type DeclarationDocumentsByIdQuery = { __typename?: 'Query', declarationDocumentsById: { __typename?: 'DeclarationDocumentPaginator', data: Array<{ __typename?: 'DeclarationDocument', id: string, type: AttachmentFileType, comment?: string | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, declaration: { __typename?: 'Declaration', id: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type DepositByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DepositByIdQuery = { __typename?: 'Query', depositById: { __typename?: 'Deposit', id: string, reference?: string | null, regime?: AttendeeDepositRegime | null, status?: DepositStatus | null, platform?: BotDestination | null, json_filters?: Array<string | null> | null, other_category?: OtherDepositCategoryEnum | null, created_at?: any | null, ticket?: { __typename?: 'Ticket', id: string, name: string } | null, packages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string } | null> | null, submissions?: Array<{ __typename?: 'Submission', id: string, status?: SubmissionStatus | null, reference?: string | null, type?: SubmissionType | null, url?: string | null, incomplete_submission_date?: any | null, authorization_refusal_date?: any | null, recommendation_date?: any | null, acceptation_date?: any | null, complete_submission_date?: any | null, submission_date?: any | null, comment?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', first_name: string, last_name: string } | null, documents?: Array<{ __typename?: 'DocumentSubmission', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null, document_submission_type?: DocumentSubmissionTypes | null, is_from_bot?: boolean | null } | null> | null, json?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null, logs?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null } | null> | null, created_by?: { __typename?: 'User', first_name: string, last_name: string } | null } };

export type DepositsByTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
  status?: InputMaybe<Array<InputMaybe<DepositStatus>> | InputMaybe<DepositStatus>>;
}>;


export type DepositsByTicketQuery = { __typename?: 'Query', depositsByTicket?: Array<{ __typename?: 'Deposit', id: string, reference?: string | null, regime?: AttendeeDepositRegime | null, platform?: BotDestination | null, status?: DepositStatus | null, json_filters?: Array<string | null> | null, other_category?: OtherDepositCategoryEnum | null, created_at?: any | null, ticket?: { __typename?: 'Ticket', id: string, code: string, name: string } | null, packages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string } | null> | null, submissions?: Array<{ __typename?: 'Submission', id: string, status?: SubmissionStatus | null, url?: string | null, incomplete_submission_date?: any | null, authorization_refusal_date?: any | null, recommendation_date?: any | null, acceptation_date?: any | null, complete_submission_date?: any | null, comment?: string | null, created_at?: any | null, documents?: Array<{ __typename?: 'DocumentSubmission', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null> | null } | null> | null, created_by?: { __typename?: 'User', first_name: string, last_name: string } | null } | null> | null };

export type GetPackageDepositsByTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
}>;


export type GetPackageDepositsByTicketQuery = { __typename?: 'Query', packageDepositsByTicket: { __typename?: 'PackagesDepositsResponse', authorization: Array<{ __typename?: 'PlannedPackage', name: string, id: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number }> }>, declaration: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number }> }> } };

export type GetHealthTypesDepositsByTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
}>;


export type GetHealthTypesDepositsByTicketQuery = { __typename?: 'Query', healthTypesDepositByTicket?: { __typename?: 'HealthDepositResponses', healthTypes?: { __typename?: 'HealthTypesDepositResponse', declaration?: Array<AttendeeHealthType | null> | null, authorization?: Array<AttendeeHealthType | null> | null } | null, pharmacistTypes?: { __typename?: 'PharmacistTypesDepositResponse', declaration?: Array<PharmacistType | null> | null, authorization?: Array<PharmacistType | null> | null } | null, regionalHealthAgency?: { __typename?: 'OtherAttendeesDepositResponse', declarationExist: boolean, authorizationExist: boolean } | null } | null };

export type DoctorsDepositsByTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  package_id: Scalars['ID']['input'];
  regime: AttendeeDepositRegime;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryDoctorsDepositsByTicketOrderByRelationOrderByClause> | QueryDoctorsDepositsByTicketOrderByRelationOrderByClause>;
}>;


export type DoctorsDepositsByTicketQuery = { __typename?: 'Query', doctorsDepositsByTicket: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, deleted_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number }> } | null> | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', name: string, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } } | null } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AttendeesDepositsByHealthTypeAndTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  health_type?: InputMaybe<AttendeeHealthType>;
  pharmacist_type?: InputMaybe<PharmacistType>;
  regional_health_agency?: InputMaybe<Scalars['Boolean']['input']>;
  regime: AttendeeDepositRegime;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryAttendeesDepositsByHealthTypeAndTicketOrderByRelationOrderByClause> | QueryAttendeesDepositsByHealthTypeAndTicketOrderByRelationOrderByClause>;
}>;


export type AttendeesDepositsByHealthTypeAndTicketQuery = { __typename?: 'Query', attendeesDepositsByHealthTypeAndTicket: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, deleted_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number }> } | null> | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', name: string, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } } | null } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetOtherDepositCategoriesAvailableByTicketQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
}>;


export type GetOtherDepositCategoriesAvailableByTicketQuery = { __typename?: 'Query', otherDepositCategoriesAvailableByTicket?: { __typename?: 'OtherDepositCategoriesAvailableResponse', declaration: Array<OtherDepositCategoryEnum>, authorization: Array<OtherDepositCategoryEnum> } | null };

export type AttendeeByOtherCategoryAndTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  other_deposit_category: OtherDepositCategoryEnum;
  regime: AttendeeDepositRegime;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryAttendeeByOtherCategoryAndTicketOrderByRelationOrderByClause> | QueryAttendeeByOtherCategoryAndTicketOrderByRelationOrderByClause>;
}>;


export type AttendeeByOtherCategoryAndTicketQuery = { __typename?: 'Query', attendeeByOtherCategoryAndTicket: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, deleted_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', id: string, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number }> } | null> | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', name: string, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } } | null } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type DepositZipFileQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
  planned_package_id?: InputMaybe<Scalars['ID']['input']>;
  json_filter?: InputMaybe<Scalars['String']['input']>;
  regime: Scalars['String']['input'];
}>;


export type DepositZipFileQuery = { __typename?: 'Query', depositZipFile?: { __typename?: 'DepositZipFile', id: string, updated_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null };

export type TransparencyExportQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransparencyExportOrderByInput> | TransparencyExportOrderByInput>;
}>;


export type TransparencyExportQuery = { __typename?: 'Query', transparencyExportPaginator?: { __typename?: 'TransparencyExportPaginator', data: Array<{ __typename?: 'TransparencyExport', id: string, filename: string, url: string, created_at: any, publication_status?: PublicationStatus | null, from_date: any, to_date: any }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type DocumentAttendeeByTicketQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
}>;


export type DocumentAttendeeByTicketQuery = { __typename?: 'Query', documentAttendeeByTicket?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string } } | null> | null };

export type DocumentAttendeeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DocumentAttendeeQuery = { __typename?: 'Query', documentAttendee: { __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string } } };

export type HistoriesByTicketQueryVariables = Exact<{
  code: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type HistoriesByTicketQuery = { __typename?: 'Query', historiesByTicket: { __typename?: 'HistoryPaginator', data: Array<{ __typename?: 'History', id: string, type: LogType, formatted_message: string, created_at: any }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type InternalSignerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalSignerQuery = { __typename?: 'Query', internalSigner?: { __typename?: 'InternalSigner', id: string, firstname: string, lastname: string, executive_role?: string | null, phone?: string | null, email: string, civility?: AttendeeCivility | null, staff_id?: string | null } | null };

export type InternalSignersPaginatorQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InternalSignersPaginatorQuery = { __typename?: 'Query', internalSignersPaginator: { __typename?: 'InternalSignerPaginator', data: Array<{ __typename?: 'InternalSigner', id: string, firstname: string, lastname: string, executive_role?: string | null, phone?: string | null, email: string, civility?: AttendeeCivility | null, staff_id?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type InternalSignersQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalSignersQuery = { __typename?: 'Query', internalSigners: Array<{ __typename?: 'InternalSigner', id: string, firstname: string, lastname: string, executive_role?: string | null, phone?: string | null, email: string, civility?: AttendeeCivility | null, staff_id?: string | null }> };

export type NotificationsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationPaginator', data: Array<{ __typename?: 'Notification', id: string, type: NotificationType, name: string, event_types: Array<EventType>, target_state?: NotificationTargetState | null, submission_regime?: NotificationSubmissionRegime | null, date_boundary?: NotificationDateBoundary | null, day_type?: NotificationDayType | null, period?: NotificationPeriod | null, delay?: number | null, enabled: boolean, external_emails?: Array<string | null> | null, internal_emails?: Array<string | null> | null, ticket_roles_to_notify?: Array<NotificationTicketRolesToNotify | null> | null, email_object: string, email_body: string, comment?: string | null, created_by?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, operations?: Array<{ __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } | null> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type NotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NotificationQuery = { __typename?: 'Query', notification?: { __typename?: 'Notification', id: string, type: NotificationType, name: string, event_types: Array<EventType>, target_state?: NotificationTargetState | null, submission_regime?: NotificationSubmissionRegime | null, date_boundary?: NotificationDateBoundary | null, day_type?: NotificationDayType | null, period?: NotificationPeriod | null, delay?: number | null, enabled: boolean, external_emails?: Array<string | null> | null, internal_emails?: Array<string | null> | null, ticket_roles_to_notify?: Array<NotificationTicketRolesToNotify | null> | null, email_object: string, email_body: string, comment?: string | null, created_by?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, operations?: Array<{ __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> } | null> | null } | null };

export type GetOneKeysAttendeesQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOneKeysAttendeesQuery = { __typename?: 'Query', oneKeysAttendees: { __typename?: 'ApiAttendeePaginator', data: Array<{ __typename?: 'ApiAttendee', id?: string | null, civility?: string | null, firstname?: string | null, lastname?: string | null, type_number?: string | null, health_number?: string | null, health_type?: string | null, healthSpecialties?: Array<string | null> | null, external_id?: string | null, email?: string | null, phone_number?: string | null, category?: string | null, title?: AttendeeTitle | null, pharmacist_type?: string | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, description?: string | null, address?: { __typename?: 'ApiAttendeeAddress', street_name?: string | null, postcode?: string | null, city?: string | null, country?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type OperationsByEventTypesQueryVariables = Exact<{
  event_type: Array<EventType> | EventType;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperationsByEventTypesQuery = { __typename?: 'Query', operationsByEventTypes: Array<{ __typename?: 'Operation', id: string, name: string, mandatory_attachments?: boolean | null, enabled: boolean, is_publication_allowed: boolean }> };

export type OperationsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OperationsQuery = { __typename?: 'Query', operations: { __typename?: 'OperationPaginator', data: Array<{ __typename?: 'Operation', id: string, name: string, donation_type?: DonationType | null, operation_type_transparency?: OperationTypeTransparency | null, operation_type_eps?: OperationTypeEps | null, operation_type_idahe?: OperationTypeIdahe | null, idahe_convention?: OperationConventionIdahe | null, idahe_typology?: OperationTypologyIdahe | null, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, plannedPackageIds: Array<string>, actualPackageIds: Array<string>, contractTemplateIds: Array<string>, attachmentIds: Array<string>, created_at?: any | null, updated_at?: any | null, enabled: boolean, is_publication_allowed: boolean, eventTypes: Array<{ __typename?: 'OperationEventType', event_type: EventType }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type PlannedPackagesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlannedPackagesQuery = { __typename?: 'Query', plannedPackages: { __typename?: 'PlannedPackagePaginator', data: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }>, ticket?: { __typename?: 'Ticket', id: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type PlannedPackageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlannedPackageQuery = { __typename?: 'Query', plannedPackage?: { __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }>, ticket?: { __typename?: 'Ticket', id: string } | null } | null };

export type AllPlannedPackagesQueryVariables = Exact<{
  ticket_code?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllPlannedPackagesQuery = { __typename?: 'Query', allPlannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }>, ticket?: { __typename?: 'Ticket', id: string } | null }> | null };

export type AssignedPlannedPackagesByTicketQueryVariables = Exact<{
  ticket_code?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssignedPlannedPackagesByTicketQuery = { __typename?: 'Query', assignedPlannedPackagesByTicket?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }>, ticket?: { __typename?: 'Ticket', id: string } | null }> | null };

export type ProductsQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null };

export type RegionsQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegionsQuery = { __typename?: 'Query', regions: { __typename?: 'RegionPaginator', data: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type RegionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RegionQuery = { __typename?: 'Query', region?: { __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null };

export type SectorsQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SectorsQuery = { __typename?: 'Query', sectors: { __typename?: 'SectorPaginator', data: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type SectorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SectorQuery = { __typename?: 'Query', sector?: { __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null };

export type WatchdogsSettingsQueryVariables = Exact<{
  type: Array<SettingsType> | SettingsType;
}>;


export type WatchdogsSettingsQuery = { __typename?: 'Query', settingsByType: Array<{ __typename?: 'Settings', is_active: boolean, type: SettingsType, data?: { __typename?: 'Data', operation_ids?: Array<string | null> | null, ticket_deadline_days?: number | null, ticket_deadline_work_days?: number | null } | null }> };

export type YouSignAuthentificationSettingQueryVariables = Exact<{
  type: SettingsType;
}>;


export type YouSignAuthentificationSettingQuery = { __typename?: 'Query', settingByType?: { __typename?: 'Settings', is_active: boolean, type: SettingsType, data?: { __typename?: 'Data', authentication_mode?: YouSignAuthenticationMode | null } | null } | null };

export type YouSignReminderSettingQueryVariables = Exact<{
  type: SettingsType;
}>;


export type YouSignReminderSettingQuery = { __typename?: 'Query', settingByType?: { __typename?: 'Settings', is_active: boolean, type: SettingsType, data?: { __typename?: 'Data', max_occurrences?: number | null, interval_in_days?: IntervalInDays | null } | null } | null };

export type YouSignWorkspaceSettingQueryVariables = Exact<{
  type: SettingsType;
}>;


export type YouSignWorkspaceSettingQuery = { __typename?: 'Query', settingByType?: { __typename?: 'Settings', is_active: boolean, type: SettingsType, data?: { __typename?: 'Data', workspace_id?: string | null, custom_experience_id?: string | null } | null } | null };

export type UpsellSettingsQueryVariables = Exact<{
  type: Array<SettingsType> | SettingsType;
}>;


export type UpsellSettingsQuery = { __typename?: 'Query', settingsByType: Array<{ __typename?: 'Settings', is_active: boolean, type: SettingsType }> };

export type UpsellSettingQueryVariables = Exact<{
  type: SettingsType;
}>;


export type UpsellSettingQuery = { __typename?: 'Query', settingByType?: { __typename?: 'Settings', is_active: boolean, type: SettingsType } | null };

export type CustomPermissionsSettingQueryVariables = Exact<{
  type?: InputMaybe<SettingsType>;
}>;


export type CustomPermissionsSettingQuery = { __typename?: 'Query', settingByType?: { __typename?: 'Settings', is_active: boolean, type: SettingsType } | null };

export type RouterSettingsQueryVariables = Exact<{
  type: Array<SettingsType> | SettingsType;
}>;


export type RouterSettingsQuery = { __typename?: 'Query', settingsByType: Array<{ __typename?: 'Settings', is_active: boolean, type: SettingsType }> };

export type ManuallySignedSheetQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ManuallySignedSheetQuery = { __typename?: 'Query', ticketByCode: { __typename?: 'Ticket', id: string, name: string, workflow_step?: Step | null, signingSheets?: Array<{ __typename?: 'SigningSheet', name: string, id: string, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null } };

export type SpecialtiesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SpecialtiesQuery = { __typename?: 'Query', specialties: { __typename?: 'SpecialtyPaginator', data: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetAllSpecialtiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSpecialtiesQuery = { __typename?: 'Query', getAllSpecialties: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null }> };

export type SpecialtyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SpecialtyQuery = { __typename?: 'Query', specialty?: { __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null };

export type SubmissionQueryVariables = Exact<{
  submission_id?: InputMaybe<Scalars['ID']['input']>;
  deposit_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SubmissionQuery = { __typename?: 'Query', submission: { __typename?: 'Submission', id: string, reference?: string | null, status?: SubmissionStatus | null, url?: string | null, type?: SubmissionType | null, created_at?: any | null, incomplete_submission_date?: any | null, authorization_refusal_date?: any | null, recommendation_date?: any | null, acceptation_date?: any | null, complete_submission_date?: any | null, submission_date?: any | null, comment?: string | null, attendees: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }>, documents?: Array<{ __typename?: 'DocumentSubmission', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null, document_submission_type?: DocumentSubmissionTypes | null, is_from_bot?: boolean | null, additional_information?: string | null } | null> | null, json?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null, logs?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null } };

export type TherapeuticAreasQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TherapeuticAreasQuery = { __typename?: 'Query', therapeuticAreas: { __typename?: 'TherapeuticAreaPaginator', data: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type TherapeuticAreaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TherapeuticAreaQuery = { __typename?: 'Query', therapeuticArea?: { __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null };

export type TicketsOnTransparencyPageQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  name?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  external_code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  submission_regime?: InputMaybe<Array<TicketSubmissionRegime> | TicketSubmissionRegime>;
  event_type?: InputMaybe<Array<EventType> | EventType>;
  operation_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  created_by_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']> | Scalars['DateTimeUtc']['input']>;
  initiator_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_1_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_2_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  crm_manager?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  filter_type: FilterAvailable;
  units?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  therapeuticAreas?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sectors?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  products?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  networks?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  zones?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  regions?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  identities?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TicketsOnTransparencyPageQuery = { __typename?: 'Query', ticketsManagement: { __typename?: 'TicketPaginator', data: Array<{ __typename?: 'Ticket', id: string, name: string, event_type: EventType, start_at: any, end_at?: any | null, code: string, created_at?: any | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, initiator?: { __typename?: 'User', full_name: string, first_name: string, last_name: string } | null, validator_1?: { __typename?: 'User', first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', first_name: string, last_name: string } | null, createdBy: { __typename?: 'User', full_name: string, first_name: string, last_name: string, avatar?: string | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type TicketsOnLibraryPageQueryVariables = Exact<{
  name?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  external_code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  submission_regime?: InputMaybe<Array<TicketSubmissionRegime> | TicketSubmissionRegime>;
  event_type?: InputMaybe<Array<EventType> | EventType>;
  operation_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  created_by_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']> | Scalars['DateTimeUtc']['input']>;
  initiator_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_1_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_2_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  crm_manager?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  filter_type: FilterAvailable;
  status?: InputMaybe<Array<Status> | Status>;
  statusFilterLibrary?: InputMaybe<Array<StatusFilterLibrary> | StatusFilterLibrary>;
  contractor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  units?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  therapeuticAreas?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sectors?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  products?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  networks?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  zones?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  regions?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  identities?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TicketsOnLibraryPageQuery = { __typename?: 'Query', ticketsManagement: { __typename?: 'TicketPaginator', data: Array<{ __typename?: 'Ticket', id: string, name: string, event_type: EventType, start_at: any, end_at?: any | null, code: string, created_at?: any | null, status?: Status | null, is_archived?: boolean | null, is_published?: boolean | null, initiator?: { __typename?: 'User', full_name: string, first_name: string, last_name: string } | null, validator_1?: { __typename?: 'User', first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', first_name: string, last_name: string } | null, createdBy: { __typename?: 'User', full_name: string, first_name: string, last_name: string, avatar?: string | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type FilteredTicketsForDashboardListQueryVariables = Exact<{
  name?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  external_code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_type?: InputMaybe<Array<EventType> | EventType>;
  submission_regime?: InputMaybe<Array<TicketSubmissionRegime> | TicketSubmissionRegime>;
  operation_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  created_by_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']> | Scalars['DateTimeUtc']['input']>;
  initiator_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_1_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_2_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  crm_manager?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  filter_type: FilterAvailable;
  status?: InputMaybe<Array<Status> | Status>;
  workflow_step?: InputMaybe<Array<Step> | Step>;
  contractor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  units?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  therapeuticAreas?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sectors?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  products?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  networks?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  zones?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  regions?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  identities?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<TicketManagementOrderByInput> | TicketManagementOrderByInput>;
}>;


export type FilteredTicketsForDashboardListQuery = { __typename?: 'Query', ticketsManagement: { __typename?: 'TicketPaginator', data: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type TicketsPaginatorQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TicketsPaginatorQuery = { __typename?: 'Query', ticketsPaginator: { __typename?: 'TicketPaginator', data: Array<{ __typename?: 'Ticket', id: string, name: string, description?: string | null, place?: string | null, code: string, external_code?: string | null, status?: Status | null, workflow_step?: Step | null, event_type: EventType, event_specialty?: TicketSpecialty | null, quantity: number, start_at: any, end_at?: any | null, created_at?: any | null, is_declared?: boolean | null, is_archived?: boolean | null, is_published?: boolean | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, with_agency?: boolean | null, agency_name?: string | null, format?: Format | null, meeting_type?: MeetingType | null, is_package_creation_allowed: boolean, address: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null }, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, attendees: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }> }, createdBy: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, validator_1?: { __typename?: 'User', id: string, full_name: string } | null, validator_2?: { __typename?: 'User', id: string, full_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, enabled: boolean, is_publication_allowed: boolean } | null, nonCompliances: Array<{ __typename?: 'NonCompliance', id: string, ticket_id: string }>, linkedTickets?: Array<{ __typename?: 'Ticket', id: string, name: string, event_type: EventType } | null> | null, declaration?: { __typename?: 'Declaration', id: string, name: string } | null, allocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, approverCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type DashboardTicketByStepAndStatusQueryVariables = Exact<{
  name?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  external_code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_type?: InputMaybe<Array<EventType> | EventType>;
  submission_regime?: InputMaybe<Array<TicketSubmissionRegime> | TicketSubmissionRegime>;
  operation_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  created_by_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']> | Scalars['DateTimeUtc']['input']>;
  initiator_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_1_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_2_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  crm_manager?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter_type: FilterAvailable;
  contractor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  units?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  therapeuticAreas?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sectors?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  products?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  networks?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  zones?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  regions?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  identities?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  pagination: TicketsGroupedByStepOrStatusPaginationInput;
}>;


export type DashboardTicketByStepAndStatusQuery = { __typename?: 'Query', ticketsGroupedByStepOrStatus: { __typename?: 'TicketsGroupedByStepOrStatusPaginator', data: { __typename?: 'TicketsGroupedByStepOrStatus', CREATING: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, FIRST_VALIDATION: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, SECOND_VALIDATION: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, TO_EDIT: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, CONTRACT_MANAGEMENT: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_IN_PROGRESS: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_VALIDATING: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_IS_FINISHED: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } }, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type DashboardTicketByStepAndStatusAdminQueryVariables = Exact<{
  name?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  external_code?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_type?: InputMaybe<Array<EventType> | EventType>;
  submission_regime?: InputMaybe<Array<TicketSubmissionRegime> | TicketSubmissionRegime>;
  operation_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  created_by_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  date_range?: InputMaybe<Array<Scalars['DateTimeUtc']['input']> | Scalars['DateTimeUtc']['input']>;
  initiator_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_1_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  validator_2_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  crm_manager?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter_type: FilterAvailable;
  contractor?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  units?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  therapeuticAreas?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sectors?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  products?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  networks?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  zones?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  regions?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  identities?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  pagination: TicketsGroupedByStepOrStatusPaginationInput;
}>;


export type DashboardTicketByStepAndStatusAdminQuery = { __typename?: 'Query', ticketsGroupedByStepOrStatus: { __typename?: 'TicketsGroupedByStepOrStatusPaginator', data: { __typename?: 'TicketsGroupedByStepOrStatus', CREATING: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, FIRST_VALIDATION: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, SECOND_VALIDATION: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, TO_EDIT: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, CONTRACT_MANAGEMENT: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_IN_PROGRESS: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_VALIDATING: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, EVENT_IS_FINISHED: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } }, LIBRARY?: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null, TRANSPARENCY?: { __typename?: 'TicketGroupedByStepOrStatus', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null } | null>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null }, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type FilterTicketsOptionsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  filter_type: FilterAvailable;
}>;


export type FilterTicketsOptionsQuery = { __typename?: 'Query', filterTicketsOptions: Array<{ __typename?: 'Ticket', id: string, name: string }> };

export type FilterTicketCodeOptionsQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
  filter_type: FilterAvailable;
}>;


export type FilterTicketCodeOptionsQuery = { __typename?: 'Query', filterTicketCodeOptions: Array<{ __typename?: 'Ticket', id: string, code: string }> };

export type FilterTicketExternalCodeOptionsQueryVariables = Exact<{
  external_code?: InputMaybe<Scalars['String']['input']>;
  filter_type: FilterAvailable;
}>;


export type FilterTicketExternalCodeOptionsQuery = { __typename?: 'Query', filterTicketExternalCodeOptions: Array<{ __typename?: 'Ticket', id: string, external_code?: string | null }> };

export type FilterCrmManagerOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilterCrmManagerOptionsQuery = { __typename?: 'Query', filterCrmManagerOptions: Array<{ __typename?: 'CrmUser', id: string, firstname: string, lastname: string, deleted_at?: any | null }> };

export type FilterContractorOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter_type: FilterAvailable;
}>;


export type FilterContractorOptionsQuery = { __typename?: 'Query', filterContractorOptions: Array<{ __typename?: 'Attendee', id: string, firstname?: string | null, lastname?: string | null }> };

export type FilterAllRestrictedAreasOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterAllRestrictedAreasOptionsQuery = { __typename?: 'Query', filterAllRestrictedAreasOptions?: { __typename?: 'RestrictedAreasResult', units: Array<{ __typename?: 'Unit', id: string, name?: string | null }>, products: Array<{ __typename?: 'Product', id: string, name?: string | null }>, sectors: Array<{ __typename?: 'Sector', id: string, name?: string | null }>, therapeuticAreas: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null }>, networks: Array<{ __typename?: 'Network', id: string, name?: string | null }>, zones: Array<{ __typename?: 'Zone', id: string, name?: string | null }>, regions: Array<{ __typename?: 'Region', id: string, name?: string | null }>, identities: Array<{ __typename?: 'Identity', id: string, name?: string | null }> } | null };

export type FilterRestrictedAreaOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  area: RestrictedAreas;
}>;


export type FilterRestrictedAreaOptionsQuery = { __typename?: 'Query', filterRestrictedAreaOptions: Array<
    | { __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null }
    | { __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null }
    | { __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null }
    | { __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null }
    | { __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null }
    | { __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null }
    | { __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null }
    | { __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null }
    | { __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null }
  > };

export type DashboardTicketsQueryVariables = Exact<{
  is_declared: Scalars['Boolean']['input'];
  is_archived: Scalars['Boolean']['input'];
}>;


export type DashboardTicketsQuery = { __typename?: 'Query', ticketsDashboard: Array<{ __typename?: 'Ticket', id: string, code: string, status?: Status | null, name: string, event_type: EventType, start_at: any, end_at?: any | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null, created_at?: any | null, contractor?: string | null, remainingDays?: number | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, isTicketInitiatedByUser: boolean, contracts?: { __typename?: 'TicketContractsStats', eligible_attendees_count: number, signed_contracts: number, generated_contracts: number } | null, deposits?: { __typename?: 'TicketDepositsStats', eligible_deposits_count: number, deposit_sent: number } | null, createdBy: { __typename?: 'User', id: string, full_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string } | null, validator_1?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', id: string, first_name: string, last_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string } | null }> };

export type LibraryTicketsQueryVariables = Exact<{
  is_declared: Scalars['Boolean']['input'];
  is_archived: Scalars['Boolean']['input'];
}>;


export type LibraryTicketsQuery = { __typename?: 'Query', ticketsDashboard: Array<{ __typename?: 'Ticket', id: string, name: string, code: string, start_at: any, end_at?: any | null, event_type: EventType, created_at?: any | null, status?: Status | null, is_archived?: boolean | null, is_published?: boolean | null, initiator?: { __typename?: 'User', full_name: string } | null, validator_1?: { __typename?: 'User', first_name: string, last_name: string } | null, validator_2?: { __typename?: 'User', first_name: string, last_name: string } | null, createdBy: { __typename?: 'User', first_name: string, last_name: string, full_name: string } }> };

export type TicketOnInfosPageQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TicketOnInfosPageQuery = { __typename?: 'Query', ticketByCode: { __typename?: 'Ticket', id: string, code: string, external_code?: string | null, name: string, quantity: number, start_at: any, end_at?: any | null, event_type: EventType, description?: string | null, workflow_step?: Step | null, event_specialty?: TicketSpecialty | null, place?: string | null, is_archived?: boolean | null, is_published?: boolean | null, created_at?: any | null, with_agency?: boolean | null, agency_name?: string | null, format?: Format | null, meeting_type?: MeetingType | null, operation?: { __typename?: 'Operation', id: string, name: string, is_publication_allowed: boolean } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, comment?: string | null, type?: AttachmentFileType | null, document: { __typename?: 'Document', url: string, filename: string } }> | null, workflow?: { __typename?: 'Workflow', name: string } | null, initiator?: { __typename?: 'User', full_name: string } | null, validator_1?: { __typename?: 'User', full_name: string } | null, validator_2?: { __typename?: 'User', full_name: string } | null, address: { __typename?: 'Address', street_name?: string | null, postcode?: string | null, city?: string | null, country?: AddressCountry | null }, linkedTickets?: Array<{ __typename?: 'Ticket', id: string, code: string, name: string, event_type: EventType } | null> | null, declaration?: { __typename?: 'Declaration', id: string, code: string, name: string } | null, createdBy: { __typename?: 'User', full_name: string }, attendees: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }> }, allocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, approverCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, originalTicketInfo?: { __typename?: 'OriginalTicketInfo', code: string, name: string } | null } };

export type TicketOnPostEventQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TicketOnPostEventQuery = { __typename?: 'Query', ticketByCode: { __typename?: 'Ticket', id: string, attendees: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, type?: AttendeeType | null, civility?: AttendeeCivility | null, health_type?: AttendeeHealthType | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, email?: string | null, regime?: AttendeeRegime | null, category?: AttendeeCategory | null, is_present?: boolean | null, is_billed?: boolean | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, address?: { __typename?: 'Address', postcode?: string | null, street_name?: string | null, city?: string | null } | null }> } } };

export type TicketOnExpensesQueryVariables = Exact<{
  code: Scalars['String']['input'];
  expenseReportsOrderBy?: InputMaybe<Array<TicketExpenseReportsOrderByOrderByClause> | TicketExpenseReportsOrderByOrderByClause>;
}>;


export type TicketOnExpensesQuery = { __typename?: 'Query', ticketByCode: { __typename?: 'Ticket', id: string, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string, name: string, reference?: string | null, document: { __typename?: 'Document', url: string, filename: string } }> } };

export type TicketOnSigningSheetQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TicketOnSigningSheetQuery = { __typename?: 'Query', attendeesByTicketWithSignatures: Array<{ __typename?: 'Attendee', id: string, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, is_signed?: boolean | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null }> };

export type TicketsForLinksQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type TicketsForLinksQuery = { __typename?: 'Query', ticketsForLinks?: { __typename?: 'TicketsForLinks', undeclared_events?: Array<{ __typename?: 'Ticket', id: string, name: string, code: string } | null> | null, simple_events?: Array<{ __typename?: 'Ticket', id: string, name: string, code: string } | null> | null, contracts?: Array<{ __typename?: 'Ticket', id: string, name: string, code: string } | null> | null, events?: Array<{ __typename?: 'Ticket', id: string, name: string, code: string } | null> | null } | null };

export type PlannedPackagesByTicketQueryVariables = Exact<{
  ticketID: Scalars['ID']['input'];
}>;


export type PlannedPackagesByTicketQuery = { __typename?: 'Query', plannedPackagesByTicket: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'PlannedAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, detail?: string | null, comment?: string | null, area?: string | null, quantity: number }> }> };

export type ActualPackagesByTicketQueryVariables = Exact<{
  ticketCode: Scalars['String']['input'];
  source?: InputMaybe<SourceEnum>;
}>;


export type ActualPackagesByTicketQuery = { __typename?: 'Query', actualPackagesByTicket: Array<{ __typename?: 'ActualPackage', id: string, name: string, source?: string | null, is_distribution?: boolean | null, created_at?: any | null, updated_at?: any | null, advantages: Array<{ __typename?: 'ActualAdvantage', advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, detail?: string | null, comment?: string | null, area?: string | null, quantity: number, payment_date?: any | null }> }> };

export type AdvantagesAmountsByTicketCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type AdvantagesAmountsByTicketCodeQuery = { __typename?: 'Query', advantagesAmountsByTicketCode: { __typename?: 'AdvantageDynamicAmounts', actual?: number | null, gap?: number | null, planned?: number | null } };

export type TicketsOnAdminManagementPageQueryVariables = Exact<{ [key: string]: never; }>;


export type TicketsOnAdminManagementPageQuery = { __typename?: 'Query', tickets: Array<{ __typename?: 'Ticket', id: string, code: string, name: string, external_code?: string | null, status?: Status | null, workflow_step?: Step | null, is_archived?: boolean | null, is_declared?: boolean | null }> };

export type SimpleEventsByDeclarationCodeQueryVariables = Exact<{
  declaration_code: Scalars['String']['input'];
  ticket_badge?: InputMaybe<TicketBadge>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<TicketByDeclarationCodeOrderByInput> | TicketByDeclarationCodeOrderByInput>;
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type SimpleEventsByDeclarationCodeQuery = { __typename?: 'Query', ticketsByDeclarationCode: { __typename?: 'TicketPaginator', data: Array<{ __typename?: 'Ticket', ticketBadge?: TicketBadge | null, doctors_count?: number | null, present_doctors_count?: number | null, doctor_list_status?: DoctorListStatus | null, is_doctor_list_status_editable?: boolean | null, id: string, name: string, description?: string | null, place?: string | null, code: string, external_code?: string | null, status?: Status | null, workflow_step?: Step | null, event_type: EventType, event_specialty?: TicketSpecialty | null, quantity: number, start_at: any, end_at?: any | null, created_at?: any | null, is_declared?: boolean | null, is_archived?: boolean | null, is_published?: boolean | null, advantages_completed: boolean, advantages_validated: boolean, submission_regime: TicketSubmissionRegime, with_agency?: boolean | null, agency_name?: string | null, format?: Format | null, meeting_type?: MeetingType | null, is_package_creation_allowed: boolean, address: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null }, workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null, signingSheets?: Array<{ __typename?: 'SigningSheet', id: string } | null> | null, expenseReports: Array<{ __typename?: 'ExpenseReport', id: string }>, attendees: { __typename?: 'AttendeePaginator', data: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }> }, createdBy: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string }, initiator?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email: string } | null, validator_1?: { __typename?: 'User', id: string, full_name: string } | null, validator_2?: { __typename?: 'User', id: string, full_name: string } | null, operation?: { __typename?: 'Operation', id: string, name: string, mandatory_planned_packages?: boolean | null, mandatory_actual_packages?: boolean | null, mandatory_contract_templates?: boolean | null, mandatory_attachments?: boolean | null, enabled: boolean, is_publication_allowed: boolean } | null, nonCompliances: Array<{ __typename?: 'NonCompliance', id: string, ticket_id: string }>, linkedTickets?: Array<{ __typename?: 'Ticket', id: string, name: string, event_type: EventType } | null> | null, declaration?: { __typename?: 'Declaration', id: string, name: string } | null, allocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null, managerCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null, approverCrm?: { __typename?: 'CrmUser', id: string, firstname: string, lastname: string, email: string, staff_id?: string | null, responsibilities: Array<CrmResponsibility>, post_title?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type HasValidEmailsQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
}>;


export type HasValidEmailsQuery = { __typename?: 'Query', hasValidEmails: boolean };

export type DepositsListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  ticket_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ticket_code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ticket_event_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ticket_operation_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ticket_initiator_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  ticket_start_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  ticket_end_at?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  ticket_submission_regime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ticket_workflow_step_or_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  submission_reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<DepositStatus>> | InputMaybe<DepositStatus>>;
}>;


export type DepositsListQuery = { __typename?: 'Query', deposits: { __typename?: 'DepositPaginator', data: Array<{ __typename?: 'Deposit', id: string, reference?: string | null, status?: DepositStatus | null, json_filters?: Array<string | null> | null, platform?: BotDestination | null, other_category?: OtherDepositCategoryEnum | null, ticket?: { __typename?: 'Ticket', id: string, code: string, name: string, start_at: any, end_at?: any | null, submission_regime: TicketSubmissionRegime, workflow_step?: Step | null, status?: Status | null, remainingDays?: number | null, operation?: { __typename?: 'Operation', id: string, name: string } | null } | null, submissions?: Array<{ __typename?: 'Submission', id: string, status?: SubmissionStatus | null, url?: string | null } | null> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type FilterDepositOptionsQueryVariables = Exact<{
  ticket_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ticket_code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type FilterDepositOptionsQuery = { __typename?: 'Query', filterDepositOptions?: Array<{ __typename?: 'DepositFilterOption', ticket_id: string, ticket_name: string, ticket_code: string }> | null };

export type DepositNotValidatedQueryVariables = Exact<{
  ticket_id: Scalars['ID']['input'];
}>;


export type DepositNotValidatedQuery = { __typename?: 'Query', depositNotValidated: { __typename?: 'DepositNotValidatedAndUnsignedContractResponse', deposit_count: number, deposit_lines: Array<string>, contract_count: number, contract_lines: Array<string> } };

export type TicketAttendeeImportQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TicketAttendeeImportQuery = { __typename?: 'Query', ticketAttendeeImports: { __typename?: 'TicketAttendeeImportPaginator', data: Array<{ __typename?: 'TicketAttendeeImport', id: string, status?: AttendeeImportStatusEnum | null, created_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type AuthTicketPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthTicketPermissionsQuery = { __typename?: 'Query', myTicketPermissions: Array<{ __typename?: 'AuthTicketPermissions', lifecycle_key: TicketLifecycleKey, permissions: Array<TicketPermission> }> };

export type UnitsQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UnitsQuery = { __typename?: 'Query', units: { __typename?: 'UnitPaginator', data: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type UnitQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnitQuery = { __typename?: 'Query', unit?: { __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null };

export type GetUserValidatorsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserValidatorsQuery = { __typename?: 'Query', getValidatorsFromUser?: { __typename?: 'UserValidators', first_validators?: Array<string | null> | null, second_validators?: Array<string | null> | null } | null };

export type GetDynamicUsersByRoleListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UserRoles> | UserRoles>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDynamicUsersByRoleListQuery = { __typename?: 'Query', getDynamicUsersByRoleList: { __typename?: 'UsersByRoleList', initiators?: Array<{ __typename?: 'User', id: string, keycloak_id: string, first_name: string, last_name: string, full_name: string, email: string, enabled: boolean }> | null, validators_1?: Array<{ __typename?: 'User', id: string, keycloak_id: string, first_name: string, last_name: string, full_name: string, email: string, enabled: boolean }> | null, validators_2?: Array<{ __typename?: 'User', id: string, keycloak_id: string, first_name: string, last_name: string, full_name: string, email: string, enabled: boolean }> | null } };

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersQuery = { __typename?: 'Query', usersForTags: Array<{ __typename?: 'User', id: string, email: string, first_name: string, last_name: string, full_name: string }> };

export type UserFindOneQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserFindOneQuery = { __typename?: 'Query', userFindOne: { __typename?: 'UserKeycloak', id?: string | null, firstName?: string | null, lastName?: string | null, staff_id?: string | null, email?: string | null, enabled?: boolean | null, attributes?: { __typename?: 'UserAttributesKeycloak', phone?: Array<string | null> | null, eps_login?: Array<string | null> | null, eps_password?: boolean | null, idahe_login?: Array<string | null> | null, idahe_password?: boolean | null } | null, allocations?: { __typename?: 'Allocations', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, enabled?: boolean | null } | null> | null, sectors?: Array<{ __typename?: 'Sector', id: string, name?: string | null, enabled?: boolean | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name?: string | null, enabled?: boolean | null } | null> | null, therapeuticAreas?: Array<{ __typename?: 'TherapeuticArea', id: string, name?: string | null, enabled?: boolean | null } | null> | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, enabled?: boolean | null } | null> | null, networks?: Array<{ __typename?: 'Network', id: string, name?: string | null, enabled?: boolean | null } | null> | null, ugas?: Array<{ __typename?: 'Uga', id: string, name?: string | null, enabled?: boolean | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, enabled?: boolean | null } | null> | null, identities?: Array<{ __typename?: 'Identity', id: string, name?: string | null, enabled?: boolean | null } | null> | null } | null } };

export type GetUserCreatorByTicketCodeQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
}>;


export type GetUserCreatorByTicketCodeQuery = { __typename?: 'Query', getUserCreatorByTicketCode: Array<{ __typename?: 'User', id: string, full_name: string }> };

export type GetUserInviterByTicketCodeQueryVariables = Exact<{
  ticket_code: Scalars['String']['input'];
}>;


export type GetUserInviterByTicketCodeQuery = { __typename?: 'Query', getUserInviterByTicketCode: Array<{ __typename?: 'User', id: string, full_name: string }> };

export type UsersListAllQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type UsersListAllQuery = { __typename?: 'Query', usersListAll: { __typename?: 'UsersListAllPaginator', data: Array<{ __typename?: 'UserKeycloak', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, enabled?: boolean | null, attributes?: { __typename?: 'UserAttributesKeycloak', phone?: Array<string | null> | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetVeevaAttendeesQueryVariables = Exact<{
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  health_number?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  legal_title?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVeevaAttendeesQuery = { __typename?: 'Query', veevaAttendees: { __typename?: 'ApiAttendeePaginator', data: Array<{ __typename?: 'ApiAttendee', id?: string | null, civility?: string | null, firstname?: string | null, lastname?: string | null, title?: AttendeeTitle | null, regime?: AttendeeRegime | null, activity?: Activity | null, type_number?: string | null, health_number?: string | null, health_type?: string | null, healthSpecialties?: Array<string | null> | null, legal_title?: string | null, description?: string | null, organization_type?: AttendeeOrganizationType | null, category?: string | null, external_id?: string | null, email?: string | null, phone_number?: string | null, pharmacist_type?: string | null, address?: { __typename?: 'ApiAttendeeAddress', street_name?: string | null, postcode?: string | null, city?: string | null, country?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetWatchdogsSettingsQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetWatchdogsSettingsQuery = { __typename?: 'Query', watchdogMessages?: Array<{ __typename?: 'WatchdogMessage', title: string, type: ToastType, list?: Array<string> | null, count?: number | null }> | null };

export type WorkflowByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkflowByIdQuery = { __typename?: 'Query', workflow?: { __typename?: 'Workflow', id: string, name: string, description?: string | null, steps: Array<{ __typename?: 'WorkflowStep', step: Step, roles: { __typename?: 'Role', READ?: Array<string | null> | null, WRITE?: Array<string | null> | null, REVIEW?: Array<string | null> | null } }>, eventTypes: Array<{ __typename?: 'WorkflowEventType', event_type: EventType }> } | null };

export type WorkflowsByEventTypeQueryVariables = Exact<{
  eventType: EventType;
}>;


export type WorkflowsByEventTypeQuery = { __typename?: 'Query', workflowsByEventType: Array<{ __typename?: 'Workflow', id: string, name: string }> };

export type AvailableWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableWorkflowsQuery = { __typename?: 'Query', availableWorkflows: { __typename?: 'AvailableSteps', steps: Array<string> } };

export type EpsDepositProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type EpsDepositProgressSubscription = { __typename?: 'Subscription', epsDepositProgress?: { __typename?: 'BatchProgress', status: BroadCastsStatusEnum, message: string, params?: { __typename?: 'BatchProgressParams', batch_id?: string | null, progress?: number | null, total?: number | null, processed?: number | null, failed_count?: number | null, ticket_code?: string | null } | null } | null };

export type GenerateExpensesImportTemplateProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GenerateExpensesImportTemplateProgressSubscription = { __typename?: 'Subscription', generateExpensesImportTemplateProgress?: { __typename?: 'GenerateExpensesImportTemplateProgress', status: BroadCastsStatusEnum, message: string, expensesImportTemplate?: { __typename?: 'ExpensesImportTemplate', id: string, updated_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null } | null };

export type ProcessExpensesImportProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ProcessExpensesImportProgressSubscription = { __typename?: 'Subscription', processExpensesImportProgress?: { __typename?: 'ProcessExpensesImportProgress', status: BroadCastsStatusEnum, message: string, expensesImportTemplate?: { __typename?: 'ExpensesImportTemplate', id: string, updated_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null } | null };

export type GenerateContractZipFileProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GenerateContractZipFileProgressSubscription = { __typename?: 'Subscription', generateContractZipFileProgress?: { __typename?: 'GenerateContractZipFileProgress', status: BroadCastsStatusEnum, message: string, attachment?: { __typename?: 'Attachment', id: string, comment?: string | null, type?: AttachmentFileType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null } | null };

export type GenerateAgencyExportProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GenerateAgencyExportProgressSubscription = { __typename?: 'Subscription', generateAgencyExportProgress?: { __typename?: 'GenerateAgencyExportProgress', status: BroadCastsStatusEnum, message: string, agencyExport?: { __typename?: 'AgencyExport', id: string, updated_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null } | null };

export type GenerateDepositZipFileProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GenerateDepositZipFileProgressSubscription = { __typename?: 'Subscription', generateDepositZipFileProgress?: { __typename?: 'GenerateDepositZipFileProgress', status: BroadCastsStatusEnum, message: string, params?: { __typename?: 'GenerateDepositZipFileParams', ticket_id: string, planned_package_id?: string | null, json_filter?: string | null, regime: AttendeeDepositRegime } | null, depositZipFile?: { __typename?: 'DepositZipFile', id: string, updated_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null } | null };

export type GenerateManualAttachmentsProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GenerateManualAttachmentsProgressSubscription = { __typename?: 'Subscription', generateManualAttachmentsProgress?: { __typename?: 'GenerateManualAttachmentsProgress', status: BroadCastsStatusEnum, message: string, params?: { __typename?: 'GenerateManualAttachmentsParams', deposit_id: string } | null, submission?: { __typename?: 'Submission', id: string, reference?: string | null, status?: SubmissionStatus | null, url?: string | null, type?: SubmissionType | null, created_at?: any | null, incomplete_submission_date?: any | null, authorization_refusal_date?: any | null, recommendation_date?: any | null, acceptation_date?: any | null, complete_submission_date?: any | null, submission_date?: any | null, comment?: string | null, attendees: Array<{ __typename?: 'Attendee', id: string, civility?: AttendeeCivility | null, type?: AttendeeType | null, category?: AttendeeCategory | null, title?: AttendeeTitle | null, firstname?: string | null, lastname?: string | null, type_number?: TypeNumber | null, health_number?: string | null, health_type?: AttendeeHealthType | null, pharmacist_type?: PharmacistType | null, regime?: AttendeeRegime | null, email?: string | null, phone_number?: string | null, description?: string | null, external_id?: string | null, is_present?: boolean | null, is_billed?: boolean | null, is_threshold_reached?: boolean | null, is_public?: boolean | null, is_military?: boolean | null, activity?: Activity | null, organization_type?: AttendeeOrganizationType | null, legal_title?: string | null, executive_role?: AttendeeExecutiveRole | null, contractual_link?: AttendeeContractualLink | null, parent_organization_name?: string | null, company?: string | null, state?: AttendeeStateType | null, acronym?: string | null, legal_status?: string | null, rcs?: string | null, place_of_registration?: string | null, capital?: string | null, prefecture_name?: string | null, prefecture_number?: string | null, base_global_code?: string | null, social_security_number?: string | null, siret?: string | null, prefecture_date?: any | null, official_journal_date?: any | null, deleted_at?: any | null, created_at?: any | null, contractsSignatureStatus?: DocumentAttendeeStatus | null, contractsDepositStatus?: DocumentAttendeeStatus | null, assignation?: string | null, healthSpecialties?: Array<{ __typename?: 'Specialty', id: string, name: string, technical_key: string, is_attribued?: boolean | null, is_editable?: boolean | null } | null> | null, ticketLink?: { __typename?: 'AttendeeTicketLink', code: string, status?: string | null, workflow_step?: string | null } | null, contracts?: Array<{ __typename?: 'ContractAttendee', id: string, signature_status: DocumentAttendeeStatus, deposit_status: DocumentAttendeeStatus, created_at: any, updated_at: any, last_reminder?: any | null, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null }, contractTemplate?: { __typename?: 'ContractTemplate', id: string, name: string, signature_request_type?: SignatureRequestType | null, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null, signatures?: Array<{ __typename?: 'Signature', created_at: any } | null> | null, attendee: { __typename?: 'Attendee', firstname?: string | null, lastname?: string | null, legal_title?: string | null } } | null> | null, documents?: Array<{ __typename?: 'DocumentAttendee', id: string, type: DocumentAttendeeTypes, signature_status?: DocumentAttendeeStatus | null, deposit_status?: DocumentAttendeeStatus | null, custom_type_name?: string | null, step?: DocumentAttendeeStep | null, signed_at?: any | null, attendee: { __typename?: 'Ticket', id: string }, ticket: { __typename?: 'Ticket', id: string }, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null> | null, address?: { __typename?: 'Address', id: string, name?: string | null, city?: string | null, street_type?: string | null, street_number?: string | null, street_name?: string | null, postcode?: string | null, cedex?: string | null, country?: AddressCountry | null } | null, actualPackages?: Array<{ __typename?: 'ActualPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'ActualAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null, payment_date?: any | null }> } | null> | null, plannedPackages?: Array<{ __typename?: 'PlannedPackage', id: string, name: string, is_distribution?: boolean | null, netTotalAdvantages?: number | null, advantages: Array<{ __typename?: 'PlannedAdvantage', id: string, attendee_id?: string | null, advantage_type: AdvantageType, net_amount: number, gross_amount?: number | null, excluding_tax_amount?: number | null, including_tax_amount?: number | null, quantity: number, detail?: string | null, area?: string | null, comment?: string | null }> } | null> | null, addedBy?: { __typename?: 'User', id: string, full_name: string } | null }>, documents?: Array<{ __typename?: 'DocumentSubmission', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null, document_submission_type?: DocumentSubmissionTypes | null, is_from_bot?: boolean | null, additional_information?: string | null } | null> | null, json?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null, logs?: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, created_at?: any | null } | null } | null } | null };

export type CreateAttendeesByImportProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CreateAttendeesByImportProgressSubscription = { __typename?: 'Subscription', createAttendeesByImportProgress?: { __typename?: 'CreateAttendeesByImportProgress', status: BroadCastsStatusEnum, message: string, ticketAttendeeImport?: { __typename?: 'TicketAttendeeImport', id: string, created_at: any, document: { __typename?: 'Document', id: string, filename: string, path: string, type: string, url: string, temporary_url: string, size: number, created_at?: any | null } } | null } | null };

export type CreateSigningProcedureProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CreateSigningProcedureProgressSubscription = { __typename?: 'Subscription', createSigningProcedureProgress?: { __typename?: 'BatchProgress', status: BroadCastsStatusEnum, message: string, params?: { __typename?: 'BatchProgressParams', batch_id?: string | null, progress?: number | null, total?: number | null, processed?: number | null, failed_count?: number | null, ticket_code?: string | null } | null } | null };

export type CancelSigningProcedureProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CancelSigningProcedureProgressSubscription = { __typename?: 'Subscription', cancelSigningProcedureProgress?: { __typename?: 'BatchProgress', status: BroadCastsStatusEnum, message: string, params?: { __typename?: 'BatchProgressParams', batch_id?: string | null, progress?: number | null, total?: number | null, processed?: number | null, failed_count?: number | null, ticket_code?: string | null } | null } | null };

export type CloneTicketProgressSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CloneTicketProgressSubscription = { __typename?: 'Subscription', cloneTicketProgress?: { __typename?: 'CloneTicketProgress', status: BroadCastsStatusEnum, message: string, ticket?: { __typename?: 'Ticket', id: string, code: string } | null } | null };

export const CoreAdditionalCostFieldsFragmentDoc = gql`
    fragment CoreAdditionalCostFields on AdditionalCost {
  id
  type
  description
  amount
  ticket_id
}
    `;
export const CoreAttendeeByImportFieldsFragmentDoc = gql`
    fragment CoreAttendeeByImportFields on Attendee {
  ticket_id
}
    `;
export const CoreSpecialtyFieldsFragmentDoc = gql`
    fragment CoreSpecialtyFields on Specialty {
  id
  name
  technical_key
  is_attribued
  is_editable
}
    `;
export const CoreAddressFieldsFragmentDoc = gql`
    fragment CoreAddressFields on Address {
  id
  name
  city
  street_type
  street_number
  street_name
  postcode
  cedex
  country
}
    `;
export const CoreUpdateAttendeeFieldsFragmentDoc = gql`
    fragment CoreUpdateAttendeeFields on Attendee {
  id
  civility
  type
  category
  title
  firstname
  lastname
  type_number
  health_number
  health_type
  healthSpecialties {
    ...CoreSpecialtyFields
  }
  regime
  email
  phone_number
  description
  external_id
  is_present
  is_billed
  is_public
  is_military
  activity
  organization_type
  legal_title
  executive_role
  contractual_link
  parent_organization_name
  company
  state
  acronym
  legal_status
  rcs
  place_of_registration
  capital
  prefecture_name
  prefecture_number
  prefecture_date
  official_journal_date
  ticketLink {
    code
    status
    workflow_step
  }
  deleted_at
  address {
    ...CoreAddressFields
  }
  assignation
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreAddressFieldsFragmentDoc}`;
export const CoreAddedByFieldsFragmentDoc = gql`
    fragment CoreAddedByFields on User {
  id
  full_name
}
    `;
export const CoreAttendeeOnPostEventFieldsFragmentDoc = gql`
    fragment CoreAttendeeOnPostEventFields on Attendee {
  id
  firstname
  lastname
  type
  civility
  healthSpecialties {
    ...CoreSpecialtyFields
  }
  health_type
  type_number
  health_number
  organization_type
  email
  regime
  phone_number
  category
  title
  is_present
  is_billed
  is_signed
  is_military
  state
  legal_title
  address {
    id
    postcode
    street_name
    city
  }
  attendeeSignature {
    id
    signature
    hospitality
  }
  createdBy {
    id
    full_name
  }
  addedBy {
    ...CoreAddedByFields
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreAddedByFieldsFragmentDoc}`;
export const CoreAttendeeByApiFieldsFragmentDoc = gql`
    fragment CoreAttendeeByApiFields on Attendee {
  id
  civility
  type
  category
  title
  firstname
  lastname
  type_number
  health_number
  health_type
  healthSpecialties {
    ...CoreSpecialtyFields
  }
  pharmacist_type
  regime
  email
  phone_number
  address {
    ...CoreAddressFields
  }
  description
  external_id
  is_present
  is_billed
  is_threshold_reached
  is_public
  is_military
  activity
  organization_type
  legal_title
  executive_role
  contractual_link
  parent_organization_name
  company
  state
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreAddressFieldsFragmentDoc}`;
export const CoreAttendeeSignatureFieldsFragmentDoc = gql`
    fragment CoreAttendeeSignatureFields on AttendeeSignature {
  id
  ticket_id
  attendee_id
  signature
  hospitality
}
    `;
export const CoreCommentFieldsFragmentDoc = gql`
    fragment CoreCommentFields on Comment {
  id
  content
  type
  ticket_id
  ticket_step
  created_by {
    id
    first_name
    last_name
    full_name
  }
  created_at
  updated_at
  deleted_at
}
    `;
export const CoreDocumentFieldsFragmentDoc = gql`
    fragment CoreDocumentFields on Document {
  id
  filename
  path
  type
  url
  temporary_url
  size
  created_at
}
    `;
export const CoreDocumentContactFieldsFragmentDoc = gql`
    fragment CoreDocumentContactFields on DocumentContact {
  id
  type
  contact {
    id
  }
  document {
    ...CoreDocumentFields
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export const CoreContactFieldsFragmentDoc = gql`
    fragment CoreContactFields on Contact {
  id
  category
  firstname
  lastname
  address {
    id
    name
    street_number
    street_name
    postcode
    city
    country
  }
  email
  phone_number
  type_number
  health_number
  health_type
  healthSpecialties {
    ...CoreSpecialtyFields
  }
  pharmacist_type
  civility
  type
  title
  regime
  description
  is_public
  is_military
  activity
  organization_type
  legal_title
  executive_role
  contractual_link
  parent_organization_name
  company
  acronym
  legal_status
  rcs
  place_of_registration
  capital
  prefecture_name
  prefecture_number
  base_global_code
  social_security_number
  siret
  prefecture_date
  official_journal_date
  created_at
  updated_at
  documents {
    ...CoreDocumentContactFields
  }
  assignation
  external_id
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreDocumentContactFieldsFragmentDoc}`;
export const CoreUserAndInternalSignerFieldsFragmentDoc = gql`
    fragment CoreUserAndInternalSignerFields on UserAndInternalSigner {
  id
  firstname
  lastname
  phone
  email
  type
}
    `;
export const CoreInternalSignerFieldsFragmentDoc = gql`
    fragment CoreInternalSignerFields on InternalSigner {
  id
  firstname
  lastname
  executive_role
  phone
  email
  civility
  staff_id
}
    `;
export const CoreUserKeycloakSignerFieldsFragmentDoc = gql`
    fragment CoreUserKeycloakSignerFields on UserKeycloakSigner {
  id
  first_name
  last_name
  phone
  email
}
    `;
export const CorePlannedAdvantageFieldsFragmentDoc = gql`
    fragment CorePlannedAdvantageFields on PlannedAdvantage {
  id
  attendee_id
  advantage_type
  net_amount
  gross_amount
  excluding_tax_amount
  including_tax_amount
  quantity
  detail
  area
  comment
}
    `;
export const CoreAdvantagesConventionFragmentDoc = gql`
    fragment CoreAdvantagesConvention on Convention {
  id
  type
  is_active
  advantages {
    ...CorePlannedAdvantageFields
  }
  is_manual_pack_allowed
}
    ${CorePlannedAdvantageFieldsFragmentDoc}`;
export const CoreCrmUserFieldsFragmentDoc = gql`
    fragment CoreCrmUserFields on CrmUser {
  id
  firstname
  lastname
  email
  staff_id
  responsibilities
  post_title
}
    `;
export const CoreDeclarationDepositFragmentDoc = gql`
    fragment CoreDeclarationDeposit on DeclarationDeposit {
  id
  reference
  status
  url
  submission_date
  recommendation_date
  comment
}
    `;
export const CoreDeclarationFragmentDoc = gql`
    fragment CoreDeclaration on Declaration {
  id
  name
  code
  status
  workflow_step
  is_accepted
  is_refused
  is_archived
  is_canceled
  declaration_count
  advantages {
    id
    advantage_type
    net_amount
    including_tax_amount
    quantity
    comment
    enabled
    originalAdvantage {
      id
      net_amount
      including_tax_amount
      quantity
      advantage_type
    }
  }
  convention {
    id
    type
    is_manual_pack_allowed
  }
  themes {
    id
    name
    duration
  }
  attendee_quantity
  attendee_medical_types
  specialties
  start_at
  end_at
  created_at
  created_by {
    id
    first_name
    last_name
  }
  address {
    id
    city
    country
  }
  reference
  external_code
  tickets {
    id
  }
  managerCrm {
    ...CoreCrmUserFields
  }
  deposit {
    ...CoreDeclarationDeposit
  }
}
    ${CoreCrmUserFieldsFragmentDoc}
${CoreDeclarationDepositFragmentDoc}`;
export const CoreDeclarationAdvantageFragmentDoc = gql`
    fragment CoreDeclarationAdvantage on DeclarationAdvantage {
  id
  advantage_type
  net_amount
  quantity
  comment
  enabled
  declaration {
    id
  }
}
    `;
export const CoreDeclarationThemeFragmentDoc = gql`
    fragment CoreDeclarationTheme on DeclarationThemes {
  id
  name
  duration
  declaration {
    id
  }
}
    `;
export const CoreDeclarationDocumentFragmentDoc = gql`
    fragment CoreDeclarationDocument on DeclarationDocument {
  id
  type
  comment
  document {
    ...CoreDocumentFields
  }
  declaration {
    id
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export const CoreIdentityFieldsFragmentDoc = gql`
    fragment CoreIdentityFields on Identity {
  id
  name
  company_form
  capital
  place_of_registration
  rcs
  gdpr_contact
  mail_gdpr_contact
  legal_notice
  address
  postal_code
  city
  department
  country
  logo_file {
    id
    type
    url
  }
  representative_name
  representative_title
  enabled
  main
  eps_login
  idahe_login
  has_eps_password
  has_idahe_password
  no_urssaf_rate
}
    `;
export const CoreOperationFieldsFragmentDoc = gql`
    fragment CoreOperationFields on Operation {
  id
  name
  eventTypes {
    event_type
  }
  donation_type
  operation_type_transparency
  operation_type_eps
  operation_type_idahe
  idahe_convention
  idahe_typology
  mandatory_planned_packages
  mandatory_actual_packages
  mandatory_contract_templates
  mandatory_attachments
  plannedPackageIds
  actualPackageIds
  contractTemplateIds
  attachmentIds
  created_at
  updated_at
  enabled
  is_publication_allowed
}
    `;
export const CoreNotificationFieldsFragmentDoc = gql`
    fragment CoreNotificationFields on Notification {
  id
  type
  name
  event_types
  target_state
  submission_regime
  date_boundary
  day_type
  period
  delay
  enabled
  external_emails
  internal_emails
  ticket_roles_to_notify
  email_object
  email_body
  comment
  created_by {
    id
    full_name
    first_name
    last_name
    email
  }
  operations {
    ...CoreOperationFields
  }
}
    ${CoreOperationFieldsFragmentDoc}`;
export const CoreSettingsFieldsFragmentDoc = gql`
    fragment CoreSettingsFields on Settings {
  is_active
  type
  data {
    max_occurrences
    interval_in_days
    authentication_mode
    operation_ids
    ticket_deadline_days
    ticket_deadline_work_days
    workspace_id
    custom_experience_id
  }
}
    `;
export const GlobalSettingsFieldsFragmentDoc = gql`
    fragment GlobalSettingsFields on Settings {
  is_active
  type
}
    `;
export const CoreWatchdogsSettingsFieldsFragmentDoc = gql`
    fragment CoreWatchdogsSettingsFields on Settings {
  is_active
  type
  data {
    operation_ids
    ticket_deadline_days
    ticket_deadline_work_days
  }
}
    `;
export const CoreContractAttendeeFragmentDoc = gql`
    fragment CoreContractAttendee on ContractAttendee {
  id
  ticket {
    id
  }
  signature_status
  deposit_status
  document {
    ...CoreDocumentFields
  }
  contractTemplate {
    id
    name
    signature_request_type
    document {
      ...CoreDocumentFields
    }
  }
  created_at
  updated_at
  last_reminder
  signatures {
    created_at
  }
  attendee {
    firstname
    lastname
    legal_title
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export const CoreDocumentAttendeeFieldsFragmentDoc = gql`
    fragment CoreDocumentAttendeeFields on DocumentAttendee {
  id
  type
  signature_status
  deposit_status
  custom_type_name
  step
  signed_at
  attendee {
    id
  }
  ticket {
    id
  }
  document {
    ...CoreDocumentFields
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export const CoreActualAdvantageFieldsFragmentDoc = gql`
    fragment CoreActualAdvantageFields on ActualAdvantage {
  id
  attendee_id
  advantage_type
  net_amount
  gross_amount
  excluding_tax_amount
  including_tax_amount
  quantity
  detail
  area
  comment
  payment_date
}
    `;
export const CoreActualPackageFieldsFragmentDoc = gql`
    fragment CoreActualPackageFields on ActualPackage {
  id
  name
  is_distribution
  netTotalAdvantages
  advantages {
    ...CoreActualAdvantageFields
  }
}
    ${CoreActualAdvantageFieldsFragmentDoc}`;
export const CorePlannedPackageFieldsFragmentDoc = gql`
    fragment CorePlannedPackageFields on PlannedPackage {
  id
  name
  is_distribution
  netTotalAdvantages
  advantages {
    ...CorePlannedAdvantageFields
  }
}
    ${CorePlannedAdvantageFieldsFragmentDoc}`;
export const CoreAttendeeTicketFieldsFragmentDoc = gql`
    fragment CoreAttendeeTicketFields on Attendee {
  id
  civility
  type
  category
  title
  firstname
  lastname
  type_number
  health_number
  health_type
  healthSpecialties {
    ...CoreSpecialtyFields
  }
  pharmacist_type
  regime
  email
  phone_number
  description
  external_id
  is_present
  is_billed
  is_threshold_reached
  is_public
  is_military
  activity
  organization_type
  legal_title
  executive_role
  contractual_link
  parent_organization_name
  company
  state
  acronym
  legal_status
  rcs
  place_of_registration
  capital
  prefecture_name
  prefecture_number
  base_global_code
  social_security_number
  siret
  prefecture_date
  official_journal_date
  ticketLink {
    code
    status
    workflow_step
  }
  deleted_at
  created_at
  contractsSignatureStatus
  contractsDepositStatus
  contracts {
    ...CoreContractAttendee
  }
  documents {
    ...CoreDocumentAttendeeFields
  }
  address {
    ...CoreAddressFields
  }
  actualPackages {
    ...CoreActualPackageFields
  }
  plannedPackages {
    ...CorePlannedPackageFields
  }
  assignation
  addedBy {
    ...CoreAddedByFields
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreContractAttendeeFragmentDoc}
${CoreDocumentAttendeeFieldsFragmentDoc}
${CoreAddressFieldsFragmentDoc}
${CoreActualPackageFieldsFragmentDoc}
${CorePlannedPackageFieldsFragmentDoc}
${CoreAddedByFieldsFragmentDoc}`;
export const CoreSubmissionFieldsFragmentDoc = gql`
    fragment CoreSubmissionFields on Submission {
  id
  reference
  status
  url
  type
  created_at
  incomplete_submission_date
  authorization_refusal_date
  recommendation_date
  acceptation_date
  complete_submission_date
  submission_date
  comment
  attendees {
    ...CoreAttendeeTicketFields
  }
  documents {
    id
    filename
    path
    type
    url
    temporary_url
    created_at
    document_submission_type
    is_from_bot
    additional_information
  }
  json {
    id
    filename
    path
    type
    url
    temporary_url
    created_at
  }
  logs {
    id
    filename
    path
    type
    url
    temporary_url
    created_at
  }
}
    ${CoreAttendeeTicketFieldsFragmentDoc}`;
export const CoreBatchProgressFieldsFragmentDoc = gql`
    fragment CoreBatchProgressFields on BatchProgress {
  status
  message
  params {
    batch_id
    progress
    total
    processed
    failed_count
    ticket_code
  }
}
    `;
export const CoreWorkflowFieldsFragmentDoc = gql`
    fragment CoreWorkflowFields on Workflow {
  id
  name
  description
  steps {
    step
    roles {
      READ
      WRITE
      REVIEW
    }
  }
  eventTypes {
    event_type
  }
}
    `;
export const CoreProductFieldsFragmentDoc = gql`
    fragment CoreProductFields on Product {
  id
  name
  enabled
}
    `;
export const CoreSectorFieldsFragmentDoc = gql`
    fragment CoreSectorFields on Sector {
  id
  name
  enabled
}
    `;
export const CoreUnitFieldsFragmentDoc = gql`
    fragment CoreUnitFields on Unit {
  id
  name
  enabled
}
    `;
export const CoreTherapeuticAreaFieldsFragmentDoc = gql`
    fragment CoreTherapeuticAreaFields on TherapeuticArea {
  id
  name
  enabled
}
    `;
export const CoreRegionFieldsFragmentDoc = gql`
    fragment CoreRegionFields on Region {
  id
  name
  enabled
}
    `;
export const CoreNetworkFieldsFragmentDoc = gql`
    fragment CoreNetworkFields on Network {
  id
  name
  enabled
}
    `;
export const CoreUgaFieldsFragmentDoc = gql`
    fragment CoreUgaFields on Uga {
  id
  name
  enabled
}
    `;
export const CoreZoneFieldsFragmentDoc = gql`
    fragment CoreZoneFields on Zone {
  id
  name
  enabled
}
    `;
export const CoreAllocationsFieldsFragmentDoc = gql`
    fragment CoreAllocationsFields on Allocations {
  products {
    ...CoreProductFields
  }
  sectors {
    ...CoreSectorFields
  }
  units {
    ...CoreUnitFields
  }
  therapeuticAreas {
    ...CoreTherapeuticAreaFields
  }
  regions {
    ...CoreRegionFields
  }
  networks {
    ...CoreNetworkFields
  }
  ugas {
    ...CoreUgaFields
  }
  zones {
    ...CoreZoneFields
  }
  identities {
    id
    name
    enabled
  }
}
    ${CoreProductFieldsFragmentDoc}
${CoreSectorFieldsFragmentDoc}
${CoreUnitFieldsFragmentDoc}
${CoreTherapeuticAreaFieldsFragmentDoc}
${CoreRegionFieldsFragmentDoc}
${CoreNetworkFieldsFragmentDoc}
${CoreUgaFieldsFragmentDoc}
${CoreZoneFieldsFragmentDoc}`;
export const CoreTicketFieldsFragmentDoc = gql`
    fragment CoreTicketFields on Ticket {
  id
  name
  description
  place
  code
  external_code
  status
  workflow_step
  event_type
  event_specialty
  quantity
  start_at
  end_at
  created_at
  is_declared
  is_archived
  is_published
  advantages_completed
  advantages_validated
  address {
    ...CoreAddressFields
  }
  workflow {
    ...CoreWorkflowFields
  }
  signingSheets {
    id
  }
  expenseReports {
    id
  }
  attendees {
    data {
      ...CoreAttendeeTicketFields
    }
  }
  createdBy {
    id
    full_name
    first_name
    last_name
    email
  }
  initiator {
    id
    full_name
    first_name
    last_name
    email
  }
  validator_1 {
    id
    full_name
  }
  validator_2 {
    id
    full_name
  }
  operation {
    id
    name
    mandatory_planned_packages
    mandatory_actual_packages
    mandatory_contract_templates
    mandatory_attachments
    enabled
    is_publication_allowed
  }
  nonCompliances {
    id
    ticket_id
  }
  linkedTickets {
    id
    name
    event_type
  }
  declaration {
    id
    name
  }
  allocations {
    ...CoreAllocationsFields
  }
  submission_regime
  managerCrm {
    ...CoreCrmUserFields
  }
  approverCrm {
    ...CoreCrmUserFields
  }
  with_agency
  agency_name
  format
  meeting_type
  is_package_creation_allowed
}
    ${CoreAddressFieldsFragmentDoc}
${CoreWorkflowFieldsFragmentDoc}
${CoreAttendeeTicketFieldsFragmentDoc}
${CoreAllocationsFieldsFragmentDoc}
${CoreCrmUserFieldsFragmentDoc}`;
export const TicketAttachmentsFragmentDoc = gql`
    fragment TicketAttachments on Ticket {
  attachments {
    id
    document {
      ...CoreDocumentFields
    }
    comment
    type
    is_added_manually
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export const CoreDashboardTicketFieldsFragmentDoc = gql`
    fragment CoreDashboardTicketFields on Ticket {
  id
  code
  status
  name
  event_type
  start_at
  end_at
  workflow_step
  is_archived
  is_declared
  created_at
  contractor
  remainingDays
  contracts {
    eligible_attendees_count
    signed_contracts
    generated_contracts
  }
  deposits {
    eligible_deposits_count
    deposit_sent
  }
  createdBy {
    id
    full_name
    email
  }
  initiator {
    id
    full_name
  }
  validator_1 {
    id
    first_name
    last_name
  }
  validator_2 {
    id
    first_name
    last_name
  }
  operation {
    id
    name
    is_publication_allowed
  }
  advantages_completed
  advantages_validated
  expenseReports {
    id
  }
  signingSheets {
    id
  }
  submission_regime
  managerCrm {
    id
    firstname
    lastname
  }
  isTicketInitiatedByUser
}
    `;
export const CorePaginationFieldsFragmentDoc = gql`
    fragment CorePaginationFields on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const TicketByStepAndStatusFieldsFragmentDoc = gql`
    fragment TicketByStepAndStatusFields on TicketsGroupedByStepOrStatus {
  CREATING {
    tickets {
      ...CoreDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  FIRST_VALIDATION {
    tickets {
      ...CoreDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  SECOND_VALIDATION {
    tickets {
      ...CoreDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  TO_EDIT {
    tickets {
      ...CoreDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  CONTRACT_MANAGEMENT {
    tickets {
      ...CoreDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  EVENT_IN_PROGRESS {
    tickets {
      ...CoreDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  EVENT_VALIDATING {
    tickets {
      ...CoreDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  EVENT_IS_FINISHED {
    tickets {
      ...CoreDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreDashboardTicketFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export const CoreAdminDashboardTicketFieldsFragmentDoc = gql`
    fragment CoreAdminDashboardTicketFields on Ticket {
  id
  code
  status
  name
  workflow_step
  is_archived
  is_declared
  created_at
  workflow {
    ...CoreWorkflowFields
  }
}
    ${CoreWorkflowFieldsFragmentDoc}`;
export const TicketByStepAndStatusAdminFieldsFragmentDoc = gql`
    fragment TicketByStepAndStatusAdminFields on TicketsGroupedByStepOrStatus {
  CREATING {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  FIRST_VALIDATION {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  SECOND_VALIDATION {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  TO_EDIT {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  CONTRACT_MANAGEMENT {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  EVENT_IN_PROGRESS {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  EVENT_VALIDATING {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  EVENT_IS_FINISHED {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  LIBRARY {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
  TRANSPARENCY {
    tickets {
      ...CoreAdminDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreAdminDashboardTicketFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export const CoreTicketStatusAndStepFieldsFragmentDoc = gql`
    fragment CoreTicketStatusAndStepFields on Ticket {
  id
  code
  status
  workflow_step
  workflow {
    ...CoreWorkflowFields
  }
  is_declared
  is_archived
  is_published
  advantages_completed
  advantages_validated
}
    ${CoreWorkflowFieldsFragmentDoc}`;
export const CoreUserKeycloakFieldsFragmentDoc = gql`
    fragment CoreUserKeycloakFields on UserKeycloak {
  id
  firstName
  lastName
  username
  email
  attributes {
    phone
  }
  enabled
}
    `;
export const CreateAdditionalCostDocument = gql`
    mutation createAdditionalCost($input: CreateAdditionalCostInput!) {
  createAdditionalCost(input: $input) {
    type
    amount
    description
    ticket_id
  }
}
    `;
export function useCreateAdditionalCostMutation(options: VueApolloComposable.UseMutationOptions<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>(CreateAdditionalCostDocument, options);
}
export type CreateAdditionalCostMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>;
export const UpdateAdditionalCostDocument = gql`
    mutation updateAdditionalCost($input: UpdateAdditionalCostInput!) {
  updateAdditionalCost(input: $input) {
    ...CoreAdditionalCostFields
  }
}
    ${CoreAdditionalCostFieldsFragmentDoc}`;
export function useUpdateAdditionalCostMutation(options: VueApolloComposable.UseMutationOptions<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>(UpdateAdditionalCostDocument, options);
}
export type UpdateAdditionalCostMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>;
export const DeleteAdditionalCostDocument = gql`
    mutation deleteAdditionalCost($input: DeleteAdditionalCostInput!) {
  deleteAdditionalCost(input: $input) {
    id
  }
}
    `;
export function useDeleteAdditionalCostMutation(options: VueApolloComposable.UseMutationOptions<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>(DeleteAdditionalCostDocument, options);
}
export type DeleteAdditionalCostMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>;
export const DownloadAttendeeTemplateDocument = gql`
    mutation DownloadAttendeeTemplate {
  downloadAttendeeTemplate {
    content
    filename
  }
}
    `;
export function useDownloadAttendeeTemplateMutation(options: VueApolloComposable.UseMutationOptions<DownloadAttendeeTemplateMutation, DownloadAttendeeTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DownloadAttendeeTemplateMutation, DownloadAttendeeTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DownloadAttendeeTemplateMutation, DownloadAttendeeTemplateMutationVariables>(DownloadAttendeeTemplateDocument, options);
}
export type DownloadAttendeeTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DownloadAttendeeTemplateMutation, DownloadAttendeeTemplateMutationVariables>;
export const CreateContractDepositInformationDocument = gql`
    mutation createContractDepositInformation($input: CreateContractDepositInformationInput!) {
  createContractDepositInformation(input: $input) {
    id
    deposit_platform
    deposit_type
  }
}
    `;
export function useCreateContractDepositInformationMutation(options: VueApolloComposable.UseMutationOptions<CreateContractDepositInformationMutation, CreateContractDepositInformationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateContractDepositInformationMutation, CreateContractDepositInformationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateContractDepositInformationMutation, CreateContractDepositInformationMutationVariables>(CreateContractDepositInformationDocument, options);
}
export type CreateContractDepositInformationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateContractDepositInformationMutation, CreateContractDepositInformationMutationVariables>;
export const UploadAttachmentsDocument = gql`
    mutation UploadAttachments($input: UploadAttachmentsInput!) {
  uploadAttachments(input: $input) {
    comment
    file
    type
  }
}
    `;
export function useUploadAttachmentsMutation(options: VueApolloComposable.UseMutationOptions<UploadAttachmentsMutation, UploadAttachmentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadAttachmentsMutation, UploadAttachmentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadAttachmentsMutation, UploadAttachmentsMutationVariables>(UploadAttachmentsDocument, options);
}
export type UploadAttachmentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadAttachmentsMutation, UploadAttachmentsMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation DeleteAttachment($input: DeleteAttachmentInput!) {
  deleteAttachment(input: $input) {
    id
  }
}
    `;
export function useDeleteAttachmentMutation(options: VueApolloComposable.UseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument, options);
}
export type DeleteAttachmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const UploadSigningSheetDocument = gql`
    mutation UploadSigningSheet($input: UploadSigningSheetInput!) {
  uploadSigningSheet(input: $input) {
    id
    name
    document {
      ...CoreDocumentFields
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useUploadSigningSheetMutation(options: VueApolloComposable.UseMutationOptions<UploadSigningSheetMutation, UploadSigningSheetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadSigningSheetMutation, UploadSigningSheetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadSigningSheetMutation, UploadSigningSheetMutationVariables>(UploadSigningSheetDocument, options);
}
export type UploadSigningSheetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadSigningSheetMutation, UploadSigningSheetMutationVariables>;
export const CreateContractAttendeeDocument = gql`
    mutation CreateContractAttendee($input: CreateContractAttendeeInput!) {
  createContractAttendee(input: $input) {
    batch_id
    attendee_id
    contract_template_id
  }
}
    `;
export function useCreateContractAttendeeMutation(options: VueApolloComposable.UseMutationOptions<CreateContractAttendeeMutation, CreateContractAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateContractAttendeeMutation, CreateContractAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateContractAttendeeMutation, CreateContractAttendeeMutationVariables>(CreateContractAttendeeDocument, options);
}
export type CreateContractAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateContractAttendeeMutation, CreateContractAttendeeMutationVariables>;
export const EditContractAttendeeInputDocument = gql`
    mutation EditContractAttendeeInput($input: EditContractAttendeeInput!) {
  editContractAttendee(input: $input)
}
    `;
export function useEditContractAttendeeInputMutation(options: VueApolloComposable.UseMutationOptions<EditContractAttendeeInputMutation, EditContractAttendeeInputMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditContractAttendeeInputMutation, EditContractAttendeeInputMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditContractAttendeeInputMutation, EditContractAttendeeInputMutationVariables>(EditContractAttendeeInputDocument, options);
}
export type EditContractAttendeeInputMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditContractAttendeeInputMutation, EditContractAttendeeInputMutationVariables>;
export const UpsertIdentityDocument = gql`
    mutation upsertIdentity($id: ID, $input: UpsertIdentityInput!) {
  upsertIdentity(id: $id, input: $input) {
    ...CoreIdentityFields
  }
}
    ${CoreIdentityFieldsFragmentDoc}`;
export function useUpsertIdentityMutation(options: VueApolloComposable.UseMutationOptions<UpsertIdentityMutation, UpsertIdentityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertIdentityMutation, UpsertIdentityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertIdentityMutation, UpsertIdentityMutationVariables>(UpsertIdentityDocument, options);
}
export type UpsertIdentityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertIdentityMutation, UpsertIdentityMutationVariables>;
export const UploadLogoDocument = gql`
    mutation uploadLogo($input: UploadLogoInput!) {
  uploadLogo(input: $input) {
    id
    filename
    type
    url
  }
}
    `;
export function useUploadLogoMutation(options: VueApolloComposable.UseMutationOptions<UploadLogoMutation, UploadLogoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadLogoMutation, UploadLogoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadLogoMutation, UploadLogoMutationVariables>(UploadLogoDocument, options);
}
export type UploadLogoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadLogoMutation, UploadLogoMutationVariables>;
export const CreateOperationDocument = gql`
    mutation createOperation($input: CreateOperationInput!) {
  createOperation(input: $input) {
    ...CoreOperationFields
  }
}
    ${CoreOperationFieldsFragmentDoc}`;
export function useCreateOperationMutation(options: VueApolloComposable.UseMutationOptions<CreateOperationMutation, CreateOperationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOperationMutation, CreateOperationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOperationMutation, CreateOperationMutationVariables>(CreateOperationDocument, options);
}
export type CreateOperationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOperationMutation, CreateOperationMutationVariables>;
export const UpdateOperationDocument = gql`
    mutation updateOperation($input: UpdateOperationInput!) {
  updateOperation(input: $input) {
    ...CoreOperationFields
  }
}
    ${CoreOperationFieldsFragmentDoc}`;
export function useUpdateOperationMutation(options: VueApolloComposable.UseMutationOptions<UpdateOperationMutation, UpdateOperationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOperationMutation, UpdateOperationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOperationMutation, UpdateOperationMutationVariables>(UpdateOperationDocument, options);
}
export type UpdateOperationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOperationMutation, UpdateOperationMutationVariables>;
export const UpsertTicketDocument = gql`
    mutation upsertTicket($id: ID, $input: UpsertTicketInput!) {
  upsertTicket(id: $id, input: $input) {
    ...CoreTicketFields
  }
}
    ${CoreTicketFieldsFragmentDoc}`;
export function useUpsertTicketMutation(options: VueApolloComposable.UseMutationOptions<UpsertTicketMutation, UpsertTicketMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertTicketMutation, UpsertTicketMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertTicketMutation, UpsertTicketMutationVariables>(UpsertTicketDocument, options);
}
export type UpsertTicketMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertTicketMutation, UpsertTicketMutationVariables>;
export const UpdateTicketDocument = gql`
    mutation updateTicket($input: UpdateTicketInput!) {
  updateTicket(input: $input) {
    ...CoreTicketFields
  }
}
    ${CoreTicketFieldsFragmentDoc}`;
export function useUpdateTicketMutation(options: VueApolloComposable.UseMutationOptions<UpdateTicketMutation, UpdateTicketMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTicketMutation, UpdateTicketMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTicketMutation, UpdateTicketMutationVariables>(UpdateTicketDocument, options);
}
export type UpdateTicketMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTicketMutation, UpdateTicketMutationVariables>;
export const UpdateUserNotificationsDocument = gql`
    mutation UpdateUserNotifications($input: UpdateUserNotificationsInput!) {
  updateUserNotifications(input: $input) {
    id
    email_notifications
  }
}
    `;
export function useUpdateUserNotificationsMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables>(UpdateUserNotificationsDocument, options);
}
export type UpdateUserNotificationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: UserKeycloakInput!) {
  createUser(input: $input) {
    firstName
  }
}
    `;
export function useCreateUserMutation(options: VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
}
export type CreateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateUserMutation, CreateUserMutationVariables>;
export const SoftDeleteUserDocument = gql`
    mutation softDeleteUser($id: ID!) {
  softDeleteUser(id: $id) {
    id
  }
}
    `;
export function useSoftDeleteUserMutation(options: VueApolloComposable.UseMutationOptions<SoftDeleteUserMutation, SoftDeleteUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>(SoftDeleteUserDocument, options);
}
export type SoftDeleteUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>;
export const AddClientLevelRoleMappingToUserDocument = gql`
    mutation addClientLevelRoleMappingToUser($id: ID!, $input: [UserRoleInput!]) {
  addClientLevelRoleMappingToUser(id: $id, input: $input) {
    id
  }
}
    `;
export function useAddClientLevelRoleMappingToUserMutation(options: VueApolloComposable.UseMutationOptions<AddClientLevelRoleMappingToUserMutation, AddClientLevelRoleMappingToUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddClientLevelRoleMappingToUserMutation, AddClientLevelRoleMappingToUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddClientLevelRoleMappingToUserMutation, AddClientLevelRoleMappingToUserMutationVariables>(AddClientLevelRoleMappingToUserDocument, options);
}
export type AddClientLevelRoleMappingToUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddClientLevelRoleMappingToUserMutation, AddClientLevelRoleMappingToUserMutationVariables>;
export const RemoveClientLevelRoleMappingFromUserDocument = gql`
    mutation removeClientLevelRoleMappingFromUser($id: ID!, $input: [UserRoleInput!]) {
  removeClientLevelRoleMappingFromUser(id: $id, input: $input) {
    id
  }
}
    `;
export function useRemoveClientLevelRoleMappingFromUserMutation(options: VueApolloComposable.UseMutationOptions<RemoveClientLevelRoleMappingFromUserMutation, RemoveClientLevelRoleMappingFromUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveClientLevelRoleMappingFromUserMutation, RemoveClientLevelRoleMappingFromUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveClientLevelRoleMappingFromUserMutation, RemoveClientLevelRoleMappingFromUserMutationVariables>(RemoveClientLevelRoleMappingFromUserDocument, options);
}
export type RemoveClientLevelRoleMappingFromUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveClientLevelRoleMappingFromUserMutation, RemoveClientLevelRoleMappingFromUserMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($input: UploadFileInput!) {
  uploadFile(input: $input) {
    id
    url
    type
  }
}
    `;
export function useUploadFileMutation(options: VueApolloComposable.UseMutationOptions<UploadFileMutation, UploadFileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadFileMutation, UploadFileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
}
export type UploadFileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadFileMutation, UploadFileMutationVariables>;
export const AdditionalCostDocument = gql`
    query additionalCost($id: ID!) {
  additionalCost(id: $id) {
    ...CoreAdditionalCostFields
  }
}
    ${CoreAdditionalCostFieldsFragmentDoc}`;
export function useAdditionalCostQuery(variables: AdditionalCostQueryVariables | VueCompositionApi.Ref<AdditionalCostQueryVariables> | ReactiveFunction<AdditionalCostQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdditionalCostQuery, AdditionalCostQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdditionalCostQuery, AdditionalCostQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdditionalCostQuery, AdditionalCostQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdditionalCostQuery, AdditionalCostQueryVariables>(AdditionalCostDocument, variables, options);
}
export function useAdditionalCostLazyQuery(variables?: AdditionalCostQueryVariables | VueCompositionApi.Ref<AdditionalCostQueryVariables> | ReactiveFunction<AdditionalCostQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdditionalCostQuery, AdditionalCostQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdditionalCostQuery, AdditionalCostQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdditionalCostQuery, AdditionalCostQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdditionalCostQuery, AdditionalCostQueryVariables>(AdditionalCostDocument, variables, options);
}
export type AdditionalCostQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdditionalCostQuery, AdditionalCostQueryVariables>;
export const AdditionalCostsByTicketDocument = gql`
    query additionalCostsByTicket($code: String!) {
  additionalCostsByTicket(code: $code) {
    ...CoreAdditionalCostFields
  }
}
    ${CoreAdditionalCostFieldsFragmentDoc}`;
export function useAdditionalCostsByTicketQuery(variables: AdditionalCostsByTicketQueryVariables | VueCompositionApi.Ref<AdditionalCostsByTicketQueryVariables> | ReactiveFunction<AdditionalCostsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdditionalCostsByTicketQuery, AdditionalCostsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdditionalCostsByTicketQuery, AdditionalCostsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdditionalCostsByTicketQuery, AdditionalCostsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdditionalCostsByTicketQuery, AdditionalCostsByTicketQueryVariables>(AdditionalCostsByTicketDocument, variables, options);
}
export function useAdditionalCostsByTicketLazyQuery(variables?: AdditionalCostsByTicketQueryVariables | VueCompositionApi.Ref<AdditionalCostsByTicketQueryVariables> | ReactiveFunction<AdditionalCostsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdditionalCostsByTicketQuery, AdditionalCostsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdditionalCostsByTicketQuery, AdditionalCostsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdditionalCostsByTicketQuery, AdditionalCostsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdditionalCostsByTicketQuery, AdditionalCostsByTicketQueryVariables>(AdditionalCostsByTicketDocument, variables, options);
}
export type AdditionalCostsByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdditionalCostsByTicketQuery, AdditionalCostsByTicketQueryVariables>;
export const AttendeesTotalByTicketDocument = gql`
    query attendeesTotalByTicket($id: ID!, $first: Int!, $page: Int, $type: AttendeeType, $category: AttendeeCategory, $health_type: AttendeeHealthType, $pack: ID) {
  attendeesTotalByTicket(
    id: $id
    first: $first
    page: $page
    type: $type
    category: $category
    health_type: $health_type
    pack: $pack
  ) {
    paginatorInfo {
      total
    }
  }
}
    `;
export function useAttendeesTotalByTicketQuery(variables: AttendeesTotalByTicketQueryVariables | VueCompositionApi.Ref<AttendeesTotalByTicketQueryVariables> | ReactiveFunction<AttendeesTotalByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesTotalByTicketQuery, AttendeesTotalByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesTotalByTicketQuery, AttendeesTotalByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesTotalByTicketQuery, AttendeesTotalByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttendeesTotalByTicketQuery, AttendeesTotalByTicketQueryVariables>(AttendeesTotalByTicketDocument, variables, options);
}
export function useAttendeesTotalByTicketLazyQuery(variables?: AttendeesTotalByTicketQueryVariables | VueCompositionApi.Ref<AttendeesTotalByTicketQueryVariables> | ReactiveFunction<AttendeesTotalByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesTotalByTicketQuery, AttendeesTotalByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesTotalByTicketQuery, AttendeesTotalByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesTotalByTicketQuery, AttendeesTotalByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttendeesTotalByTicketQuery, AttendeesTotalByTicketQueryVariables>(AttendeesTotalByTicketDocument, variables, options);
}
export type AttendeesTotalByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttendeesTotalByTicketQuery, AttendeesTotalByTicketQueryVariables>;
export const CreateAttendeeDocument = gql`
    mutation createAttendee($input: CreateAttendeeInput!) {
  createAttendee(input: $input) {
    ...CoreAttendeeTicketFields
  }
}
    ${CoreAttendeeTicketFieldsFragmentDoc}`;
export function useCreateAttendeeMutation(options: VueApolloComposable.UseMutationOptions<CreateAttendeeMutation, CreateAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAttendeeMutation, CreateAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAttendeeMutation, CreateAttendeeMutationVariables>(CreateAttendeeDocument, options);
}
export type CreateAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAttendeeMutation, CreateAttendeeMutationVariables>;
export const UpdateAttendeeDocument = gql`
    mutation updateAttendee($input: UpdateAttendeeInput!) {
  updateAttendee(input: $input) {
    ...CoreUpdateAttendeeFields
  }
}
    ${CoreUpdateAttendeeFieldsFragmentDoc}`;
export function useUpdateAttendeeMutation(options: VueApolloComposable.UseMutationOptions<UpdateAttendeeMutation, UpdateAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAttendeeMutation, UpdateAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAttendeeMutation, UpdateAttendeeMutationVariables>(UpdateAttendeeDocument, options);
}
export type UpdateAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAttendeeMutation, UpdateAttendeeMutationVariables>;
export const TrashAttendeeDocument = gql`
    mutation trashAttendee($id: ID!) {
  trashAttendee(id: $id) {
    ...CoreAttendeeTicketFields
  }
}
    ${CoreAttendeeTicketFieldsFragmentDoc}`;
export function useTrashAttendeeMutation(options: VueApolloComposable.UseMutationOptions<TrashAttendeeMutation, TrashAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashAttendeeMutation, TrashAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashAttendeeMutation, TrashAttendeeMutationVariables>(TrashAttendeeDocument, options);
}
export type TrashAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashAttendeeMutation, TrashAttendeeMutationVariables>;
export const DeleteAttendeeDocument = gql`
    mutation deleteAttendee($input: DeleteAttendeeInput!) {
  deleteAttendee(input: $input) {
    ...CoreAttendeeTicketFields
  }
}
    ${CoreAttendeeTicketFieldsFragmentDoc}`;
export function useDeleteAttendeeMutation(options: VueApolloComposable.UseMutationOptions<DeleteAttendeeMutation, DeleteAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAttendeeMutation, DeleteAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAttendeeMutation, DeleteAttendeeMutationVariables>(DeleteAttendeeDocument, options);
}
export type DeleteAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAttendeeMutation, DeleteAttendeeMutationVariables>;
export const CreateCommentDocument = gql`
    mutation createComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    ...CoreCommentFields
  }
}
    ${CoreCommentFieldsFragmentDoc}`;
export function useCreateCommentMutation(options: VueApolloComposable.UseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
}
export type CreateCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCommentMutation, CreateCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation updateComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    id
    content
    type
  }
}
    `;
export function useUpdateCommentMutation(options: VueApolloComposable.UseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
}
export type UpdateCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const TrashCommentDocument = gql`
    mutation trashComment($input: TrashCommentInput!) {
  trashComment(input: $input) {
    ...CoreCommentFields
  }
}
    ${CoreCommentFieldsFragmentDoc}`;
export function useTrashCommentMutation(options: VueApolloComposable.UseMutationOptions<TrashCommentMutation, TrashCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashCommentMutation, TrashCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashCommentMutation, TrashCommentMutationVariables>(TrashCommentDocument, options);
}
export type TrashCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashCommentMutation, TrashCommentMutationVariables>;
export const ContractDepositInformationDocument = gql`
    query contractDepositInformation($input: ID!) {
  contractDepositInformation(contract_attendee_id: $input) {
    contract_attendee_id
  }
}
    `;
export function useContractDepositInformationQuery(variables: ContractDepositInformationQueryVariables | VueCompositionApi.Ref<ContractDepositInformationQueryVariables> | ReactiveFunction<ContractDepositInformationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractDepositInformationQuery, ContractDepositInformationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractDepositInformationQuery, ContractDepositInformationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractDepositInformationQuery, ContractDepositInformationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContractDepositInformationQuery, ContractDepositInformationQueryVariables>(ContractDepositInformationDocument, variables, options);
}
export function useContractDepositInformationLazyQuery(variables?: ContractDepositInformationQueryVariables | VueCompositionApi.Ref<ContractDepositInformationQueryVariables> | ReactiveFunction<ContractDepositInformationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractDepositInformationQuery, ContractDepositInformationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractDepositInformationQuery, ContractDepositInformationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractDepositInformationQuery, ContractDepositInformationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContractDepositInformationQuery, ContractDepositInformationQueryVariables>(ContractDepositInformationDocument, variables, options);
}
export type ContractDepositInformationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContractDepositInformationQuery, ContractDepositInformationQueryVariables>;
export const SigningSheetsByTicketDocument = gql`
    query signingSheetsByTicket($ticket_id: ID!) {
  signingSheetsByTicket(ticket_id: $ticket_id) {
    id
    name
  }
}
    `;
export function useSigningSheetsByTicketQuery(variables: SigningSheetsByTicketQueryVariables | VueCompositionApi.Ref<SigningSheetsByTicketQueryVariables> | ReactiveFunction<SigningSheetsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<SigningSheetsByTicketQuery, SigningSheetsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SigningSheetsByTicketQuery, SigningSheetsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SigningSheetsByTicketQuery, SigningSheetsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SigningSheetsByTicketQuery, SigningSheetsByTicketQueryVariables>(SigningSheetsByTicketDocument, variables, options);
}
export function useSigningSheetsByTicketLazyQuery(variables?: SigningSheetsByTicketQueryVariables | VueCompositionApi.Ref<SigningSheetsByTicketQueryVariables> | ReactiveFunction<SigningSheetsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<SigningSheetsByTicketQuery, SigningSheetsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SigningSheetsByTicketQuery, SigningSheetsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SigningSheetsByTicketQuery, SigningSheetsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SigningSheetsByTicketQuery, SigningSheetsByTicketQueryVariables>(SigningSheetsByTicketDocument, variables, options);
}
export type SigningSheetsByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SigningSheetsByTicketQuery, SigningSheetsByTicketQueryVariables>;
export const IdentityDocument = gql`
    query Identity {
  identity {
    ...CoreIdentityFields
  }
}
    ${CoreIdentityFieldsFragmentDoc}`;
export function useIdentityQuery(options: VueApolloComposable.UseQueryOptions<IdentityQuery, IdentityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IdentityQuery, IdentityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IdentityQuery, IdentityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IdentityQuery, IdentityQueryVariables>(IdentityDocument, {}, options);
}
export function useIdentityLazyQuery(options: VueApolloComposable.UseQueryOptions<IdentityQuery, IdentityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IdentityQuery, IdentityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IdentityQuery, IdentityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IdentityQuery, IdentityQueryVariables>(IdentityDocument, {}, options);
}
export type IdentityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IdentityQuery, IdentityQueryVariables>;
export const IdentityLogoDocument = gql`
    query IdentityLogo($id: ID!) {
  identityLogo(id: $id) {
    id
    url
    filename
    type
  }
}
    `;
export function useIdentityLogoQuery(variables: IdentityLogoQueryVariables | VueCompositionApi.Ref<IdentityLogoQueryVariables> | ReactiveFunction<IdentityLogoQueryVariables>, options: VueApolloComposable.UseQueryOptions<IdentityLogoQuery, IdentityLogoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IdentityLogoQuery, IdentityLogoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IdentityLogoQuery, IdentityLogoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IdentityLogoQuery, IdentityLogoQueryVariables>(IdentityLogoDocument, variables, options);
}
export function useIdentityLogoLazyQuery(variables?: IdentityLogoQueryVariables | VueCompositionApi.Ref<IdentityLogoQueryVariables> | ReactiveFunction<IdentityLogoQueryVariables>, options: VueApolloComposable.UseQueryOptions<IdentityLogoQuery, IdentityLogoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IdentityLogoQuery, IdentityLogoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IdentityLogoQuery, IdentityLogoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IdentityLogoQuery, IdentityLogoQueryVariables>(IdentityLogoDocument, variables, options);
}
export type IdentityLogoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IdentityLogoQuery, IdentityLogoQueryVariables>;
export const OperationDocument = gql`
    query Operation($id: ID!) {
  operation(id: $id) {
    ...CoreOperationFields
  }
}
    ${CoreOperationFieldsFragmentDoc}`;
export function useOperationQuery(variables: OperationQueryVariables | VueCompositionApi.Ref<OperationQueryVariables> | ReactiveFunction<OperationQueryVariables>, options: VueApolloComposable.UseQueryOptions<OperationQuery, OperationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OperationQuery, OperationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OperationQuery, OperationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OperationQuery, OperationQueryVariables>(OperationDocument, variables, options);
}
export function useOperationLazyQuery(variables?: OperationQueryVariables | VueCompositionApi.Ref<OperationQueryVariables> | ReactiveFunction<OperationQueryVariables>, options: VueApolloComposable.UseQueryOptions<OperationQuery, OperationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OperationQuery, OperationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OperationQuery, OperationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OperationQuery, OperationQueryVariables>(OperationDocument, variables, options);
}
export type OperationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OperationQuery, OperationQueryVariables>;
export const TicketByCodeDocument = gql`
    query TicketByCode($code: String!) {
  ticketByCode(code: $code) {
    ...CoreTicketFields
    ...TicketAttachments
  }
}
    ${CoreTicketFieldsFragmentDoc}
${TicketAttachmentsFragmentDoc}`;
export function useTicketByCodeQuery(variables: TicketByCodeQueryVariables | VueCompositionApi.Ref<TicketByCodeQueryVariables> | ReactiveFunction<TicketByCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketByCodeQuery, TicketByCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketByCodeQuery, TicketByCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketByCodeQuery, TicketByCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketByCodeQuery, TicketByCodeQueryVariables>(TicketByCodeDocument, variables, options);
}
export function useTicketByCodeLazyQuery(variables?: TicketByCodeQueryVariables | VueCompositionApi.Ref<TicketByCodeQueryVariables> | ReactiveFunction<TicketByCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketByCodeQuery, TicketByCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketByCodeQuery, TicketByCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketByCodeQuery, TicketByCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketByCodeQuery, TicketByCodeQueryVariables>(TicketByCodeDocument, variables, options);
}
export type TicketByCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketByCodeQuery, TicketByCodeQueryVariables>;
export const NonCompliancesByTicketDocument = gql`
    query nonCompliancesByTicket($ticket_id: ID!) {
  nonCompliancesByTicket(ticket_id: $ticket_id) {
    id
    ticket_id
    type
    internal_code
  }
}
    `;
export function useNonCompliancesByTicketQuery(variables: NonCompliancesByTicketQueryVariables | VueCompositionApi.Ref<NonCompliancesByTicketQueryVariables> | ReactiveFunction<NonCompliancesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<NonCompliancesByTicketQuery, NonCompliancesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NonCompliancesByTicketQuery, NonCompliancesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NonCompliancesByTicketQuery, NonCompliancesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NonCompliancesByTicketQuery, NonCompliancesByTicketQueryVariables>(NonCompliancesByTicketDocument, variables, options);
}
export function useNonCompliancesByTicketLazyQuery(variables?: NonCompliancesByTicketQueryVariables | VueCompositionApi.Ref<NonCompliancesByTicketQueryVariables> | ReactiveFunction<NonCompliancesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<NonCompliancesByTicketQuery, NonCompliancesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NonCompliancesByTicketQuery, NonCompliancesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NonCompliancesByTicketQuery, NonCompliancesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NonCompliancesByTicketQuery, NonCompliancesByTicketQueryVariables>(NonCompliancesByTicketDocument, variables, options);
}
export type NonCompliancesByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NonCompliancesByTicketQuery, NonCompliancesByTicketQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    name
    first_name
    last_name
    full_name
    email
    keycloak_id
    phone
    email_notifications
    allocations {
      ...CoreAllocationsFields
    }
  }
}
    ${CoreAllocationsFieldsFragmentDoc}`;
export function useMeQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export function useMeLazyQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export type MeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MeQuery, MeQueryVariables>;
export const UserAssignableRoleDocument = gql`
    query UserAssignableRole($id: ID!) {
  getClientRoleFromUser(id: $id) {
    id
    name
    composite
    clientRole
    containerId
  }
  UserRolesListAll {
    id
    name
    composite
    clientRole
    containerId
  }
}
    `;
export function useUserAssignableRoleQuery(variables: UserAssignableRoleQueryVariables | VueCompositionApi.Ref<UserAssignableRoleQueryVariables> | ReactiveFunction<UserAssignableRoleQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignableRoleQuery, UserAssignableRoleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignableRoleQuery, UserAssignableRoleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignableRoleQuery, UserAssignableRoleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAssignableRoleQuery, UserAssignableRoleQueryVariables>(UserAssignableRoleDocument, variables, options);
}
export function useUserAssignableRoleLazyQuery(variables?: UserAssignableRoleQueryVariables | VueCompositionApi.Ref<UserAssignableRoleQueryVariables> | ReactiveFunction<UserAssignableRoleQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAssignableRoleQuery, UserAssignableRoleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAssignableRoleQuery, UserAssignableRoleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAssignableRoleQuery, UserAssignableRoleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAssignableRoleQuery, UserAssignableRoleQueryVariables>(UserAssignableRoleDocument, variables, options);
}
export type UserAssignableRoleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAssignableRoleQuery, UserAssignableRoleQueryVariables>;
export const UserClientRoleDocument = gql`
    query UserClientRole($id: ID!) {
  getClientRoleFromUser(id: $id) {
    id
    name
  }
}
    `;
export function useUserClientRoleQuery(variables: UserClientRoleQueryVariables | VueCompositionApi.Ref<UserClientRoleQueryVariables> | ReactiveFunction<UserClientRoleQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserClientRoleQuery, UserClientRoleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserClientRoleQuery, UserClientRoleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserClientRoleQuery, UserClientRoleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserClientRoleQuery, UserClientRoleQueryVariables>(UserClientRoleDocument, variables, options);
}
export function useUserClientRoleLazyQuery(variables?: UserClientRoleQueryVariables | VueCompositionApi.Ref<UserClientRoleQueryVariables> | ReactiveFunction<UserClientRoleQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserClientRoleQuery, UserClientRoleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserClientRoleQuery, UserClientRoleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserClientRoleQuery, UserClientRoleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserClientRoleQuery, UserClientRoleQueryVariables>(UserClientRoleDocument, variables, options);
}
export type UserClientRoleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserClientRoleQuery, UserClientRoleQueryVariables>;
export const UserRolesListAllDocument = gql`
    query UserRolesListAll {
  UserRolesListAll {
    id
    name
    composite
    clientRole
    containerId
  }
}
    `;
export function useUserRolesListAllQuery(options: VueApolloComposable.UseQueryOptions<UserRolesListAllQuery, UserRolesListAllQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserRolesListAllQuery, UserRolesListAllQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserRolesListAllQuery, UserRolesListAllQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserRolesListAllQuery, UserRolesListAllQueryVariables>(UserRolesListAllDocument, {}, options);
}
export function useUserRolesListAllLazyQuery(options: VueApolloComposable.UseQueryOptions<UserRolesListAllQuery, UserRolesListAllQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserRolesListAllQuery, UserRolesListAllQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserRolesListAllQuery, UserRolesListAllQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserRolesListAllQuery, UserRolesListAllQueryVariables>(UserRolesListAllDocument, {}, options);
}
export type UserRolesListAllQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserRolesListAllQuery, UserRolesListAllQueryVariables>;
export const UserAvatarDocument = gql`
    query UserAvatar($id: ID!) {
  userAvatar(id: $id) {
    id
    url
    filename
    type
  }
}
    `;
export function useUserAvatarQuery(variables: UserAvatarQueryVariables | VueCompositionApi.Ref<UserAvatarQueryVariables> | ReactiveFunction<UserAvatarQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAvatarQuery, UserAvatarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAvatarQuery, UserAvatarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAvatarQuery, UserAvatarQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAvatarQuery, UserAvatarQueryVariables>(UserAvatarDocument, variables, options);
}
export function useUserAvatarLazyQuery(variables?: UserAvatarQueryVariables | VueCompositionApi.Ref<UserAvatarQueryVariables> | ReactiveFunction<UserAvatarQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAvatarQuery, UserAvatarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAvatarQuery, UserAvatarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAvatarQuery, UserAvatarQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAvatarQuery, UserAvatarQueryVariables>(UserAvatarDocument, variables, options);
}
export type UserAvatarQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAvatarQuery, UserAvatarQueryVariables>;
export const UsersValidatorListDocument = gql`
    query UsersValidatorList {
  UsersValidatorList {
    validators_1 {
      id
      keycloak_id
      first_name
      last_name
      email
    }
    validators_2 {
      id
      keycloak_id
      first_name
      last_name
      email
    }
  }
}
    `;
export function useUsersValidatorListQuery(options: VueApolloComposable.UseQueryOptions<UsersValidatorListQuery, UsersValidatorListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersValidatorListQuery, UsersValidatorListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersValidatorListQuery, UsersValidatorListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UsersValidatorListQuery, UsersValidatorListQueryVariables>(UsersValidatorListDocument, {}, options);
}
export function useUsersValidatorListLazyQuery(options: VueApolloComposable.UseQueryOptions<UsersValidatorListQuery, UsersValidatorListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersValidatorListQuery, UsersValidatorListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersValidatorListQuery, UsersValidatorListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UsersValidatorListQuery, UsersValidatorListQueryVariables>(UsersValidatorListDocument, {}, options);
}
export type UsersValidatorListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UsersValidatorListQuery, UsersValidatorListQueryVariables>;
export const GetAllWorkflowsDocument = gql`
    query GetAllWorkflows {
  workflows {
    ...CoreWorkflowFields
  }
}
    ${CoreWorkflowFieldsFragmentDoc}`;
export function useGetAllWorkflowsQuery(options: VueApolloComposable.UseQueryOptions<GetAllWorkflowsQuery, GetAllWorkflowsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllWorkflowsQuery, GetAllWorkflowsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllWorkflowsQuery, GetAllWorkflowsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllWorkflowsQuery, GetAllWorkflowsQueryVariables>(GetAllWorkflowsDocument, {}, options);
}
export function useGetAllWorkflowsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAllWorkflowsQuery, GetAllWorkflowsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllWorkflowsQuery, GetAllWorkflowsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllWorkflowsQuery, GetAllWorkflowsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllWorkflowsQuery, GetAllWorkflowsQueryVariables>(GetAllWorkflowsDocument, {}, options);
}
export type GetAllWorkflowsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllWorkflowsQuery, GetAllWorkflowsQueryVariables>;
export const FetchWorkflowByIdDocument = gql`
    query fetchWorkflowById($id: ID!) {
  workflow(id: $id) {
    ...CoreWorkflowFields
  }
}
    ${CoreWorkflowFieldsFragmentDoc}`;
export function useFetchWorkflowByIdQuery(variables: FetchWorkflowByIdQueryVariables | VueCompositionApi.Ref<FetchWorkflowByIdQueryVariables> | ReactiveFunction<FetchWorkflowByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchWorkflowByIdQuery, FetchWorkflowByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchWorkflowByIdQuery, FetchWorkflowByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchWorkflowByIdQuery, FetchWorkflowByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchWorkflowByIdQuery, FetchWorkflowByIdQueryVariables>(FetchWorkflowByIdDocument, variables, options);
}
export function useFetchWorkflowByIdLazyQuery(variables?: FetchWorkflowByIdQueryVariables | VueCompositionApi.Ref<FetchWorkflowByIdQueryVariables> | ReactiveFunction<FetchWorkflowByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchWorkflowByIdQuery, FetchWorkflowByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchWorkflowByIdQuery, FetchWorkflowByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchWorkflowByIdQuery, FetchWorkflowByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchWorkflowByIdQuery, FetchWorkflowByIdQueryVariables>(FetchWorkflowByIdDocument, variables, options);
}
export type FetchWorkflowByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchWorkflowByIdQuery, FetchWorkflowByIdQueryVariables>;
export const CreateWorkflowDocument = gql`
    mutation CreateWorkflow($input: CreateWorkflowInput!) {
  createWorkflow(input: $input) {
    ...CoreWorkflowFields
  }
}
    ${CoreWorkflowFieldsFragmentDoc}`;
export function useCreateWorkflowMutation(options: VueApolloComposable.UseMutationOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateWorkflowMutation, CreateWorkflowMutationVariables>(CreateWorkflowDocument, options);
}
export type CreateWorkflowMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const UpdateWorkflowDocument = gql`
    mutation UpdateWorkflow($input: UpdateWorkflowInput!) {
  updateWorkflow(input: $input) {
    ...CoreWorkflowFields
  }
}
    ${CoreWorkflowFieldsFragmentDoc}`;
export function useUpdateWorkflowMutation(options: VueApolloComposable.UseMutationOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>(UpdateWorkflowDocument, options);
}
export type UpdateWorkflowMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const WorkflowsPaginatorDocument = gql`
    query WorkflowsPaginator($first: Int!, $page: Int) {
  workflowsPaginator(first: $first, page: $page) {
    data {
      ...CoreWorkflowFields
      is_used
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreWorkflowFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useWorkflowsPaginatorQuery(variables: WorkflowsPaginatorQueryVariables | VueCompositionApi.Ref<WorkflowsPaginatorQueryVariables> | ReactiveFunction<WorkflowsPaginatorQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkflowsPaginatorQuery, WorkflowsPaginatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkflowsPaginatorQuery, WorkflowsPaginatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkflowsPaginatorQuery, WorkflowsPaginatorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WorkflowsPaginatorQuery, WorkflowsPaginatorQueryVariables>(WorkflowsPaginatorDocument, variables, options);
}
export function useWorkflowsPaginatorLazyQuery(variables?: WorkflowsPaginatorQueryVariables | VueCompositionApi.Ref<WorkflowsPaginatorQueryVariables> | ReactiveFunction<WorkflowsPaginatorQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkflowsPaginatorQuery, WorkflowsPaginatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkflowsPaginatorQuery, WorkflowsPaginatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkflowsPaginatorQuery, WorkflowsPaginatorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WorkflowsPaginatorQuery, WorkflowsPaginatorQueryVariables>(WorkflowsPaginatorDocument, variables, options);
}
export type WorkflowsPaginatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WorkflowsPaginatorQuery, WorkflowsPaginatorQueryVariables>;
export const TrashWorkflowDocument = gql`
    mutation trashWorkflow($input: TrashWorkflowInput!) {
  trashWorkflow(input: $input) {
    ...CoreWorkflowFields
  }
}
    ${CoreWorkflowFieldsFragmentDoc}`;
export function useTrashWorkflowMutation(options: VueApolloComposable.UseMutationOptions<TrashWorkflowMutation, TrashWorkflowMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashWorkflowMutation, TrashWorkflowMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashWorkflowMutation, TrashWorkflowMutationVariables>(TrashWorkflowDocument, options);
}
export type TrashWorkflowMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashWorkflowMutation, TrashWorkflowMutationVariables>;
export const CreateActualAdvantageDocument = gql`
    mutation createActualAdvantage($input: CreateActualAdvantageInput!) {
  createActualAdvantage(input: $input) {
    advantage_type
    net_amount
    gross_amount
    excluding_tax_amount
    including_tax_amount
    attendee_id
    quantity
    payment_date
  }
}
    `;
export function useCreateActualAdvantageMutation(options: VueApolloComposable.UseMutationOptions<CreateActualAdvantageMutation, CreateActualAdvantageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateActualAdvantageMutation, CreateActualAdvantageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateActualAdvantageMutation, CreateActualAdvantageMutationVariables>(CreateActualAdvantageDocument, options);
}
export type CreateActualAdvantageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateActualAdvantageMutation, CreateActualAdvantageMutationVariables>;
export const UpdateActualAdvantageDocument = gql`
    mutation updateActualAdvantage($input: UpdateActualAdvantageInput!) {
  updateActualAdvantage(input: $input) {
    advantage_type
    net_amount
    gross_amount
    excluding_tax_amount
    including_tax_amount
    attendee_id
    quantity
    detail
    comment
    area
    payment_date
  }
}
    `;
export function useUpdateActualAdvantageMutation(options: VueApolloComposable.UseMutationOptions<UpdateActualAdvantageMutation, UpdateActualAdvantageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateActualAdvantageMutation, UpdateActualAdvantageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateActualAdvantageMutation, UpdateActualAdvantageMutationVariables>(UpdateActualAdvantageDocument, options);
}
export type UpdateActualAdvantageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateActualAdvantageMutation, UpdateActualAdvantageMutationVariables>;
export const TrashActualAdvantageDocument = gql`
    mutation trashActualAdvantage($input: TrashActualAdvantageInput!) {
  trashActualAdvantage(input: $input) {
    id
  }
}
    `;
export function useTrashActualAdvantageMutation(options: VueApolloComposable.UseMutationOptions<TrashActualAdvantageMutation, TrashActualAdvantageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashActualAdvantageMutation, TrashActualAdvantageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashActualAdvantageMutation, TrashActualAdvantageMutationVariables>(TrashActualAdvantageDocument, options);
}
export type TrashActualAdvantageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashActualAdvantageMutation, TrashActualAdvantageMutationVariables>;
export const CreateActualAdvantagesDocument = gql`
    mutation createActualAdvantages($packageID: ID!, $input: [CreateActualAdvantageInput!]!) {
  createActualAdvantages(packageID: $packageID, input: $input)
}
    `;
export function useCreateActualAdvantagesMutation(options: VueApolloComposable.UseMutationOptions<CreateActualAdvantagesMutation, CreateActualAdvantagesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateActualAdvantagesMutation, CreateActualAdvantagesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateActualAdvantagesMutation, CreateActualAdvantagesMutationVariables>(CreateActualAdvantagesDocument, options);
}
export type CreateActualAdvantagesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateActualAdvantagesMutation, CreateActualAdvantagesMutationVariables>;
export const CreateActualPackageDocument = gql`
    mutation createActualPackage($input: CreateActualPackageInput!) {
  createActualPackage(input: $input) {
    id
    name
    advantages {
      ...CoreActualAdvantageFields
    }
    ticket {
      id
    }
    is_distribution
    created_at
    updated_at
  }
}
    ${CoreActualAdvantageFieldsFragmentDoc}`;
export function useCreateActualPackageMutation(options: VueApolloComposable.UseMutationOptions<CreateActualPackageMutation, CreateActualPackageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateActualPackageMutation, CreateActualPackageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateActualPackageMutation, CreateActualPackageMutationVariables>(CreateActualPackageDocument, options);
}
export type CreateActualPackageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateActualPackageMutation, CreateActualPackageMutationVariables>;
export const UpdateActualPackageDocument = gql`
    mutation updateActualPackage($input: UpdateActualPackageInput!) {
  updateActualPackage(input: $input) {
    id
    name
    advantages {
      ...CoreActualAdvantageFields
    }
    ticket {
      id
    }
    created_at
    updated_at
  }
}
    ${CoreActualAdvantageFieldsFragmentDoc}`;
export function useUpdateActualPackageMutation(options: VueApolloComposable.UseMutationOptions<UpdateActualPackageMutation, UpdateActualPackageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateActualPackageMutation, UpdateActualPackageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateActualPackageMutation, UpdateActualPackageMutationVariables>(UpdateActualPackageDocument, options);
}
export type UpdateActualPackageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateActualPackageMutation, UpdateActualPackageMutationVariables>;
export const TrashActualPackageDocument = gql`
    mutation trashActualPackage($input: TrashActualPackageInput!) {
  trashActualPackage(input: $input) {
    id
  }
}
    `;
export function useTrashActualPackageMutation(options: VueApolloComposable.UseMutationOptions<TrashActualPackageMutation, TrashActualPackageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashActualPackageMutation, TrashActualPackageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashActualPackageMutation, TrashActualPackageMutationVariables>(TrashActualPackageDocument, options);
}
export type TrashActualPackageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashActualPackageMutation, TrashActualPackageMutationVariables>;
export const DeleteActualPackageDocument = gql`
    mutation deleteActualPackage($input: DeleteActualPackageInput!) {
  deleteActualPackage(input: $input) {
    id
  }
}
    `;
export function useDeleteActualPackageMutation(options: VueApolloComposable.UseMutationOptions<DeleteActualPackageMutation, DeleteActualPackageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteActualPackageMutation, DeleteActualPackageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteActualPackageMutation, DeleteActualPackageMutationVariables>(DeleteActualPackageDocument, options);
}
export type DeleteActualPackageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteActualPackageMutation, DeleteActualPackageMutationVariables>;
export const AssignActualPackagesToTicketDocument = gql`
    mutation assignActualPackagesToTicket($input: AssignActualPackagesToTicketInput) {
  assignActualPackagesToTicket(input: $input) {
    id
    name
    advantages {
      ...CoreActualAdvantageFields
    }
    ticket {
      id
    }
    created_at
    updated_at
  }
}
    ${CoreActualAdvantageFieldsFragmentDoc}`;
export function useAssignActualPackagesToTicketMutation(options: VueApolloComposable.UseMutationOptions<AssignActualPackagesToTicketMutation, AssignActualPackagesToTicketMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignActualPackagesToTicketMutation, AssignActualPackagesToTicketMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AssignActualPackagesToTicketMutation, AssignActualPackagesToTicketMutationVariables>(AssignActualPackagesToTicketDocument, options);
}
export type AssignActualPackagesToTicketMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignActualPackagesToTicketMutation, AssignActualPackagesToTicketMutationVariables>;
export const AssignActualPackageToAttendeesDocument = gql`
    mutation assignActualPackageToAttendees($input: AssignActualPackageToAttendeesInput) {
  assignActualPackageToAttendees(input: $input)
}
    `;
export function useAssignActualPackageToAttendeesMutation(options: VueApolloComposable.UseMutationOptions<AssignActualPackageToAttendeesMutation, AssignActualPackageToAttendeesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignActualPackageToAttendeesMutation, AssignActualPackageToAttendeesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AssignActualPackageToAttendeesMutation, AssignActualPackageToAttendeesMutationVariables>(AssignActualPackageToAttendeesDocument, options);
}
export type AssignActualPackageToAttendeesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignActualPackageToAttendeesMutation, AssignActualPackageToAttendeesMutationVariables>;
export const UnassignActualPackageToAttendeeDocument = gql`
    mutation unassignActualPackageToAttendee($input: UnassignActualPackageToAttendeeInput) {
  unassignActualPackageToAttendee(input: $input)
}
    `;
export function useUnassignActualPackageToAttendeeMutation(options: VueApolloComposable.UseMutationOptions<UnassignActualPackageToAttendeeMutation, UnassignActualPackageToAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnassignActualPackageToAttendeeMutation, UnassignActualPackageToAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnassignActualPackageToAttendeeMutation, UnassignActualPackageToAttendeeMutationVariables>(UnassignActualPackageToAttendeeDocument, options);
}
export type UnassignActualPackageToAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnassignActualPackageToAttendeeMutation, UnassignActualPackageToAttendeeMutationVariables>;
export const ClonePlannedPackagesAsActualPackagesDocument = gql`
    mutation clonePlannedPackagesAsActualPackages($input: ClonePlannedPackagesAsActualPackagesInput) {
  clonePlannedPackagesAsActualPackages(input: $input) {
    id
    name
    advantages {
      ...CoreActualAdvantageFields
    }
    ticket {
      id
    }
    created_at
    updated_at
  }
}
    ${CoreActualAdvantageFieldsFragmentDoc}`;
export function useClonePlannedPackagesAsActualPackagesMutation(options: VueApolloComposable.UseMutationOptions<ClonePlannedPackagesAsActualPackagesMutation, ClonePlannedPackagesAsActualPackagesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClonePlannedPackagesAsActualPackagesMutation, ClonePlannedPackagesAsActualPackagesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ClonePlannedPackagesAsActualPackagesMutation, ClonePlannedPackagesAsActualPackagesMutationVariables>(ClonePlannedPackagesAsActualPackagesDocument, options);
}
export type ClonePlannedPackagesAsActualPackagesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClonePlannedPackagesAsActualPackagesMutation, ClonePlannedPackagesAsActualPackagesMutationVariables>;
export const GenerateAgencyExportDocument = gql`
    mutation GenerateAgencyExport($input: GenerateAgencyExportInput!) {
  generateAgencyExport(input: $input) {
    batch_id
  }
}
    `;
export function useGenerateAgencyExportMutation(options: VueApolloComposable.UseMutationOptions<GenerateAgencyExportMutation, GenerateAgencyExportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateAgencyExportMutation, GenerateAgencyExportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateAgencyExportMutation, GenerateAgencyExportMutationVariables>(GenerateAgencyExportDocument, options);
}
export type GenerateAgencyExportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateAgencyExportMutation, GenerateAgencyExportMutationVariables>;
export const UpsertAllocationsNetworkDocument = gql`
    mutation UpsertAllocationsNetwork($id: ID, $input: UpsertNetworkInput!) {
  upsertNetwork(id: $id, input: $input) {
    ...CoreNetworkFields
  }
}
    ${CoreNetworkFieldsFragmentDoc}`;
export function useUpsertAllocationsNetworkMutation(options: VueApolloComposable.UseMutationOptions<UpsertAllocationsNetworkMutation, UpsertAllocationsNetworkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertAllocationsNetworkMutation, UpsertAllocationsNetworkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertAllocationsNetworkMutation, UpsertAllocationsNetworkMutationVariables>(UpsertAllocationsNetworkDocument, options);
}
export type UpsertAllocationsNetworkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertAllocationsNetworkMutation, UpsertAllocationsNetworkMutationVariables>;
export const UpsertAllocationsUgaDocument = gql`
    mutation UpsertAllocationsUga($id: ID, $input: UpsertUgaInput!) {
  upsertUga(id: $id, input: $input) {
    ...CoreUgaFields
  }
}
    ${CoreUgaFieldsFragmentDoc}`;
export function useUpsertAllocationsUgaMutation(options: VueApolloComposable.UseMutationOptions<UpsertAllocationsUgaMutation, UpsertAllocationsUgaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertAllocationsUgaMutation, UpsertAllocationsUgaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertAllocationsUgaMutation, UpsertAllocationsUgaMutationVariables>(UpsertAllocationsUgaDocument, options);
}
export type UpsertAllocationsUgaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertAllocationsUgaMutation, UpsertAllocationsUgaMutationVariables>;
export const UpsertAllocationsZoneDocument = gql`
    mutation UpsertAllocationsZone($id: ID, $input: UpsertZoneInput!) {
  upsertZone(id: $id, input: $input) {
    ...CoreZoneFields
  }
}
    ${CoreZoneFieldsFragmentDoc}`;
export function useUpsertAllocationsZoneMutation(options: VueApolloComposable.UseMutationOptions<UpsertAllocationsZoneMutation, UpsertAllocationsZoneMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertAllocationsZoneMutation, UpsertAllocationsZoneMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertAllocationsZoneMutation, UpsertAllocationsZoneMutationVariables>(UpsertAllocationsZoneDocument, options);
}
export type UpsertAllocationsZoneMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertAllocationsZoneMutation, UpsertAllocationsZoneMutationVariables>;
export const CreateAttachmentTemplatesDocument = gql`
    mutation createAttachmentTemplates($input: AttachmentInput!) {
  createAttachmentTemplates(input: $input) {
    id
    comment
    type
  }
}
    `;
export function useCreateAttachmentTemplatesMutation(options: VueApolloComposable.UseMutationOptions<CreateAttachmentTemplatesMutation, CreateAttachmentTemplatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAttachmentTemplatesMutation, CreateAttachmentTemplatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAttachmentTemplatesMutation, CreateAttachmentTemplatesMutationVariables>(CreateAttachmentTemplatesDocument, options);
}
export type CreateAttachmentTemplatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAttachmentTemplatesMutation, CreateAttachmentTemplatesMutationVariables>;
export const GenerateContractZipFileDocument = gql`
    mutation generateContractZipFile($input: GenerateContractZipFileInput!) {
  generateContractZipFile(input: $input) {
    batch_id
  }
}
    `;
export function useGenerateContractZipFileMutation(options: VueApolloComposable.UseMutationOptions<GenerateContractZipFileMutation, GenerateContractZipFileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateContractZipFileMutation, GenerateContractZipFileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateContractZipFileMutation, GenerateContractZipFileMutationVariables>(GenerateContractZipFileDocument, options);
}
export type GenerateContractZipFileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateContractZipFileMutation, GenerateContractZipFileMutationVariables>;
export const CreateAttachmentsDocument = gql`
    mutation createAttachments($input: AttachmentInput!) {
  createAttachments(input: $input) {
    id
    comment
    type
  }
}
    `;
export function useCreateAttachmentsMutation(options: VueApolloComposable.UseMutationOptions<CreateAttachmentsMutation, CreateAttachmentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>(CreateAttachmentsDocument, options);
}
export type CreateAttachmentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>;
export const CreateAttendeeByImportDocument = gql`
    mutation createAttendeeByImport($input: CreateAttendeeByImportInput!) {
  createAttendeeByImport(input: $input) {
    batch_id
  }
}
    `;
export function useCreateAttendeeByImportMutation(options: VueApolloComposable.UseMutationOptions<CreateAttendeeByImportMutation, CreateAttendeeByImportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAttendeeByImportMutation, CreateAttendeeByImportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAttendeeByImportMutation, CreateAttendeeByImportMutationVariables>(CreateAttendeeByImportDocument, options);
}
export type CreateAttendeeByImportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAttendeeByImportMutation, CreateAttendeeByImportMutationVariables>;
export const CreateAttendeeByApiDocument = gql`
    mutation createAttendeeByApi($input: CreateAttendeeByApiInput!) {
  createAttendeeByApi(input: $input) {
    ...CoreAttendeeByApiFields
  }
}
    ${CoreAttendeeByApiFieldsFragmentDoc}`;
export function useCreateAttendeeByApiMutation(options: VueApolloComposable.UseMutationOptions<CreateAttendeeByApiMutation, CreateAttendeeByApiMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAttendeeByApiMutation, CreateAttendeeByApiMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAttendeeByApiMutation, CreateAttendeeByApiMutationVariables>(CreateAttendeeByApiDocument, options);
}
export type CreateAttendeeByApiMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAttendeeByApiMutation, CreateAttendeeByApiMutationVariables>;
export const CreateAttendeesByApiDocument = gql`
    mutation createAttendeesByApi($input: CreateAttendeesByApiInput!) {
  createAttendeesByApi(input: $input) {
    created {
      ...CoreAttendeeByApiFields
    }
    errors {
      index
      firstname
      lastname
      message
    }
  }
}
    ${CoreAttendeeByApiFieldsFragmentDoc}`;
export function useCreateAttendeesByApiMutation(options: VueApolloComposable.UseMutationOptions<CreateAttendeesByApiMutation, CreateAttendeesByApiMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAttendeesByApiMutation, CreateAttendeesByApiMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAttendeesByApiMutation, CreateAttendeesByApiMutationVariables>(CreateAttendeesByApiDocument, options);
}
export type CreateAttendeesByApiMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAttendeesByApiMutation, CreateAttendeesByApiMutationVariables>;
export const UpdateAttendeeFacturationDocument = gql`
    mutation updateAttendeeFacturation($input: UpdateAttendeeFacturationInput!) {
  updateAttendeeFacturation(input: $input) {
    id
    is_present
    is_billed
  }
}
    `;
export function useUpdateAttendeeFacturationMutation(options: VueApolloComposable.UseMutationOptions<UpdateAttendeeFacturationMutation, UpdateAttendeeFacturationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAttendeeFacturationMutation, UpdateAttendeeFacturationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAttendeeFacturationMutation, UpdateAttendeeFacturationMutationVariables>(UpdateAttendeeFacturationDocument, options);
}
export type UpdateAttendeeFacturationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAttendeeFacturationMutation, UpdateAttendeeFacturationMutationVariables>;
export const UpdateAttendeesBillingDocument = gql`
    mutation updateAttendeesBilling($input: UpdateAttendeesBillingInput!) {
  updateAttendeesBilling(input: $input)
}
    `;
export function useUpdateAttendeesBillingMutation(options: VueApolloComposable.UseMutationOptions<UpdateAttendeesBillingMutation, UpdateAttendeesBillingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAttendeesBillingMutation, UpdateAttendeesBillingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAttendeesBillingMutation, UpdateAttendeesBillingMutationVariables>(UpdateAttendeesBillingDocument, options);
}
export type UpdateAttendeesBillingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAttendeesBillingMutation, UpdateAttendeesBillingMutationVariables>;
export const BulkUpdateAttendeesDocument = gql`
    mutation bulkUpdateAttendees($input: BulkUpdateAttendeesInput!) {
  bulkUpdateAttendees(input: $input) {
    ...CoreAttendeeTicketFields
  }
}
    ${CoreAttendeeTicketFieldsFragmentDoc}`;
export function useBulkUpdateAttendeesMutation(options: VueApolloComposable.UseMutationOptions<BulkUpdateAttendeesMutation, BulkUpdateAttendeesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkUpdateAttendeesMutation, BulkUpdateAttendeesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BulkUpdateAttendeesMutation, BulkUpdateAttendeesMutationVariables>(BulkUpdateAttendeesDocument, options);
}
export type BulkUpdateAttendeesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkUpdateAttendeesMutation, BulkUpdateAttendeesMutationVariables>;
export const CloneContactAsAttendeeDocument = gql`
    mutation cloneContactAsAttendee($input: CloneContactAsAttendeeInput!) {
  cloneContactAsAttendee(input: $input) {
    ...CoreAttendeeByApiFields
  }
}
    ${CoreAttendeeByApiFieldsFragmentDoc}`;
export function useCloneContactAsAttendeeMutation(options: VueApolloComposable.UseMutationOptions<CloneContactAsAttendeeMutation, CloneContactAsAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloneContactAsAttendeeMutation, CloneContactAsAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CloneContactAsAttendeeMutation, CloneContactAsAttendeeMutationVariables>(CloneContactAsAttendeeDocument, options);
}
export type CloneContactAsAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloneContactAsAttendeeMutation, CloneContactAsAttendeeMutationVariables>;
export const CloneContactsAsAttendeesDocument = gql`
    mutation cloneContactsAsAttendees($input: CloneContactsAsAttendeesInput!) {
  cloneContactsAsAttendees(input: $input) {
    created {
      ...CoreAttendeeByApiFields
    }
    errors {
      index
      contact_id
      message
    }
  }
}
    ${CoreAttendeeByApiFieldsFragmentDoc}`;
export function useCloneContactsAsAttendeesMutation(options: VueApolloComposable.UseMutationOptions<CloneContactsAsAttendeesMutation, CloneContactsAsAttendeesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloneContactsAsAttendeesMutation, CloneContactsAsAttendeesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CloneContactsAsAttendeesMutation, CloneContactsAsAttendeesMutationVariables>(CloneContactsAsAttendeesDocument, options);
}
export type CloneContactsAsAttendeesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloneContactsAsAttendeesMutation, CloneContactsAsAttendeesMutationVariables>;
export const TrashAttendeesDocument = gql`
    mutation trashAttendees($ids: [ID!]!, $ticket_id: ID!) {
  trashAttendees(ids: $ids, ticket_id: $ticket_id)
}
    `;
export function useTrashAttendeesMutation(options: VueApolloComposable.UseMutationOptions<TrashAttendeesMutation, TrashAttendeesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashAttendeesMutation, TrashAttendeesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashAttendeesMutation, TrashAttendeesMutationVariables>(TrashAttendeesDocument, options);
}
export type TrashAttendeesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashAttendeesMutation, TrashAttendeesMutationVariables>;
export const UpsertAttendeeSignatureDocument = gql`
    mutation UpsertAttendeeSignature($id: ID, $input: UpsertAttendeeSignatureInput!) {
  upsertAttendeeSignature(id: $id, input: $input) {
    ...CoreAttendeeSignatureFields
  }
}
    ${CoreAttendeeSignatureFieldsFragmentDoc}`;
export function useUpsertAttendeeSignatureMutation(options: VueApolloComposable.UseMutationOptions<UpsertAttendeeSignatureMutation, UpsertAttendeeSignatureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertAttendeeSignatureMutation, UpsertAttendeeSignatureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertAttendeeSignatureMutation, UpsertAttendeeSignatureMutationVariables>(UpsertAttendeeSignatureDocument, options);
}
export type UpsertAttendeeSignatureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertAttendeeSignatureMutation, UpsertAttendeeSignatureMutationVariables>;
export const DeleteAttendeeSignatureDocument = gql`
    mutation DeleteAttendeeSignature($id: ID!) {
  deleteAttendeeSignature(id: $id) {
    ...CoreAttendeeSignatureFields
  }
}
    ${CoreAttendeeSignatureFieldsFragmentDoc}`;
export function useDeleteAttendeeSignatureMutation(options: VueApolloComposable.UseMutationOptions<DeleteAttendeeSignatureMutation, DeleteAttendeeSignatureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAttendeeSignatureMutation, DeleteAttendeeSignatureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAttendeeSignatureMutation, DeleteAttendeeSignatureMutationVariables>(DeleteAttendeeSignatureDocument, options);
}
export type DeleteAttendeeSignatureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAttendeeSignatureMutation, DeleteAttendeeSignatureMutationVariables>;
export const CreateContactDocument = gql`
    mutation createContact($input: CreateContactInput!) {
  createContact(input: $input) {
    ...CoreContactFields
  }
}
    ${CoreContactFieldsFragmentDoc}`;
export function useCreateContactMutation(options: VueApolloComposable.UseMutationOptions<CreateContactMutation, CreateContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateContactMutation, CreateContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
}
export type CreateContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation updateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    ...CoreContactFields
  }
}
    ${CoreContactFieldsFragmentDoc}`;
export function useUpdateContactMutation(options: VueApolloComposable.UseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
}
export type UpdateContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateContactMutation, UpdateContactMutationVariables>;
export const TrashContactDocument = gql`
    mutation trashContact($input: TrashContactInput!) {
  trashContact(input: $input) {
    id
  }
}
    `;
export function useTrashContactMutation(options: VueApolloComposable.UseMutationOptions<TrashContactMutation, TrashContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashContactMutation, TrashContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashContactMutation, TrashContactMutationVariables>(TrashContactDocument, options);
}
export type TrashContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashContactMutation, TrashContactMutationVariables>;
export const ContractAttendeeDocument = gql`
    query ContractAttendee($id: ID!) {
  contractAttendee(id: $id) {
    ...CoreContractAttendee
  }
}
    ${CoreContractAttendeeFragmentDoc}`;
export function useContractAttendeeQuery(variables: ContractAttendeeQueryVariables | VueCompositionApi.Ref<ContractAttendeeQueryVariables> | ReactiveFunction<ContractAttendeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractAttendeeQuery, ContractAttendeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractAttendeeQuery, ContractAttendeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractAttendeeQuery, ContractAttendeeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContractAttendeeQuery, ContractAttendeeQueryVariables>(ContractAttendeeDocument, variables, options);
}
export function useContractAttendeeLazyQuery(variables?: ContractAttendeeQueryVariables | VueCompositionApi.Ref<ContractAttendeeQueryVariables> | ReactiveFunction<ContractAttendeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractAttendeeQuery, ContractAttendeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractAttendeeQuery, ContractAttendeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractAttendeeQuery, ContractAttendeeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContractAttendeeQuery, ContractAttendeeQueryVariables>(ContractAttendeeDocument, variables, options);
}
export type ContractAttendeeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContractAttendeeQuery, ContractAttendeeQueryVariables>;
export const UploadContractTemplateDocument = gql`
    mutation UploadContractTemplate($input: UploadContractTemplateInput!) {
  uploadContractTemplate(input: $input) {
    id
    ticket_id
    name
    signature_request_type
    document {
      ...CoreDocumentFields
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useUploadContractTemplateMutation(options: VueApolloComposable.UseMutationOptions<UploadContractTemplateMutation, UploadContractTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadContractTemplateMutation, UploadContractTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadContractTemplateMutation, UploadContractTemplateMutationVariables>(UploadContractTemplateDocument, options);
}
export type UploadContractTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadContractTemplateMutation, UploadContractTemplateMutationVariables>;
export const DeleteContractTemplateDocument = gql`
    mutation DeleteContractTemplate($input: DeleteTemplateContractInput!) {
  deleteContractTemplate(input: $input) {
    id
  }
}
    `;
export function useDeleteContractTemplateMutation(options: VueApolloComposable.UseMutationOptions<DeleteContractTemplateMutation, DeleteContractTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteContractTemplateMutation, DeleteContractTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteContractTemplateMutation, DeleteContractTemplateMutationVariables>(DeleteContractTemplateDocument, options);
}
export type DeleteContractTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteContractTemplateMutation, DeleteContractTemplateMutationVariables>;
export const ToggleActiveStateConventionsDocument = gql`
    mutation toggleActiveStateConventions($input: ToggleActiveStateConventionsInput!) {
  toggleActiveStateConventions(input: $input)
}
    `;
export function useToggleActiveStateConventionsMutation(options: VueApolloComposable.UseMutationOptions<ToggleActiveStateConventionsMutation, ToggleActiveStateConventionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ToggleActiveStateConventionsMutation, ToggleActiveStateConventionsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ToggleActiveStateConventionsMutation, ToggleActiveStateConventionsMutationVariables>(ToggleActiveStateConventionsDocument, options);
}
export type ToggleActiveStateConventionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ToggleActiveStateConventionsMutation, ToggleActiveStateConventionsMutationVariables>;
export const CreateConventionDocument = gql`
    mutation createConvention($input: CreateConventionInput!) {
  createConvention(input: $input) {
    ...CoreAdvantagesConvention
  }
}
    ${CoreAdvantagesConventionFragmentDoc}`;
export function useCreateConventionMutation(options: VueApolloComposable.UseMutationOptions<CreateConventionMutation, CreateConventionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateConventionMutation, CreateConventionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateConventionMutation, CreateConventionMutationVariables>(CreateConventionDocument, options);
}
export type CreateConventionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateConventionMutation, CreateConventionMutationVariables>;
export const UpdateConventionDocument = gql`
    mutation updateConvention($input: UpdateConventionInput!) {
  updateConvention(input: $input) {
    ...CoreAdvantagesConvention
  }
}
    ${CoreAdvantagesConventionFragmentDoc}`;
export function useUpdateConventionMutation(options: VueApolloComposable.UseMutationOptions<UpdateConventionMutation, UpdateConventionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateConventionMutation, UpdateConventionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateConventionMutation, UpdateConventionMutationVariables>(UpdateConventionDocument, options);
}
export type UpdateConventionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateConventionMutation, UpdateConventionMutationVariables>;
export const UpsertCrmUserDocument = gql`
    mutation upsertCrmUser($id: ID, $input: UpsertCrmUserInput!) {
  upsertCrmUser(id: $id, input: $input) {
    ...CoreCrmUserFields
  }
}
    ${CoreCrmUserFieldsFragmentDoc}`;
export function useUpsertCrmUserMutation(options: VueApolloComposable.UseMutationOptions<UpsertCrmUserMutation, UpsertCrmUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertCrmUserMutation, UpsertCrmUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertCrmUserMutation, UpsertCrmUserMutationVariables>(UpsertCrmUserDocument, options);
}
export type UpsertCrmUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertCrmUserMutation, UpsertCrmUserMutationVariables>;
export const TrashCrmUserDocument = gql`
    mutation trashCrmUser($input: TrashCrmUserInput!) {
  trashCrmUser(input: $input) {
    ...CoreCrmUserFields
  }
}
    ${CoreCrmUserFieldsFragmentDoc}`;
export function useTrashCrmUserMutation(options: VueApolloComposable.UseMutationOptions<TrashCrmUserMutation, TrashCrmUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashCrmUserMutation, TrashCrmUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashCrmUserMutation, TrashCrmUserMutationVariables>(TrashCrmUserDocument, options);
}
export type TrashCrmUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashCrmUserMutation, TrashCrmUserMutationVariables>;
export const CreateDeclarationDocument = gql`
    mutation CreateDeclaration($input: CreateDeclarationInput!) {
  createDeclaration(input: $input) {
    ...CoreDeclaration
  }
}
    ${CoreDeclarationFragmentDoc}`;
export function useCreateDeclarationMutation(options: VueApolloComposable.UseMutationOptions<CreateDeclarationMutation, CreateDeclarationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDeclarationMutation, CreateDeclarationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateDeclarationMutation, CreateDeclarationMutationVariables>(CreateDeclarationDocument, options);
}
export type CreateDeclarationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateDeclarationMutation, CreateDeclarationMutationVariables>;
export const UpdateDeclarationDocument = gql`
    mutation UpdateDeclaration($id: ID!, $input: UpdateDeclarationInput!) {
  updateDeclaration(id: $id, input: $input) {
    ...CoreDeclaration
  }
}
    ${CoreDeclarationFragmentDoc}`;
export function useUpdateDeclarationMutation(options: VueApolloComposable.UseMutationOptions<UpdateDeclarationMutation, UpdateDeclarationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDeclarationMutation, UpdateDeclarationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateDeclarationMutation, UpdateDeclarationMutationVariables>(UpdateDeclarationDocument, options);
}
export type UpdateDeclarationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateDeclarationMutation, UpdateDeclarationMutationVariables>;
export const UpdateDeclarationAndNextStepDocument = gql`
    mutation UpdateDeclarationAndNextStep($id: ID!, $input: UpdateDeclarationInput!) {
  updateDeclarationAndNextStep(id: $id, input: $input) {
    ...CoreDeclaration
  }
}
    ${CoreDeclarationFragmentDoc}`;
export function useUpdateDeclarationAndNextStepMutation(options: VueApolloComposable.UseMutationOptions<UpdateDeclarationAndNextStepMutation, UpdateDeclarationAndNextStepMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDeclarationAndNextStepMutation, UpdateDeclarationAndNextStepMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateDeclarationAndNextStepMutation, UpdateDeclarationAndNextStepMutationVariables>(UpdateDeclarationAndNextStepDocument, options);
}
export type UpdateDeclarationAndNextStepMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateDeclarationAndNextStepMutation, UpdateDeclarationAndNextStepMutationVariables>;
export const UpdateDeclarationAndSendBackToInitiatorDocument = gql`
    mutation UpdateDeclarationAndSendBackToInitiator($id: ID!, $input: UpdateDeclarationInput!) {
  updateDeclarationAndSendBackToInitiator(id: $id, input: $input) {
    ...CoreDeclaration
  }
}
    ${CoreDeclarationFragmentDoc}`;
export function useUpdateDeclarationAndSendBackToInitiatorMutation(options: VueApolloComposable.UseMutationOptions<UpdateDeclarationAndSendBackToInitiatorMutation, UpdateDeclarationAndSendBackToInitiatorMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDeclarationAndSendBackToInitiatorMutation, UpdateDeclarationAndSendBackToInitiatorMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateDeclarationAndSendBackToInitiatorMutation, UpdateDeclarationAndSendBackToInitiatorMutationVariables>(UpdateDeclarationAndSendBackToInitiatorDocument, options);
}
export type UpdateDeclarationAndSendBackToInitiatorMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateDeclarationAndSendBackToInitiatorMutation, UpdateDeclarationAndSendBackToInitiatorMutationVariables>;
export const UpdateDeclarationFlagDocument = gql`
    mutation UpdateDeclarationFlag($input: UpdateDeclarationFlagInput!) {
  updateDeclarationFlag(input: $input) {
    ...CoreDeclaration
  }
}
    ${CoreDeclarationFragmentDoc}`;
export function useUpdateDeclarationFlagMutation(options: VueApolloComposable.UseMutationOptions<UpdateDeclarationFlagMutation, UpdateDeclarationFlagMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateDeclarationFlagMutation, UpdateDeclarationFlagMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateDeclarationFlagMutation, UpdateDeclarationFlagMutationVariables>(UpdateDeclarationFlagDocument, options);
}
export type UpdateDeclarationFlagMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateDeclarationFlagMutation, UpdateDeclarationFlagMutationVariables>;
export const DeleteDeclarationDocument = gql`
    mutation DeleteDeclaration($input: DeleteDeclarationInput!) {
  deleteDeclaration(input: $input) {
    ...CoreDeclaration
  }
}
    ${CoreDeclarationFragmentDoc}`;
export function useDeleteDeclarationMutation(options: VueApolloComposable.UseMutationOptions<DeleteDeclarationMutation, DeleteDeclarationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteDeclarationMutation, DeleteDeclarationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteDeclarationMutation, DeleteDeclarationMutationVariables>(DeleteDeclarationDocument, options);
}
export type DeleteDeclarationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteDeclarationMutation, DeleteDeclarationMutationVariables>;
export const UpsertDeclarationThemeDocument = gql`
    mutation UpsertDeclarationTheme($id: ID, $input: UpsertDeclarationThemesInput!) {
  upsertDeclarationTheme(id: $id, input: $input) {
    ...CoreDeclarationTheme
  }
}
    ${CoreDeclarationThemeFragmentDoc}`;
export function useUpsertDeclarationThemeMutation(options: VueApolloComposable.UseMutationOptions<UpsertDeclarationThemeMutation, UpsertDeclarationThemeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertDeclarationThemeMutation, UpsertDeclarationThemeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertDeclarationThemeMutation, UpsertDeclarationThemeMutationVariables>(UpsertDeclarationThemeDocument, options);
}
export type UpsertDeclarationThemeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertDeclarationThemeMutation, UpsertDeclarationThemeMutationVariables>;
export const DeleteDeclarationThemeDocument = gql`
    mutation DeleteDeclarationTheme($input: DeleteDeclarationThemesInput!) {
  deleteDeclarationTheme(input: $input) {
    ...CoreDeclarationTheme
  }
}
    ${CoreDeclarationThemeFragmentDoc}`;
export function useDeleteDeclarationThemeMutation(options: VueApolloComposable.UseMutationOptions<DeleteDeclarationThemeMutation, DeleteDeclarationThemeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteDeclarationThemeMutation, DeleteDeclarationThemeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteDeclarationThemeMutation, DeleteDeclarationThemeMutationVariables>(DeleteDeclarationThemeDocument, options);
}
export type DeleteDeclarationThemeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteDeclarationThemeMutation, DeleteDeclarationThemeMutationVariables>;
export const CreateDeclarationDocumentDocument = gql`
    mutation CreateDeclarationDocument($input: CreateDeclarationDocumentInput!) {
  createDeclarationDocument(input: $input) {
    ...CoreDeclarationDocument
  }
}
    ${CoreDeclarationDocumentFragmentDoc}`;
export function useCreateDeclarationDocumentMutation(options: VueApolloComposable.UseMutationOptions<CreateDeclarationDocumentMutation, CreateDeclarationDocumentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDeclarationDocumentMutation, CreateDeclarationDocumentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateDeclarationDocumentMutation, CreateDeclarationDocumentMutationVariables>(CreateDeclarationDocumentDocument, options);
}
export type CreateDeclarationDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateDeclarationDocumentMutation, CreateDeclarationDocumentMutationVariables>;
export const DeleteDeclarationDocumentDocument = gql`
    mutation DeleteDeclarationDocument($input: DeleteDeclarationDocumentInput!) {
  deleteDeclarationDocument(input: $input) {
    ...CoreDeclarationDocument
  }
}
    ${CoreDeclarationDocumentFragmentDoc}`;
export function useDeleteDeclarationDocumentMutation(options: VueApolloComposable.UseMutationOptions<DeleteDeclarationDocumentMutation, DeleteDeclarationDocumentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteDeclarationDocumentMutation, DeleteDeclarationDocumentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteDeclarationDocumentMutation, DeleteDeclarationDocumentMutationVariables>(DeleteDeclarationDocumentDocument, options);
}
export type DeleteDeclarationDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteDeclarationDocumentMutation, DeleteDeclarationDocumentMutationVariables>;
export const UpsertDeclarationDepositDocument = gql`
    mutation UpsertDeclarationDeposit($id: ID, $input: UpsertDeclarationDepositInput!) {
  upsertDeclarationDeposit(id: $id, input: $input) {
    ...CoreDeclarationDeposit
  }
}
    ${CoreDeclarationDepositFragmentDoc}`;
export function useUpsertDeclarationDepositMutation(options: VueApolloComposable.UseMutationOptions<UpsertDeclarationDepositMutation, UpsertDeclarationDepositMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertDeclarationDepositMutation, UpsertDeclarationDepositMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertDeclarationDepositMutation, UpsertDeclarationDepositMutationVariables>(UpsertDeclarationDepositDocument, options);
}
export type UpsertDeclarationDepositMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertDeclarationDepositMutation, UpsertDeclarationDepositMutationVariables>;
export const SendIdaheToBotDocument = gql`
    mutation SendIDAHEToBot($input: SendToBotInput!) {
  sendIDAHEToBot(input: $input)
}
    `;
export function useSendIdaheToBotMutation(options: VueApolloComposable.UseMutationOptions<SendIdaheToBotMutation, SendIdaheToBotMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendIdaheToBotMutation, SendIdaheToBotMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendIdaheToBotMutation, SendIdaheToBotMutationVariables>(SendIdaheToBotDocument, options);
}
export type SendIdaheToBotMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendIdaheToBotMutation, SendIdaheToBotMutationVariables>;
export const SendEpsToBotDocument = gql`
    mutation SendEPSToBot($input: SendEPSToBotInput!) {
  sendEPSToBot(input: $input) {
    batch_id
    realtime {
      channel
      event
    }
  }
}
    `;
export function useSendEpsToBotMutation(options: VueApolloComposable.UseMutationOptions<SendEpsToBotMutation, SendEpsToBotMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendEpsToBotMutation, SendEpsToBotMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendEpsToBotMutation, SendEpsToBotMutationVariables>(SendEpsToBotDocument, options);
}
export type SendEpsToBotMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendEpsToBotMutation, SendEpsToBotMutationVariables>;
export const CreateManualSubmissionDocument = gql`
    mutation CreateManualSubmission($input: CreateManualSubmissionInput!) {
  createManualSubmission(input: $input) {
    id
    reference
    regime
    platform
    status
    json_filters
    ticket {
      id
      code
      name
    }
    packages {
      id
      name
    }
    submissions {
      id
      status
      url
      incomplete_submission_date
      authorization_refusal_date
      recommendation_date
      acceptation_date
      complete_submission_date
      comment
      created_at
      documents {
        id
        filename
        path
        type
        url
        temporary_url
        created_at
      }
    }
    created_at
    created_by {
      first_name
      last_name
    }
  }
}
    `;
export function useCreateManualSubmissionMutation(options: VueApolloComposable.UseMutationOptions<CreateManualSubmissionMutation, CreateManualSubmissionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateManualSubmissionMutation, CreateManualSubmissionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateManualSubmissionMutation, CreateManualSubmissionMutationVariables>(CreateManualSubmissionDocument, options);
}
export type CreateManualSubmissionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateManualSubmissionMutation, CreateManualSubmissionMutationVariables>;
export const UpdateSubmissionDocument = gql`
    mutation updateSubmission($input: UpdateSubmissionInput) {
  updateSubmission(input: $input) {
    id
    reference
    status
    url
    created_at
    attendees {
      ...CoreAttendeeTicketFields
    }
    documents {
      id
      filename
      path
      type
      url
      temporary_url
      created_at
    }
    json {
      id
      filename
      path
      type
      url
      temporary_url
      created_at
    }
    logs {
      id
      filename
      path
      type
      url
      temporary_url
      created_at
    }
  }
}
    ${CoreAttendeeTicketFieldsFragmentDoc}`;
export function useUpdateSubmissionMutation(options: VueApolloComposable.UseMutationOptions<UpdateSubmissionMutation, UpdateSubmissionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>(UpdateSubmissionDocument, options);
}
export type UpdateSubmissionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>;
export const GenerateManualAttachmentsDocument = gql`
    mutation GenerateManualAttachments($input: GenerateManualAttachmentsInput!) {
  generateManualAttachments(input: $input) {
    batch_id
  }
}
    `;
export function useGenerateManualAttachmentsMutation(options: VueApolloComposable.UseMutationOptions<GenerateManualAttachmentsMutation, GenerateManualAttachmentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateManualAttachmentsMutation, GenerateManualAttachmentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateManualAttachmentsMutation, GenerateManualAttachmentsMutationVariables>(GenerateManualAttachmentsDocument, options);
}
export type GenerateManualAttachmentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateManualAttachmentsMutation, GenerateManualAttachmentsMutationVariables>;
export const GenerateDepositZipFileDocument = gql`
    mutation generateDepositZipFile($input: GenerateDepositZipFileInput!) {
  generateDepositZipFile(input: $input) {
    batch_id
  }
}
    `;
export function useGenerateDepositZipFileMutation(options: VueApolloComposable.UseMutationOptions<GenerateDepositZipFileMutation, GenerateDepositZipFileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateDepositZipFileMutation, GenerateDepositZipFileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateDepositZipFileMutation, GenerateDepositZipFileMutationVariables>(GenerateDepositZipFileDocument, options);
}
export type GenerateDepositZipFileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateDepositZipFileMutation, GenerateDepositZipFileMutationVariables>;
export const DeleteDocumentAttendeeContactDocument = gql`
    mutation deleteDocumentAttendeeContact($input: DeleteDocumentAttendeeContactInput!) {
  deleteDocumentAttendeeContact(input: $input)
}
    `;
export function useDeleteDocumentAttendeeContactMutation(options: VueApolloComposable.UseMutationOptions<DeleteDocumentAttendeeContactMutation, DeleteDocumentAttendeeContactMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteDocumentAttendeeContactMutation, DeleteDocumentAttendeeContactMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteDocumentAttendeeContactMutation, DeleteDocumentAttendeeContactMutationVariables>(DeleteDocumentAttendeeContactDocument, options);
}
export type DeleteDocumentAttendeeContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteDocumentAttendeeContactMutation, DeleteDocumentAttendeeContactMutationVariables>;
export const DeleteSigningSheetDocument = gql`
    mutation DeleteSigningSheet($id: ID!) {
  deleteSigningSheet(id: $id) {
    id
  }
}
    `;
export function useDeleteSigningSheetMutation(options: VueApolloComposable.UseMutationOptions<DeleteSigningSheetMutation, DeleteSigningSheetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSigningSheetMutation, DeleteSigningSheetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteSigningSheetMutation, DeleteSigningSheetMutationVariables>(DeleteSigningSheetDocument, options);
}
export type DeleteSigningSheetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSigningSheetMutation, DeleteSigningSheetMutationVariables>;
export const UploadDocumentAttendeeDocument = gql`
    mutation UploadDocumentAttendee($input: UploadDocumentAttendeeInput!) {
  uploadDocumentAttendee(input: $input) {
    id
    type
    signature_status
    deposit_status
    document {
      ...CoreDocumentFields
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useUploadDocumentAttendeeMutation(options: VueApolloComposable.UseMutationOptions<UploadDocumentAttendeeMutation, UploadDocumentAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadDocumentAttendeeMutation, UploadDocumentAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadDocumentAttendeeMutation, UploadDocumentAttendeeMutationVariables>(UploadDocumentAttendeeDocument, options);
}
export type UploadDocumentAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadDocumentAttendeeMutation, UploadDocumentAttendeeMutationVariables>;
export const DeleteDocumentAttendeeDocument = gql`
    mutation DeleteDocumentAttendee($id: ID!) {
  deleteDocumentAttendee(id: $id) {
    id
  }
}
    `;
export function useDeleteDocumentAttendeeMutation(options: VueApolloComposable.UseMutationOptions<DeleteDocumentAttendeeMutation, DeleteDocumentAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteDocumentAttendeeMutation, DeleteDocumentAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteDocumentAttendeeMutation, DeleteDocumentAttendeeMutationVariables>(DeleteDocumentAttendeeDocument, options);
}
export type DeleteDocumentAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteDocumentAttendeeMutation, DeleteDocumentAttendeeMutationVariables>;
export const DeleteContractAttendeeDocument = gql`
    mutation DeleteContractAttendee($input: DeleteContractAttendeeInput!) {
  deleteContractAttendee(input: $input)
}
    `;
export function useDeleteContractAttendeeMutation(options: VueApolloComposable.UseMutationOptions<DeleteContractAttendeeMutation, DeleteContractAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteContractAttendeeMutation, DeleteContractAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteContractAttendeeMutation, DeleteContractAttendeeMutationVariables>(DeleteContractAttendeeDocument, options);
}
export type DeleteContractAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteContractAttendeeMutation, DeleteContractAttendeeMutationVariables>;
export const DeleteContractsAttendeesDocument = gql`
    mutation DeleteContractsAttendees($input: DeleteContractsAttendeesInput!) {
  deleteContractsAttendees(input: $input) {
    ticket_code
    batch_id
  }
}
    `;
export function useDeleteContractsAttendeesMutation(options: VueApolloComposable.UseMutationOptions<DeleteContractsAttendeesMutation, DeleteContractsAttendeesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteContractsAttendeesMutation, DeleteContractsAttendeesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteContractsAttendeesMutation, DeleteContractsAttendeesMutationVariables>(DeleteContractsAttendeesDocument, options);
}
export type DeleteContractsAttendeesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteContractsAttendeesMutation, DeleteContractsAttendeesMutationVariables>;
export const UploadExpenseReportDocument = gql`
    mutation UploadExpenseReport($input: UploadExpenseReportInput!) {
  uploadExpenseReport(input: $input) {
    id
    name
    reference
    document {
      ...CoreDocumentFields
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useUploadExpenseReportMutation(options: VueApolloComposable.UseMutationOptions<UploadExpenseReportMutation, UploadExpenseReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadExpenseReportMutation, UploadExpenseReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadExpenseReportMutation, UploadExpenseReportMutationVariables>(UploadExpenseReportDocument, options);
}
export type UploadExpenseReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadExpenseReportMutation, UploadExpenseReportMutationVariables>;
export const DeleteExpenseReportDocument = gql`
    mutation DeleteExpenseReport($input: DeleteExpenseReportInput!) {
  deleteExpenseReport(input: $input) {
    id
  }
}
    `;
export function useDeleteExpenseReportMutation(options: VueApolloComposable.UseMutationOptions<DeleteExpenseReportMutation, DeleteExpenseReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteExpenseReportMutation, DeleteExpenseReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteExpenseReportMutation, DeleteExpenseReportMutationVariables>(DeleteExpenseReportDocument, options);
}
export type DeleteExpenseReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteExpenseReportMutation, DeleteExpenseReportMutationVariables>;
export const UploadExpensesImportDocument = gql`
    mutation UploadExpensesImport($input: ExpensesImportInput!) {
  expensesImport(input: $input) {
    batch_id
  }
}
    `;
export function useUploadExpensesImportMutation(options: VueApolloComposable.UseMutationOptions<UploadExpensesImportMutation, UploadExpensesImportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadExpensesImportMutation, UploadExpensesImportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadExpensesImportMutation, UploadExpensesImportMutationVariables>(UploadExpensesImportDocument, options);
}
export type UploadExpensesImportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadExpensesImportMutation, UploadExpensesImportMutationVariables>;
export const ExpenseImportByCrmDocument = gql`
    mutation expenseImportByCrm($input: ExpensesImportInput!) {
  expenseImportByCrm(input: $input)
}
    `;
export function useExpenseImportByCrmMutation(options: VueApolloComposable.UseMutationOptions<ExpenseImportByCrmMutation, ExpenseImportByCrmMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExpenseImportByCrmMutation, ExpenseImportByCrmMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExpenseImportByCrmMutation, ExpenseImportByCrmMutationVariables>(ExpenseImportByCrmDocument, options);
}
export type ExpenseImportByCrmMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExpenseImportByCrmMutation, ExpenseImportByCrmMutationVariables>;
export const GenerateExpensesImportTemplateDocument = gql`
    mutation GenerateExpensesImportTemplate($input: GenerateExpensesImportInput!) {
  expensesImportTemplate(input: $input) {
    batch_id
  }
}
    `;
export function useGenerateExpensesImportTemplateMutation(options: VueApolloComposable.UseMutationOptions<GenerateExpensesImportTemplateMutation, GenerateExpensesImportTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateExpensesImportTemplateMutation, GenerateExpensesImportTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateExpensesImportTemplateMutation, GenerateExpensesImportTemplateMutationVariables>(GenerateExpensesImportTemplateDocument, options);
}
export type GenerateExpensesImportTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateExpensesImportTemplateMutation, GenerateExpensesImportTemplateMutationVariables>;
export const UpsertInternalSignerDocument = gql`
    mutation upsertInternalSigner($id: ID, $input: UpsertInternalSignerInput!) {
  upsertInternalSigner(id: $id, input: $input) {
    ...CoreInternalSignerFields
  }
}
    ${CoreInternalSignerFieldsFragmentDoc}`;
export function useUpsertInternalSignerMutation(options: VueApolloComposable.UseMutationOptions<UpsertInternalSignerMutation, UpsertInternalSignerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertInternalSignerMutation, UpsertInternalSignerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertInternalSignerMutation, UpsertInternalSignerMutationVariables>(UpsertInternalSignerDocument, options);
}
export type UpsertInternalSignerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertInternalSignerMutation, UpsertInternalSignerMutationVariables>;
export const TrashInternalSignerDocument = gql`
    mutation trashInternalSigner($input: TrashInternalSignerInput!) {
  trashInternalSigner(input: $input) {
    ...CoreInternalSignerFields
  }
}
    ${CoreInternalSignerFieldsFragmentDoc}`;
export function useTrashInternalSignerMutation(options: VueApolloComposable.UseMutationOptions<TrashInternalSignerMutation, TrashInternalSignerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashInternalSignerMutation, TrashInternalSignerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashInternalSignerMutation, TrashInternalSignerMutationVariables>(TrashInternalSignerDocument, options);
}
export type TrashInternalSignerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashInternalSignerMutation, TrashInternalSignerMutationVariables>;
export const CreateNotificationDocument = gql`
    mutation CreateNotification($input: CreateNotificationInput!) {
  createNotification(input: $input) {
    ...CoreNotificationFields
  }
}
    ${CoreNotificationFieldsFragmentDoc}`;
export function useCreateNotificationMutation(options: VueApolloComposable.UseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
}
export type CreateNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation UpdateNotification($input: UpdateNotificationInput!) {
  updateNotification(input: $input) {
    ...CoreNotificationFields
  }
}
    ${CoreNotificationFieldsFragmentDoc}`;
export function useUpdateNotificationMutation(options: VueApolloComposable.UseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
}
export type UpdateNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const ToggleNotificationsDocument = gql`
    mutation ToggleNotifications($input: [ToggleNotificationInput!]!) {
  toggleNotifications(input: $input) {
    ...CoreNotificationFields
  }
}
    ${CoreNotificationFieldsFragmentDoc}`;
export function useToggleNotificationsMutation(options: VueApolloComposable.UseMutationOptions<ToggleNotificationsMutation, ToggleNotificationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ToggleNotificationsMutation, ToggleNotificationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ToggleNotificationsMutation, ToggleNotificationsMutationVariables>(ToggleNotificationsDocument, options);
}
export type ToggleNotificationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ToggleNotificationsMutation, ToggleNotificationsMutationVariables>;
export const CloneOperationDocument = gql`
    mutation cloneOperation($input: UpdateOperationInput!) {
  cloneOperation(input: $input) {
    ...CoreOperationFields
  }
}
    ${CoreOperationFieldsFragmentDoc}`;
export function useCloneOperationMutation(options: VueApolloComposable.UseMutationOptions<CloneOperationMutation, CloneOperationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloneOperationMutation, CloneOperationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CloneOperationMutation, CloneOperationMutationVariables>(CloneOperationDocument, options);
}
export type CloneOperationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloneOperationMutation, CloneOperationMutationVariables>;
export const ToggleActiveStateOperationsDocument = gql`
    mutation toggleActiveStateOperations($input: ToggleActiveStateOperationsInput!) {
  toggleActiveStateOperations(input: $input)
}
    `;
export function useToggleActiveStateOperationsMutation(options: VueApolloComposable.UseMutationOptions<ToggleActiveStateOperationsMutation, ToggleActiveStateOperationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ToggleActiveStateOperationsMutation, ToggleActiveStateOperationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ToggleActiveStateOperationsMutation, ToggleActiveStateOperationsMutationVariables>(ToggleActiveStateOperationsDocument, options);
}
export type ToggleActiveStateOperationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ToggleActiveStateOperationsMutation, ToggleActiveStateOperationsMutationVariables>;
export const CreatePlannedAdvantageDocument = gql`
    mutation createPlannedAdvantage($input: CreatePlannedAdvantageInput!) {
  createPlannedAdvantage(input: $input) {
    advantage_type
    net_amount
    gross_amount
    excluding_tax_amount
    including_tax_amount
    attendee_id
    quantity
    detail
    comment
    area
  }
}
    `;
export function useCreatePlannedAdvantageMutation(options: VueApolloComposable.UseMutationOptions<CreatePlannedAdvantageMutation, CreatePlannedAdvantageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePlannedAdvantageMutation, CreatePlannedAdvantageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreatePlannedAdvantageMutation, CreatePlannedAdvantageMutationVariables>(CreatePlannedAdvantageDocument, options);
}
export type CreatePlannedAdvantageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePlannedAdvantageMutation, CreatePlannedAdvantageMutationVariables>;
export const UpdatePlannedAdvantageDocument = gql`
    mutation updatePlannedAdvantage($input: UpdatePlannedAdvantageInput!) {
  updatePlannedAdvantage(input: $input) {
    advantage_type
    net_amount
    gross_amount
    excluding_tax_amount
    including_tax_amount
    attendee_id
    quantity
    detail
    comment
    area
  }
}
    `;
export function useUpdatePlannedAdvantageMutation(options: VueApolloComposable.UseMutationOptions<UpdatePlannedAdvantageMutation, UpdatePlannedAdvantageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePlannedAdvantageMutation, UpdatePlannedAdvantageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdatePlannedAdvantageMutation, UpdatePlannedAdvantageMutationVariables>(UpdatePlannedAdvantageDocument, options);
}
export type UpdatePlannedAdvantageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePlannedAdvantageMutation, UpdatePlannedAdvantageMutationVariables>;
export const TrashPlannedAdvantageDocument = gql`
    mutation trashPlannedAdvantage($input: TrashPlannedAdvantageInput!) {
  trashPlannedAdvantage(input: $input) {
    id
  }
}
    `;
export function useTrashPlannedAdvantageMutation(options: VueApolloComposable.UseMutationOptions<TrashPlannedAdvantageMutation, TrashPlannedAdvantageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashPlannedAdvantageMutation, TrashPlannedAdvantageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashPlannedAdvantageMutation, TrashPlannedAdvantageMutationVariables>(TrashPlannedAdvantageDocument, options);
}
export type TrashPlannedAdvantageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashPlannedAdvantageMutation, TrashPlannedAdvantageMutationVariables>;
export const CreatePlannedAdvantagesDocument = gql`
    mutation createPlannedAdvantages($packageID: ID!, $input: [CreatePlannedAdvantageInput!]!) {
  createPlannedAdvantages(packageID: $packageID, input: $input)
}
    `;
export function useCreatePlannedAdvantagesMutation(options: VueApolloComposable.UseMutationOptions<CreatePlannedAdvantagesMutation, CreatePlannedAdvantagesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePlannedAdvantagesMutation, CreatePlannedAdvantagesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreatePlannedAdvantagesMutation, CreatePlannedAdvantagesMutationVariables>(CreatePlannedAdvantagesDocument, options);
}
export type CreatePlannedAdvantagesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePlannedAdvantagesMutation, CreatePlannedAdvantagesMutationVariables>;
export const CreatePlannedPackageDocument = gql`
    mutation createPlannedPackage($input: CreatePlannedPackageInput!) {
  createPlannedPackage(input: $input) {
    id
    name
    advantages {
      advantage_type
      net_amount
      gross_amount
      excluding_tax_amount
      including_tax_amount
      quantity
      detail
      comment
      area
    }
    ticket {
      id
    }
    is_distribution
    created_at
    updated_at
  }
}
    `;
export function useCreatePlannedPackageMutation(options: VueApolloComposable.UseMutationOptions<CreatePlannedPackageMutation, CreatePlannedPackageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePlannedPackageMutation, CreatePlannedPackageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreatePlannedPackageMutation, CreatePlannedPackageMutationVariables>(CreatePlannedPackageDocument, options);
}
export type CreatePlannedPackageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePlannedPackageMutation, CreatePlannedPackageMutationVariables>;
export const UpdatePlannedPackageDocument = gql`
    mutation updatePlannedPackage($input: UpdatePlannedPackageInput!) {
  updatePlannedPackage(input: $input) {
    id
    name
    advantages {
      advantage_type
      net_amount
      gross_amount
      excluding_tax_amount
      including_tax_amount
      quantity
      detail
      comment
      area
    }
    ticket {
      id
    }
    is_distribution
    created_at
    updated_at
  }
}
    `;
export function useUpdatePlannedPackageMutation(options: VueApolloComposable.UseMutationOptions<UpdatePlannedPackageMutation, UpdatePlannedPackageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePlannedPackageMutation, UpdatePlannedPackageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdatePlannedPackageMutation, UpdatePlannedPackageMutationVariables>(UpdatePlannedPackageDocument, options);
}
export type UpdatePlannedPackageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePlannedPackageMutation, UpdatePlannedPackageMutationVariables>;
export const TrashPlannedPackageDocument = gql`
    mutation trashPlannedPackage($input: TrashPlannedPackageInput!) {
  trashPlannedPackage(input: $input) {
    id
  }
}
    `;
export function useTrashPlannedPackageMutation(options: VueApolloComposable.UseMutationOptions<TrashPlannedPackageMutation, TrashPlannedPackageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrashPlannedPackageMutation, TrashPlannedPackageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrashPlannedPackageMutation, TrashPlannedPackageMutationVariables>(TrashPlannedPackageDocument, options);
}
export type TrashPlannedPackageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrashPlannedPackageMutation, TrashPlannedPackageMutationVariables>;
export const DeletePlannedPackageDocument = gql`
    mutation deletePlannedPackage($input: DeletePlannedPackageInput!) {
  deletePlannedPackage(input: $input) {
    id
  }
}
    `;
export function useDeletePlannedPackageMutation(options: VueApolloComposable.UseMutationOptions<DeletePlannedPackageMutation, DeletePlannedPackageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeletePlannedPackageMutation, DeletePlannedPackageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeletePlannedPackageMutation, DeletePlannedPackageMutationVariables>(DeletePlannedPackageDocument, options);
}
export type DeletePlannedPackageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeletePlannedPackageMutation, DeletePlannedPackageMutationVariables>;
export const AssignPlannedPackagesToTicketDocument = gql`
    mutation assignPlannedPackagesToTicket($input: AssignPlannedPackagesToTicketInput) {
  assignPlannedPackagesToTicket(input: $input) {
    id
    name
    advantages {
      advantage_type
      net_amount
      gross_amount
      excluding_tax_amount
      including_tax_amount
      quantity
      detail
      comment
      area
    }
    ticket {
      id
    }
    is_distribution
    created_at
    updated_at
  }
}
    `;
export function useAssignPlannedPackagesToTicketMutation(options: VueApolloComposable.UseMutationOptions<AssignPlannedPackagesToTicketMutation, AssignPlannedPackagesToTicketMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignPlannedPackagesToTicketMutation, AssignPlannedPackagesToTicketMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AssignPlannedPackagesToTicketMutation, AssignPlannedPackagesToTicketMutationVariables>(AssignPlannedPackagesToTicketDocument, options);
}
export type AssignPlannedPackagesToTicketMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignPlannedPackagesToTicketMutation, AssignPlannedPackagesToTicketMutationVariables>;
export const AssignPlannedPackageToAttendeesDocument = gql`
    mutation assignPlannedPackageToAttendees($input: AssignPlannedPackageToAttendeesInput) {
  assignPlannedPackageToAttendees(input: $input)
}
    `;
export function useAssignPlannedPackageToAttendeesMutation(options: VueApolloComposable.UseMutationOptions<AssignPlannedPackageToAttendeesMutation, AssignPlannedPackageToAttendeesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignPlannedPackageToAttendeesMutation, AssignPlannedPackageToAttendeesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AssignPlannedPackageToAttendeesMutation, AssignPlannedPackageToAttendeesMutationVariables>(AssignPlannedPackageToAttendeesDocument, options);
}
export type AssignPlannedPackageToAttendeesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignPlannedPackageToAttendeesMutation, AssignPlannedPackageToAttendeesMutationVariables>;
export const UnassignPlannedPackageToAttendeeDocument = gql`
    mutation unassignPlannedPackageToAttendee($input: UnassignPlannedPackageToAttendeeInput) {
  unassignPlannedPackageToAttendee(input: $input)
}
    `;
export function useUnassignPlannedPackageToAttendeeMutation(options: VueApolloComposable.UseMutationOptions<UnassignPlannedPackageToAttendeeMutation, UnassignPlannedPackageToAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnassignPlannedPackageToAttendeeMutation, UnassignPlannedPackageToAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnassignPlannedPackageToAttendeeMutation, UnassignPlannedPackageToAttendeeMutationVariables>(UnassignPlannedPackageToAttendeeDocument, options);
}
export type UnassignPlannedPackageToAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnassignPlannedPackageToAttendeeMutation, UnassignPlannedPackageToAttendeeMutationVariables>;
export const UnassignPlannedPackagesToAttendeesDocument = gql`
    mutation unassignPlannedPackagesToAttendees($input: UnassignPlannedPackagesToAttendeesInput) {
  unassignPlannedPackagesToAttendees(input: $input)
}
    `;
export function useUnassignPlannedPackagesToAttendeesMutation(options: VueApolloComposable.UseMutationOptions<UnassignPlannedPackagesToAttendeesMutation, UnassignPlannedPackagesToAttendeesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnassignPlannedPackagesToAttendeesMutation, UnassignPlannedPackagesToAttendeesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnassignPlannedPackagesToAttendeesMutation, UnassignPlannedPackagesToAttendeesMutationVariables>(UnassignPlannedPackagesToAttendeesDocument, options);
}
export type UnassignPlannedPackagesToAttendeesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnassignPlannedPackagesToAttendeesMutation, UnassignPlannedPackagesToAttendeesMutationVariables>;
export const UpsertProductDocument = gql`
    mutation UpsertProduct($id: ID, $input: UpsertProductInput!) {
  upsertProduct(id: $id, input: $input) {
    id
    name
    enabled
  }
}
    `;
export function useUpsertProductMutation(options: VueApolloComposable.UseMutationOptions<UpsertProductMutation, UpsertProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertProductMutation, UpsertProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertProductMutation, UpsertProductMutationVariables>(UpsertProductDocument, options);
}
export type UpsertProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertProductMutation, UpsertProductMutationVariables>;
export const UpsertRegionDocument = gql`
    mutation UpsertRegion($id: ID, $input: UpsertRegionInput!) {
  upsertRegion(id: $id, input: $input) {
    id
    name
    enabled
  }
}
    `;
export function useUpsertRegionMutation(options: VueApolloComposable.UseMutationOptions<UpsertRegionMutation, UpsertRegionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertRegionMutation, UpsertRegionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertRegionMutation, UpsertRegionMutationVariables>(UpsertRegionDocument, options);
}
export type UpsertRegionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertRegionMutation, UpsertRegionMutationVariables>;
export const UpsertSectorDocument = gql`
    mutation UpsertSector($id: ID, $input: UpsertSectorInput!) {
  upsertSector(id: $id, input: $input) {
    id
    name
    enabled
  }
}
    `;
export function useUpsertSectorMutation(options: VueApolloComposable.UseMutationOptions<UpsertSectorMutation, UpsertSectorMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertSectorMutation, UpsertSectorMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertSectorMutation, UpsertSectorMutationVariables>(UpsertSectorDocument, options);
}
export type UpsertSectorMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertSectorMutation, UpsertSectorMutationVariables>;
export const UpdateSettingsDocument = gql`
    mutation UpdateSettings($input: [SettingsInput!]!) {
  updateSettings(input: $input) {
    ...CoreSettingsFields
  }
}
    ${CoreSettingsFieldsFragmentDoc}`;
export function useUpdateSettingsMutation(options: VueApolloComposable.UseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
}
export type UpdateSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const UpdateSettingDocument = gql`
    mutation UpdateSetting($input: SettingsInput!) {
  updateSetting(input: $input) {
    ...CoreSettingsFields
  }
}
    ${CoreSettingsFieldsFragmentDoc}`;
export function useUpdateSettingMutation(options: VueApolloComposable.UseMutationOptions<UpdateSettingMutation, UpdateSettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSettingMutation, UpdateSettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSettingMutation, UpdateSettingMutationVariables>(UpdateSettingDocument, options);
}
export type UpdateSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSettingMutation, UpdateSettingMutationVariables>;
export const SendReminderDocument = gql`
    mutation SendReminder($input: sendReminderInput!) {
  sendReminder(input: $input)
}
    `;
export function useSendReminderMutation(options: VueApolloComposable.UseMutationOptions<SendReminderMutation, SendReminderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendReminderMutation, SendReminderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendReminderMutation, SendReminderMutationVariables>(SendReminderDocument, options);
}
export type SendReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendReminderMutation, SendReminderMutationVariables>;
export const CancelContractAttendeeSignatureRequestDocument = gql`
    mutation CancelContractAttendeeSignatureRequest($input: CancelContractAttendeeSignatureRequestInput!) {
  cancelContractAttendeeSignatureRequest(input: $input)
}
    `;
export function useCancelContractAttendeeSignatureRequestMutation(options: VueApolloComposable.UseMutationOptions<CancelContractAttendeeSignatureRequestMutation, CancelContractAttendeeSignatureRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelContractAttendeeSignatureRequestMutation, CancelContractAttendeeSignatureRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelContractAttendeeSignatureRequestMutation, CancelContractAttendeeSignatureRequestMutationVariables>(CancelContractAttendeeSignatureRequestDocument, options);
}
export type CancelContractAttendeeSignatureRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelContractAttendeeSignatureRequestMutation, CancelContractAttendeeSignatureRequestMutationVariables>;
export const CreateSigningProcedureDocument = gql`
    mutation CreateSigningProcedure($input: createSigningProcedureInput!) {
  createSigningProcedure(input: $input) {
    success
    skipped
    error
    batch_id
  }
}
    `;
export function useCreateSigningProcedureMutation(options: VueApolloComposable.UseMutationOptions<CreateSigningProcedureMutation, CreateSigningProcedureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSigningProcedureMutation, CreateSigningProcedureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateSigningProcedureMutation, CreateSigningProcedureMutationVariables>(CreateSigningProcedureDocument, options);
}
export type CreateSigningProcedureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSigningProcedureMutation, CreateSigningProcedureMutationVariables>;
export const DownloadSigningSheetDocument = gql`
    mutation downloadSigningSheet($input: DownloadSigningSheetInput!) {
  downloadSigningSheet(input: $input) {
    content
    filename
    type
  }
}
    `;
export function useDownloadSigningSheetMutation(options: VueApolloComposable.UseMutationOptions<DownloadSigningSheetMutation, DownloadSigningSheetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DownloadSigningSheetMutation, DownloadSigningSheetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DownloadSigningSheetMutation, DownloadSigningSheetMutationVariables>(DownloadSigningSheetDocument, options);
}
export type DownloadSigningSheetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DownloadSigningSheetMutation, DownloadSigningSheetMutationVariables>;
export const UpsertSpecialtyDocument = gql`
    mutation UpsertSpecialty($id: ID, $input: UpsertSpecialtyInput!) {
  upsertSpecialty(id: $id, input: $input) {
    ...CoreSpecialtyFields
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}`;
export function useUpsertSpecialtyMutation(options: VueApolloComposable.UseMutationOptions<UpsertSpecialtyMutation, UpsertSpecialtyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertSpecialtyMutation, UpsertSpecialtyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertSpecialtyMutation, UpsertSpecialtyMutationVariables>(UpsertSpecialtyDocument, options);
}
export type UpsertSpecialtyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertSpecialtyMutation, UpsertSpecialtyMutationVariables>;
export const DeleteSpecialtyDocument = gql`
    mutation DeleteSpecialty($id: ID!) {
  deleteSpecialty(id: $id) {
    ...CoreSpecialtyFields
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}`;
export function useDeleteSpecialtyMutation(options: VueApolloComposable.UseMutationOptions<DeleteSpecialtyMutation, DeleteSpecialtyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSpecialtyMutation, DeleteSpecialtyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteSpecialtyMutation, DeleteSpecialtyMutationVariables>(DeleteSpecialtyDocument, options);
}
export type DeleteSpecialtyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSpecialtyMutation, DeleteSpecialtyMutationVariables>;
export const UpsertTherapeuticAreaDocument = gql`
    mutation UpsertTherapeuticArea($id: ID, $input: UpsertTherapeuticAreaInput!) {
  upsertTherapeuticArea(id: $id, input: $input) {
    id
    name
    enabled
  }
}
    `;
export function useUpsertTherapeuticAreaMutation(options: VueApolloComposable.UseMutationOptions<UpsertTherapeuticAreaMutation, UpsertTherapeuticAreaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertTherapeuticAreaMutation, UpsertTherapeuticAreaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertTherapeuticAreaMutation, UpsertTherapeuticAreaMutationVariables>(UpsertTherapeuticAreaDocument, options);
}
export type UpsertTherapeuticAreaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertTherapeuticAreaMutation, UpsertTherapeuticAreaMutationVariables>;
export const UpdateTicketLifeCycleDocument = gql`
    mutation UpdateTicketLifeCycle($input: UpdateTicketLifeCycleInput!) {
  updateTicketLifeCycle(input: $input) {
    ticket {
      ...CoreTicketStatusAndStepFields
    }
    batch_id
  }
}
    ${CoreTicketStatusAndStepFieldsFragmentDoc}`;
export function useUpdateTicketLifeCycleMutation(options: VueApolloComposable.UseMutationOptions<UpdateTicketLifeCycleMutation, UpdateTicketLifeCycleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTicketLifeCycleMutation, UpdateTicketLifeCycleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTicketLifeCycleMutation, UpdateTicketLifeCycleMutationVariables>(UpdateTicketLifeCycleDocument, options);
}
export type UpdateTicketLifeCycleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTicketLifeCycleMutation, UpdateTicketLifeCycleMutationVariables>;
export const UpdateTicketFromDashboardDocument = gql`
    mutation UpdateTicketFromDashboard($input: UpdateTicketInput!) {
  updateTicket(input: $input) {
    id
    code
    name
    is_archived
  }
}
    `;
export function useUpdateTicketFromDashboardMutation(options: VueApolloComposable.UseMutationOptions<UpdateTicketFromDashboardMutation, UpdateTicketFromDashboardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTicketFromDashboardMutation, UpdateTicketFromDashboardMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTicketFromDashboardMutation, UpdateTicketFromDashboardMutationVariables>(UpdateTicketFromDashboardDocument, options);
}
export type UpdateTicketFromDashboardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTicketFromDashboardMutation, UpdateTicketFromDashboardMutationVariables>;
export const UpdateCoreTicketDocument = gql`
    mutation UpdateCoreTicket($input: UpdateCoreTicketInput!) {
  updateCoreTicket(input: $input) {
    id
    name
    description
    place
    code
    external_code
    address {
      id
      city
      street_type
      street_number
      street_name
      postcode
      cedex
      country
    }
    status
    workflow_step
    event_type
    event_specialty
    quantity
    workflow {
      id
      name
      steps {
        step
        roles {
          READ
          WRITE
          REVIEW
        }
      }
    }
    signingSheets {
      id
    }
    expenseReports {
      id
    }
    attendees {
      data {
        id
        firstname
        lastname
        title
        health_number
        health_type
      }
    }
    createdBy {
      id
      full_name
      first_name
      last_name
      avatar
      avatar_file_id
      avatar_file {
        id
        type
        url
      }
    }
    start_at
    end_at
    created_at
    initiator {
      id
      full_name
    }
    validator_1 {
      id
      full_name
    }
    validator_2 {
      id
      full_name
    }
    operation {
      id
      name
    }
    is_declared
    is_archived
    advantages_completed
    advantages_validated
    nonCompliances {
      id
      ticket_id
    }
    managerCrm {
      ...CoreCrmUserFields
    }
    approverCrm {
      ...CoreCrmUserFields
    }
    with_agency
    agency_name
    format
    meeting_type
  }
}
    ${CoreCrmUserFieldsFragmentDoc}`;
export function useUpdateCoreTicketMutation(options: VueApolloComposable.UseMutationOptions<UpdateCoreTicketMutation, UpdateCoreTicketMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCoreTicketMutation, UpdateCoreTicketMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCoreTicketMutation, UpdateCoreTicketMutationVariables>(UpdateCoreTicketDocument, options);
}
export type UpdateCoreTicketMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCoreTicketMutation, UpdateCoreTicketMutationVariables>;
export const UpdateTicketsFromTicketsManagementDocument = gql`
    mutation UpdateTicketsFromTicketsManagement($input: UpdateFromManagementTickets!) {
  updateManagedTickets(input: $input) {
    id
    is_archived
    is_declared
  }
}
    `;
export function useUpdateTicketsFromTicketsManagementMutation(options: VueApolloComposable.UseMutationOptions<UpdateTicketsFromTicketsManagementMutation, UpdateTicketsFromTicketsManagementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTicketsFromTicketsManagementMutation, UpdateTicketsFromTicketsManagementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTicketsFromTicketsManagementMutation, UpdateTicketsFromTicketsManagementMutationVariables>(UpdateTicketsFromTicketsManagementDocument, options);
}
export type UpdateTicketsFromTicketsManagementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTicketsFromTicketsManagementMutation, UpdateTicketsFromTicketsManagementMutationVariables>;
export const CreateDeclarationExportFromTicketsManagementDocument = gql`
    mutation CreateDeclarationExportFromTicketsManagement($input: CreateDeclarationExportInput!) {
  createDeclarationExport(input: $input) {
    batch_id
  }
}
    `;
export function useCreateDeclarationExportFromTicketsManagementMutation(options: VueApolloComposable.UseMutationOptions<CreateDeclarationExportFromTicketsManagementMutation, CreateDeclarationExportFromTicketsManagementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDeclarationExportFromTicketsManagementMutation, CreateDeclarationExportFromTicketsManagementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateDeclarationExportFromTicketsManagementMutation, CreateDeclarationExportFromTicketsManagementMutationVariables>(CreateDeclarationExportFromTicketsManagementDocument, options);
}
export type CreateDeclarationExportFromTicketsManagementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateDeclarationExportFromTicketsManagementMutation, CreateDeclarationExportFromTicketsManagementMutationVariables>;
export const CreateDiagnosticExportFromTicketsManagementDocument = gql`
    mutation CreateDiagnosticExportFromTicketsManagement($input: CreateDiagnosticExportInput!) {
  createDiagnosticExport(input: $input) {
    batch_id
  }
}
    `;
export function useCreateDiagnosticExportFromTicketsManagementMutation(options: VueApolloComposable.UseMutationOptions<CreateDiagnosticExportFromTicketsManagementMutation, CreateDiagnosticExportFromTicketsManagementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateDiagnosticExportFromTicketsManagementMutation, CreateDiagnosticExportFromTicketsManagementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateDiagnosticExportFromTicketsManagementMutation, CreateDiagnosticExportFromTicketsManagementMutationVariables>(CreateDiagnosticExportFromTicketsManagementDocument, options);
}
export type CreateDiagnosticExportFromTicketsManagementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateDiagnosticExportFromTicketsManagementMutation, CreateDiagnosticExportFromTicketsManagementMutationVariables>;
export const CloneTicketDocument = gql`
    mutation CloneTicket($input: CloneTicketInput!) {
  cloneTicket(input: $input) {
    batch_id
  }
}
    `;
export function useCloneTicketMutation(options: VueApolloComposable.UseMutationOptions<CloneTicketMutation, CloneTicketMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloneTicketMutation, CloneTicketMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CloneTicketMutation, CloneTicketMutationVariables>(CloneTicketDocument, options);
}
export type CloneTicketMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloneTicketMutation, CloneTicketMutationVariables>;
export const CreateContractForAttendeeDocument = gql`
    mutation CreateContractForAttendee($input: CreateContractForAttendeeInput!) {
  createContractForAttendee(input: $input) {
    id
    code
  }
}
    `;
export function useCreateContractForAttendeeMutation(options: VueApolloComposable.UseMutationOptions<CreateContractForAttendeeMutation, CreateContractForAttendeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateContractForAttendeeMutation, CreateContractForAttendeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateContractForAttendeeMutation, CreateContractForAttendeeMutationVariables>(CreateContractForAttendeeDocument, options);
}
export type CreateContractForAttendeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateContractForAttendeeMutation, CreateContractForAttendeeMutationVariables>;
export const UpdateSimpleEventsInBulkDocument = gql`
    mutation UpdateSimpleEventsInBulk($input: UpdateSimpleEventsInBulkInput!) {
  updateSimpleEventsInBulk(input: $input) {
    id
    doctor_list_status
  }
}
    `;
export function useUpdateSimpleEventsInBulkMutation(options: VueApolloComposable.UseMutationOptions<UpdateSimpleEventsInBulkMutation, UpdateSimpleEventsInBulkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSimpleEventsInBulkMutation, UpdateSimpleEventsInBulkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSimpleEventsInBulkMutation, UpdateSimpleEventsInBulkMutationVariables>(UpdateSimpleEventsInBulkDocument, options);
}
export type UpdateSimpleEventsInBulkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSimpleEventsInBulkMutation, UpdateSimpleEventsInBulkMutationVariables>;
export const UpsertUnitDocument = gql`
    mutation UpsertUnit($id: ID, $input: UpsertUnitInput!) {
  upsertUnit(id: $id, input: $input) {
    id
    name
    enabled
  }
}
    `;
export function useUpsertUnitMutation(options: VueApolloComposable.UseMutationOptions<UpsertUnitMutation, UpsertUnitMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertUnitMutation, UpsertUnitMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertUnitMutation, UpsertUnitMutationVariables>(UpsertUnitDocument, options);
}
export type UpsertUnitMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertUnitMutation, UpsertUnitMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: ID!, $input: UserKeycloakInput!) {
  updateUser(id: $id, input: $input) {
    id
    firstName
  }
}
    `;
export function useUpdateUserMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserValidatorsDocument = gql`
    mutation updateUserValidators($id: ID!, $input: UserValidatorsInput!) {
  updateUserValidators(id: $id, input: $input) {
    id
    firstName
  }
}
    `;
export function useUpdateUserValidatorsMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserValidatorsMutation, UpdateUserValidatorsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserValidatorsMutation, UpdateUserValidatorsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserValidatorsMutation, UpdateUserValidatorsMutationVariables>(UpdateUserValidatorsDocument, options);
}
export type UpdateUserValidatorsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserValidatorsMutation, UpdateUserValidatorsMutationVariables>;
export const ActualPackagesDocument = gql`
    query ActualPackages($first: Int!, $page: Int) {
  actualPackages(first: $first, page: $page) {
    data {
      id
      name
      advantages {
        ...CoreActualAdvantageFields
      }
      ticket {
        id
      }
      is_distribution
      created_at
      updated_at
      source
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreActualAdvantageFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useActualPackagesQuery(variables: ActualPackagesQueryVariables | VueCompositionApi.Ref<ActualPackagesQueryVariables> | ReactiveFunction<ActualPackagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActualPackagesQuery, ActualPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActualPackagesQuery, ActualPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActualPackagesQuery, ActualPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActualPackagesQuery, ActualPackagesQueryVariables>(ActualPackagesDocument, variables, options);
}
export function useActualPackagesLazyQuery(variables?: ActualPackagesQueryVariables | VueCompositionApi.Ref<ActualPackagesQueryVariables> | ReactiveFunction<ActualPackagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActualPackagesQuery, ActualPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActualPackagesQuery, ActualPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActualPackagesQuery, ActualPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActualPackagesQuery, ActualPackagesQueryVariables>(ActualPackagesDocument, variables, options);
}
export type ActualPackagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActualPackagesQuery, ActualPackagesQueryVariables>;
export const ActualPackageDocument = gql`
    query ActualPackage($id: ID!) {
  actualPackage(id: $id) {
    id
    name
    advantages {
      ...CoreActualAdvantageFields
    }
    ticket {
      id
    }
    is_distribution
    source
    created_at
    updated_at
  }
}
    ${CoreActualAdvantageFieldsFragmentDoc}`;
export function useActualPackageQuery(variables: ActualPackageQueryVariables | VueCompositionApi.Ref<ActualPackageQueryVariables> | ReactiveFunction<ActualPackageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActualPackageQuery, ActualPackageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActualPackageQuery, ActualPackageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActualPackageQuery, ActualPackageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActualPackageQuery, ActualPackageQueryVariables>(ActualPackageDocument, variables, options);
}
export function useActualPackageLazyQuery(variables?: ActualPackageQueryVariables | VueCompositionApi.Ref<ActualPackageQueryVariables> | ReactiveFunction<ActualPackageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActualPackageQuery, ActualPackageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActualPackageQuery, ActualPackageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActualPackageQuery, ActualPackageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActualPackageQuery, ActualPackageQueryVariables>(ActualPackageDocument, variables, options);
}
export type ActualPackageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActualPackageQuery, ActualPackageQueryVariables>;
export const AllActualPackagesDocument = gql`
    query AllActualPackages($ticket_code: String) {
  allActualPackages(ticket_code: $ticket_code) {
    id
    name
    advantages {
      ...CoreActualAdvantageFields
    }
    ticket {
      id
    }
    is_distribution
    source
    created_at
    updated_at
  }
}
    ${CoreActualAdvantageFieldsFragmentDoc}`;
export function useAllActualPackagesQuery(variables: AllActualPackagesQueryVariables | VueCompositionApi.Ref<AllActualPackagesQueryVariables> | ReactiveFunction<AllActualPackagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AllActualPackagesQuery, AllActualPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllActualPackagesQuery, AllActualPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllActualPackagesQuery, AllActualPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllActualPackagesQuery, AllActualPackagesQueryVariables>(AllActualPackagesDocument, variables, options);
}
export function useAllActualPackagesLazyQuery(variables: AllActualPackagesQueryVariables | VueCompositionApi.Ref<AllActualPackagesQueryVariables> | ReactiveFunction<AllActualPackagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AllActualPackagesQuery, AllActualPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllActualPackagesQuery, AllActualPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllActualPackagesQuery, AllActualPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllActualPackagesQuery, AllActualPackagesQueryVariables>(AllActualPackagesDocument, variables, options);
}
export type AllActualPackagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllActualPackagesQuery, AllActualPackagesQueryVariables>;
export const ExpensesImportDocument = gql`
    query ExpensesImport($ticket_code: String!, $first: Int!, $page: Int) {
  expensesImport(ticket_code: $ticket_code, first: $first, page: $page) {
    data {
      id
      state
      type
      created_at
      document {
        ...CoreDocumentFields
      }
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useExpensesImportQuery(variables: ExpensesImportQueryVariables | VueCompositionApi.Ref<ExpensesImportQueryVariables> | ReactiveFunction<ExpensesImportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpensesImportQuery, ExpensesImportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpensesImportQuery, ExpensesImportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpensesImportQuery, ExpensesImportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExpensesImportQuery, ExpensesImportQueryVariables>(ExpensesImportDocument, variables, options);
}
export function useExpensesImportLazyQuery(variables?: ExpensesImportQueryVariables | VueCompositionApi.Ref<ExpensesImportQueryVariables> | ReactiveFunction<ExpensesImportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpensesImportQuery, ExpensesImportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpensesImportQuery, ExpensesImportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpensesImportQuery, ExpensesImportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExpensesImportQuery, ExpensesImportQueryVariables>(ExpensesImportDocument, variables, options);
}
export type ExpensesImportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExpensesImportQuery, ExpensesImportQueryVariables>;
export const ExpensesImportTemplateDocument = gql`
    query ExpensesImportTemplate($ticket_code: String!) {
  expensesImportTemplate(ticket_code: $ticket_code) {
    id
    updated_at
    document {
      ...CoreDocumentFields
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useExpensesImportTemplateQuery(variables: ExpensesImportTemplateQueryVariables | VueCompositionApi.Ref<ExpensesImportTemplateQueryVariables> | ReactiveFunction<ExpensesImportTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpensesImportTemplateQuery, ExpensesImportTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpensesImportTemplateQuery, ExpensesImportTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpensesImportTemplateQuery, ExpensesImportTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExpensesImportTemplateQuery, ExpensesImportTemplateQueryVariables>(ExpensesImportTemplateDocument, variables, options);
}
export function useExpensesImportTemplateLazyQuery(variables?: ExpensesImportTemplateQueryVariables | VueCompositionApi.Ref<ExpensesImportTemplateQueryVariables> | ReactiveFunction<ExpensesImportTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpensesImportTemplateQuery, ExpensesImportTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpensesImportTemplateQuery, ExpensesImportTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpensesImportTemplateQuery, ExpensesImportTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExpensesImportTemplateQuery, ExpensesImportTemplateQueryVariables>(ExpensesImportTemplateDocument, variables, options);
}
export type ExpensesImportTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExpensesImportTemplateQuery, ExpensesImportTemplateQueryVariables>;
export const AgencyExportDocument = gql`
    query AgencyExport($ticket_id: ID!) {
  agencyExport(ticket_id: $ticket_id) {
    id
    updated_at
    document {
      ...CoreDocumentFields
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useAgencyExportQuery(variables: AgencyExportQueryVariables | VueCompositionApi.Ref<AgencyExportQueryVariables> | ReactiveFunction<AgencyExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<AgencyExportQuery, AgencyExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AgencyExportQuery, AgencyExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AgencyExportQuery, AgencyExportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AgencyExportQuery, AgencyExportQueryVariables>(AgencyExportDocument, variables, options);
}
export function useAgencyExportLazyQuery(variables?: AgencyExportQueryVariables | VueCompositionApi.Ref<AgencyExportQueryVariables> | ReactiveFunction<AgencyExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<AgencyExportQuery, AgencyExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AgencyExportQuery, AgencyExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AgencyExportQuery, AgencyExportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AgencyExportQuery, AgencyExportQueryVariables>(AgencyExportDocument, variables, options);
}
export type AgencyExportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AgencyExportQuery, AgencyExportQueryVariables>;
export const GetEnabledAllocationsDocument = gql`
    query getEnabledAllocations {
  getEnabledAllocations {
    ...CoreAllocationsFields
  }
}
    ${CoreAllocationsFieldsFragmentDoc}`;
export function useGetEnabledAllocationsQuery(options: VueApolloComposable.UseQueryOptions<GetEnabledAllocationsQuery, GetEnabledAllocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEnabledAllocationsQuery, GetEnabledAllocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEnabledAllocationsQuery, GetEnabledAllocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEnabledAllocationsQuery, GetEnabledAllocationsQueryVariables>(GetEnabledAllocationsDocument, {}, options);
}
export function useGetEnabledAllocationsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetEnabledAllocationsQuery, GetEnabledAllocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEnabledAllocationsQuery, GetEnabledAllocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEnabledAllocationsQuery, GetEnabledAllocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEnabledAllocationsQuery, GetEnabledAllocationsQueryVariables>(GetEnabledAllocationsDocument, {}, options);
}
export type GetEnabledAllocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEnabledAllocationsQuery, GetEnabledAllocationsQueryVariables>;
export const GetAllAllocationsDocument = gql`
    query getAllAllocations {
  getAllAllocations {
    ...CoreAllocationsFields
  }
}
    ${CoreAllocationsFieldsFragmentDoc}`;
export function useGetAllAllocationsQuery(options: VueApolloComposable.UseQueryOptions<GetAllAllocationsQuery, GetAllAllocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllAllocationsQuery, GetAllAllocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllAllocationsQuery, GetAllAllocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllAllocationsQuery, GetAllAllocationsQueryVariables>(GetAllAllocationsDocument, {}, options);
}
export function useGetAllAllocationsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAllAllocationsQuery, GetAllAllocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllAllocationsQuery, GetAllAllocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllAllocationsQuery, GetAllAllocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllAllocationsQuery, GetAllAllocationsQueryVariables>(GetAllAllocationsDocument, {}, options);
}
export type GetAllAllocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllAllocationsQuery, GetAllAllocationsQueryVariables>;
export const AllocationsIdentitiesDocument = gql`
    query AllocationsIdentities($enabled: Boolean, $first: Int!, $page: Int) {
  identityPaginator(enabled: $enabled, first: $first, page: $page) {
    data {
      ...CoreIdentityFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreIdentityFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useAllocationsIdentitiesQuery(variables: AllocationsIdentitiesQueryVariables | VueCompositionApi.Ref<AllocationsIdentitiesQueryVariables> | ReactiveFunction<AllocationsIdentitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsIdentitiesQuery, AllocationsIdentitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsIdentitiesQuery, AllocationsIdentitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsIdentitiesQuery, AllocationsIdentitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllocationsIdentitiesQuery, AllocationsIdentitiesQueryVariables>(AllocationsIdentitiesDocument, variables, options);
}
export function useAllocationsIdentitiesLazyQuery(variables?: AllocationsIdentitiesQueryVariables | VueCompositionApi.Ref<AllocationsIdentitiesQueryVariables> | ReactiveFunction<AllocationsIdentitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsIdentitiesQuery, AllocationsIdentitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsIdentitiesQuery, AllocationsIdentitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsIdentitiesQuery, AllocationsIdentitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllocationsIdentitiesQuery, AllocationsIdentitiesQueryVariables>(AllocationsIdentitiesDocument, variables, options);
}
export type AllocationsIdentitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllocationsIdentitiesQuery, AllocationsIdentitiesQueryVariables>;
export const AllocationsIdentityDocument = gql`
    query AllocationsIdentity($id: ID!) {
  identityById(id: $id) {
    ...CoreIdentityFields
  }
}
    ${CoreIdentityFieldsFragmentDoc}`;
export function useAllocationsIdentityQuery(variables: AllocationsIdentityQueryVariables | VueCompositionApi.Ref<AllocationsIdentityQueryVariables> | ReactiveFunction<AllocationsIdentityQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsIdentityQuery, AllocationsIdentityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsIdentityQuery, AllocationsIdentityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsIdentityQuery, AllocationsIdentityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllocationsIdentityQuery, AllocationsIdentityQueryVariables>(AllocationsIdentityDocument, variables, options);
}
export function useAllocationsIdentityLazyQuery(variables?: AllocationsIdentityQueryVariables | VueCompositionApi.Ref<AllocationsIdentityQueryVariables> | ReactiveFunction<AllocationsIdentityQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsIdentityQuery, AllocationsIdentityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsIdentityQuery, AllocationsIdentityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsIdentityQuery, AllocationsIdentityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllocationsIdentityQuery, AllocationsIdentityQueryVariables>(AllocationsIdentityDocument, variables, options);
}
export type AllocationsIdentityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllocationsIdentityQuery, AllocationsIdentityQueryVariables>;
export const AllocationsNetworksDocument = gql`
    query AllocationsNetworks($enabled: Boolean, $first: Int!, $page: Int) {
  networks(enabled: $enabled, first: $first, page: $page) {
    data {
      ...CoreNetworkFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreNetworkFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useAllocationsNetworksQuery(variables: AllocationsNetworksQueryVariables | VueCompositionApi.Ref<AllocationsNetworksQueryVariables> | ReactiveFunction<AllocationsNetworksQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsNetworksQuery, AllocationsNetworksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsNetworksQuery, AllocationsNetworksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsNetworksQuery, AllocationsNetworksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllocationsNetworksQuery, AllocationsNetworksQueryVariables>(AllocationsNetworksDocument, variables, options);
}
export function useAllocationsNetworksLazyQuery(variables?: AllocationsNetworksQueryVariables | VueCompositionApi.Ref<AllocationsNetworksQueryVariables> | ReactiveFunction<AllocationsNetworksQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsNetworksQuery, AllocationsNetworksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsNetworksQuery, AllocationsNetworksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsNetworksQuery, AllocationsNetworksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllocationsNetworksQuery, AllocationsNetworksQueryVariables>(AllocationsNetworksDocument, variables, options);
}
export type AllocationsNetworksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllocationsNetworksQuery, AllocationsNetworksQueryVariables>;
export const AllocationsNetworkDocument = gql`
    query AllocationsNetwork($id: ID!) {
  network(id: $id) {
    ...CoreNetworkFields
  }
}
    ${CoreNetworkFieldsFragmentDoc}`;
export function useAllocationsNetworkQuery(variables: AllocationsNetworkQueryVariables | VueCompositionApi.Ref<AllocationsNetworkQueryVariables> | ReactiveFunction<AllocationsNetworkQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsNetworkQuery, AllocationsNetworkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsNetworkQuery, AllocationsNetworkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsNetworkQuery, AllocationsNetworkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllocationsNetworkQuery, AllocationsNetworkQueryVariables>(AllocationsNetworkDocument, variables, options);
}
export function useAllocationsNetworkLazyQuery(variables?: AllocationsNetworkQueryVariables | VueCompositionApi.Ref<AllocationsNetworkQueryVariables> | ReactiveFunction<AllocationsNetworkQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsNetworkQuery, AllocationsNetworkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsNetworkQuery, AllocationsNetworkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsNetworkQuery, AllocationsNetworkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllocationsNetworkQuery, AllocationsNetworkQueryVariables>(AllocationsNetworkDocument, variables, options);
}
export type AllocationsNetworkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllocationsNetworkQuery, AllocationsNetworkQueryVariables>;
export const AllocationsUgasDocument = gql`
    query AllocationsUgas($enabled: Boolean, $first: Int!, $page: Int) {
  ugas(enabled: $enabled, first: $first, page: $page) {
    data {
      ...CoreUgaFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreUgaFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useAllocationsUgasQuery(variables: AllocationsUgasQueryVariables | VueCompositionApi.Ref<AllocationsUgasQueryVariables> | ReactiveFunction<AllocationsUgasQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsUgasQuery, AllocationsUgasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsUgasQuery, AllocationsUgasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsUgasQuery, AllocationsUgasQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllocationsUgasQuery, AllocationsUgasQueryVariables>(AllocationsUgasDocument, variables, options);
}
export function useAllocationsUgasLazyQuery(variables?: AllocationsUgasQueryVariables | VueCompositionApi.Ref<AllocationsUgasQueryVariables> | ReactiveFunction<AllocationsUgasQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsUgasQuery, AllocationsUgasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsUgasQuery, AllocationsUgasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsUgasQuery, AllocationsUgasQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllocationsUgasQuery, AllocationsUgasQueryVariables>(AllocationsUgasDocument, variables, options);
}
export type AllocationsUgasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllocationsUgasQuery, AllocationsUgasQueryVariables>;
export const AllocationsUgaDocument = gql`
    query AllocationsUga($id: ID!) {
  uga(id: $id) {
    ...CoreUgaFields
  }
}
    ${CoreUgaFieldsFragmentDoc}`;
export function useAllocationsUgaQuery(variables: AllocationsUgaQueryVariables | VueCompositionApi.Ref<AllocationsUgaQueryVariables> | ReactiveFunction<AllocationsUgaQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsUgaQuery, AllocationsUgaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsUgaQuery, AllocationsUgaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsUgaQuery, AllocationsUgaQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllocationsUgaQuery, AllocationsUgaQueryVariables>(AllocationsUgaDocument, variables, options);
}
export function useAllocationsUgaLazyQuery(variables?: AllocationsUgaQueryVariables | VueCompositionApi.Ref<AllocationsUgaQueryVariables> | ReactiveFunction<AllocationsUgaQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsUgaQuery, AllocationsUgaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsUgaQuery, AllocationsUgaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsUgaQuery, AllocationsUgaQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllocationsUgaQuery, AllocationsUgaQueryVariables>(AllocationsUgaDocument, variables, options);
}
export type AllocationsUgaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllocationsUgaQuery, AllocationsUgaQueryVariables>;
export const AllocationsZonesDocument = gql`
    query AllocationsZones($enabled: Boolean, $first: Int!, $page: Int) {
  zones(enabled: $enabled, first: $first, page: $page) {
    data {
      ...CoreZoneFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreZoneFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useAllocationsZonesQuery(variables: AllocationsZonesQueryVariables | VueCompositionApi.Ref<AllocationsZonesQueryVariables> | ReactiveFunction<AllocationsZonesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsZonesQuery, AllocationsZonesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsZonesQuery, AllocationsZonesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsZonesQuery, AllocationsZonesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllocationsZonesQuery, AllocationsZonesQueryVariables>(AllocationsZonesDocument, variables, options);
}
export function useAllocationsZonesLazyQuery(variables?: AllocationsZonesQueryVariables | VueCompositionApi.Ref<AllocationsZonesQueryVariables> | ReactiveFunction<AllocationsZonesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsZonesQuery, AllocationsZonesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsZonesQuery, AllocationsZonesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsZonesQuery, AllocationsZonesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllocationsZonesQuery, AllocationsZonesQueryVariables>(AllocationsZonesDocument, variables, options);
}
export type AllocationsZonesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllocationsZonesQuery, AllocationsZonesQueryVariables>;
export const AllocationsZoneDocument = gql`
    query AllocationsZone($id: ID!) {
  zone(id: $id) {
    ...CoreZoneFields
  }
}
    ${CoreZoneFieldsFragmentDoc}`;
export function useAllocationsZoneQuery(variables: AllocationsZoneQueryVariables | VueCompositionApi.Ref<AllocationsZoneQueryVariables> | ReactiveFunction<AllocationsZoneQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsZoneQuery, AllocationsZoneQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsZoneQuery, AllocationsZoneQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsZoneQuery, AllocationsZoneQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllocationsZoneQuery, AllocationsZoneQueryVariables>(AllocationsZoneDocument, variables, options);
}
export function useAllocationsZoneLazyQuery(variables?: AllocationsZoneQueryVariables | VueCompositionApi.Ref<AllocationsZoneQueryVariables> | ReactiveFunction<AllocationsZoneQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllocationsZoneQuery, AllocationsZoneQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllocationsZoneQuery, AllocationsZoneQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllocationsZoneQuery, AllocationsZoneQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllocationsZoneQuery, AllocationsZoneQueryVariables>(AllocationsZoneDocument, variables, options);
}
export type AllocationsZoneQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllocationsZoneQuery, AllocationsZoneQueryVariables>;
export const SignedOmniUrlDocument = gql`
    query signedOmniUrl($dashboard: AnalyticsType!) {
  signedOmniUrl(dashboard: $dashboard) {
    url
  }
}
    `;
export function useSignedOmniUrlQuery(variables: SignedOmniUrlQueryVariables | VueCompositionApi.Ref<SignedOmniUrlQueryVariables> | ReactiveFunction<SignedOmniUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<SignedOmniUrlQuery, SignedOmniUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SignedOmniUrlQuery, SignedOmniUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SignedOmniUrlQuery, SignedOmniUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SignedOmniUrlQuery, SignedOmniUrlQueryVariables>(SignedOmniUrlDocument, variables, options);
}
export function useSignedOmniUrlLazyQuery(variables?: SignedOmniUrlQueryVariables | VueCompositionApi.Ref<SignedOmniUrlQueryVariables> | ReactiveFunction<SignedOmniUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<SignedOmniUrlQuery, SignedOmniUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SignedOmniUrlQuery, SignedOmniUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SignedOmniUrlQuery, SignedOmniUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SignedOmniUrlQuery, SignedOmniUrlQueryVariables>(SignedOmniUrlDocument, variables, options);
}
export type SignedOmniUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SignedOmniUrlQuery, SignedOmniUrlQueryVariables>;
export const GetAnsAttendeesDocument = gql`
    query GetAnsAttendees($firstname: String, $lastname: String, $health_number: String) {
  ansAttendees(
    firstname: $firstname
    lastname: $lastname
    health_number: $health_number
  ) {
    id
    title
    civility
    firstname
    lastname
    category
    type_number
    health_number
    health_type
    healthSpecialties
    pharmacist_type
    external_id
    email
    phone_number
    address {
      name
      street_name
      postcode
      city
      country
    }
  }
}
    `;
export function useGetAnsAttendeesQuery(variables: GetAnsAttendeesQueryVariables | VueCompositionApi.Ref<GetAnsAttendeesQueryVariables> | ReactiveFunction<GetAnsAttendeesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAnsAttendeesQuery, GetAnsAttendeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAnsAttendeesQuery, GetAnsAttendeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAnsAttendeesQuery, GetAnsAttendeesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAnsAttendeesQuery, GetAnsAttendeesQueryVariables>(GetAnsAttendeesDocument, variables, options);
}
export function useGetAnsAttendeesLazyQuery(variables: GetAnsAttendeesQueryVariables | VueCompositionApi.Ref<GetAnsAttendeesQueryVariables> | ReactiveFunction<GetAnsAttendeesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetAnsAttendeesQuery, GetAnsAttendeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAnsAttendeesQuery, GetAnsAttendeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAnsAttendeesQuery, GetAnsAttendeesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAnsAttendeesQuery, GetAnsAttendeesQueryVariables>(GetAnsAttendeesDocument, variables, options);
}
export type GetAnsAttendeesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAnsAttendeesQuery, GetAnsAttendeesQueryVariables>;
export const AttachmentsWhereTicketNullPaginateDocument = gql`
    query attachmentsWhereTicketNullPaginate($first: Int!, $page: Int) {
  attachmentsWhereTicketNullPaginate(first: $first, page: $page) {
    data {
      id
      document {
        url
        filename
      }
      comment
      type
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useAttachmentsWhereTicketNullPaginateQuery(variables: AttachmentsWhereTicketNullPaginateQueryVariables | VueCompositionApi.Ref<AttachmentsWhereTicketNullPaginateQueryVariables> | ReactiveFunction<AttachmentsWhereTicketNullPaginateQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttachmentsWhereTicketNullPaginateQuery, AttachmentsWhereTicketNullPaginateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttachmentsWhereTicketNullPaginateQuery, AttachmentsWhereTicketNullPaginateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttachmentsWhereTicketNullPaginateQuery, AttachmentsWhereTicketNullPaginateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttachmentsWhereTicketNullPaginateQuery, AttachmentsWhereTicketNullPaginateQueryVariables>(AttachmentsWhereTicketNullPaginateDocument, variables, options);
}
export function useAttachmentsWhereTicketNullPaginateLazyQuery(variables?: AttachmentsWhereTicketNullPaginateQueryVariables | VueCompositionApi.Ref<AttachmentsWhereTicketNullPaginateQueryVariables> | ReactiveFunction<AttachmentsWhereTicketNullPaginateQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttachmentsWhereTicketNullPaginateQuery, AttachmentsWhereTicketNullPaginateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttachmentsWhereTicketNullPaginateQuery, AttachmentsWhereTicketNullPaginateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttachmentsWhereTicketNullPaginateQuery, AttachmentsWhereTicketNullPaginateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttachmentsWhereTicketNullPaginateQuery, AttachmentsWhereTicketNullPaginateQueryVariables>(AttachmentsWhereTicketNullPaginateDocument, variables, options);
}
export type AttachmentsWhereTicketNullPaginateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttachmentsWhereTicketNullPaginateQuery, AttachmentsWhereTicketNullPaginateQueryVariables>;
export const AllAttachmentsWhereTicketNullDocument = gql`
    query allAttachmentsWhereTicketNull {
  allAttachmentsWhereTicketNull {
    id
    document {
      url
      filename
    }
    comment
    type
  }
}
    `;
export function useAllAttachmentsWhereTicketNullQuery(options: VueApolloComposable.UseQueryOptions<AllAttachmentsWhereTicketNullQuery, AllAttachmentsWhereTicketNullQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllAttachmentsWhereTicketNullQuery, AllAttachmentsWhereTicketNullQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllAttachmentsWhereTicketNullQuery, AllAttachmentsWhereTicketNullQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllAttachmentsWhereTicketNullQuery, AllAttachmentsWhereTicketNullQueryVariables>(AllAttachmentsWhereTicketNullDocument, {}, options);
}
export function useAllAttachmentsWhereTicketNullLazyQuery(options: VueApolloComposable.UseQueryOptions<AllAttachmentsWhereTicketNullQuery, AllAttachmentsWhereTicketNullQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllAttachmentsWhereTicketNullQuery, AllAttachmentsWhereTicketNullQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllAttachmentsWhereTicketNullQuery, AllAttachmentsWhereTicketNullQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllAttachmentsWhereTicketNullQuery, AllAttachmentsWhereTicketNullQueryVariables>(AllAttachmentsWhereTicketNullDocument, {}, options);
}
export type AllAttachmentsWhereTicketNullQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllAttachmentsWhereTicketNullQuery, AllAttachmentsWhereTicketNullQueryVariables>;
export const ZipFileDocument = gql`
    query zipFile($ticket_code: String!) {
  zipFile(ticket_code: $ticket_code) {
    id
    document {
      ...CoreDocumentFields
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useZipFileQuery(variables: ZipFileQueryVariables | VueCompositionApi.Ref<ZipFileQueryVariables> | ReactiveFunction<ZipFileQueryVariables>, options: VueApolloComposable.UseQueryOptions<ZipFileQuery, ZipFileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ZipFileQuery, ZipFileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ZipFileQuery, ZipFileQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ZipFileQuery, ZipFileQueryVariables>(ZipFileDocument, variables, options);
}
export function useZipFileLazyQuery(variables?: ZipFileQueryVariables | VueCompositionApi.Ref<ZipFileQueryVariables> | ReactiveFunction<ZipFileQueryVariables>, options: VueApolloComposable.UseQueryOptions<ZipFileQuery, ZipFileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ZipFileQuery, ZipFileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ZipFileQuery, ZipFileQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ZipFileQuery, ZipFileQueryVariables>(ZipFileDocument, variables, options);
}
export type ZipFileQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ZipFileQuery, ZipFileQueryVariables>;
export const AttendeesByTicketDocument = gql`
    query attendeesByTicket($id: ID, $code: String, $first: Int!, $page: Int, $name: String, $type: AttendeeType, $category: AttendeeCategory, $state: [AttendeeStateType], $health_type: AttendeeHealthType, $submission_regime: AttendeeSubmissionRegime, $added_by: ID, $pack: ID, $orderBy: [QueryAttendeesByTicketOrderByRelationOrderByClause!]) {
  attendeesByTicket(
    id: $id
    code: $code
    first: $first
    page: $page
    name: $name
    type: $type
    state: $state
    category: $category
    health_type: $health_type
    submission_regime: $submission_regime
    pack: $pack
    added_by: $added_by
    orderBy: $orderBy
  ) {
    data {
      id
      civility
      type
      category
      title
      firstname
      lastname
      type_number
      health_number
      health_type
      healthSpecialties {
        ...CoreSpecialtyFields
      }
      pharmacist_type
      regime
      email
      phone_number
      address {
        ...CoreAddressFields
      }
      description
      external_id
      is_present
      is_billed
      is_threshold_reached
      is_public
      is_military
      activity
      organization_type
      legal_title
      executive_role
      contractual_link
      parent_organization_name
      company
      state
      acronym
      legal_status
      rcs
      place_of_registration
      capital
      prefecture_name
      prefecture_number
      base_global_code
      social_security_number
      siret
      prefecture_date
      official_journal_date
      ticketLink {
        code
        status
        workflow_step
      }
      deleted_at
      plannedPackages {
        ...CorePlannedPackageFields
      }
      actualPackages {
        ...CoreActualPackageFields
      }
      contractsSignatureStatus
      contractsDepositStatus
      contracts {
        id
        ticket {
          id
        }
        signature_status
        deposit_status
        document {
          id
          filename
          path
          type
          url
          temporary_url
          created_at
        }
        contractTemplate {
          id
          name
          document {
            id
            filename
            path
            type
            url
            temporary_url
            created_at
          }
          signature_request_type
        }
      }
      documents {
        id
        type
        signature_status
        deposit_status
        step
        document {
          id
          filename
          path
          type
          url
          temporary_url
          created_at
        }
      }
      assignation
      addedBy {
        ...CoreAddedByFields
      }
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreAddressFieldsFragmentDoc}
${CorePlannedPackageFieldsFragmentDoc}
${CoreActualPackageFieldsFragmentDoc}
${CoreAddedByFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useAttendeesByTicketQuery(variables: AttendeesByTicketQueryVariables | VueCompositionApi.Ref<AttendeesByTicketQueryVariables> | ReactiveFunction<AttendeesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesByTicketQuery, AttendeesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesByTicketQuery, AttendeesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesByTicketQuery, AttendeesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttendeesByTicketQuery, AttendeesByTicketQueryVariables>(AttendeesByTicketDocument, variables, options);
}
export function useAttendeesByTicketLazyQuery(variables?: AttendeesByTicketQueryVariables | VueCompositionApi.Ref<AttendeesByTicketQueryVariables> | ReactiveFunction<AttendeesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesByTicketQuery, AttendeesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesByTicketQuery, AttendeesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesByTicketQuery, AttendeesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttendeesByTicketQuery, AttendeesByTicketQueryVariables>(AttendeesByTicketDocument, variables, options);
}
export type AttendeesByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttendeesByTicketQuery, AttendeesByTicketQueryVariables>;
export const GetAttendeeTotalByTicketDocument = gql`
    query GetAttendeeTotalByTicket($id: ID!, $first: Int!, $page: Int, $name: String, $type: AttendeeType, $category: AttendeeCategory, $health_type: AttendeeHealthType, $added_by: ID, $submission_regime: AttendeeSubmissionRegime, $pack: ID) {
  total: attendeesTotalByTicket(
    id: $id
    first: $first
    page: $page
    name: $name
    type: $type
    category: $category
    health_type: $health_type
    submission_regime: $submission_regime
    added_by: $added_by
    pack: $pack
  ) {
    paginatorInfo {
      total
    }
  }
}
    `;
export function useGetAttendeeTotalByTicketQuery(variables: GetAttendeeTotalByTicketQueryVariables | VueCompositionApi.Ref<GetAttendeeTotalByTicketQueryVariables> | ReactiveFunction<GetAttendeeTotalByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAttendeeTotalByTicketQuery, GetAttendeeTotalByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAttendeeTotalByTicketQuery, GetAttendeeTotalByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAttendeeTotalByTicketQuery, GetAttendeeTotalByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAttendeeTotalByTicketQuery, GetAttendeeTotalByTicketQueryVariables>(GetAttendeeTotalByTicketDocument, variables, options);
}
export function useGetAttendeeTotalByTicketLazyQuery(variables?: GetAttendeeTotalByTicketQueryVariables | VueCompositionApi.Ref<GetAttendeeTotalByTicketQueryVariables> | ReactiveFunction<GetAttendeeTotalByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAttendeeTotalByTicketQuery, GetAttendeeTotalByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAttendeeTotalByTicketQuery, GetAttendeeTotalByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAttendeeTotalByTicketQuery, GetAttendeeTotalByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAttendeeTotalByTicketQuery, GetAttendeeTotalByTicketQueryVariables>(GetAttendeeTotalByTicketDocument, variables, options);
}
export type GetAttendeeTotalByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAttendeeTotalByTicketQuery, GetAttendeeTotalByTicketQueryVariables>;
export const GetAttendeeDocument = gql`
    query GetAttendee($id: ID!) {
  attendee(id: $id) {
    ...CoreAttendeeTicketFields
  }
}
    ${CoreAttendeeTicketFieldsFragmentDoc}`;
export function useGetAttendeeQuery(variables: GetAttendeeQueryVariables | VueCompositionApi.Ref<GetAttendeeQueryVariables> | ReactiveFunction<GetAttendeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAttendeeQuery, GetAttendeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAttendeeQuery, GetAttendeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAttendeeQuery, GetAttendeeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAttendeeQuery, GetAttendeeQueryVariables>(GetAttendeeDocument, variables, options);
}
export function useGetAttendeeLazyQuery(variables?: GetAttendeeQueryVariables | VueCompositionApi.Ref<GetAttendeeQueryVariables> | ReactiveFunction<GetAttendeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAttendeeQuery, GetAttendeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAttendeeQuery, GetAttendeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAttendeeQuery, GetAttendeeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAttendeeQuery, GetAttendeeQueryVariables>(GetAttendeeDocument, variables, options);
}
export type GetAttendeeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAttendeeQuery, GetAttendeeQueryVariables>;
export const AttendeeAdvantageTypeTotalDocument = gql`
    query attendeeAdvantageTypeTotal($ticket_code: String!, $attendee_id: ID, $advantage_type: AdvantageType) {
  attendeeAdvantageTypeTotal(
    ticket_code: $ticket_code
    attendee_id: $attendee_id
    advantage_type: $advantage_type
  ) {
    data {
      id
      advantage_type
      total_actual_advantages
      total_planned_advantages
      total_gap
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useAttendeeAdvantageTypeTotalQuery(variables: AttendeeAdvantageTypeTotalQueryVariables | VueCompositionApi.Ref<AttendeeAdvantageTypeTotalQueryVariables> | ReactiveFunction<AttendeeAdvantageTypeTotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeeAdvantageTypeTotalQuery, AttendeeAdvantageTypeTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeeAdvantageTypeTotalQuery, AttendeeAdvantageTypeTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeeAdvantageTypeTotalQuery, AttendeeAdvantageTypeTotalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttendeeAdvantageTypeTotalQuery, AttendeeAdvantageTypeTotalQueryVariables>(AttendeeAdvantageTypeTotalDocument, variables, options);
}
export function useAttendeeAdvantageTypeTotalLazyQuery(variables?: AttendeeAdvantageTypeTotalQueryVariables | VueCompositionApi.Ref<AttendeeAdvantageTypeTotalQueryVariables> | ReactiveFunction<AttendeeAdvantageTypeTotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeeAdvantageTypeTotalQuery, AttendeeAdvantageTypeTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeeAdvantageTypeTotalQuery, AttendeeAdvantageTypeTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeeAdvantageTypeTotalQuery, AttendeeAdvantageTypeTotalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttendeeAdvantageTypeTotalQuery, AttendeeAdvantageTypeTotalQueryVariables>(AttendeeAdvantageTypeTotalDocument, variables, options);
}
export type AttendeeAdvantageTypeTotalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttendeeAdvantageTypeTotalQuery, AttendeeAdvantageTypeTotalQueryVariables>;
export const AggregatedAdvantageTypeTotalByTicketDocument = gql`
    query aggregatedAdvantageTypeTotalByTicket($ticket_code: String!, $first: Int, $page: Int) {
  aggregatedAdvantageTypeTotalByTicket(
    ticket_code: $ticket_code
    first: $first
    page: $page
  ) {
    data {
      id
      advantage_type
      total_actual_advantages
      total_planned_advantages
      total_gap
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useAggregatedAdvantageTypeTotalByTicketQuery(variables: AggregatedAdvantageTypeTotalByTicketQueryVariables | VueCompositionApi.Ref<AggregatedAdvantageTypeTotalByTicketQueryVariables> | ReactiveFunction<AggregatedAdvantageTypeTotalByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketQuery, AggregatedAdvantageTypeTotalByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketQuery, AggregatedAdvantageTypeTotalByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketQuery, AggregatedAdvantageTypeTotalByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AggregatedAdvantageTypeTotalByTicketQuery, AggregatedAdvantageTypeTotalByTicketQueryVariables>(AggregatedAdvantageTypeTotalByTicketDocument, variables, options);
}
export function useAggregatedAdvantageTypeTotalByTicketLazyQuery(variables?: AggregatedAdvantageTypeTotalByTicketQueryVariables | VueCompositionApi.Ref<AggregatedAdvantageTypeTotalByTicketQueryVariables> | ReactiveFunction<AggregatedAdvantageTypeTotalByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketQuery, AggregatedAdvantageTypeTotalByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketQuery, AggregatedAdvantageTypeTotalByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketQuery, AggregatedAdvantageTypeTotalByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AggregatedAdvantageTypeTotalByTicketQuery, AggregatedAdvantageTypeTotalByTicketQueryVariables>(AggregatedAdvantageTypeTotalByTicketDocument, variables, options);
}
export type AggregatedAdvantageTypeTotalByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AggregatedAdvantageTypeTotalByTicketQuery, AggregatedAdvantageTypeTotalByTicketQueryVariables>;
export const AggregatedAdvantageTypeTotalByTicketThenByAttendeeDocument = gql`
    query aggregatedAdvantageTypeTotalByTicketThenByAttendee($ticket_code: String!, $attendee_name: String, $first: Int, $page: Int, $orderBy: [AggregatedAdvantageTypeTotalOrderByInput!]) {
  aggregatedAdvantageTypeTotalByTicketThenByAttendee(
    ticket_code: $ticket_code
    attendee_name: $attendee_name
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    data {
      id
      firstname
      lastname
      civility
      category
      health_type
      healthSpecialties {
        ...CoreSpecialtyFields
      }
      health_number
      organization_type
      legal_title
      address {
        ...CoreAddressFields
      }
      advantage_types {
        advantage_type
        total_planned_advantages
        total_actual_advantages
        total_gap
      }
      is_military
      is_present
      is_billed
      total_planned_advantages
      total_actual_advantages
      total_gap
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreAddressFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useAggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery(variables: AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables | VueCompositionApi.Ref<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables> | ReactiveFunction<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery, AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery, AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery, AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery, AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables>(AggregatedAdvantageTypeTotalByTicketThenByAttendeeDocument, variables, options);
}
export function useAggregatedAdvantageTypeTotalByTicketThenByAttendeeLazyQuery(variables?: AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables | VueCompositionApi.Ref<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables> | ReactiveFunction<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery, AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery, AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery, AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery, AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables>(AggregatedAdvantageTypeTotalByTicketThenByAttendeeDocument, variables, options);
}
export type AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AggregatedAdvantageTypeTotalByTicketThenByAttendeeQuery, AggregatedAdvantageTypeTotalByTicketThenByAttendeeQueryVariables>;
export const AttendeesOnSigningSheetDocument = gql`
    query AttendeesOnSigningSheet($code: String!, $state: [AttendeeStateType]) {
  attendeesByTicketWithSignatures(code: $code, state: $state) {
    id
    ticket_id
    healthSpecialties {
      ...CoreSpecialtyFields
    }
    firstname
    lastname
    type_number
    health_number
    is_signed
    category
    legal_title
    attendeeSignature {
      id
      signature
      hospitality
    }
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}`;
export function useAttendeesOnSigningSheetQuery(variables: AttendeesOnSigningSheetQueryVariables | VueCompositionApi.Ref<AttendeesOnSigningSheetQueryVariables> | ReactiveFunction<AttendeesOnSigningSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesOnSigningSheetQuery, AttendeesOnSigningSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesOnSigningSheetQuery, AttendeesOnSigningSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesOnSigningSheetQuery, AttendeesOnSigningSheetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttendeesOnSigningSheetQuery, AttendeesOnSigningSheetQueryVariables>(AttendeesOnSigningSheetDocument, variables, options);
}
export function useAttendeesOnSigningSheetLazyQuery(variables?: AttendeesOnSigningSheetQueryVariables | VueCompositionApi.Ref<AttendeesOnSigningSheetQueryVariables> | ReactiveFunction<AttendeesOnSigningSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesOnSigningSheetQuery, AttendeesOnSigningSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesOnSigningSheetQuery, AttendeesOnSigningSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesOnSigningSheetQuery, AttendeesOnSigningSheetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttendeesOnSigningSheetQuery, AttendeesOnSigningSheetQueryVariables>(AttendeesOnSigningSheetDocument, variables, options);
}
export type AttendeesOnSigningSheetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttendeesOnSigningSheetQuery, AttendeesOnSigningSheetQueryVariables>;
export const AttendeesOnPostEventDocument = gql`
    query AttendeesOnPostEvent($code: String!, $state: [AttendeeStateType]) {
  attendeesByTicketWithSignatures(code: $code, state: $state) {
    ...CoreAttendeeOnPostEventFields
  }
}
    ${CoreAttendeeOnPostEventFieldsFragmentDoc}`;
export function useAttendeesOnPostEventQuery(variables: AttendeesOnPostEventQueryVariables | VueCompositionApi.Ref<AttendeesOnPostEventQueryVariables> | ReactiveFunction<AttendeesOnPostEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesOnPostEventQuery, AttendeesOnPostEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesOnPostEventQuery, AttendeesOnPostEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesOnPostEventQuery, AttendeesOnPostEventQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttendeesOnPostEventQuery, AttendeesOnPostEventQueryVariables>(AttendeesOnPostEventDocument, variables, options);
}
export function useAttendeesOnPostEventLazyQuery(variables?: AttendeesOnPostEventQueryVariables | VueCompositionApi.Ref<AttendeesOnPostEventQueryVariables> | ReactiveFunction<AttendeesOnPostEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesOnPostEventQuery, AttendeesOnPostEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesOnPostEventQuery, AttendeesOnPostEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesOnPostEventQuery, AttendeesOnPostEventQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttendeesOnPostEventQuery, AttendeesOnPostEventQueryVariables>(AttendeesOnPostEventDocument, variables, options);
}
export type AttendeesOnPostEventQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttendeesOnPostEventQuery, AttendeesOnPostEventQueryVariables>;
export const AttendeesOnPostEventPaginationDocument = gql`
    query AttendeesOnPostEventPagination($code: String!, $name: String, $state: [AttendeeStateType], $first: Int!, $page: Int, $orderBy: [QueryAttendeesByTicketWithSignaturesPaginationOrderByRelationOrderByClause!]) {
  attendeesByTicketWithSignaturesPagination(
    code: $code
    name: $name
    state: $state
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    data {
      ...CoreAttendeeOnPostEventFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreAttendeeOnPostEventFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useAttendeesOnPostEventPaginationQuery(variables: AttendeesOnPostEventPaginationQueryVariables | VueCompositionApi.Ref<AttendeesOnPostEventPaginationQueryVariables> | ReactiveFunction<AttendeesOnPostEventPaginationQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesOnPostEventPaginationQuery, AttendeesOnPostEventPaginationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesOnPostEventPaginationQuery, AttendeesOnPostEventPaginationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesOnPostEventPaginationQuery, AttendeesOnPostEventPaginationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttendeesOnPostEventPaginationQuery, AttendeesOnPostEventPaginationQueryVariables>(AttendeesOnPostEventPaginationDocument, variables, options);
}
export function useAttendeesOnPostEventPaginationLazyQuery(variables?: AttendeesOnPostEventPaginationQueryVariables | VueCompositionApi.Ref<AttendeesOnPostEventPaginationQueryVariables> | ReactiveFunction<AttendeesOnPostEventPaginationQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesOnPostEventPaginationQuery, AttendeesOnPostEventPaginationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesOnPostEventPaginationQuery, AttendeesOnPostEventPaginationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesOnPostEventPaginationQuery, AttendeesOnPostEventPaginationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttendeesOnPostEventPaginationQuery, AttendeesOnPostEventPaginationQueryVariables>(AttendeesOnPostEventPaginationDocument, variables, options);
}
export type AttendeesOnPostEventPaginationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttendeesOnPostEventPaginationQuery, AttendeesOnPostEventPaginationQueryVariables>;
export const CheckExpensesImportBatchDocument = gql`
    query CheckExpensesImportBatch($input: ExpensesImportBatchInput!) {
  checkExpensesImportBatch(input: $input) {
    batch_id
    expenses_import {
      id
      state
      created_at
      document {
        ...CoreDocumentFields
      }
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useCheckExpensesImportBatchQuery(variables: CheckExpensesImportBatchQueryVariables | VueCompositionApi.Ref<CheckExpensesImportBatchQueryVariables> | ReactiveFunction<CheckExpensesImportBatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckExpensesImportBatchQuery, CheckExpensesImportBatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckExpensesImportBatchQuery, CheckExpensesImportBatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckExpensesImportBatchQuery, CheckExpensesImportBatchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CheckExpensesImportBatchQuery, CheckExpensesImportBatchQueryVariables>(CheckExpensesImportBatchDocument, variables, options);
}
export function useCheckExpensesImportBatchLazyQuery(variables?: CheckExpensesImportBatchQueryVariables | VueCompositionApi.Ref<CheckExpensesImportBatchQueryVariables> | ReactiveFunction<CheckExpensesImportBatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckExpensesImportBatchQuery, CheckExpensesImportBatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckExpensesImportBatchQuery, CheckExpensesImportBatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckExpensesImportBatchQuery, CheckExpensesImportBatchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CheckExpensesImportBatchQuery, CheckExpensesImportBatchQueryVariables>(CheckExpensesImportBatchDocument, variables, options);
}
export type CheckExpensesImportBatchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CheckExpensesImportBatchQuery, CheckExpensesImportBatchQueryVariables>;
export const CheckContractZipFileBatchDocument = gql`
    query CheckContractZipFileBatch($input: ContractZipFileBatchInput!) {
  checkContractZipFileBatch(input: $input) {
    batch_id
    has_failed
    attachment {
      id
      document {
        ...CoreDocumentFields
      }
      comment
      type
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useCheckContractZipFileBatchQuery(variables: CheckContractZipFileBatchQueryVariables | VueCompositionApi.Ref<CheckContractZipFileBatchQueryVariables> | ReactiveFunction<CheckContractZipFileBatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckContractZipFileBatchQuery, CheckContractZipFileBatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckContractZipFileBatchQuery, CheckContractZipFileBatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckContractZipFileBatchQuery, CheckContractZipFileBatchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CheckContractZipFileBatchQuery, CheckContractZipFileBatchQueryVariables>(CheckContractZipFileBatchDocument, variables, options);
}
export function useCheckContractZipFileBatchLazyQuery(variables?: CheckContractZipFileBatchQueryVariables | VueCompositionApi.Ref<CheckContractZipFileBatchQueryVariables> | ReactiveFunction<CheckContractZipFileBatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckContractZipFileBatchQuery, CheckContractZipFileBatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckContractZipFileBatchQuery, CheckContractZipFileBatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckContractZipFileBatchQuery, CheckContractZipFileBatchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CheckContractZipFileBatchQuery, CheckContractZipFileBatchQueryVariables>(CheckContractZipFileBatchDocument, variables, options);
}
export type CheckContractZipFileBatchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CheckContractZipFileBatchQuery, CheckContractZipFileBatchQueryVariables>;
export const CheckContractTemplateBatchesDocument = gql`
    query CheckContractTemplateBatches($input: [checkBatchesInput]!) {
  checkBatches(input: $input) {
    batch_id
    attendee_id
    contract_template_id
    contract_attendee {
      ...CoreContractAttendee
    }
  }
}
    ${CoreContractAttendeeFragmentDoc}`;
export function useCheckContractTemplateBatchesQuery(variables: CheckContractTemplateBatchesQueryVariables | VueCompositionApi.Ref<CheckContractTemplateBatchesQueryVariables> | ReactiveFunction<CheckContractTemplateBatchesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckContractTemplateBatchesQuery, CheckContractTemplateBatchesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckContractTemplateBatchesQuery, CheckContractTemplateBatchesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckContractTemplateBatchesQuery, CheckContractTemplateBatchesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CheckContractTemplateBatchesQuery, CheckContractTemplateBatchesQueryVariables>(CheckContractTemplateBatchesDocument, variables, options);
}
export function useCheckContractTemplateBatchesLazyQuery(variables?: CheckContractTemplateBatchesQueryVariables | VueCompositionApi.Ref<CheckContractTemplateBatchesQueryVariables> | ReactiveFunction<CheckContractTemplateBatchesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckContractTemplateBatchesQuery, CheckContractTemplateBatchesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckContractTemplateBatchesQuery, CheckContractTemplateBatchesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckContractTemplateBatchesQuery, CheckContractTemplateBatchesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CheckContractTemplateBatchesQuery, CheckContractTemplateBatchesQueryVariables>(CheckContractTemplateBatchesDocument, variables, options);
}
export type CheckContractTemplateBatchesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CheckContractTemplateBatchesQuery, CheckContractTemplateBatchesQueryVariables>;
export const CommentsByTicketCodeDocument = gql`
    query commentsByTicketCode($code: String!, $first: Int, $page: Int) {
  commentsByTicketCode(code: $code, first: $first, page: $page) {
    data {
      ...CoreCommentFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreCommentFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useCommentsByTicketCodeQuery(variables: CommentsByTicketCodeQueryVariables | VueCompositionApi.Ref<CommentsByTicketCodeQueryVariables> | ReactiveFunction<CommentsByTicketCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommentsByTicketCodeQuery, CommentsByTicketCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommentsByTicketCodeQuery, CommentsByTicketCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommentsByTicketCodeQuery, CommentsByTicketCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CommentsByTicketCodeQuery, CommentsByTicketCodeQueryVariables>(CommentsByTicketCodeDocument, variables, options);
}
export function useCommentsByTicketCodeLazyQuery(variables?: CommentsByTicketCodeQueryVariables | VueCompositionApi.Ref<CommentsByTicketCodeQueryVariables> | ReactiveFunction<CommentsByTicketCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommentsByTicketCodeQuery, CommentsByTicketCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommentsByTicketCodeQuery, CommentsByTicketCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommentsByTicketCodeQuery, CommentsByTicketCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CommentsByTicketCodeQuery, CommentsByTicketCodeQueryVariables>(CommentsByTicketCodeDocument, variables, options);
}
export type CommentsByTicketCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CommentsByTicketCodeQuery, CommentsByTicketCodeQueryVariables>;
export const ContactDocument = gql`
    query Contact($id: ID!) {
  contact(id: $id) {
    ...CoreContactFields
  }
}
    ${CoreContactFieldsFragmentDoc}`;
export function useContactQuery(variables: ContactQueryVariables | VueCompositionApi.Ref<ContactQueryVariables> | ReactiveFunction<ContactQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContactQuery, ContactQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactQuery, ContactQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactQuery, ContactQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, variables, options);
}
export function useContactLazyQuery(variables?: ContactQueryVariables | VueCompositionApi.Ref<ContactQueryVariables> | ReactiveFunction<ContactQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContactQuery, ContactQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContactQuery, ContactQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContactQuery, ContactQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, variables, options);
}
export type ContactQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContactQuery, ContactQueryVariables>;
export const GetContactsDocument = gql`
    query GetContacts($first: Int!, $page: Int, $type: AttendeeType, $category: AttendeeCategory, $health_type: AttendeeHealthType, $organization_type: AttendeeOrganizationType, $legal_title: String, $health_number: String, $company: String, $firstname: String, $lastname: String, $name: String) {
  contacts(
    first: $first
    page: $page
    type: $type
    category: $category
    health_type: $health_type
    organization_type: $organization_type
    legal_title: $legal_title
    health_number: $health_number
    company: $company
    firstname: $firstname
    lastname: $lastname
    name: $name
  ) {
    data {
      ...CoreContactFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreContactFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useGetContactsQuery(variables: GetContactsQueryVariables | VueCompositionApi.Ref<GetContactsQueryVariables> | ReactiveFunction<GetContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, variables, options);
}
export function useGetContactsLazyQuery(variables?: GetContactsQueryVariables | VueCompositionApi.Ref<GetContactsQueryVariables> | ReactiveFunction<GetContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, variables, options);
}
export type GetContactsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContactsQuery, GetContactsQueryVariables>;
export const GetContactsTotalDocument = gql`
    query GetContactsTotal($type: AttendeeType, $category: AttendeeCategory, $health_type: AttendeeHealthType, $organization_type: AttendeeOrganizationType, $health_number: String, $company: String, $legal_title: String, $firstname: String, $lastname: String, $name: String) {
  totalContacts(
    type: $type
    category: $category
    health_type: $health_type
    organization_type: $organization_type
    legal_title: $legal_title
    health_number: $health_number
    company: $company
    firstname: $firstname
    lastname: $lastname
    name: $name
  )
}
    `;
export function useGetContactsTotalQuery(variables: GetContactsTotalQueryVariables | VueCompositionApi.Ref<GetContactsTotalQueryVariables> | ReactiveFunction<GetContactsTotalQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetContactsTotalQuery, GetContactsTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContactsTotalQuery, GetContactsTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContactsTotalQuery, GetContactsTotalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContactsTotalQuery, GetContactsTotalQueryVariables>(GetContactsTotalDocument, variables, options);
}
export function useGetContactsTotalLazyQuery(variables: GetContactsTotalQueryVariables | VueCompositionApi.Ref<GetContactsTotalQueryVariables> | ReactiveFunction<GetContactsTotalQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetContactsTotalQuery, GetContactsTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContactsTotalQuery, GetContactsTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContactsTotalQuery, GetContactsTotalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetContactsTotalQuery, GetContactsTotalQueryVariables>(GetContactsTotalDocument, variables, options);
}
export type GetContactsTotalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContactsTotalQuery, GetContactsTotalQueryVariables>;
export const ContractAndSignersDocument = gql`
    query ContractAndSigners($code: String!, $attendeeIds: [ID]) {
  contractAndSignersByTicketCode(code: $code, attendeeIds: $attendeeIds) {
    contract {
      ...CoreContractAttendee
    }
    signers {
      id
      email
    }
  }
}
    ${CoreContractAttendeeFragmentDoc}`;
export function useContractAndSignersQuery(variables: ContractAndSignersQueryVariables | VueCompositionApi.Ref<ContractAndSignersQueryVariables> | ReactiveFunction<ContractAndSignersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractAndSignersQuery, ContractAndSignersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractAndSignersQuery, ContractAndSignersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractAndSignersQuery, ContractAndSignersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContractAndSignersQuery, ContractAndSignersQueryVariables>(ContractAndSignersDocument, variables, options);
}
export function useContractAndSignersLazyQuery(variables?: ContractAndSignersQueryVariables | VueCompositionApi.Ref<ContractAndSignersQueryVariables> | ReactiveFunction<ContractAndSignersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractAndSignersQuery, ContractAndSignersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractAndSignersQuery, ContractAndSignersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractAndSignersQuery, ContractAndSignersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContractAndSignersQuery, ContractAndSignersQueryVariables>(ContractAndSignersDocument, variables, options);
}
export type ContractAndSignersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContractAndSignersQuery, ContractAndSignersQueryVariables>;
export const ContractAttendeesForReminderDocument = gql`
    query ContractAttendeesForReminder($code: String!) {
  contractAttendeesForReminder(code: $code) {
    contractAttendees {
      contract {
        ...CoreContractAttendee
      }
      signers {
        id
        email
      }
    }
    latestReminder
  }
}
    ${CoreContractAttendeeFragmentDoc}`;
export function useContractAttendeesForReminderQuery(variables: ContractAttendeesForReminderQueryVariables | VueCompositionApi.Ref<ContractAttendeesForReminderQueryVariables> | ReactiveFunction<ContractAttendeesForReminderQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractAttendeesForReminderQuery, ContractAttendeesForReminderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractAttendeesForReminderQuery, ContractAttendeesForReminderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractAttendeesForReminderQuery, ContractAttendeesForReminderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContractAttendeesForReminderQuery, ContractAttendeesForReminderQueryVariables>(ContractAttendeesForReminderDocument, variables, options);
}
export function useContractAttendeesForReminderLazyQuery(variables?: ContractAttendeesForReminderQueryVariables | VueCompositionApi.Ref<ContractAttendeesForReminderQueryVariables> | ReactiveFunction<ContractAttendeesForReminderQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractAttendeesForReminderQuery, ContractAttendeesForReminderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractAttendeesForReminderQuery, ContractAttendeesForReminderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractAttendeesForReminderQuery, ContractAttendeesForReminderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContractAttendeesForReminderQuery, ContractAttendeesForReminderQueryVariables>(ContractAttendeesForReminderDocument, variables, options);
}
export type ContractAttendeesForReminderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContractAttendeesForReminderQuery, ContractAttendeesForReminderQueryVariables>;
export const AllInternalSignersDocument = gql`
    query AllInternalSigners {
  allInternalSigners {
    validator_signers {
      ...CoreUserKeycloakSignerFields
    }
    internal_signers {
      ...CoreInternalSignerFields
    }
    users_and_internal_signers {
      ...CoreUserAndInternalSignerFields
    }
  }
}
    ${CoreUserKeycloakSignerFieldsFragmentDoc}
${CoreInternalSignerFieldsFragmentDoc}
${CoreUserAndInternalSignerFieldsFragmentDoc}`;
export function useAllInternalSignersQuery(options: VueApolloComposable.UseQueryOptions<AllInternalSignersQuery, AllInternalSignersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllInternalSignersQuery, AllInternalSignersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllInternalSignersQuery, AllInternalSignersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllInternalSignersQuery, AllInternalSignersQueryVariables>(AllInternalSignersDocument, {}, options);
}
export function useAllInternalSignersLazyQuery(options: VueApolloComposable.UseQueryOptions<AllInternalSignersQuery, AllInternalSignersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllInternalSignersQuery, AllInternalSignersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllInternalSignersQuery, AllInternalSignersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllInternalSignersQuery, AllInternalSignersQueryVariables>(AllInternalSignersDocument, {}, options);
}
export type AllInternalSignersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllInternalSignersQuery, AllInternalSignersQueryVariables>;
export const ContractTemplatesByTicketDocument = gql`
    query contractTemplatesByTicket($ticket_id: ID!) {
  contractTemplatesByTicket(ticket_id: $ticket_id) {
    id
    name
    signature_request_type
  }
}
    `;
export function useContractTemplatesByTicketQuery(variables: ContractTemplatesByTicketQueryVariables | VueCompositionApi.Ref<ContractTemplatesByTicketQueryVariables> | ReactiveFunction<ContractTemplatesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractTemplatesByTicketQuery, ContractTemplatesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractTemplatesByTicketQuery, ContractTemplatesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractTemplatesByTicketQuery, ContractTemplatesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContractTemplatesByTicketQuery, ContractTemplatesByTicketQueryVariables>(ContractTemplatesByTicketDocument, variables, options);
}
export function useContractTemplatesByTicketLazyQuery(variables?: ContractTemplatesByTicketQueryVariables | VueCompositionApi.Ref<ContractTemplatesByTicketQueryVariables> | ReactiveFunction<ContractTemplatesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractTemplatesByTicketQuery, ContractTemplatesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractTemplatesByTicketQuery, ContractTemplatesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractTemplatesByTicketQuery, ContractTemplatesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContractTemplatesByTicketQuery, ContractTemplatesByTicketQueryVariables>(ContractTemplatesByTicketDocument, variables, options);
}
export type ContractTemplatesByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContractTemplatesByTicketQuery, ContractTemplatesByTicketQueryVariables>;
export const ContractTemplatesAllByTicketDocument = gql`
    query contractTemplatesAllByTicket($ticket_code: String!) {
  contractTemplatesAllByTicket(ticket_code: $ticket_code) {
    id
    name
    signature_request_type
    ticket_id
  }
}
    `;
export function useContractTemplatesAllByTicketQuery(variables: ContractTemplatesAllByTicketQueryVariables | VueCompositionApi.Ref<ContractTemplatesAllByTicketQueryVariables> | ReactiveFunction<ContractTemplatesAllByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractTemplatesAllByTicketQuery, ContractTemplatesAllByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractTemplatesAllByTicketQuery, ContractTemplatesAllByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractTemplatesAllByTicketQuery, ContractTemplatesAllByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContractTemplatesAllByTicketQuery, ContractTemplatesAllByTicketQueryVariables>(ContractTemplatesAllByTicketDocument, variables, options);
}
export function useContractTemplatesAllByTicketLazyQuery(variables?: ContractTemplatesAllByTicketQueryVariables | VueCompositionApi.Ref<ContractTemplatesAllByTicketQueryVariables> | ReactiveFunction<ContractTemplatesAllByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractTemplatesAllByTicketQuery, ContractTemplatesAllByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractTemplatesAllByTicketQuery, ContractTemplatesAllByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractTemplatesAllByTicketQuery, ContractTemplatesAllByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContractTemplatesAllByTicketQuery, ContractTemplatesAllByTicketQueryVariables>(ContractTemplatesAllByTicketDocument, variables, options);
}
export type ContractTemplatesAllByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContractTemplatesAllByTicketQuery, ContractTemplatesAllByTicketQueryVariables>;
export const ContractTemplatesAllWhereTicketNullDocument = gql`
    query contractTemplatesAllWhereTicketNull($ticket_code: String, $first: Int!, $page: Int, $orderBy: [ContractTemplateOrderByInput!]) {
  contractTemplatesAllWhereTicketNull(
    ticket_code: $ticket_code
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    data {
      id
      name
      signature_request_type
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useContractTemplatesAllWhereTicketNullQuery(variables: ContractTemplatesAllWhereTicketNullQueryVariables | VueCompositionApi.Ref<ContractTemplatesAllWhereTicketNullQueryVariables> | ReactiveFunction<ContractTemplatesAllWhereTicketNullQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractTemplatesAllWhereTicketNullQuery, ContractTemplatesAllWhereTicketNullQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractTemplatesAllWhereTicketNullQuery, ContractTemplatesAllWhereTicketNullQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractTemplatesAllWhereTicketNullQuery, ContractTemplatesAllWhereTicketNullQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContractTemplatesAllWhereTicketNullQuery, ContractTemplatesAllWhereTicketNullQueryVariables>(ContractTemplatesAllWhereTicketNullDocument, variables, options);
}
export function useContractTemplatesAllWhereTicketNullLazyQuery(variables?: ContractTemplatesAllWhereTicketNullQueryVariables | VueCompositionApi.Ref<ContractTemplatesAllWhereTicketNullQueryVariables> | ReactiveFunction<ContractTemplatesAllWhereTicketNullQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractTemplatesAllWhereTicketNullQuery, ContractTemplatesAllWhereTicketNullQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractTemplatesAllWhereTicketNullQuery, ContractTemplatesAllWhereTicketNullQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractTemplatesAllWhereTicketNullQuery, ContractTemplatesAllWhereTicketNullQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContractTemplatesAllWhereTicketNullQuery, ContractTemplatesAllWhereTicketNullQueryVariables>(ContractTemplatesAllWhereTicketNullDocument, variables, options);
}
export type ContractTemplatesAllWhereTicketNullQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContractTemplatesAllWhereTicketNullQuery, ContractTemplatesAllWhereTicketNullQueryVariables>;
export const GetAllContractTemplatesWhereTicketNullDocument = gql`
    query getAllContractTemplatesWhereTicketNull {
  getAllContractTemplatesWhereTicketNull {
    id
    name
    signature_request_type
  }
}
    `;
export function useGetAllContractTemplatesWhereTicketNullQuery(options: VueApolloComposable.UseQueryOptions<GetAllContractTemplatesWhereTicketNullQuery, GetAllContractTemplatesWhereTicketNullQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllContractTemplatesWhereTicketNullQuery, GetAllContractTemplatesWhereTicketNullQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllContractTemplatesWhereTicketNullQuery, GetAllContractTemplatesWhereTicketNullQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllContractTemplatesWhereTicketNullQuery, GetAllContractTemplatesWhereTicketNullQueryVariables>(GetAllContractTemplatesWhereTicketNullDocument, {}, options);
}
export function useGetAllContractTemplatesWhereTicketNullLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAllContractTemplatesWhereTicketNullQuery, GetAllContractTemplatesWhereTicketNullQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllContractTemplatesWhereTicketNullQuery, GetAllContractTemplatesWhereTicketNullQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllContractTemplatesWhereTicketNullQuery, GetAllContractTemplatesWhereTicketNullQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllContractTemplatesWhereTicketNullQuery, GetAllContractTemplatesWhereTicketNullQueryVariables>(GetAllContractTemplatesWhereTicketNullDocument, {}, options);
}
export type GetAllContractTemplatesWhereTicketNullQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllContractTemplatesWhereTicketNullQuery, GetAllContractTemplatesWhereTicketNullQueryVariables>;
export const ContractTemplateByIdDocument = gql`
    query contractTemplateById($contract_template_id: ID!, $first: Int!, $page: Int) {
  contractTemplate(id: $contract_template_id) {
    id
    name
    signature_request_type
    contractTemplateDocuments(first: $first, page: $page) {
      data {
        id
        name
        version
        status
        created_by {
          id
          full_name
        }
        document {
          url
          filename
          size
        }
        created_at
      }
      paginatorInfo {
        ...CorePaginationFields
      }
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useContractTemplateByIdQuery(variables: ContractTemplateByIdQueryVariables | VueCompositionApi.Ref<ContractTemplateByIdQueryVariables> | ReactiveFunction<ContractTemplateByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables>(ContractTemplateByIdDocument, variables, options);
}
export function useContractTemplateByIdLazyQuery(variables?: ContractTemplateByIdQueryVariables | VueCompositionApi.Ref<ContractTemplateByIdQueryVariables> | ReactiveFunction<ContractTemplateByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables>(ContractTemplateByIdDocument, variables, options);
}
export type ContractTemplateByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables>;
export const GetConventionsDocument = gql`
    query GetConventions($is_active: Boolean, $first: Int!, $page: Int!) {
  conventionsPaginator(is_active: $is_active, first: $first, page: $page) {
    data {
      ...CoreAdvantagesConvention
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreAdvantagesConventionFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useGetConventionsQuery(variables: GetConventionsQueryVariables | VueCompositionApi.Ref<GetConventionsQueryVariables> | ReactiveFunction<GetConventionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConventionsQuery, GetConventionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConventionsQuery, GetConventionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConventionsQuery, GetConventionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConventionsQuery, GetConventionsQueryVariables>(GetConventionsDocument, variables, options);
}
export function useGetConventionsLazyQuery(variables?: GetConventionsQueryVariables | VueCompositionApi.Ref<GetConventionsQueryVariables> | ReactiveFunction<GetConventionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConventionsQuery, GetConventionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConventionsQuery, GetConventionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConventionsQuery, GetConventionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConventionsQuery, GetConventionsQueryVariables>(GetConventionsDocument, variables, options);
}
export type GetConventionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConventionsQuery, GetConventionsQueryVariables>;
export const GetConventionDocument = gql`
    query GetConvention($id: ID!) {
  convention(id: $id) {
    ...CoreAdvantagesConvention
  }
}
    ${CoreAdvantagesConventionFragmentDoc}`;
export function useGetConventionQuery(variables: GetConventionQueryVariables | VueCompositionApi.Ref<GetConventionQueryVariables> | ReactiveFunction<GetConventionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConventionQuery, GetConventionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConventionQuery, GetConventionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConventionQuery, GetConventionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConventionQuery, GetConventionQueryVariables>(GetConventionDocument, variables, options);
}
export function useGetConventionLazyQuery(variables?: GetConventionQueryVariables | VueCompositionApi.Ref<GetConventionQueryVariables> | ReactiveFunction<GetConventionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConventionQuery, GetConventionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConventionQuery, GetConventionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConventionQuery, GetConventionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConventionQuery, GetConventionQueryVariables>(GetConventionDocument, variables, options);
}
export type GetConventionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConventionQuery, GetConventionQueryVariables>;
export const GetAvailableConventionsDocument = gql`
    query GetAvailableConventions {
  availableConventions
}
    `;
export function useGetAvailableConventionsQuery(options: VueApolloComposable.UseQueryOptions<GetAvailableConventionsQuery, GetAvailableConventionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailableConventionsQuery, GetAvailableConventionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailableConventionsQuery, GetAvailableConventionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAvailableConventionsQuery, GetAvailableConventionsQueryVariables>(GetAvailableConventionsDocument, {}, options);
}
export function useGetAvailableConventionsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAvailableConventionsQuery, GetAvailableConventionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailableConventionsQuery, GetAvailableConventionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailableConventionsQuery, GetAvailableConventionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAvailableConventionsQuery, GetAvailableConventionsQueryVariables>(GetAvailableConventionsDocument, {}, options);
}
export type GetAvailableConventionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAvailableConventionsQuery, GetAvailableConventionsQueryVariables>;
export const GetConventionsForSelectDocument = gql`
    query GetConventionsForSelect($is_active: Boolean) {
  conventions(is_active: $is_active) {
    id
    type
  }
}
    `;
export function useGetConventionsForSelectQuery(variables: GetConventionsForSelectQueryVariables | VueCompositionApi.Ref<GetConventionsForSelectQueryVariables> | ReactiveFunction<GetConventionsForSelectQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetConventionsForSelectQuery, GetConventionsForSelectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConventionsForSelectQuery, GetConventionsForSelectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConventionsForSelectQuery, GetConventionsForSelectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConventionsForSelectQuery, GetConventionsForSelectQueryVariables>(GetConventionsForSelectDocument, variables, options);
}
export function useGetConventionsForSelectLazyQuery(variables: GetConventionsForSelectQueryVariables | VueCompositionApi.Ref<GetConventionsForSelectQueryVariables> | ReactiveFunction<GetConventionsForSelectQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetConventionsForSelectQuery, GetConventionsForSelectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConventionsForSelectQuery, GetConventionsForSelectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConventionsForSelectQuery, GetConventionsForSelectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConventionsForSelectQuery, GetConventionsForSelectQueryVariables>(GetConventionsForSelectDocument, variables, options);
}
export type GetConventionsForSelectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConventionsForSelectQuery, GetConventionsForSelectQueryVariables>;
export const CrmUserDocument = gql`
    query CrmUser($id: ID!) {
  crmUser(id: $id) {
    ...CoreCrmUserFields
  }
}
    ${CoreCrmUserFieldsFragmentDoc}`;
export function useCrmUserQuery(variables: CrmUserQueryVariables | VueCompositionApi.Ref<CrmUserQueryVariables> | ReactiveFunction<CrmUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<CrmUserQuery, CrmUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CrmUserQuery, CrmUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CrmUserQuery, CrmUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CrmUserQuery, CrmUserQueryVariables>(CrmUserDocument, variables, options);
}
export function useCrmUserLazyQuery(variables?: CrmUserQueryVariables | VueCompositionApi.Ref<CrmUserQueryVariables> | ReactiveFunction<CrmUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<CrmUserQuery, CrmUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CrmUserQuery, CrmUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CrmUserQuery, CrmUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CrmUserQuery, CrmUserQueryVariables>(CrmUserDocument, variables, options);
}
export type CrmUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CrmUserQuery, CrmUserQueryVariables>;
export const CrmUsersPaginatorDocument = gql`
    query CrmUsersPaginator($first: Int!, $page: Int, $search: String, $responsibilities: [CrmResponsibility!]) {
  crmUsersPaginator(
    first: $first
    page: $page
    search: $search
    responsibilities: $responsibilities
  ) {
    data {
      ...CoreCrmUserFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreCrmUserFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useCrmUsersPaginatorQuery(variables: CrmUsersPaginatorQueryVariables | VueCompositionApi.Ref<CrmUsersPaginatorQueryVariables> | ReactiveFunction<CrmUsersPaginatorQueryVariables>, options: VueApolloComposable.UseQueryOptions<CrmUsersPaginatorQuery, CrmUsersPaginatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CrmUsersPaginatorQuery, CrmUsersPaginatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CrmUsersPaginatorQuery, CrmUsersPaginatorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CrmUsersPaginatorQuery, CrmUsersPaginatorQueryVariables>(CrmUsersPaginatorDocument, variables, options);
}
export function useCrmUsersPaginatorLazyQuery(variables?: CrmUsersPaginatorQueryVariables | VueCompositionApi.Ref<CrmUsersPaginatorQueryVariables> | ReactiveFunction<CrmUsersPaginatorQueryVariables>, options: VueApolloComposable.UseQueryOptions<CrmUsersPaginatorQuery, CrmUsersPaginatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CrmUsersPaginatorQuery, CrmUsersPaginatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CrmUsersPaginatorQuery, CrmUsersPaginatorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CrmUsersPaginatorQuery, CrmUsersPaginatorQueryVariables>(CrmUsersPaginatorDocument, variables, options);
}
export type CrmUsersPaginatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CrmUsersPaginatorQuery, CrmUsersPaginatorQueryVariables>;
export const CrmUsersDocument = gql`
    query CrmUsers($search: String, $responsibilities: [CrmResponsibility!]) {
  crmUsers(search: $search, responsibilities: $responsibilities) {
    ...CoreCrmUserFields
  }
}
    ${CoreCrmUserFieldsFragmentDoc}`;
export function useCrmUsersQuery(variables: CrmUsersQueryVariables | VueCompositionApi.Ref<CrmUsersQueryVariables> | ReactiveFunction<CrmUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CrmUsersQuery, CrmUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CrmUsersQuery, CrmUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CrmUsersQuery, CrmUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CrmUsersQuery, CrmUsersQueryVariables>(CrmUsersDocument, variables, options);
}
export function useCrmUsersLazyQuery(variables: CrmUsersQueryVariables | VueCompositionApi.Ref<CrmUsersQueryVariables> | ReactiveFunction<CrmUsersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CrmUsersQuery, CrmUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CrmUsersQuery, CrmUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CrmUsersQuery, CrmUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CrmUsersQuery, CrmUsersQueryVariables>(CrmUsersDocument, variables, options);
}
export type CrmUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CrmUsersQuery, CrmUsersQueryVariables>;
export const CrmUserByResponsibilityDocument = gql`
    query CrmUserByResponsibility {
  approvers: crmUsers(responsibilities: [APPROVER]) {
    ...CoreCrmUserFields
  }
  managers: crmUsers(responsibilities: [MANAGER]) {
    ...CoreCrmUserFields
  }
}
    ${CoreCrmUserFieldsFragmentDoc}`;
export function useCrmUserByResponsibilityQuery(options: VueApolloComposable.UseQueryOptions<CrmUserByResponsibilityQuery, CrmUserByResponsibilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CrmUserByResponsibilityQuery, CrmUserByResponsibilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CrmUserByResponsibilityQuery, CrmUserByResponsibilityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CrmUserByResponsibilityQuery, CrmUserByResponsibilityQueryVariables>(CrmUserByResponsibilityDocument, {}, options);
}
export function useCrmUserByResponsibilityLazyQuery(options: VueApolloComposable.UseQueryOptions<CrmUserByResponsibilityQuery, CrmUserByResponsibilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CrmUserByResponsibilityQuery, CrmUserByResponsibilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CrmUserByResponsibilityQuery, CrmUserByResponsibilityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CrmUserByResponsibilityQuery, CrmUserByResponsibilityQueryVariables>(CrmUserByResponsibilityDocument, {}, options);
}
export type CrmUserByResponsibilityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CrmUserByResponsibilityQuery, CrmUserByResponsibilityQueryVariables>;
export const DeclarationsDocument = gql`
    query Declarations($first: Int!, $page: Int!, $search: String, $badge: DeclarationBadge) {
  declarations(first: $first, page: $page, search: $search, badge: $badge) {
    data {
      ...CoreDeclaration
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreDeclarationFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useDeclarationsQuery(variables: DeclarationsQueryVariables | VueCompositionApi.Ref<DeclarationsQueryVariables> | ReactiveFunction<DeclarationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationsQuery, DeclarationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationsQuery, DeclarationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationsQuery, DeclarationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DeclarationsQuery, DeclarationsQueryVariables>(DeclarationsDocument, variables, options);
}
export function useDeclarationsLazyQuery(variables?: DeclarationsQueryVariables | VueCompositionApi.Ref<DeclarationsQueryVariables> | ReactiveFunction<DeclarationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationsQuery, DeclarationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationsQuery, DeclarationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationsQuery, DeclarationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DeclarationsQuery, DeclarationsQueryVariables>(DeclarationsDocument, variables, options);
}
export type DeclarationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DeclarationsQuery, DeclarationsQueryVariables>;
export const DeclarationsForLinksDocument = gql`
    query DeclarationsForLinks($code: String) {
  declarationsForLinks(code: $code) {
    id
    name
    code
  }
}
    `;
export function useDeclarationsForLinksQuery(variables: DeclarationsForLinksQueryVariables | VueCompositionApi.Ref<DeclarationsForLinksQueryVariables> | ReactiveFunction<DeclarationsForLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DeclarationsForLinksQuery, DeclarationsForLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationsForLinksQuery, DeclarationsForLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationsForLinksQuery, DeclarationsForLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DeclarationsForLinksQuery, DeclarationsForLinksQueryVariables>(DeclarationsForLinksDocument, variables, options);
}
export function useDeclarationsForLinksLazyQuery(variables: DeclarationsForLinksQueryVariables | VueCompositionApi.Ref<DeclarationsForLinksQueryVariables> | ReactiveFunction<DeclarationsForLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DeclarationsForLinksQuery, DeclarationsForLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationsForLinksQuery, DeclarationsForLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationsForLinksQuery, DeclarationsForLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DeclarationsForLinksQuery, DeclarationsForLinksQueryVariables>(DeclarationsForLinksDocument, variables, options);
}
export type DeclarationsForLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DeclarationsForLinksQuery, DeclarationsForLinksQueryVariables>;
export const DeclarationByCodeDocument = gql`
    query DeclarationByCode($code: String!) {
  declarationByCode(code: $code) {
    ...CoreDeclaration
  }
}
    ${CoreDeclarationFragmentDoc}`;
export function useDeclarationByCodeQuery(variables: DeclarationByCodeQueryVariables | VueCompositionApi.Ref<DeclarationByCodeQueryVariables> | ReactiveFunction<DeclarationByCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationByCodeQuery, DeclarationByCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationByCodeQuery, DeclarationByCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationByCodeQuery, DeclarationByCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DeclarationByCodeQuery, DeclarationByCodeQueryVariables>(DeclarationByCodeDocument, variables, options);
}
export function useDeclarationByCodeLazyQuery(variables?: DeclarationByCodeQueryVariables | VueCompositionApi.Ref<DeclarationByCodeQueryVariables> | ReactiveFunction<DeclarationByCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationByCodeQuery, DeclarationByCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationByCodeQuery, DeclarationByCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationByCodeQuery, DeclarationByCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DeclarationByCodeQuery, DeclarationByCodeQueryVariables>(DeclarationByCodeDocument, variables, options);
}
export type DeclarationByCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DeclarationByCodeQuery, DeclarationByCodeQueryVariables>;
export const DeclarationThemeDocument = gql`
    query DeclarationTheme($id: ID!) {
  declarationTheme(id: $id) {
    ...CoreDeclarationTheme
  }
}
    ${CoreDeclarationThemeFragmentDoc}`;
export function useDeclarationThemeQuery(variables: DeclarationThemeQueryVariables | VueCompositionApi.Ref<DeclarationThemeQueryVariables> | ReactiveFunction<DeclarationThemeQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationThemeQuery, DeclarationThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationThemeQuery, DeclarationThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationThemeQuery, DeclarationThemeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DeclarationThemeQuery, DeclarationThemeQueryVariables>(DeclarationThemeDocument, variables, options);
}
export function useDeclarationThemeLazyQuery(variables?: DeclarationThemeQueryVariables | VueCompositionApi.Ref<DeclarationThemeQueryVariables> | ReactiveFunction<DeclarationThemeQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationThemeQuery, DeclarationThemeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationThemeQuery, DeclarationThemeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationThemeQuery, DeclarationThemeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DeclarationThemeQuery, DeclarationThemeQueryVariables>(DeclarationThemeDocument, variables, options);
}
export type DeclarationThemeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DeclarationThemeQuery, DeclarationThemeQueryVariables>;
export const DeclarationThemesByIdDocument = gql`
    query DeclarationThemesById($first: Int!, $page: Int!, $declaration_id: ID!) {
  declarationThemesById(
    first: $first
    page: $page
    declaration_id: $declaration_id
  ) {
    data {
      ...CoreDeclarationTheme
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreDeclarationThemeFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useDeclarationThemesByIdQuery(variables: DeclarationThemesByIdQueryVariables | VueCompositionApi.Ref<DeclarationThemesByIdQueryVariables> | ReactiveFunction<DeclarationThemesByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationThemesByIdQuery, DeclarationThemesByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationThemesByIdQuery, DeclarationThemesByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationThemesByIdQuery, DeclarationThemesByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DeclarationThemesByIdQuery, DeclarationThemesByIdQueryVariables>(DeclarationThemesByIdDocument, variables, options);
}
export function useDeclarationThemesByIdLazyQuery(variables?: DeclarationThemesByIdQueryVariables | VueCompositionApi.Ref<DeclarationThemesByIdQueryVariables> | ReactiveFunction<DeclarationThemesByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationThemesByIdQuery, DeclarationThemesByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationThemesByIdQuery, DeclarationThemesByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationThemesByIdQuery, DeclarationThemesByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DeclarationThemesByIdQuery, DeclarationThemesByIdQueryVariables>(DeclarationThemesByIdDocument, variables, options);
}
export type DeclarationThemesByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DeclarationThemesByIdQuery, DeclarationThemesByIdQueryVariables>;
export const DeclarationDocumentsByIdDocument = gql`
    query DeclarationDocumentsById($first: Int!, $page: Int!, $declaration_id: ID!) {
  declarationDocumentsById(
    first: $first
    page: $page
    declaration_id: $declaration_id
  ) {
    data {
      ...CoreDeclarationDocument
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreDeclarationDocumentFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useDeclarationDocumentsByIdQuery(variables: DeclarationDocumentsByIdQueryVariables | VueCompositionApi.Ref<DeclarationDocumentsByIdQueryVariables> | ReactiveFunction<DeclarationDocumentsByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationDocumentsByIdQuery, DeclarationDocumentsByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationDocumentsByIdQuery, DeclarationDocumentsByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationDocumentsByIdQuery, DeclarationDocumentsByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DeclarationDocumentsByIdQuery, DeclarationDocumentsByIdQueryVariables>(DeclarationDocumentsByIdDocument, variables, options);
}
export function useDeclarationDocumentsByIdLazyQuery(variables?: DeclarationDocumentsByIdQueryVariables | VueCompositionApi.Ref<DeclarationDocumentsByIdQueryVariables> | ReactiveFunction<DeclarationDocumentsByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<DeclarationDocumentsByIdQuery, DeclarationDocumentsByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeclarationDocumentsByIdQuery, DeclarationDocumentsByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeclarationDocumentsByIdQuery, DeclarationDocumentsByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DeclarationDocumentsByIdQuery, DeclarationDocumentsByIdQueryVariables>(DeclarationDocumentsByIdDocument, variables, options);
}
export type DeclarationDocumentsByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DeclarationDocumentsByIdQuery, DeclarationDocumentsByIdQueryVariables>;
export const DepositByIdDocument = gql`
    query DepositById($id: ID!) {
  depositById(id: $id) {
    id
    reference
    regime
    status
    platform
    json_filters
    other_category
    ticket {
      id
      name
    }
    packages {
      id
      name
    }
    submissions {
      id
      status
      reference
      type
      url
      incomplete_submission_date
      authorization_refusal_date
      recommendation_date
      acceptation_date
      complete_submission_date
      submission_date
      comment
      created_at
      created_by {
        first_name
        last_name
      }
      documents {
        id
        filename
        path
        type
        url
        temporary_url
        created_at
        document_submission_type
        is_from_bot
      }
      json {
        id
        filename
        path
        type
        url
        temporary_url
        created_at
      }
      logs {
        id
        filename
        path
        type
        url
        temporary_url
        created_at
      }
    }
    created_at
    created_by {
      first_name
      last_name
    }
  }
}
    `;
export function useDepositByIdQuery(variables: DepositByIdQueryVariables | VueCompositionApi.Ref<DepositByIdQueryVariables> | ReactiveFunction<DepositByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositByIdQuery, DepositByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositByIdQuery, DepositByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositByIdQuery, DepositByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DepositByIdQuery, DepositByIdQueryVariables>(DepositByIdDocument, variables, options);
}
export function useDepositByIdLazyQuery(variables?: DepositByIdQueryVariables | VueCompositionApi.Ref<DepositByIdQueryVariables> | ReactiveFunction<DepositByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositByIdQuery, DepositByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositByIdQuery, DepositByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositByIdQuery, DepositByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DepositByIdQuery, DepositByIdQueryVariables>(DepositByIdDocument, variables, options);
}
export type DepositByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DepositByIdQuery, DepositByIdQueryVariables>;
export const DepositsByTicketDocument = gql`
    query depositsByTicket($ticket_id: ID!, $status: [DepositStatus]) {
  depositsByTicket(ticket_id: $ticket_id, status: $status) {
    id
    reference
    regime
    platform
    status
    json_filters
    other_category
    ticket {
      id
      code
      name
    }
    packages {
      id
      name
    }
    submissions {
      id
      status
      url
      incomplete_submission_date
      authorization_refusal_date
      recommendation_date
      acceptation_date
      complete_submission_date
      comment
      created_at
      documents {
        id
        filename
        path
        type
        url
        temporary_url
        created_at
      }
    }
    created_at
    created_by {
      first_name
      last_name
    }
  }
}
    `;
export function useDepositsByTicketQuery(variables: DepositsByTicketQueryVariables | VueCompositionApi.Ref<DepositsByTicketQueryVariables> | ReactiveFunction<DepositsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositsByTicketQuery, DepositsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositsByTicketQuery, DepositsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositsByTicketQuery, DepositsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DepositsByTicketQuery, DepositsByTicketQueryVariables>(DepositsByTicketDocument, variables, options);
}
export function useDepositsByTicketLazyQuery(variables?: DepositsByTicketQueryVariables | VueCompositionApi.Ref<DepositsByTicketQueryVariables> | ReactiveFunction<DepositsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositsByTicketQuery, DepositsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositsByTicketQuery, DepositsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositsByTicketQuery, DepositsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DepositsByTicketQuery, DepositsByTicketQueryVariables>(DepositsByTicketDocument, variables, options);
}
export type DepositsByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DepositsByTicketQuery, DepositsByTicketQueryVariables>;
export const GetPackageDepositsByTicketDocument = gql`
    query GetPackageDepositsByTicket($ticket_id: ID!) {
  packageDepositsByTicket(ticket_id: $ticket_id) {
    authorization {
      name
      id
      advantages {
        advantage_type
        net_amount
        gross_amount
        excluding_tax_amount
        including_tax_amount
        quantity
      }
      is_distribution
      created_at
      updated_at
    }
    declaration {
      id
      name
      advantages {
        advantage_type
        net_amount
        gross_amount
        excluding_tax_amount
        including_tax_amount
        quantity
      }
      is_distribution
      created_at
      updated_at
    }
  }
}
    `;
export function useGetPackageDepositsByTicketQuery(variables: GetPackageDepositsByTicketQueryVariables | VueCompositionApi.Ref<GetPackageDepositsByTicketQueryVariables> | ReactiveFunction<GetPackageDepositsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPackageDepositsByTicketQuery, GetPackageDepositsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPackageDepositsByTicketQuery, GetPackageDepositsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPackageDepositsByTicketQuery, GetPackageDepositsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPackageDepositsByTicketQuery, GetPackageDepositsByTicketQueryVariables>(GetPackageDepositsByTicketDocument, variables, options);
}
export function useGetPackageDepositsByTicketLazyQuery(variables?: GetPackageDepositsByTicketQueryVariables | VueCompositionApi.Ref<GetPackageDepositsByTicketQueryVariables> | ReactiveFunction<GetPackageDepositsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPackageDepositsByTicketQuery, GetPackageDepositsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPackageDepositsByTicketQuery, GetPackageDepositsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPackageDepositsByTicketQuery, GetPackageDepositsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPackageDepositsByTicketQuery, GetPackageDepositsByTicketQueryVariables>(GetPackageDepositsByTicketDocument, variables, options);
}
export type GetPackageDepositsByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPackageDepositsByTicketQuery, GetPackageDepositsByTicketQueryVariables>;
export const GetHealthTypesDepositsByTicketDocument = gql`
    query GetHealthTypesDepositsByTicket($ticket_id: ID!) {
  healthTypesDepositByTicket(ticket_id: $ticket_id) {
    healthTypes {
      declaration
      authorization
    }
    pharmacistTypes {
      declaration
      authorization
    }
    regionalHealthAgency {
      declarationExist
      authorizationExist
    }
  }
}
    `;
export function useGetHealthTypesDepositsByTicketQuery(variables: GetHealthTypesDepositsByTicketQueryVariables | VueCompositionApi.Ref<GetHealthTypesDepositsByTicketQueryVariables> | ReactiveFunction<GetHealthTypesDepositsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetHealthTypesDepositsByTicketQuery, GetHealthTypesDepositsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHealthTypesDepositsByTicketQuery, GetHealthTypesDepositsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHealthTypesDepositsByTicketQuery, GetHealthTypesDepositsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHealthTypesDepositsByTicketQuery, GetHealthTypesDepositsByTicketQueryVariables>(GetHealthTypesDepositsByTicketDocument, variables, options);
}
export function useGetHealthTypesDepositsByTicketLazyQuery(variables?: GetHealthTypesDepositsByTicketQueryVariables | VueCompositionApi.Ref<GetHealthTypesDepositsByTicketQueryVariables> | ReactiveFunction<GetHealthTypesDepositsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetHealthTypesDepositsByTicketQuery, GetHealthTypesDepositsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHealthTypesDepositsByTicketQuery, GetHealthTypesDepositsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHealthTypesDepositsByTicketQuery, GetHealthTypesDepositsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetHealthTypesDepositsByTicketQuery, GetHealthTypesDepositsByTicketQueryVariables>(GetHealthTypesDepositsByTicketDocument, variables, options);
}
export type GetHealthTypesDepositsByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHealthTypesDepositsByTicketQuery, GetHealthTypesDepositsByTicketQueryVariables>;
export const DoctorsDepositsByTicketDocument = gql`
    query DoctorsDepositsByTicket($ticket_id: ID!, $name: String, $package_id: ID!, $regime: AttendeeDepositRegime!, $first: Int!, $page: Int, $orderBy: [QueryDoctorsDepositsByTicketOrderByRelationOrderByClause!]) {
  doctorsDepositsByTicket(
    first: $first
    name: $name
    package_id: $package_id
    regime: $regime
    page: $page
    ticket_id: $ticket_id
    orderBy: $orderBy
  ) {
    data {
      id
      civility
      type
      category
      title
      firstname
      lastname
      type_number
      health_number
      health_type
      healthSpecialties {
        ...CoreSpecialtyFields
      }
      regime
      email
      phone_number
      address {
        id
        city
        street_type
        street_number
        street_name
        postcode
        cedex
        country
      }
      description
      external_id
      is_present
      is_billed
      is_threshold_reached
      is_public
      is_military
      activity
      organization_type
      legal_title
      executive_role
      contractual_link
      parent_organization_name
      company
      deleted_at
      plannedPackages {
        id
        name
        advantages {
          advantage_type
          net_amount
          gross_amount
          excluding_tax_amount
          including_tax_amount
          quantity
        }
        is_distribution
        created_at
        updated_at
      }
      contractsSignatureStatus
      contractsDepositStatus
      contracts {
        id
        ticket {
          id
        }
        signature_status
        deposit_status
        document {
          id
          filename
          path
          type
          url
          temporary_url
          created_at
        }
        contractTemplate {
          name
          document {
            id
            filename
            path
            type
            url
            temporary_url
            created_at
          }
        }
      }
      documents {
        id
        type
        signature_status
        deposit_status
        document {
          id
          filename
          path
          type
          url
          temporary_url
          created_at
        }
      }
      addedBy {
        ...CoreAddedByFields
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreAddedByFieldsFragmentDoc}`;
export function useDoctorsDepositsByTicketQuery(variables: DoctorsDepositsByTicketQueryVariables | VueCompositionApi.Ref<DoctorsDepositsByTicketQueryVariables> | ReactiveFunction<DoctorsDepositsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<DoctorsDepositsByTicketQuery, DoctorsDepositsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DoctorsDepositsByTicketQuery, DoctorsDepositsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DoctorsDepositsByTicketQuery, DoctorsDepositsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DoctorsDepositsByTicketQuery, DoctorsDepositsByTicketQueryVariables>(DoctorsDepositsByTicketDocument, variables, options);
}
export function useDoctorsDepositsByTicketLazyQuery(variables?: DoctorsDepositsByTicketQueryVariables | VueCompositionApi.Ref<DoctorsDepositsByTicketQueryVariables> | ReactiveFunction<DoctorsDepositsByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<DoctorsDepositsByTicketQuery, DoctorsDepositsByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DoctorsDepositsByTicketQuery, DoctorsDepositsByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DoctorsDepositsByTicketQuery, DoctorsDepositsByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DoctorsDepositsByTicketQuery, DoctorsDepositsByTicketQueryVariables>(DoctorsDepositsByTicketDocument, variables, options);
}
export type DoctorsDepositsByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DoctorsDepositsByTicketQuery, DoctorsDepositsByTicketQueryVariables>;
export const AttendeesDepositsByHealthTypeAndTicketDocument = gql`
    query AttendeesDepositsByHealthTypeAndTicket($ticket_id: ID!, $name: String!, $health_type: AttendeeHealthType, $pharmacist_type: PharmacistType, $regional_health_agency: Boolean, $regime: AttendeeDepositRegime!, $first: Int!, $page: Int, $orderBy: [QueryAttendeesDepositsByHealthTypeAndTicketOrderByRelationOrderByClause!]) {
  attendeesDepositsByHealthTypeAndTicket(
    ticket_id: $ticket_id
    name: $name
    health_type: $health_type
    pharmacist_type: $pharmacist_type
    regional_health_agency: $regional_health_agency
    regime: $regime
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    data {
      id
      civility
      type
      category
      title
      firstname
      lastname
      type_number
      health_number
      health_type
      healthSpecialties {
        ...CoreSpecialtyFields
      }
      regime
      email
      phone_number
      address {
        id
        city
        street_type
        street_number
        street_name
        postcode
        cedex
        country
      }
      description
      external_id
      is_present
      is_billed
      is_threshold_reached
      is_public
      is_military
      activity
      organization_type
      legal_title
      executive_role
      contractual_link
      parent_organization_name
      company
      deleted_at
      plannedPackages {
        id
        name
        advantages {
          advantage_type
          net_amount
          gross_amount
          excluding_tax_amount
          including_tax_amount
          quantity
        }
        is_distribution
        created_at
        updated_at
      }
      contractsSignatureStatus
      contractsDepositStatus
      contracts {
        id
        ticket {
          id
        }
        signature_status
        deposit_status
        document {
          id
          filename
          path
          type
          url
          temporary_url
          created_at
        }
        contractTemplate {
          name
          document {
            id
            filename
            path
            type
            url
            temporary_url
            created_at
          }
        }
      }
      documents {
        id
        type
        signature_status
        deposit_status
        document {
          id
          filename
          path
          type
          url
          temporary_url
          created_at
        }
      }
      addedBy {
        ...CoreAddedByFields
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreAddedByFieldsFragmentDoc}`;
export function useAttendeesDepositsByHealthTypeAndTicketQuery(variables: AttendeesDepositsByHealthTypeAndTicketQueryVariables | VueCompositionApi.Ref<AttendeesDepositsByHealthTypeAndTicketQueryVariables> | ReactiveFunction<AttendeesDepositsByHealthTypeAndTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesDepositsByHealthTypeAndTicketQuery, AttendeesDepositsByHealthTypeAndTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesDepositsByHealthTypeAndTicketQuery, AttendeesDepositsByHealthTypeAndTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesDepositsByHealthTypeAndTicketQuery, AttendeesDepositsByHealthTypeAndTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttendeesDepositsByHealthTypeAndTicketQuery, AttendeesDepositsByHealthTypeAndTicketQueryVariables>(AttendeesDepositsByHealthTypeAndTicketDocument, variables, options);
}
export function useAttendeesDepositsByHealthTypeAndTicketLazyQuery(variables?: AttendeesDepositsByHealthTypeAndTicketQueryVariables | VueCompositionApi.Ref<AttendeesDepositsByHealthTypeAndTicketQueryVariables> | ReactiveFunction<AttendeesDepositsByHealthTypeAndTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeesDepositsByHealthTypeAndTicketQuery, AttendeesDepositsByHealthTypeAndTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeesDepositsByHealthTypeAndTicketQuery, AttendeesDepositsByHealthTypeAndTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeesDepositsByHealthTypeAndTicketQuery, AttendeesDepositsByHealthTypeAndTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttendeesDepositsByHealthTypeAndTicketQuery, AttendeesDepositsByHealthTypeAndTicketQueryVariables>(AttendeesDepositsByHealthTypeAndTicketDocument, variables, options);
}
export type AttendeesDepositsByHealthTypeAndTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttendeesDepositsByHealthTypeAndTicketQuery, AttendeesDepositsByHealthTypeAndTicketQueryVariables>;
export const GetOtherDepositCategoriesAvailableByTicketDocument = gql`
    query GetOtherDepositCategoriesAvailableByTicket($ticket_code: String!) {
  otherDepositCategoriesAvailableByTicket(ticket_code: $ticket_code) {
    declaration
    authorization
  }
}
    `;
export function useGetOtherDepositCategoriesAvailableByTicketQuery(variables: GetOtherDepositCategoriesAvailableByTicketQueryVariables | VueCompositionApi.Ref<GetOtherDepositCategoriesAvailableByTicketQueryVariables> | ReactiveFunction<GetOtherDepositCategoriesAvailableByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOtherDepositCategoriesAvailableByTicketQuery, GetOtherDepositCategoriesAvailableByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOtherDepositCategoriesAvailableByTicketQuery, GetOtherDepositCategoriesAvailableByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOtherDepositCategoriesAvailableByTicketQuery, GetOtherDepositCategoriesAvailableByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOtherDepositCategoriesAvailableByTicketQuery, GetOtherDepositCategoriesAvailableByTicketQueryVariables>(GetOtherDepositCategoriesAvailableByTicketDocument, variables, options);
}
export function useGetOtherDepositCategoriesAvailableByTicketLazyQuery(variables?: GetOtherDepositCategoriesAvailableByTicketQueryVariables | VueCompositionApi.Ref<GetOtherDepositCategoriesAvailableByTicketQueryVariables> | ReactiveFunction<GetOtherDepositCategoriesAvailableByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOtherDepositCategoriesAvailableByTicketQuery, GetOtherDepositCategoriesAvailableByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOtherDepositCategoriesAvailableByTicketQuery, GetOtherDepositCategoriesAvailableByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOtherDepositCategoriesAvailableByTicketQuery, GetOtherDepositCategoriesAvailableByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOtherDepositCategoriesAvailableByTicketQuery, GetOtherDepositCategoriesAvailableByTicketQueryVariables>(GetOtherDepositCategoriesAvailableByTicketDocument, variables, options);
}
export type GetOtherDepositCategoriesAvailableByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOtherDepositCategoriesAvailableByTicketQuery, GetOtherDepositCategoriesAvailableByTicketQueryVariables>;
export const AttendeeByOtherCategoryAndTicketDocument = gql`
    query AttendeeByOtherCategoryAndTicket($ticket_id: ID!, $name: String, $other_deposit_category: OtherDepositCategoryEnum!, $regime: AttendeeDepositRegime!, $first: Int!, $page: Int, $orderBy: [QueryAttendeeByOtherCategoryAndTicketOrderByRelationOrderByClause!]) {
  attendeeByOtherCategoryAndTicket(
    ticket_id: $ticket_id
    name: $name
    other_deposit_category: $other_deposit_category
    regime: $regime
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    data {
      id
      civility
      type
      category
      title
      firstname
      lastname
      type_number
      health_number
      health_type
      healthSpecialties {
        ...CoreSpecialtyFields
      }
      regime
      email
      phone_number
      address {
        id
        city
        street_type
        street_number
        street_name
        postcode
        cedex
        country
      }
      description
      external_id
      is_present
      is_billed
      is_threshold_reached
      is_public
      is_military
      activity
      organization_type
      legal_title
      executive_role
      contractual_link
      parent_organization_name
      company
      deleted_at
      plannedPackages {
        id
        name
        advantages {
          advantage_type
          net_amount
          gross_amount
          excluding_tax_amount
          including_tax_amount
          quantity
        }
        is_distribution
        created_at
        updated_at
      }
      contractsSignatureStatus
      contractsDepositStatus
      contracts {
        id
        ticket {
          id
        }
        signature_status
        deposit_status
        document {
          id
          filename
          path
          type
          url
          temporary_url
          created_at
        }
        contractTemplate {
          name
          document {
            id
            filename
            path
            type
            url
            temporary_url
            created_at
          }
        }
      }
      documents {
        id
        type
        signature_status
        deposit_status
        document {
          id
          filename
          path
          type
          url
          temporary_url
          created_at
        }
      }
      addedBy {
        ...CoreAddedByFields
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CoreAddedByFieldsFragmentDoc}`;
export function useAttendeeByOtherCategoryAndTicketQuery(variables: AttendeeByOtherCategoryAndTicketQueryVariables | VueCompositionApi.Ref<AttendeeByOtherCategoryAndTicketQueryVariables> | ReactiveFunction<AttendeeByOtherCategoryAndTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeeByOtherCategoryAndTicketQuery, AttendeeByOtherCategoryAndTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeeByOtherCategoryAndTicketQuery, AttendeeByOtherCategoryAndTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeeByOtherCategoryAndTicketQuery, AttendeeByOtherCategoryAndTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttendeeByOtherCategoryAndTicketQuery, AttendeeByOtherCategoryAndTicketQueryVariables>(AttendeeByOtherCategoryAndTicketDocument, variables, options);
}
export function useAttendeeByOtherCategoryAndTicketLazyQuery(variables?: AttendeeByOtherCategoryAndTicketQueryVariables | VueCompositionApi.Ref<AttendeeByOtherCategoryAndTicketQueryVariables> | ReactiveFunction<AttendeeByOtherCategoryAndTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<AttendeeByOtherCategoryAndTicketQuery, AttendeeByOtherCategoryAndTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttendeeByOtherCategoryAndTicketQuery, AttendeeByOtherCategoryAndTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttendeeByOtherCategoryAndTicketQuery, AttendeeByOtherCategoryAndTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttendeeByOtherCategoryAndTicketQuery, AttendeeByOtherCategoryAndTicketQueryVariables>(AttendeeByOtherCategoryAndTicketDocument, variables, options);
}
export type AttendeeByOtherCategoryAndTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttendeeByOtherCategoryAndTicketQuery, AttendeeByOtherCategoryAndTicketQueryVariables>;
export const DepositZipFileDocument = gql`
    query DepositZipFile($ticket_id: ID!, $planned_package_id: ID, $json_filter: String, $regime: String!) {
  depositZipFile(
    ticket_id: $ticket_id
    planned_package_id: $planned_package_id
    json_filter: $json_filter
    regime: $regime
  ) {
    id
    document {
      ...CoreDocumentFields
    }
    updated_at
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useDepositZipFileQuery(variables: DepositZipFileQueryVariables | VueCompositionApi.Ref<DepositZipFileQueryVariables> | ReactiveFunction<DepositZipFileQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositZipFileQuery, DepositZipFileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositZipFileQuery, DepositZipFileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositZipFileQuery, DepositZipFileQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DepositZipFileQuery, DepositZipFileQueryVariables>(DepositZipFileDocument, variables, options);
}
export function useDepositZipFileLazyQuery(variables?: DepositZipFileQueryVariables | VueCompositionApi.Ref<DepositZipFileQueryVariables> | ReactiveFunction<DepositZipFileQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositZipFileQuery, DepositZipFileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositZipFileQuery, DepositZipFileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositZipFileQuery, DepositZipFileQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DepositZipFileQuery, DepositZipFileQueryVariables>(DepositZipFileDocument, variables, options);
}
export type DepositZipFileQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DepositZipFileQuery, DepositZipFileQueryVariables>;
export const TransparencyExportDocument = gql`
    query TransparencyExport($first: Int, $page: Int, $orderBy: [TransparencyExportOrderByInput!]) {
  transparencyExportPaginator(first: $first, page: $page, orderBy: $orderBy) {
    data {
      id
      filename
      url
      created_at
      publication_status
      from_date
      to_date
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useTransparencyExportQuery(variables: TransparencyExportQueryVariables | VueCompositionApi.Ref<TransparencyExportQueryVariables> | ReactiveFunction<TransparencyExportQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TransparencyExportQuery, TransparencyExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TransparencyExportQuery, TransparencyExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TransparencyExportQuery, TransparencyExportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TransparencyExportQuery, TransparencyExportQueryVariables>(TransparencyExportDocument, variables, options);
}
export function useTransparencyExportLazyQuery(variables: TransparencyExportQueryVariables | VueCompositionApi.Ref<TransparencyExportQueryVariables> | ReactiveFunction<TransparencyExportQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TransparencyExportQuery, TransparencyExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TransparencyExportQuery, TransparencyExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TransparencyExportQuery, TransparencyExportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TransparencyExportQuery, TransparencyExportQueryVariables>(TransparencyExportDocument, variables, options);
}
export type TransparencyExportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TransparencyExportQuery, TransparencyExportQueryVariables>;
export const DocumentAttendeeByTicketDocument = gql`
    query DocumentAttendeeByTicket($ticket_id: ID!) {
  documentAttendeeByTicket(ticket_id: $ticket_id) {
    ...CoreDocumentAttendeeFields
    document {
      ...CoreDocumentFields
    }
  }
}
    ${CoreDocumentAttendeeFieldsFragmentDoc}
${CoreDocumentFieldsFragmentDoc}`;
export function useDocumentAttendeeByTicketQuery(variables: DocumentAttendeeByTicketQueryVariables | VueCompositionApi.Ref<DocumentAttendeeByTicketQueryVariables> | ReactiveFunction<DocumentAttendeeByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<DocumentAttendeeByTicketQuery, DocumentAttendeeByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DocumentAttendeeByTicketQuery, DocumentAttendeeByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DocumentAttendeeByTicketQuery, DocumentAttendeeByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DocumentAttendeeByTicketQuery, DocumentAttendeeByTicketQueryVariables>(DocumentAttendeeByTicketDocument, variables, options);
}
export function useDocumentAttendeeByTicketLazyQuery(variables?: DocumentAttendeeByTicketQueryVariables | VueCompositionApi.Ref<DocumentAttendeeByTicketQueryVariables> | ReactiveFunction<DocumentAttendeeByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<DocumentAttendeeByTicketQuery, DocumentAttendeeByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DocumentAttendeeByTicketQuery, DocumentAttendeeByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DocumentAttendeeByTicketQuery, DocumentAttendeeByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DocumentAttendeeByTicketQuery, DocumentAttendeeByTicketQueryVariables>(DocumentAttendeeByTicketDocument, variables, options);
}
export type DocumentAttendeeByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DocumentAttendeeByTicketQuery, DocumentAttendeeByTicketQueryVariables>;
export const DocumentAttendeeDocument = gql`
    query DocumentAttendee($id: ID!) {
  documentAttendee(id: $id) {
    ...CoreDocumentAttendeeFields
    document {
      ...CoreDocumentFields
    }
  }
}
    ${CoreDocumentAttendeeFieldsFragmentDoc}
${CoreDocumentFieldsFragmentDoc}`;
export function useDocumentAttendeeQuery(variables: DocumentAttendeeQueryVariables | VueCompositionApi.Ref<DocumentAttendeeQueryVariables> | ReactiveFunction<DocumentAttendeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<DocumentAttendeeQuery, DocumentAttendeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DocumentAttendeeQuery, DocumentAttendeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DocumentAttendeeQuery, DocumentAttendeeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DocumentAttendeeQuery, DocumentAttendeeQueryVariables>(DocumentAttendeeDocument, variables, options);
}
export function useDocumentAttendeeLazyQuery(variables?: DocumentAttendeeQueryVariables | VueCompositionApi.Ref<DocumentAttendeeQueryVariables> | ReactiveFunction<DocumentAttendeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<DocumentAttendeeQuery, DocumentAttendeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DocumentAttendeeQuery, DocumentAttendeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DocumentAttendeeQuery, DocumentAttendeeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DocumentAttendeeQuery, DocumentAttendeeQueryVariables>(DocumentAttendeeDocument, variables, options);
}
export type DocumentAttendeeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DocumentAttendeeQuery, DocumentAttendeeQueryVariables>;
export const HistoriesByTicketDocument = gql`
    query HistoriesByTicket($code: String!, $locale: String!, $first: Int!, $page: Int!, $search: String) {
  historiesByTicket(
    code: $code
    locale: $locale
    first: $first
    page: $page
    search: $search
  ) {
    data {
      id
      type
      formatted_message
      created_at
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useHistoriesByTicketQuery(variables: HistoriesByTicketQueryVariables | VueCompositionApi.Ref<HistoriesByTicketQueryVariables> | ReactiveFunction<HistoriesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<HistoriesByTicketQuery, HistoriesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HistoriesByTicketQuery, HistoriesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HistoriesByTicketQuery, HistoriesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HistoriesByTicketQuery, HistoriesByTicketQueryVariables>(HistoriesByTicketDocument, variables, options);
}
export function useHistoriesByTicketLazyQuery(variables?: HistoriesByTicketQueryVariables | VueCompositionApi.Ref<HistoriesByTicketQueryVariables> | ReactiveFunction<HistoriesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<HistoriesByTicketQuery, HistoriesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HistoriesByTicketQuery, HistoriesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HistoriesByTicketQuery, HistoriesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<HistoriesByTicketQuery, HistoriesByTicketQueryVariables>(HistoriesByTicketDocument, variables, options);
}
export type HistoriesByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HistoriesByTicketQuery, HistoriesByTicketQueryVariables>;
export const InternalSignerDocument = gql`
    query InternalSigner($id: ID!) {
  internalSigner(id: $id) {
    ...CoreInternalSignerFields
  }
}
    ${CoreInternalSignerFieldsFragmentDoc}`;
export function useInternalSignerQuery(variables: InternalSignerQueryVariables | VueCompositionApi.Ref<InternalSignerQueryVariables> | ReactiveFunction<InternalSignerQueryVariables>, options: VueApolloComposable.UseQueryOptions<InternalSignerQuery, InternalSignerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InternalSignerQuery, InternalSignerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InternalSignerQuery, InternalSignerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<InternalSignerQuery, InternalSignerQueryVariables>(InternalSignerDocument, variables, options);
}
export function useInternalSignerLazyQuery(variables?: InternalSignerQueryVariables | VueCompositionApi.Ref<InternalSignerQueryVariables> | ReactiveFunction<InternalSignerQueryVariables>, options: VueApolloComposable.UseQueryOptions<InternalSignerQuery, InternalSignerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InternalSignerQuery, InternalSignerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InternalSignerQuery, InternalSignerQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<InternalSignerQuery, InternalSignerQueryVariables>(InternalSignerDocument, variables, options);
}
export type InternalSignerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<InternalSignerQuery, InternalSignerQueryVariables>;
export const InternalSignersPaginatorDocument = gql`
    query InternalSignersPaginator($first: Int!, $page: Int) {
  internalSignersPaginator(first: $first, page: $page) {
    data {
      ...CoreInternalSignerFields
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${CoreInternalSignerFieldsFragmentDoc}`;
export function useInternalSignersPaginatorQuery(variables: InternalSignersPaginatorQueryVariables | VueCompositionApi.Ref<InternalSignersPaginatorQueryVariables> | ReactiveFunction<InternalSignersPaginatorQueryVariables>, options: VueApolloComposable.UseQueryOptions<InternalSignersPaginatorQuery, InternalSignersPaginatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InternalSignersPaginatorQuery, InternalSignersPaginatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InternalSignersPaginatorQuery, InternalSignersPaginatorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<InternalSignersPaginatorQuery, InternalSignersPaginatorQueryVariables>(InternalSignersPaginatorDocument, variables, options);
}
export function useInternalSignersPaginatorLazyQuery(variables?: InternalSignersPaginatorQueryVariables | VueCompositionApi.Ref<InternalSignersPaginatorQueryVariables> | ReactiveFunction<InternalSignersPaginatorQueryVariables>, options: VueApolloComposable.UseQueryOptions<InternalSignersPaginatorQuery, InternalSignersPaginatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InternalSignersPaginatorQuery, InternalSignersPaginatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InternalSignersPaginatorQuery, InternalSignersPaginatorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<InternalSignersPaginatorQuery, InternalSignersPaginatorQueryVariables>(InternalSignersPaginatorDocument, variables, options);
}
export type InternalSignersPaginatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<InternalSignersPaginatorQuery, InternalSignersPaginatorQueryVariables>;
export const InternalSignersDocument = gql`
    query internalSigners {
  internalSigners {
    ...CoreInternalSignerFields
  }
}
    ${CoreInternalSignerFieldsFragmentDoc}`;
export function useInternalSignersQuery(options: VueApolloComposable.UseQueryOptions<InternalSignersQuery, InternalSignersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InternalSignersQuery, InternalSignersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InternalSignersQuery, InternalSignersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<InternalSignersQuery, InternalSignersQueryVariables>(InternalSignersDocument, {}, options);
}
export function useInternalSignersLazyQuery(options: VueApolloComposable.UseQueryOptions<InternalSignersQuery, InternalSignersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InternalSignersQuery, InternalSignersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InternalSignersQuery, InternalSignersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<InternalSignersQuery, InternalSignersQueryVariables>(InternalSignersDocument, {}, options);
}
export type InternalSignersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<InternalSignersQuery, InternalSignersQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($first: Int!, $page: Int, $enabled: Boolean) {
  notifications(first: $first, page: $page, enabled: $enabled) {
    data {
      ...CoreNotificationFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreNotificationFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useNotificationsQuery(variables: NotificationsQueryVariables | VueCompositionApi.Ref<NotificationsQueryVariables> | ReactiveFunction<NotificationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables, options);
}
export function useNotificationsLazyQuery(variables?: NotificationsQueryVariables | VueCompositionApi.Ref<NotificationsQueryVariables> | ReactiveFunction<NotificationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables, options);
}
export type NotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationsQuery, NotificationsQueryVariables>;
export const NotificationDocument = gql`
    query Notification($id: ID!) {
  notification(id: $id) {
    ...CoreNotificationFields
  }
}
    ${CoreNotificationFieldsFragmentDoc}`;
export function useNotificationQuery(variables: NotificationQueryVariables | VueCompositionApi.Ref<NotificationQueryVariables> | ReactiveFunction<NotificationQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotificationQuery, NotificationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationQuery, NotificationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationQuery, NotificationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationQuery, NotificationQueryVariables>(NotificationDocument, variables, options);
}
export function useNotificationLazyQuery(variables?: NotificationQueryVariables | VueCompositionApi.Ref<NotificationQueryVariables> | ReactiveFunction<NotificationQueryVariables>, options: VueApolloComposable.UseQueryOptions<NotificationQuery, NotificationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationQuery, NotificationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationQuery, NotificationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NotificationQuery, NotificationQueryVariables>(NotificationDocument, variables, options);
}
export type NotificationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationQuery, NotificationQueryVariables>;
export const GetOneKeysAttendeesDocument = gql`
    query GetOneKeysAttendees($category: String, $firstname: String, $lastname: String, $health_number: String, $organization_type: String, $legal_title: String, $first: Int!, $page: Int) {
  oneKeysAttendees(
    category: $category
    firstname: $firstname
    lastname: $lastname
    health_number: $health_number
    organization_type: $organization_type
    legal_title: $legal_title
    first: $first
    page: $page
  ) {
    data {
      id
      civility
      firstname
      lastname
      type_number
      health_number
      health_type
      healthSpecialties
      external_id
      email
      phone_number
      category
      title
      pharmacist_type
      organization_type
      legal_title
      description
      address {
        street_name
        postcode
        city
        country
      }
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useGetOneKeysAttendeesQuery(variables: GetOneKeysAttendeesQueryVariables | VueCompositionApi.Ref<GetOneKeysAttendeesQueryVariables> | ReactiveFunction<GetOneKeysAttendeesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOneKeysAttendeesQuery, GetOneKeysAttendeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOneKeysAttendeesQuery, GetOneKeysAttendeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOneKeysAttendeesQuery, GetOneKeysAttendeesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOneKeysAttendeesQuery, GetOneKeysAttendeesQueryVariables>(GetOneKeysAttendeesDocument, variables, options);
}
export function useGetOneKeysAttendeesLazyQuery(variables?: GetOneKeysAttendeesQueryVariables | VueCompositionApi.Ref<GetOneKeysAttendeesQueryVariables> | ReactiveFunction<GetOneKeysAttendeesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOneKeysAttendeesQuery, GetOneKeysAttendeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOneKeysAttendeesQuery, GetOneKeysAttendeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOneKeysAttendeesQuery, GetOneKeysAttendeesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOneKeysAttendeesQuery, GetOneKeysAttendeesQueryVariables>(GetOneKeysAttendeesDocument, variables, options);
}
export type GetOneKeysAttendeesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOneKeysAttendeesQuery, GetOneKeysAttendeesQueryVariables>;
export const OperationsByEventTypesDocument = gql`
    query OperationsByEventTypes($event_type: [EventType!]!, $enabled: Boolean) {
  operationsByEventTypes(event_type: $event_type, enabled: $enabled) {
    id
    name
    mandatory_attachments
    enabled
    is_publication_allowed
  }
}
    `;
export function useOperationsByEventTypesQuery(variables: OperationsByEventTypesQueryVariables | VueCompositionApi.Ref<OperationsByEventTypesQueryVariables> | ReactiveFunction<OperationsByEventTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<OperationsByEventTypesQuery, OperationsByEventTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OperationsByEventTypesQuery, OperationsByEventTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OperationsByEventTypesQuery, OperationsByEventTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OperationsByEventTypesQuery, OperationsByEventTypesQueryVariables>(OperationsByEventTypesDocument, variables, options);
}
export function useOperationsByEventTypesLazyQuery(variables?: OperationsByEventTypesQueryVariables | VueCompositionApi.Ref<OperationsByEventTypesQueryVariables> | ReactiveFunction<OperationsByEventTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<OperationsByEventTypesQuery, OperationsByEventTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OperationsByEventTypesQuery, OperationsByEventTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OperationsByEventTypesQuery, OperationsByEventTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OperationsByEventTypesQuery, OperationsByEventTypesQueryVariables>(OperationsByEventTypesDocument, variables, options);
}
export type OperationsByEventTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OperationsByEventTypesQuery, OperationsByEventTypesQueryVariables>;
export const OperationsDocument = gql`
    query Operations($name: String, $enabled: Boolean, $first: Int!, $page: Int) {
  operations(name: $name, enabled: $enabled, first: $first, page: $page) {
    data {
      ...CoreOperationFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreOperationFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useOperationsQuery(variables: OperationsQueryVariables | VueCompositionApi.Ref<OperationsQueryVariables> | ReactiveFunction<OperationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OperationsQuery, OperationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OperationsQuery, OperationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OperationsQuery, OperationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OperationsQuery, OperationsQueryVariables>(OperationsDocument, variables, options);
}
export function useOperationsLazyQuery(variables?: OperationsQueryVariables | VueCompositionApi.Ref<OperationsQueryVariables> | ReactiveFunction<OperationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OperationsQuery, OperationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OperationsQuery, OperationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OperationsQuery, OperationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OperationsQuery, OperationsQueryVariables>(OperationsDocument, variables, options);
}
export type OperationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OperationsQuery, OperationsQueryVariables>;
export const PlannedPackagesDocument = gql`
    query PlannedPackages($first: Int!, $page: Int) {
  plannedPackages(first: $first, page: $page) {
    data {
      id
      name
      advantages {
        ...CorePlannedAdvantageFields
      }
      ticket {
        id
      }
      is_distribution
      created_at
      updated_at
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePlannedAdvantageFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function usePlannedPackagesQuery(variables: PlannedPackagesQueryVariables | VueCompositionApi.Ref<PlannedPackagesQueryVariables> | ReactiveFunction<PlannedPackagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannedPackagesQuery, PlannedPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannedPackagesQuery, PlannedPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannedPackagesQuery, PlannedPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PlannedPackagesQuery, PlannedPackagesQueryVariables>(PlannedPackagesDocument, variables, options);
}
export function usePlannedPackagesLazyQuery(variables?: PlannedPackagesQueryVariables | VueCompositionApi.Ref<PlannedPackagesQueryVariables> | ReactiveFunction<PlannedPackagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannedPackagesQuery, PlannedPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannedPackagesQuery, PlannedPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannedPackagesQuery, PlannedPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PlannedPackagesQuery, PlannedPackagesQueryVariables>(PlannedPackagesDocument, variables, options);
}
export type PlannedPackagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PlannedPackagesQuery, PlannedPackagesQueryVariables>;
export const PlannedPackageDocument = gql`
    query PlannedPackage($id: ID!) {
  plannedPackage(id: $id) {
    id
    name
    advantages {
      ...CorePlannedAdvantageFields
    }
    ticket {
      id
    }
    is_distribution
    created_at
    updated_at
  }
}
    ${CorePlannedAdvantageFieldsFragmentDoc}`;
export function usePlannedPackageQuery(variables: PlannedPackageQueryVariables | VueCompositionApi.Ref<PlannedPackageQueryVariables> | ReactiveFunction<PlannedPackageQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannedPackageQuery, PlannedPackageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannedPackageQuery, PlannedPackageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannedPackageQuery, PlannedPackageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PlannedPackageQuery, PlannedPackageQueryVariables>(PlannedPackageDocument, variables, options);
}
export function usePlannedPackageLazyQuery(variables?: PlannedPackageQueryVariables | VueCompositionApi.Ref<PlannedPackageQueryVariables> | ReactiveFunction<PlannedPackageQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannedPackageQuery, PlannedPackageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannedPackageQuery, PlannedPackageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannedPackageQuery, PlannedPackageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PlannedPackageQuery, PlannedPackageQueryVariables>(PlannedPackageDocument, variables, options);
}
export type PlannedPackageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PlannedPackageQuery, PlannedPackageQueryVariables>;
export const AllPlannedPackagesDocument = gql`
    query AllPlannedPackages($ticket_code: String) {
  allPlannedPackages(ticket_code: $ticket_code) {
    id
    name
    advantages {
      ...CorePlannedAdvantageFields
    }
    ticket {
      id
    }
    is_distribution
    created_at
    updated_at
  }
}
    ${CorePlannedAdvantageFieldsFragmentDoc}`;
export function useAllPlannedPackagesQuery(variables: AllPlannedPackagesQueryVariables | VueCompositionApi.Ref<AllPlannedPackagesQueryVariables> | ReactiveFunction<AllPlannedPackagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AllPlannedPackagesQuery, AllPlannedPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllPlannedPackagesQuery, AllPlannedPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllPlannedPackagesQuery, AllPlannedPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllPlannedPackagesQuery, AllPlannedPackagesQueryVariables>(AllPlannedPackagesDocument, variables, options);
}
export function useAllPlannedPackagesLazyQuery(variables: AllPlannedPackagesQueryVariables | VueCompositionApi.Ref<AllPlannedPackagesQueryVariables> | ReactiveFunction<AllPlannedPackagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AllPlannedPackagesQuery, AllPlannedPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllPlannedPackagesQuery, AllPlannedPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllPlannedPackagesQuery, AllPlannedPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllPlannedPackagesQuery, AllPlannedPackagesQueryVariables>(AllPlannedPackagesDocument, variables, options);
}
export type AllPlannedPackagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllPlannedPackagesQuery, AllPlannedPackagesQueryVariables>;
export const AssignedPlannedPackagesByTicketDocument = gql`
    query AssignedPlannedPackagesByTicket($ticket_code: String) {
  assignedPlannedPackagesByTicket(ticket_code: $ticket_code) {
    id
    name
    advantages {
      ...CorePlannedAdvantageFields
    }
    ticket {
      id
    }
    is_distribution
    created_at
    updated_at
  }
}
    ${CorePlannedAdvantageFieldsFragmentDoc}`;
export function useAssignedPlannedPackagesByTicketQuery(variables: AssignedPlannedPackagesByTicketQueryVariables | VueCompositionApi.Ref<AssignedPlannedPackagesByTicketQueryVariables> | ReactiveFunction<AssignedPlannedPackagesByTicketQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AssignedPlannedPackagesByTicketQuery, AssignedPlannedPackagesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssignedPlannedPackagesByTicketQuery, AssignedPlannedPackagesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssignedPlannedPackagesByTicketQuery, AssignedPlannedPackagesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AssignedPlannedPackagesByTicketQuery, AssignedPlannedPackagesByTicketQueryVariables>(AssignedPlannedPackagesByTicketDocument, variables, options);
}
export function useAssignedPlannedPackagesByTicketLazyQuery(variables: AssignedPlannedPackagesByTicketQueryVariables | VueCompositionApi.Ref<AssignedPlannedPackagesByTicketQueryVariables> | ReactiveFunction<AssignedPlannedPackagesByTicketQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AssignedPlannedPackagesByTicketQuery, AssignedPlannedPackagesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AssignedPlannedPackagesByTicketQuery, AssignedPlannedPackagesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AssignedPlannedPackagesByTicketQuery, AssignedPlannedPackagesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AssignedPlannedPackagesByTicketQuery, AssignedPlannedPackagesByTicketQueryVariables>(AssignedPlannedPackagesByTicketDocument, variables, options);
}
export type AssignedPlannedPackagesByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AssignedPlannedPackagesByTicketQuery, AssignedPlannedPackagesByTicketQueryVariables>;
export const ProductsDocument = gql`
    query Products($enabled: Boolean, $first: Int!, $page: Int) {
  products(enabled: $enabled, first: $first, page: $page) {
    data {
      id
      name
      enabled
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useProductsQuery(variables: ProductsQueryVariables | VueCompositionApi.Ref<ProductsQueryVariables> | ReactiveFunction<ProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, variables, options);
}
export function useProductsLazyQuery(variables?: ProductsQueryVariables | VueCompositionApi.Ref<ProductsQueryVariables> | ReactiveFunction<ProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductsQuery, ProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, variables, options);
}
export type ProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProductsQuery, ProductsQueryVariables>;
export const ProductDocument = gql`
    query Product($id: ID!) {
  product(id: $id) {
    id
    name
    enabled
  }
}
    `;
export function useProductQuery(variables: ProductQueryVariables | VueCompositionApi.Ref<ProductQueryVariables> | ReactiveFunction<ProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, variables, options);
}
export function useProductLazyQuery(variables?: ProductQueryVariables | VueCompositionApi.Ref<ProductQueryVariables> | ReactiveFunction<ProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductQuery, ProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, variables, options);
}
export type ProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProductQuery, ProductQueryVariables>;
export const RegionsDocument = gql`
    query Regions($enabled: Boolean, $first: Int!, $page: Int) {
  regions(enabled: $enabled, first: $first, page: $page) {
    data {
      id
      name
      enabled
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useRegionsQuery(variables: RegionsQueryVariables | VueCompositionApi.Ref<RegionsQueryVariables> | ReactiveFunction<RegionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, variables, options);
}
export function useRegionsLazyQuery(variables?: RegionsQueryVariables | VueCompositionApi.Ref<RegionsQueryVariables> | ReactiveFunction<RegionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, variables, options);
}
export type RegionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RegionsQuery, RegionsQueryVariables>;
export const RegionDocument = gql`
    query Region($id: ID!) {
  region(id: $id) {
    id
    name
    enabled
  }
}
    `;
export function useRegionQuery(variables: RegionQueryVariables | VueCompositionApi.Ref<RegionQueryVariables> | ReactiveFunction<RegionQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegionQuery, RegionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegionQuery, RegionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegionQuery, RegionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RegionQuery, RegionQueryVariables>(RegionDocument, variables, options);
}
export function useRegionLazyQuery(variables?: RegionQueryVariables | VueCompositionApi.Ref<RegionQueryVariables> | ReactiveFunction<RegionQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegionQuery, RegionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegionQuery, RegionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegionQuery, RegionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RegionQuery, RegionQueryVariables>(RegionDocument, variables, options);
}
export type RegionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RegionQuery, RegionQueryVariables>;
export const SectorsDocument = gql`
    query Sectors($enabled: Boolean, $first: Int!, $page: Int) {
  sectors(enabled: $enabled, first: $first, page: $page) {
    data {
      id
      name
      enabled
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useSectorsQuery(variables: SectorsQueryVariables | VueCompositionApi.Ref<SectorsQueryVariables> | ReactiveFunction<SectorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SectorsQuery, SectorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SectorsQuery, SectorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SectorsQuery, SectorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SectorsQuery, SectorsQueryVariables>(SectorsDocument, variables, options);
}
export function useSectorsLazyQuery(variables?: SectorsQueryVariables | VueCompositionApi.Ref<SectorsQueryVariables> | ReactiveFunction<SectorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SectorsQuery, SectorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SectorsQuery, SectorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SectorsQuery, SectorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SectorsQuery, SectorsQueryVariables>(SectorsDocument, variables, options);
}
export type SectorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SectorsQuery, SectorsQueryVariables>;
export const SectorDocument = gql`
    query Sector($id: ID!) {
  sector(id: $id) {
    id
    name
    enabled
  }
}
    `;
export function useSectorQuery(variables: SectorQueryVariables | VueCompositionApi.Ref<SectorQueryVariables> | ReactiveFunction<SectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<SectorQuery, SectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SectorQuery, SectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SectorQuery, SectorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SectorQuery, SectorQueryVariables>(SectorDocument, variables, options);
}
export function useSectorLazyQuery(variables?: SectorQueryVariables | VueCompositionApi.Ref<SectorQueryVariables> | ReactiveFunction<SectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<SectorQuery, SectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SectorQuery, SectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SectorQuery, SectorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SectorQuery, SectorQueryVariables>(SectorDocument, variables, options);
}
export type SectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SectorQuery, SectorQueryVariables>;
export const WatchdogsSettingsDocument = gql`
    query WatchdogsSettings($type: [SettingsType!]!) {
  settingsByType(type: $type) {
    ...CoreWatchdogsSettingsFields
  }
}
    ${CoreWatchdogsSettingsFieldsFragmentDoc}`;
export function useWatchdogsSettingsQuery(variables: WatchdogsSettingsQueryVariables | VueCompositionApi.Ref<WatchdogsSettingsQueryVariables> | ReactiveFunction<WatchdogsSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<WatchdogsSettingsQuery, WatchdogsSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WatchdogsSettingsQuery, WatchdogsSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WatchdogsSettingsQuery, WatchdogsSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WatchdogsSettingsQuery, WatchdogsSettingsQueryVariables>(WatchdogsSettingsDocument, variables, options);
}
export function useWatchdogsSettingsLazyQuery(variables?: WatchdogsSettingsQueryVariables | VueCompositionApi.Ref<WatchdogsSettingsQueryVariables> | ReactiveFunction<WatchdogsSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<WatchdogsSettingsQuery, WatchdogsSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WatchdogsSettingsQuery, WatchdogsSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WatchdogsSettingsQuery, WatchdogsSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WatchdogsSettingsQuery, WatchdogsSettingsQueryVariables>(WatchdogsSettingsDocument, variables, options);
}
export type WatchdogsSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WatchdogsSettingsQuery, WatchdogsSettingsQueryVariables>;
export const YouSignAuthentificationSettingDocument = gql`
    query YouSignAuthentificationSetting($type: SettingsType!) {
  settingByType(type: $type) {
    ...GlobalSettingsFields
    data {
      authentication_mode
    }
  }
}
    ${GlobalSettingsFieldsFragmentDoc}`;
export function useYouSignAuthentificationSettingQuery(variables: YouSignAuthentificationSettingQueryVariables | VueCompositionApi.Ref<YouSignAuthentificationSettingQueryVariables> | ReactiveFunction<YouSignAuthentificationSettingQueryVariables>, options: VueApolloComposable.UseQueryOptions<YouSignAuthentificationSettingQuery, YouSignAuthentificationSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<YouSignAuthentificationSettingQuery, YouSignAuthentificationSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<YouSignAuthentificationSettingQuery, YouSignAuthentificationSettingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<YouSignAuthentificationSettingQuery, YouSignAuthentificationSettingQueryVariables>(YouSignAuthentificationSettingDocument, variables, options);
}
export function useYouSignAuthentificationSettingLazyQuery(variables?: YouSignAuthentificationSettingQueryVariables | VueCompositionApi.Ref<YouSignAuthentificationSettingQueryVariables> | ReactiveFunction<YouSignAuthentificationSettingQueryVariables>, options: VueApolloComposable.UseQueryOptions<YouSignAuthentificationSettingQuery, YouSignAuthentificationSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<YouSignAuthentificationSettingQuery, YouSignAuthentificationSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<YouSignAuthentificationSettingQuery, YouSignAuthentificationSettingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<YouSignAuthentificationSettingQuery, YouSignAuthentificationSettingQueryVariables>(YouSignAuthentificationSettingDocument, variables, options);
}
export type YouSignAuthentificationSettingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<YouSignAuthentificationSettingQuery, YouSignAuthentificationSettingQueryVariables>;
export const YouSignReminderSettingDocument = gql`
    query YouSignReminderSetting($type: SettingsType!) {
  settingByType(type: $type) {
    ...GlobalSettingsFields
    data {
      max_occurrences
      interval_in_days
    }
  }
}
    ${GlobalSettingsFieldsFragmentDoc}`;
export function useYouSignReminderSettingQuery(variables: YouSignReminderSettingQueryVariables | VueCompositionApi.Ref<YouSignReminderSettingQueryVariables> | ReactiveFunction<YouSignReminderSettingQueryVariables>, options: VueApolloComposable.UseQueryOptions<YouSignReminderSettingQuery, YouSignReminderSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<YouSignReminderSettingQuery, YouSignReminderSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<YouSignReminderSettingQuery, YouSignReminderSettingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<YouSignReminderSettingQuery, YouSignReminderSettingQueryVariables>(YouSignReminderSettingDocument, variables, options);
}
export function useYouSignReminderSettingLazyQuery(variables?: YouSignReminderSettingQueryVariables | VueCompositionApi.Ref<YouSignReminderSettingQueryVariables> | ReactiveFunction<YouSignReminderSettingQueryVariables>, options: VueApolloComposable.UseQueryOptions<YouSignReminderSettingQuery, YouSignReminderSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<YouSignReminderSettingQuery, YouSignReminderSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<YouSignReminderSettingQuery, YouSignReminderSettingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<YouSignReminderSettingQuery, YouSignReminderSettingQueryVariables>(YouSignReminderSettingDocument, variables, options);
}
export type YouSignReminderSettingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<YouSignReminderSettingQuery, YouSignReminderSettingQueryVariables>;
export const YouSignWorkspaceSettingDocument = gql`
    query YouSignWorkspaceSetting($type: SettingsType!) {
  settingByType(type: $type) {
    ...GlobalSettingsFields
    data {
      workspace_id
      custom_experience_id
    }
  }
}
    ${GlobalSettingsFieldsFragmentDoc}`;
export function useYouSignWorkspaceSettingQuery(variables: YouSignWorkspaceSettingQueryVariables | VueCompositionApi.Ref<YouSignWorkspaceSettingQueryVariables> | ReactiveFunction<YouSignWorkspaceSettingQueryVariables>, options: VueApolloComposable.UseQueryOptions<YouSignWorkspaceSettingQuery, YouSignWorkspaceSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<YouSignWorkspaceSettingQuery, YouSignWorkspaceSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<YouSignWorkspaceSettingQuery, YouSignWorkspaceSettingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<YouSignWorkspaceSettingQuery, YouSignWorkspaceSettingQueryVariables>(YouSignWorkspaceSettingDocument, variables, options);
}
export function useYouSignWorkspaceSettingLazyQuery(variables?: YouSignWorkspaceSettingQueryVariables | VueCompositionApi.Ref<YouSignWorkspaceSettingQueryVariables> | ReactiveFunction<YouSignWorkspaceSettingQueryVariables>, options: VueApolloComposable.UseQueryOptions<YouSignWorkspaceSettingQuery, YouSignWorkspaceSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<YouSignWorkspaceSettingQuery, YouSignWorkspaceSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<YouSignWorkspaceSettingQuery, YouSignWorkspaceSettingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<YouSignWorkspaceSettingQuery, YouSignWorkspaceSettingQueryVariables>(YouSignWorkspaceSettingDocument, variables, options);
}
export type YouSignWorkspaceSettingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<YouSignWorkspaceSettingQuery, YouSignWorkspaceSettingQueryVariables>;
export const UpsellSettingsDocument = gql`
    query UpsellSettings($type: [SettingsType!]!) {
  settingsByType(type: $type) {
    ...GlobalSettingsFields
  }
}
    ${GlobalSettingsFieldsFragmentDoc}`;
export function useUpsellSettingsQuery(variables: UpsellSettingsQueryVariables | VueCompositionApi.Ref<UpsellSettingsQueryVariables> | ReactiveFunction<UpsellSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UpsellSettingsQuery, UpsellSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpsellSettingsQuery, UpsellSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpsellSettingsQuery, UpsellSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UpsellSettingsQuery, UpsellSettingsQueryVariables>(UpsellSettingsDocument, variables, options);
}
export function useUpsellSettingsLazyQuery(variables?: UpsellSettingsQueryVariables | VueCompositionApi.Ref<UpsellSettingsQueryVariables> | ReactiveFunction<UpsellSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UpsellSettingsQuery, UpsellSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpsellSettingsQuery, UpsellSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpsellSettingsQuery, UpsellSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UpsellSettingsQuery, UpsellSettingsQueryVariables>(UpsellSettingsDocument, variables, options);
}
export type UpsellSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UpsellSettingsQuery, UpsellSettingsQueryVariables>;
export const UpsellSettingDocument = gql`
    query UpsellSetting($type: SettingsType!) {
  settingByType(type: $type) {
    ...GlobalSettingsFields
  }
}
    ${GlobalSettingsFieldsFragmentDoc}`;
export function useUpsellSettingQuery(variables: UpsellSettingQueryVariables | VueCompositionApi.Ref<UpsellSettingQueryVariables> | ReactiveFunction<UpsellSettingQueryVariables>, options: VueApolloComposable.UseQueryOptions<UpsellSettingQuery, UpsellSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpsellSettingQuery, UpsellSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpsellSettingQuery, UpsellSettingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UpsellSettingQuery, UpsellSettingQueryVariables>(UpsellSettingDocument, variables, options);
}
export function useUpsellSettingLazyQuery(variables?: UpsellSettingQueryVariables | VueCompositionApi.Ref<UpsellSettingQueryVariables> | ReactiveFunction<UpsellSettingQueryVariables>, options: VueApolloComposable.UseQueryOptions<UpsellSettingQuery, UpsellSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpsellSettingQuery, UpsellSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpsellSettingQuery, UpsellSettingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UpsellSettingQuery, UpsellSettingQueryVariables>(UpsellSettingDocument, variables, options);
}
export type UpsellSettingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UpsellSettingQuery, UpsellSettingQueryVariables>;
export const CustomPermissionsSettingDocument = gql`
    query CustomPermissionsSetting($type: SettingsType = CUSTOM_PERMISSIONS) {
  settingByType(type: $type) {
    ...GlobalSettingsFields
  }
}
    ${GlobalSettingsFieldsFragmentDoc}`;
export function useCustomPermissionsSettingQuery(variables: CustomPermissionsSettingQueryVariables | VueCompositionApi.Ref<CustomPermissionsSettingQueryVariables> | ReactiveFunction<CustomPermissionsSettingQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CustomPermissionsSettingQuery, CustomPermissionsSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CustomPermissionsSettingQuery, CustomPermissionsSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CustomPermissionsSettingQuery, CustomPermissionsSettingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CustomPermissionsSettingQuery, CustomPermissionsSettingQueryVariables>(CustomPermissionsSettingDocument, variables, options);
}
export function useCustomPermissionsSettingLazyQuery(variables: CustomPermissionsSettingQueryVariables | VueCompositionApi.Ref<CustomPermissionsSettingQueryVariables> | ReactiveFunction<CustomPermissionsSettingQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CustomPermissionsSettingQuery, CustomPermissionsSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CustomPermissionsSettingQuery, CustomPermissionsSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CustomPermissionsSettingQuery, CustomPermissionsSettingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CustomPermissionsSettingQuery, CustomPermissionsSettingQueryVariables>(CustomPermissionsSettingDocument, variables, options);
}
export type CustomPermissionsSettingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CustomPermissionsSettingQuery, CustomPermissionsSettingQueryVariables>;
export const RouterSettingsDocument = gql`
    query RouterSettings($type: [SettingsType!]!) {
  settingsByType(type: $type) {
    ...GlobalSettingsFields
  }
}
    ${GlobalSettingsFieldsFragmentDoc}`;
export function useRouterSettingsQuery(variables: RouterSettingsQueryVariables | VueCompositionApi.Ref<RouterSettingsQueryVariables> | ReactiveFunction<RouterSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RouterSettingsQuery, RouterSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RouterSettingsQuery, RouterSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RouterSettingsQuery, RouterSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RouterSettingsQuery, RouterSettingsQueryVariables>(RouterSettingsDocument, variables, options);
}
export function useRouterSettingsLazyQuery(variables?: RouterSettingsQueryVariables | VueCompositionApi.Ref<RouterSettingsQueryVariables> | ReactiveFunction<RouterSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RouterSettingsQuery, RouterSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RouterSettingsQuery, RouterSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RouterSettingsQuery, RouterSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RouterSettingsQuery, RouterSettingsQueryVariables>(RouterSettingsDocument, variables, options);
}
export type RouterSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RouterSettingsQuery, RouterSettingsQueryVariables>;
export const ManuallySignedSheetDocument = gql`
    query ManuallySignedSheet($code: String!) {
  ticketByCode(code: $code) {
    id
    name
    workflow_step
    signingSheets {
      name
      id
      document {
        ...CoreDocumentFields
      }
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useManuallySignedSheetQuery(variables: ManuallySignedSheetQueryVariables | VueCompositionApi.Ref<ManuallySignedSheetQueryVariables> | ReactiveFunction<ManuallySignedSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<ManuallySignedSheetQuery, ManuallySignedSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ManuallySignedSheetQuery, ManuallySignedSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ManuallySignedSheetQuery, ManuallySignedSheetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ManuallySignedSheetQuery, ManuallySignedSheetQueryVariables>(ManuallySignedSheetDocument, variables, options);
}
export function useManuallySignedSheetLazyQuery(variables?: ManuallySignedSheetQueryVariables | VueCompositionApi.Ref<ManuallySignedSheetQueryVariables> | ReactiveFunction<ManuallySignedSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<ManuallySignedSheetQuery, ManuallySignedSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ManuallySignedSheetQuery, ManuallySignedSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ManuallySignedSheetQuery, ManuallySignedSheetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ManuallySignedSheetQuery, ManuallySignedSheetQueryVariables>(ManuallySignedSheetDocument, variables, options);
}
export type ManuallySignedSheetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ManuallySignedSheetQuery, ManuallySignedSheetQueryVariables>;
export const SpecialtiesDocument = gql`
    query Specialties($first: Int!, $page: Int) {
  specialties(first: $first, page: $page) {
    data {
      ...CoreSpecialtyFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useSpecialtiesQuery(variables: SpecialtiesQueryVariables | VueCompositionApi.Ref<SpecialtiesQueryVariables> | ReactiveFunction<SpecialtiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SpecialtiesQuery, SpecialtiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SpecialtiesQuery, SpecialtiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SpecialtiesQuery, SpecialtiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SpecialtiesQuery, SpecialtiesQueryVariables>(SpecialtiesDocument, variables, options);
}
export function useSpecialtiesLazyQuery(variables?: SpecialtiesQueryVariables | VueCompositionApi.Ref<SpecialtiesQueryVariables> | ReactiveFunction<SpecialtiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SpecialtiesQuery, SpecialtiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SpecialtiesQuery, SpecialtiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SpecialtiesQuery, SpecialtiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SpecialtiesQuery, SpecialtiesQueryVariables>(SpecialtiesDocument, variables, options);
}
export type SpecialtiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SpecialtiesQuery, SpecialtiesQueryVariables>;
export const GetAllSpecialtiesDocument = gql`
    query GetAllSpecialties {
  getAllSpecialties {
    ...CoreSpecialtyFields
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}`;
export function useGetAllSpecialtiesQuery(options: VueApolloComposable.UseQueryOptions<GetAllSpecialtiesQuery, GetAllSpecialtiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllSpecialtiesQuery, GetAllSpecialtiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllSpecialtiesQuery, GetAllSpecialtiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllSpecialtiesQuery, GetAllSpecialtiesQueryVariables>(GetAllSpecialtiesDocument, {}, options);
}
export function useGetAllSpecialtiesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAllSpecialtiesQuery, GetAllSpecialtiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllSpecialtiesQuery, GetAllSpecialtiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllSpecialtiesQuery, GetAllSpecialtiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllSpecialtiesQuery, GetAllSpecialtiesQueryVariables>(GetAllSpecialtiesDocument, {}, options);
}
export type GetAllSpecialtiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllSpecialtiesQuery, GetAllSpecialtiesQueryVariables>;
export const SpecialtyDocument = gql`
    query Specialty($id: ID!) {
  specialty(id: $id) {
    ...CoreSpecialtyFields
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}`;
export function useSpecialtyQuery(variables: SpecialtyQueryVariables | VueCompositionApi.Ref<SpecialtyQueryVariables> | ReactiveFunction<SpecialtyQueryVariables>, options: VueApolloComposable.UseQueryOptions<SpecialtyQuery, SpecialtyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SpecialtyQuery, SpecialtyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SpecialtyQuery, SpecialtyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SpecialtyQuery, SpecialtyQueryVariables>(SpecialtyDocument, variables, options);
}
export function useSpecialtyLazyQuery(variables?: SpecialtyQueryVariables | VueCompositionApi.Ref<SpecialtyQueryVariables> | ReactiveFunction<SpecialtyQueryVariables>, options: VueApolloComposable.UseQueryOptions<SpecialtyQuery, SpecialtyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SpecialtyQuery, SpecialtyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SpecialtyQuery, SpecialtyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SpecialtyQuery, SpecialtyQueryVariables>(SpecialtyDocument, variables, options);
}
export type SpecialtyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SpecialtyQuery, SpecialtyQueryVariables>;
export const SubmissionDocument = gql`
    query Submission($submission_id: ID, $deposit_id: ID) {
  submission(submission_id: $submission_id, deposit_id: $deposit_id) {
    ...CoreSubmissionFields
  }
}
    ${CoreSubmissionFieldsFragmentDoc}`;
export function useSubmissionQuery(variables: SubmissionQueryVariables | VueCompositionApi.Ref<SubmissionQueryVariables> | ReactiveFunction<SubmissionQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SubmissionQuery, SubmissionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SubmissionQuery, SubmissionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SubmissionQuery, SubmissionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, variables, options);
}
export function useSubmissionLazyQuery(variables: SubmissionQueryVariables | VueCompositionApi.Ref<SubmissionQueryVariables> | ReactiveFunction<SubmissionQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SubmissionQuery, SubmissionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SubmissionQuery, SubmissionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SubmissionQuery, SubmissionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, variables, options);
}
export type SubmissionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SubmissionQuery, SubmissionQueryVariables>;
export const TherapeuticAreasDocument = gql`
    query TherapeuticAreas($enabled: Boolean, $first: Int!, $page: Int) {
  therapeuticAreas(enabled: $enabled, first: $first, page: $page) {
    data {
      id
      name
      enabled
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useTherapeuticAreasQuery(variables: TherapeuticAreasQueryVariables | VueCompositionApi.Ref<TherapeuticAreasQueryVariables> | ReactiveFunction<TherapeuticAreasQueryVariables>, options: VueApolloComposable.UseQueryOptions<TherapeuticAreasQuery, TherapeuticAreasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TherapeuticAreasQuery, TherapeuticAreasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TherapeuticAreasQuery, TherapeuticAreasQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TherapeuticAreasQuery, TherapeuticAreasQueryVariables>(TherapeuticAreasDocument, variables, options);
}
export function useTherapeuticAreasLazyQuery(variables?: TherapeuticAreasQueryVariables | VueCompositionApi.Ref<TherapeuticAreasQueryVariables> | ReactiveFunction<TherapeuticAreasQueryVariables>, options: VueApolloComposable.UseQueryOptions<TherapeuticAreasQuery, TherapeuticAreasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TherapeuticAreasQuery, TherapeuticAreasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TherapeuticAreasQuery, TherapeuticAreasQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TherapeuticAreasQuery, TherapeuticAreasQueryVariables>(TherapeuticAreasDocument, variables, options);
}
export type TherapeuticAreasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TherapeuticAreasQuery, TherapeuticAreasQueryVariables>;
export const TherapeuticAreaDocument = gql`
    query TherapeuticArea($id: ID!) {
  therapeuticArea(id: $id) {
    id
    name
    enabled
  }
}
    `;
export function useTherapeuticAreaQuery(variables: TherapeuticAreaQueryVariables | VueCompositionApi.Ref<TherapeuticAreaQueryVariables> | ReactiveFunction<TherapeuticAreaQueryVariables>, options: VueApolloComposable.UseQueryOptions<TherapeuticAreaQuery, TherapeuticAreaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TherapeuticAreaQuery, TherapeuticAreaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TherapeuticAreaQuery, TherapeuticAreaQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TherapeuticAreaQuery, TherapeuticAreaQueryVariables>(TherapeuticAreaDocument, variables, options);
}
export function useTherapeuticAreaLazyQuery(variables?: TherapeuticAreaQueryVariables | VueCompositionApi.Ref<TherapeuticAreaQueryVariables> | ReactiveFunction<TherapeuticAreaQueryVariables>, options: VueApolloComposable.UseQueryOptions<TherapeuticAreaQuery, TherapeuticAreaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TherapeuticAreaQuery, TherapeuticAreaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TherapeuticAreaQuery, TherapeuticAreaQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TherapeuticAreaQuery, TherapeuticAreaQueryVariables>(TherapeuticAreaDocument, variables, options);
}
export type TherapeuticAreaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TherapeuticAreaQuery, TherapeuticAreaQueryVariables>;
export const TicketsOnTransparencyPageDocument = gql`
    query TicketsOnTransparencyPage($first: Int!, $name: [String!], $code: [String!], $external_code: [String!], $submission_regime: [TicketSubmissionRegime!], $event_type: [EventType!], $operation_id: [ID!], $created_by_id: [ID!], $date_range: [DateTimeUtc!], $initiator_id: [ID!], $validator_1_id: [ID!], $validator_2_id: [ID!], $crm_manager: [ID!], $page: Int, $filter_type: FilterAvailable!, $units: [ID!], $therapeuticAreas: [ID!], $sectors: [ID!], $products: [ID!], $networks: [ID!], $zones: [ID!], $regions: [ID!], $identities: [ID!]) {
  ticketsManagement(
    name: $name
    code: $code
    external_code: $external_code
    submission_regime: $submission_regime
    event_type: $event_type
    created_by_id: $created_by_id
    date_range: $date_range
    operation_id: $operation_id
    initiator_id: $initiator_id
    validator_1_id: $validator_1_id
    validator_2_id: $validator_2_id
    crm_manager: $crm_manager
    page: $page
    first: $first
    filter_type: $filter_type
    units: $units
    therapeuticAreas: $therapeuticAreas
    sectors: $sectors
    products: $products
    networks: $networks
    zones: $zones
    regions: $regions
    identities: $identities
  ) {
    data {
      id
      name
      event_type
      operation {
        id
        name
        is_publication_allowed
      }
      start_at
      end_at
      code
      created_at
      initiator {
        full_name
        first_name
        last_name
      }
      validator_1 {
        first_name
        last_name
      }
      validator_2 {
        first_name
        last_name
      }
      createdBy {
        full_name
        first_name
        last_name
        avatar
      }
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useTicketsOnTransparencyPageQuery(variables: TicketsOnTransparencyPageQueryVariables | VueCompositionApi.Ref<TicketsOnTransparencyPageQueryVariables> | ReactiveFunction<TicketsOnTransparencyPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketsOnTransparencyPageQuery, TicketsOnTransparencyPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsOnTransparencyPageQuery, TicketsOnTransparencyPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsOnTransparencyPageQuery, TicketsOnTransparencyPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketsOnTransparencyPageQuery, TicketsOnTransparencyPageQueryVariables>(TicketsOnTransparencyPageDocument, variables, options);
}
export function useTicketsOnTransparencyPageLazyQuery(variables?: TicketsOnTransparencyPageQueryVariables | VueCompositionApi.Ref<TicketsOnTransparencyPageQueryVariables> | ReactiveFunction<TicketsOnTransparencyPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketsOnTransparencyPageQuery, TicketsOnTransparencyPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsOnTransparencyPageQuery, TicketsOnTransparencyPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsOnTransparencyPageQuery, TicketsOnTransparencyPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketsOnTransparencyPageQuery, TicketsOnTransparencyPageQueryVariables>(TicketsOnTransparencyPageDocument, variables, options);
}
export type TicketsOnTransparencyPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketsOnTransparencyPageQuery, TicketsOnTransparencyPageQueryVariables>;
export const TicketsOnLibraryPageDocument = gql`
    query TicketsOnLibraryPage($name: [String!], $code: [String!], $external_code: [String!], $submission_regime: [TicketSubmissionRegime!], $event_type: [EventType!], $operation_id: [ID!], $created_by_id: [ID!], $date_range: [DateTimeUtc!], $initiator_id: [ID!], $validator_1_id: [ID!], $validator_2_id: [ID!], $crm_manager: [ID!], $first: Int!, $page: Int, $filter_type: FilterAvailable!, $status: [Status!], $statusFilterLibrary: [StatusFilterLibrary!], $contractor: [String!], $units: [ID!], $therapeuticAreas: [ID!], $sectors: [ID!], $products: [ID!], $networks: [ID!], $zones: [ID!], $regions: [ID!], $identities: [ID!]) {
  ticketsManagement(
    name: $name
    code: $code
    external_code: $external_code
    submission_regime: $submission_regime
    event_type: $event_type
    created_by_id: $created_by_id
    date_range: $date_range
    operation_id: $operation_id
    initiator_id: $initiator_id
    validator_1_id: $validator_1_id
    validator_2_id: $validator_2_id
    crm_manager: $crm_manager
    first: $first
    page: $page
    filter_type: $filter_type
    status: $status
    statusFilterLibrary: $statusFilterLibrary
    contractor: $contractor
    units: $units
    therapeuticAreas: $therapeuticAreas
    sectors: $sectors
    products: $products
    networks: $networks
    zones: $zones
    regions: $regions
    identities: $identities
  ) {
    data {
      id
      name
      event_type
      start_at
      end_at
      code
      created_at
      initiator {
        full_name
        first_name
        last_name
      }
      validator_1 {
        first_name
        last_name
      }
      validator_2 {
        first_name
        last_name
      }
      createdBy {
        full_name
        first_name
        last_name
        avatar
      }
      status
      is_archived
      is_published
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useTicketsOnLibraryPageQuery(variables: TicketsOnLibraryPageQueryVariables | VueCompositionApi.Ref<TicketsOnLibraryPageQueryVariables> | ReactiveFunction<TicketsOnLibraryPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketsOnLibraryPageQuery, TicketsOnLibraryPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsOnLibraryPageQuery, TicketsOnLibraryPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsOnLibraryPageQuery, TicketsOnLibraryPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketsOnLibraryPageQuery, TicketsOnLibraryPageQueryVariables>(TicketsOnLibraryPageDocument, variables, options);
}
export function useTicketsOnLibraryPageLazyQuery(variables?: TicketsOnLibraryPageQueryVariables | VueCompositionApi.Ref<TicketsOnLibraryPageQueryVariables> | ReactiveFunction<TicketsOnLibraryPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketsOnLibraryPageQuery, TicketsOnLibraryPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsOnLibraryPageQuery, TicketsOnLibraryPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsOnLibraryPageQuery, TicketsOnLibraryPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketsOnLibraryPageQuery, TicketsOnLibraryPageQueryVariables>(TicketsOnLibraryPageDocument, variables, options);
}
export type TicketsOnLibraryPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketsOnLibraryPageQuery, TicketsOnLibraryPageQueryVariables>;
export const FilteredTicketsForDashboardListDocument = gql`
    query FilteredTicketsForDashboardList($name: [String!], $code: [String!], $external_code: [String!], $event_type: [EventType!], $submission_regime: [TicketSubmissionRegime!], $operation_id: [ID!], $created_by_id: [ID!], $date_range: [DateTimeUtc!], $initiator_id: [ID!], $validator_1_id: [ID!], $validator_2_id: [ID!], $crm_manager: [ID!], $first: Int!, $page: Int, $filter_type: FilterAvailable!, $status: [Status!], $workflow_step: [Step!], $contractor: [String!], $units: [ID!], $therapeuticAreas: [ID!], $sectors: [ID!], $products: [ID!], $networks: [ID!], $zones: [ID!], $regions: [ID!], $identities: [ID!], $orderBy: [TicketManagementOrderByInput!]) {
  ticketsManagement(
    name: $name
    code: $code
    external_code: $external_code
    event_type: $event_type
    submission_regime: $submission_regime
    created_by_id: $created_by_id
    date_range: $date_range
    operation_id: $operation_id
    initiator_id: $initiator_id
    validator_1_id: $validator_1_id
    validator_2_id: $validator_2_id
    crm_manager: $crm_manager
    first: $first
    page: $page
    filter_type: $filter_type
    status: $status
    workflow_step: $workflow_step
    contractor: $contractor
    units: $units
    therapeuticAreas: $therapeuticAreas
    sectors: $sectors
    products: $products
    networks: $networks
    zones: $zones
    regions: $regions
    identities: $identities
    orderBy: $orderBy
  ) {
    data {
      ...CoreDashboardTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreDashboardTicketFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useFilteredTicketsForDashboardListQuery(variables: FilteredTicketsForDashboardListQueryVariables | VueCompositionApi.Ref<FilteredTicketsForDashboardListQueryVariables> | ReactiveFunction<FilteredTicketsForDashboardListQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilteredTicketsForDashboardListQuery, FilteredTicketsForDashboardListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilteredTicketsForDashboardListQuery, FilteredTicketsForDashboardListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilteredTicketsForDashboardListQuery, FilteredTicketsForDashboardListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilteredTicketsForDashboardListQuery, FilteredTicketsForDashboardListQueryVariables>(FilteredTicketsForDashboardListDocument, variables, options);
}
export function useFilteredTicketsForDashboardListLazyQuery(variables?: FilteredTicketsForDashboardListQueryVariables | VueCompositionApi.Ref<FilteredTicketsForDashboardListQueryVariables> | ReactiveFunction<FilteredTicketsForDashboardListQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilteredTicketsForDashboardListQuery, FilteredTicketsForDashboardListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilteredTicketsForDashboardListQuery, FilteredTicketsForDashboardListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilteredTicketsForDashboardListQuery, FilteredTicketsForDashboardListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilteredTicketsForDashboardListQuery, FilteredTicketsForDashboardListQueryVariables>(FilteredTicketsForDashboardListDocument, variables, options);
}
export type FilteredTicketsForDashboardListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilteredTicketsForDashboardListQuery, FilteredTicketsForDashboardListQueryVariables>;
export const TicketsPaginatorDocument = gql`
    query TicketsPaginator($first: Int!, $page: Int) {
  ticketsPaginator(first: $first, page: $page) {
    data {
      ...CoreTicketFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreTicketFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useTicketsPaginatorQuery(variables: TicketsPaginatorQueryVariables | VueCompositionApi.Ref<TicketsPaginatorQueryVariables> | ReactiveFunction<TicketsPaginatorQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketsPaginatorQuery, TicketsPaginatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsPaginatorQuery, TicketsPaginatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsPaginatorQuery, TicketsPaginatorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketsPaginatorQuery, TicketsPaginatorQueryVariables>(TicketsPaginatorDocument, variables, options);
}
export function useTicketsPaginatorLazyQuery(variables?: TicketsPaginatorQueryVariables | VueCompositionApi.Ref<TicketsPaginatorQueryVariables> | ReactiveFunction<TicketsPaginatorQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketsPaginatorQuery, TicketsPaginatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsPaginatorQuery, TicketsPaginatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsPaginatorQuery, TicketsPaginatorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketsPaginatorQuery, TicketsPaginatorQueryVariables>(TicketsPaginatorDocument, variables, options);
}
export type TicketsPaginatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketsPaginatorQuery, TicketsPaginatorQueryVariables>;
export const DashboardTicketByStepAndStatusDocument = gql`
    query DashboardTicketByStepAndStatus($name: [String!], $code: [String!], $external_code: [String!], $event_type: [EventType!], $submission_regime: [TicketSubmissionRegime!], $operation_id: [ID!], $created_by_id: [ID!], $date_range: [DateTimeUtc!], $initiator_id: [ID!], $validator_1_id: [ID!], $validator_2_id: [ID!], $crm_manager: [ID!], $filter_type: FilterAvailable!, $contractor: [String!], $units: [ID!], $therapeuticAreas: [ID!], $sectors: [ID!], $products: [ID!], $networks: [ID!], $zones: [ID!], $regions: [ID!], $identities: [ID!], $pagination: TicketsGroupedByStepOrStatusPaginationInput!) {
  ticketsGroupedByStepOrStatus(
    name: $name
    code: $code
    external_code: $external_code
    event_type: $event_type
    submission_regime: $submission_regime
    created_by_id: $created_by_id
    date_range: $date_range
    operation_id: $operation_id
    initiator_id: $initiator_id
    validator_1_id: $validator_1_id
    validator_2_id: $validator_2_id
    crm_manager: $crm_manager
    filter_type: $filter_type
    contractor: $contractor
    units: $units
    therapeuticAreas: $therapeuticAreas
    sectors: $sectors
    products: $products
    networks: $networks
    zones: $zones
    regions: $regions
    identities: $identities
    pagination: $pagination
  ) {
    data {
      ...TicketByStepAndStatusFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${TicketByStepAndStatusFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useDashboardTicketByStepAndStatusQuery(variables: DashboardTicketByStepAndStatusQueryVariables | VueCompositionApi.Ref<DashboardTicketByStepAndStatusQueryVariables> | ReactiveFunction<DashboardTicketByStepAndStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusQuery, DashboardTicketByStepAndStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusQuery, DashboardTicketByStepAndStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusQuery, DashboardTicketByStepAndStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DashboardTicketByStepAndStatusQuery, DashboardTicketByStepAndStatusQueryVariables>(DashboardTicketByStepAndStatusDocument, variables, options);
}
export function useDashboardTicketByStepAndStatusLazyQuery(variables?: DashboardTicketByStepAndStatusQueryVariables | VueCompositionApi.Ref<DashboardTicketByStepAndStatusQueryVariables> | ReactiveFunction<DashboardTicketByStepAndStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusQuery, DashboardTicketByStepAndStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusQuery, DashboardTicketByStepAndStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusQuery, DashboardTicketByStepAndStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DashboardTicketByStepAndStatusQuery, DashboardTicketByStepAndStatusQueryVariables>(DashboardTicketByStepAndStatusDocument, variables, options);
}
export type DashboardTicketByStepAndStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DashboardTicketByStepAndStatusQuery, DashboardTicketByStepAndStatusQueryVariables>;
export const DashboardTicketByStepAndStatusAdminDocument = gql`
    query DashboardTicketByStepAndStatusAdmin($name: [String!], $code: [String!], $external_code: [String!], $event_type: [EventType!], $submission_regime: [TicketSubmissionRegime!], $operation_id: [ID!], $created_by_id: [ID!], $date_range: [DateTimeUtc!], $initiator_id: [ID!], $validator_1_id: [ID!], $validator_2_id: [ID!], $crm_manager: [ID!], $filter_type: FilterAvailable!, $contractor: [String!], $units: [ID!], $therapeuticAreas: [ID!], $sectors: [ID!], $products: [ID!], $networks: [ID!], $zones: [ID!], $regions: [ID!], $identities: [ID!], $pagination: TicketsGroupedByStepOrStatusPaginationInput!) {
  ticketsGroupedByStepOrStatus(
    name: $name
    code: $code
    external_code: $external_code
    event_type: $event_type
    submission_regime: $submission_regime
    created_by_id: $created_by_id
    date_range: $date_range
    operation_id: $operation_id
    initiator_id: $initiator_id
    validator_1_id: $validator_1_id
    validator_2_id: $validator_2_id
    crm_manager: $crm_manager
    filter_type: $filter_type
    contractor: $contractor
    units: $units
    therapeuticAreas: $therapeuticAreas
    sectors: $sectors
    products: $products
    networks: $networks
    zones: $zones
    regions: $regions
    identities: $identities
    pagination: $pagination
  ) {
    data {
      ...TicketByStepAndStatusAdminFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${TicketByStepAndStatusAdminFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useDashboardTicketByStepAndStatusAdminQuery(variables: DashboardTicketByStepAndStatusAdminQueryVariables | VueCompositionApi.Ref<DashboardTicketByStepAndStatusAdminQueryVariables> | ReactiveFunction<DashboardTicketByStepAndStatusAdminQueryVariables>, options: VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusAdminQuery, DashboardTicketByStepAndStatusAdminQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusAdminQuery, DashboardTicketByStepAndStatusAdminQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusAdminQuery, DashboardTicketByStepAndStatusAdminQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DashboardTicketByStepAndStatusAdminQuery, DashboardTicketByStepAndStatusAdminQueryVariables>(DashboardTicketByStepAndStatusAdminDocument, variables, options);
}
export function useDashboardTicketByStepAndStatusAdminLazyQuery(variables?: DashboardTicketByStepAndStatusAdminQueryVariables | VueCompositionApi.Ref<DashboardTicketByStepAndStatusAdminQueryVariables> | ReactiveFunction<DashboardTicketByStepAndStatusAdminQueryVariables>, options: VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusAdminQuery, DashboardTicketByStepAndStatusAdminQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusAdminQuery, DashboardTicketByStepAndStatusAdminQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardTicketByStepAndStatusAdminQuery, DashboardTicketByStepAndStatusAdminQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DashboardTicketByStepAndStatusAdminQuery, DashboardTicketByStepAndStatusAdminQueryVariables>(DashboardTicketByStepAndStatusAdminDocument, variables, options);
}
export type DashboardTicketByStepAndStatusAdminQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DashboardTicketByStepAndStatusAdminQuery, DashboardTicketByStepAndStatusAdminQueryVariables>;
export const FilterTicketsOptionsDocument = gql`
    query FilterTicketsOptions($name: String, $filter_type: FilterAvailable!) {
  filterTicketsOptions(name: $name, filter_type: $filter_type) {
    id
    name
  }
}
    `;
export function useFilterTicketsOptionsQuery(variables: FilterTicketsOptionsQueryVariables | VueCompositionApi.Ref<FilterTicketsOptionsQueryVariables> | ReactiveFunction<FilterTicketsOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterTicketsOptionsQuery, FilterTicketsOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterTicketsOptionsQuery, FilterTicketsOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterTicketsOptionsQuery, FilterTicketsOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilterTicketsOptionsQuery, FilterTicketsOptionsQueryVariables>(FilterTicketsOptionsDocument, variables, options);
}
export function useFilterTicketsOptionsLazyQuery(variables?: FilterTicketsOptionsQueryVariables | VueCompositionApi.Ref<FilterTicketsOptionsQueryVariables> | ReactiveFunction<FilterTicketsOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterTicketsOptionsQuery, FilterTicketsOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterTicketsOptionsQuery, FilterTicketsOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterTicketsOptionsQuery, FilterTicketsOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilterTicketsOptionsQuery, FilterTicketsOptionsQueryVariables>(FilterTicketsOptionsDocument, variables, options);
}
export type FilterTicketsOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilterTicketsOptionsQuery, FilterTicketsOptionsQueryVariables>;
export const FilterTicketCodeOptionsDocument = gql`
    query FilterTicketCodeOptions($code: String, $filter_type: FilterAvailable!) {
  filterTicketCodeOptions(code: $code, filter_type: $filter_type) {
    id
    code
  }
}
    `;
export function useFilterTicketCodeOptionsQuery(variables: FilterTicketCodeOptionsQueryVariables | VueCompositionApi.Ref<FilterTicketCodeOptionsQueryVariables> | ReactiveFunction<FilterTicketCodeOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterTicketCodeOptionsQuery, FilterTicketCodeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterTicketCodeOptionsQuery, FilterTicketCodeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterTicketCodeOptionsQuery, FilterTicketCodeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilterTicketCodeOptionsQuery, FilterTicketCodeOptionsQueryVariables>(FilterTicketCodeOptionsDocument, variables, options);
}
export function useFilterTicketCodeOptionsLazyQuery(variables?: FilterTicketCodeOptionsQueryVariables | VueCompositionApi.Ref<FilterTicketCodeOptionsQueryVariables> | ReactiveFunction<FilterTicketCodeOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterTicketCodeOptionsQuery, FilterTicketCodeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterTicketCodeOptionsQuery, FilterTicketCodeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterTicketCodeOptionsQuery, FilterTicketCodeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilterTicketCodeOptionsQuery, FilterTicketCodeOptionsQueryVariables>(FilterTicketCodeOptionsDocument, variables, options);
}
export type FilterTicketCodeOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilterTicketCodeOptionsQuery, FilterTicketCodeOptionsQueryVariables>;
export const FilterTicketExternalCodeOptionsDocument = gql`
    query FilterTicketExternalCodeOptions($external_code: String, $filter_type: FilterAvailable!) {
  filterTicketExternalCodeOptions(
    external_code: $external_code
    filter_type: $filter_type
  ) {
    id
    external_code
  }
}
    `;
export function useFilterTicketExternalCodeOptionsQuery(variables: FilterTicketExternalCodeOptionsQueryVariables | VueCompositionApi.Ref<FilterTicketExternalCodeOptionsQueryVariables> | ReactiveFunction<FilterTicketExternalCodeOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterTicketExternalCodeOptionsQuery, FilterTicketExternalCodeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterTicketExternalCodeOptionsQuery, FilterTicketExternalCodeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterTicketExternalCodeOptionsQuery, FilterTicketExternalCodeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilterTicketExternalCodeOptionsQuery, FilterTicketExternalCodeOptionsQueryVariables>(FilterTicketExternalCodeOptionsDocument, variables, options);
}
export function useFilterTicketExternalCodeOptionsLazyQuery(variables?: FilterTicketExternalCodeOptionsQueryVariables | VueCompositionApi.Ref<FilterTicketExternalCodeOptionsQueryVariables> | ReactiveFunction<FilterTicketExternalCodeOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterTicketExternalCodeOptionsQuery, FilterTicketExternalCodeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterTicketExternalCodeOptionsQuery, FilterTicketExternalCodeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterTicketExternalCodeOptionsQuery, FilterTicketExternalCodeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilterTicketExternalCodeOptionsQuery, FilterTicketExternalCodeOptionsQueryVariables>(FilterTicketExternalCodeOptionsDocument, variables, options);
}
export type FilterTicketExternalCodeOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilterTicketExternalCodeOptionsQuery, FilterTicketExternalCodeOptionsQueryVariables>;
export const FilterCrmManagerOptionsDocument = gql`
    query FilterCrmManagerOptions($search: String) {
  filterCrmManagerOptions(search: $search) {
    id
    firstname
    lastname
    deleted_at
  }
}
    `;
export function useFilterCrmManagerOptionsQuery(variables: FilterCrmManagerOptionsQueryVariables | VueCompositionApi.Ref<FilterCrmManagerOptionsQueryVariables> | ReactiveFunction<FilterCrmManagerOptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FilterCrmManagerOptionsQuery, FilterCrmManagerOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterCrmManagerOptionsQuery, FilterCrmManagerOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterCrmManagerOptionsQuery, FilterCrmManagerOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilterCrmManagerOptionsQuery, FilterCrmManagerOptionsQueryVariables>(FilterCrmManagerOptionsDocument, variables, options);
}
export function useFilterCrmManagerOptionsLazyQuery(variables: FilterCrmManagerOptionsQueryVariables | VueCompositionApi.Ref<FilterCrmManagerOptionsQueryVariables> | ReactiveFunction<FilterCrmManagerOptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FilterCrmManagerOptionsQuery, FilterCrmManagerOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterCrmManagerOptionsQuery, FilterCrmManagerOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterCrmManagerOptionsQuery, FilterCrmManagerOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilterCrmManagerOptionsQuery, FilterCrmManagerOptionsQueryVariables>(FilterCrmManagerOptionsDocument, variables, options);
}
export type FilterCrmManagerOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilterCrmManagerOptionsQuery, FilterCrmManagerOptionsQueryVariables>;
export const FilterContractorOptionsDocument = gql`
    query FilterContractorOptions($search: String, $filter_type: FilterAvailable!) {
  filterContractorOptions(search: $search, filter_type: $filter_type) {
    id
    firstname
    lastname
  }
}
    `;
export function useFilterContractorOptionsQuery(variables: FilterContractorOptionsQueryVariables | VueCompositionApi.Ref<FilterContractorOptionsQueryVariables> | ReactiveFunction<FilterContractorOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterContractorOptionsQuery, FilterContractorOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterContractorOptionsQuery, FilterContractorOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterContractorOptionsQuery, FilterContractorOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilterContractorOptionsQuery, FilterContractorOptionsQueryVariables>(FilterContractorOptionsDocument, variables, options);
}
export function useFilterContractorOptionsLazyQuery(variables?: FilterContractorOptionsQueryVariables | VueCompositionApi.Ref<FilterContractorOptionsQueryVariables> | ReactiveFunction<FilterContractorOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterContractorOptionsQuery, FilterContractorOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterContractorOptionsQuery, FilterContractorOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterContractorOptionsQuery, FilterContractorOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilterContractorOptionsQuery, FilterContractorOptionsQueryVariables>(FilterContractorOptionsDocument, variables, options);
}
export type FilterContractorOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilterContractorOptionsQuery, FilterContractorOptionsQueryVariables>;
export const FilterAllRestrictedAreasOptionsDocument = gql`
    query FilterAllRestrictedAreasOptions {
  filterAllRestrictedAreasOptions {
    units {
      id
      name
    }
    products {
      id
      name
    }
    sectors {
      id
      name
    }
    therapeuticAreas {
      id
      name
    }
    networks {
      id
      name
    }
    zones {
      id
      name
    }
    regions {
      id
      name
    }
    identities {
      id
      name
    }
  }
}
    `;
export function useFilterAllRestrictedAreasOptionsQuery(options: VueApolloComposable.UseQueryOptions<FilterAllRestrictedAreasOptionsQuery, FilterAllRestrictedAreasOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterAllRestrictedAreasOptionsQuery, FilterAllRestrictedAreasOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterAllRestrictedAreasOptionsQuery, FilterAllRestrictedAreasOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilterAllRestrictedAreasOptionsQuery, FilterAllRestrictedAreasOptionsQueryVariables>(FilterAllRestrictedAreasOptionsDocument, {}, options);
}
export function useFilterAllRestrictedAreasOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<FilterAllRestrictedAreasOptionsQuery, FilterAllRestrictedAreasOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterAllRestrictedAreasOptionsQuery, FilterAllRestrictedAreasOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterAllRestrictedAreasOptionsQuery, FilterAllRestrictedAreasOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilterAllRestrictedAreasOptionsQuery, FilterAllRestrictedAreasOptionsQueryVariables>(FilterAllRestrictedAreasOptionsDocument, {}, options);
}
export type FilterAllRestrictedAreasOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilterAllRestrictedAreasOptionsQuery, FilterAllRestrictedAreasOptionsQueryVariables>;
export const FilterRestrictedAreaOptionsDocument = gql`
    query FilterRestrictedAreaOptions($search: String, $area: RestrictedAreas!) {
  filterRestrictedAreaOptions(search: $search, area: $area) {
    id
    name
    enabled
  }
}
    `;
export function useFilterRestrictedAreaOptionsQuery(variables: FilterRestrictedAreaOptionsQueryVariables | VueCompositionApi.Ref<FilterRestrictedAreaOptionsQueryVariables> | ReactiveFunction<FilterRestrictedAreaOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterRestrictedAreaOptionsQuery, FilterRestrictedAreaOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterRestrictedAreaOptionsQuery, FilterRestrictedAreaOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterRestrictedAreaOptionsQuery, FilterRestrictedAreaOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilterRestrictedAreaOptionsQuery, FilterRestrictedAreaOptionsQueryVariables>(FilterRestrictedAreaOptionsDocument, variables, options);
}
export function useFilterRestrictedAreaOptionsLazyQuery(variables?: FilterRestrictedAreaOptionsQueryVariables | VueCompositionApi.Ref<FilterRestrictedAreaOptionsQueryVariables> | ReactiveFunction<FilterRestrictedAreaOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilterRestrictedAreaOptionsQuery, FilterRestrictedAreaOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterRestrictedAreaOptionsQuery, FilterRestrictedAreaOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterRestrictedAreaOptionsQuery, FilterRestrictedAreaOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilterRestrictedAreaOptionsQuery, FilterRestrictedAreaOptionsQueryVariables>(FilterRestrictedAreaOptionsDocument, variables, options);
}
export type FilterRestrictedAreaOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilterRestrictedAreaOptionsQuery, FilterRestrictedAreaOptionsQueryVariables>;
export const DashboardTicketsDocument = gql`
    query DashboardTickets($is_declared: Boolean!, $is_archived: Boolean!) {
  ticketsDashboard(is_declared: $is_declared, is_archived: $is_archived) {
    ...CoreDashboardTicketFields
  }
}
    ${CoreDashboardTicketFieldsFragmentDoc}`;
export function useDashboardTicketsQuery(variables: DashboardTicketsQueryVariables | VueCompositionApi.Ref<DashboardTicketsQueryVariables> | ReactiveFunction<DashboardTicketsQueryVariables>, options: VueApolloComposable.UseQueryOptions<DashboardTicketsQuery, DashboardTicketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardTicketsQuery, DashboardTicketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardTicketsQuery, DashboardTicketsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DashboardTicketsQuery, DashboardTicketsQueryVariables>(DashboardTicketsDocument, variables, options);
}
export function useDashboardTicketsLazyQuery(variables?: DashboardTicketsQueryVariables | VueCompositionApi.Ref<DashboardTicketsQueryVariables> | ReactiveFunction<DashboardTicketsQueryVariables>, options: VueApolloComposable.UseQueryOptions<DashboardTicketsQuery, DashboardTicketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardTicketsQuery, DashboardTicketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardTicketsQuery, DashboardTicketsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DashboardTicketsQuery, DashboardTicketsQueryVariables>(DashboardTicketsDocument, variables, options);
}
export type DashboardTicketsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DashboardTicketsQuery, DashboardTicketsQueryVariables>;
export const LibraryTicketsDocument = gql`
    query LibraryTickets($is_declared: Boolean!, $is_archived: Boolean!) {
  ticketsDashboard(is_archived: $is_archived, is_declared: $is_declared) {
    id
    name
    code
    start_at
    end_at
    event_type
    created_at
    initiator {
      full_name
    }
    validator_1 {
      first_name
      last_name
    }
    validator_2 {
      first_name
      last_name
    }
    createdBy {
      first_name
      last_name
      full_name
    }
    status
    is_archived
    is_published
  }
}
    `;
export function useLibraryTicketsQuery(variables: LibraryTicketsQueryVariables | VueCompositionApi.Ref<LibraryTicketsQueryVariables> | ReactiveFunction<LibraryTicketsQueryVariables>, options: VueApolloComposable.UseQueryOptions<LibraryTicketsQuery, LibraryTicketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LibraryTicketsQuery, LibraryTicketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LibraryTicketsQuery, LibraryTicketsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LibraryTicketsQuery, LibraryTicketsQueryVariables>(LibraryTicketsDocument, variables, options);
}
export function useLibraryTicketsLazyQuery(variables?: LibraryTicketsQueryVariables | VueCompositionApi.Ref<LibraryTicketsQueryVariables> | ReactiveFunction<LibraryTicketsQueryVariables>, options: VueApolloComposable.UseQueryOptions<LibraryTicketsQuery, LibraryTicketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LibraryTicketsQuery, LibraryTicketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LibraryTicketsQuery, LibraryTicketsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LibraryTicketsQuery, LibraryTicketsQueryVariables>(LibraryTicketsDocument, variables, options);
}
export type LibraryTicketsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LibraryTicketsQuery, LibraryTicketsQueryVariables>;
export const TicketOnInfosPageDocument = gql`
    query TicketOnInfosPage($code: String!) {
  ticketByCode(code: $code) {
    id
    code
    external_code
    name
    quantity
    start_at
    end_at
    event_type
    description
    workflow_step
    event_specialty
    place
    is_archived
    is_published
    operation {
      id
      name
      is_publication_allowed
    }
    attachments {
      id
      document {
        url
        filename
      }
      comment
      type
    }
    workflow {
      name
    }
    initiator {
      full_name
    }
    validator_1 {
      full_name
    }
    validator_2 {
      full_name
    }
    address {
      street_name
      postcode
      city
      country
    }
    linkedTickets {
      id
      code
      name
      event_type
    }
    declaration {
      id
      code
      name
    }
    createdBy {
      full_name
    }
    attendees {
      data {
        ...CoreAttendeeTicketFields
      }
    }
    allocations {
      ...CoreAllocationsFields
    }
    created_at
    managerCrm {
      ...CoreCrmUserFields
    }
    approverCrm {
      ...CoreCrmUserFields
    }
    with_agency
    agency_name
    format
    meeting_type
    originalTicketInfo {
      code
      name
    }
  }
}
    ${CoreAttendeeTicketFieldsFragmentDoc}
${CoreAllocationsFieldsFragmentDoc}
${CoreCrmUserFieldsFragmentDoc}`;
export function useTicketOnInfosPageQuery(variables: TicketOnInfosPageQueryVariables | VueCompositionApi.Ref<TicketOnInfosPageQueryVariables> | ReactiveFunction<TicketOnInfosPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketOnInfosPageQuery, TicketOnInfosPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketOnInfosPageQuery, TicketOnInfosPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketOnInfosPageQuery, TicketOnInfosPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketOnInfosPageQuery, TicketOnInfosPageQueryVariables>(TicketOnInfosPageDocument, variables, options);
}
export function useTicketOnInfosPageLazyQuery(variables?: TicketOnInfosPageQueryVariables | VueCompositionApi.Ref<TicketOnInfosPageQueryVariables> | ReactiveFunction<TicketOnInfosPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketOnInfosPageQuery, TicketOnInfosPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketOnInfosPageQuery, TicketOnInfosPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketOnInfosPageQuery, TicketOnInfosPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketOnInfosPageQuery, TicketOnInfosPageQueryVariables>(TicketOnInfosPageDocument, variables, options);
}
export type TicketOnInfosPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketOnInfosPageQuery, TicketOnInfosPageQueryVariables>;
export const TicketOnPostEventDocument = gql`
    query TicketOnPostEvent($code: String!) {
  ticketByCode(code: $code) {
    id
    attendees {
      data {
        id
        type
        civility
        healthSpecialties {
          ...CoreSpecialtyFields
        }
        health_type
        firstname
        lastname
        type_number
        health_number
        email
        regime
        category
        is_present
        is_billed
        address {
          postcode
          street_name
          city
        }
      }
    }
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}`;
export function useTicketOnPostEventQuery(variables: TicketOnPostEventQueryVariables | VueCompositionApi.Ref<TicketOnPostEventQueryVariables> | ReactiveFunction<TicketOnPostEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketOnPostEventQuery, TicketOnPostEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketOnPostEventQuery, TicketOnPostEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketOnPostEventQuery, TicketOnPostEventQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketOnPostEventQuery, TicketOnPostEventQueryVariables>(TicketOnPostEventDocument, variables, options);
}
export function useTicketOnPostEventLazyQuery(variables?: TicketOnPostEventQueryVariables | VueCompositionApi.Ref<TicketOnPostEventQueryVariables> | ReactiveFunction<TicketOnPostEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketOnPostEventQuery, TicketOnPostEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketOnPostEventQuery, TicketOnPostEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketOnPostEventQuery, TicketOnPostEventQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketOnPostEventQuery, TicketOnPostEventQueryVariables>(TicketOnPostEventDocument, variables, options);
}
export type TicketOnPostEventQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketOnPostEventQuery, TicketOnPostEventQueryVariables>;
export const TicketOnExpensesDocument = gql`
    query TicketOnExpenses($code: String!, $expenseReportsOrderBy: [TicketExpenseReportsOrderByOrderByClause!]) {
  ticketByCode(code: $code) {
    id
    expenseReports(orderBy: $expenseReportsOrderBy) {
      id
      name
      reference
      document {
        url
        filename
      }
    }
  }
}
    `;
export function useTicketOnExpensesQuery(variables: TicketOnExpensesQueryVariables | VueCompositionApi.Ref<TicketOnExpensesQueryVariables> | ReactiveFunction<TicketOnExpensesQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketOnExpensesQuery, TicketOnExpensesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketOnExpensesQuery, TicketOnExpensesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketOnExpensesQuery, TicketOnExpensesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketOnExpensesQuery, TicketOnExpensesQueryVariables>(TicketOnExpensesDocument, variables, options);
}
export function useTicketOnExpensesLazyQuery(variables?: TicketOnExpensesQueryVariables | VueCompositionApi.Ref<TicketOnExpensesQueryVariables> | ReactiveFunction<TicketOnExpensesQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketOnExpensesQuery, TicketOnExpensesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketOnExpensesQuery, TicketOnExpensesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketOnExpensesQuery, TicketOnExpensesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketOnExpensesQuery, TicketOnExpensesQueryVariables>(TicketOnExpensesDocument, variables, options);
}
export type TicketOnExpensesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketOnExpensesQuery, TicketOnExpensesQueryVariables>;
export const TicketOnSigningSheetDocument = gql`
    query TicketOnSigningSheet($code: String!) {
  attendeesByTicketWithSignatures(code: $code) {
    id
    healthSpecialties {
      ...CoreSpecialtyFields
    }
    firstname
    lastname
    type_number
    health_number
    is_signed
  }
}
    ${CoreSpecialtyFieldsFragmentDoc}`;
export function useTicketOnSigningSheetQuery(variables: TicketOnSigningSheetQueryVariables | VueCompositionApi.Ref<TicketOnSigningSheetQueryVariables> | ReactiveFunction<TicketOnSigningSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketOnSigningSheetQuery, TicketOnSigningSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketOnSigningSheetQuery, TicketOnSigningSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketOnSigningSheetQuery, TicketOnSigningSheetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketOnSigningSheetQuery, TicketOnSigningSheetQueryVariables>(TicketOnSigningSheetDocument, variables, options);
}
export function useTicketOnSigningSheetLazyQuery(variables?: TicketOnSigningSheetQueryVariables | VueCompositionApi.Ref<TicketOnSigningSheetQueryVariables> | ReactiveFunction<TicketOnSigningSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketOnSigningSheetQuery, TicketOnSigningSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketOnSigningSheetQuery, TicketOnSigningSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketOnSigningSheetQuery, TicketOnSigningSheetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketOnSigningSheetQuery, TicketOnSigningSheetQueryVariables>(TicketOnSigningSheetDocument, variables, options);
}
export type TicketOnSigningSheetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketOnSigningSheetQuery, TicketOnSigningSheetQueryVariables>;
export const TicketsForLinksDocument = gql`
    query TicketsForLinks($code: String) {
  ticketsForLinks(code: $code) {
    undeclared_events {
      id
      name
      code
    }
    simple_events {
      id
      name
      code
    }
    contracts {
      id
      name
      code
    }
    events {
      id
      name
      code
    }
  }
}
    `;
export function useTicketsForLinksQuery(variables: TicketsForLinksQueryVariables | VueCompositionApi.Ref<TicketsForLinksQueryVariables> | ReactiveFunction<TicketsForLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TicketsForLinksQuery, TicketsForLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsForLinksQuery, TicketsForLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsForLinksQuery, TicketsForLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketsForLinksQuery, TicketsForLinksQueryVariables>(TicketsForLinksDocument, variables, options);
}
export function useTicketsForLinksLazyQuery(variables: TicketsForLinksQueryVariables | VueCompositionApi.Ref<TicketsForLinksQueryVariables> | ReactiveFunction<TicketsForLinksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TicketsForLinksQuery, TicketsForLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsForLinksQuery, TicketsForLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsForLinksQuery, TicketsForLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketsForLinksQuery, TicketsForLinksQueryVariables>(TicketsForLinksDocument, variables, options);
}
export type TicketsForLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketsForLinksQuery, TicketsForLinksQueryVariables>;
export const PlannedPackagesByTicketDocument = gql`
    query plannedPackagesByTicket($ticketID: ID!) {
  plannedPackagesByTicket(ticketID: $ticketID) {
    id
    name
    advantages {
      advantage_type
      net_amount
      gross_amount
      excluding_tax_amount
      including_tax_amount
      detail
      comment
      area
      quantity
    }
    is_distribution
    created_at
    updated_at
  }
}
    `;
export function usePlannedPackagesByTicketQuery(variables: PlannedPackagesByTicketQueryVariables | VueCompositionApi.Ref<PlannedPackagesByTicketQueryVariables> | ReactiveFunction<PlannedPackagesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannedPackagesByTicketQuery, PlannedPackagesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannedPackagesByTicketQuery, PlannedPackagesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannedPackagesByTicketQuery, PlannedPackagesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PlannedPackagesByTicketQuery, PlannedPackagesByTicketQueryVariables>(PlannedPackagesByTicketDocument, variables, options);
}
export function usePlannedPackagesByTicketLazyQuery(variables?: PlannedPackagesByTicketQueryVariables | VueCompositionApi.Ref<PlannedPackagesByTicketQueryVariables> | ReactiveFunction<PlannedPackagesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannedPackagesByTicketQuery, PlannedPackagesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannedPackagesByTicketQuery, PlannedPackagesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannedPackagesByTicketQuery, PlannedPackagesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PlannedPackagesByTicketQuery, PlannedPackagesByTicketQueryVariables>(PlannedPackagesByTicketDocument, variables, options);
}
export type PlannedPackagesByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PlannedPackagesByTicketQuery, PlannedPackagesByTicketQueryVariables>;
export const ActualPackagesByTicketDocument = gql`
    query actualPackagesByTicket($ticketCode: String!, $source: SourceEnum) {
  actualPackagesByTicket(ticketCode: $ticketCode, source: $source) {
    id
    name
    advantages {
      advantage_type
      net_amount
      gross_amount
      excluding_tax_amount
      including_tax_amount
      detail
      comment
      area
      quantity
      payment_date
    }
    source
    is_distribution
    created_at
    updated_at
  }
}
    `;
export function useActualPackagesByTicketQuery(variables: ActualPackagesByTicketQueryVariables | VueCompositionApi.Ref<ActualPackagesByTicketQueryVariables> | ReactiveFunction<ActualPackagesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActualPackagesByTicketQuery, ActualPackagesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActualPackagesByTicketQuery, ActualPackagesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActualPackagesByTicketQuery, ActualPackagesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActualPackagesByTicketQuery, ActualPackagesByTicketQueryVariables>(ActualPackagesByTicketDocument, variables, options);
}
export function useActualPackagesByTicketLazyQuery(variables?: ActualPackagesByTicketQueryVariables | VueCompositionApi.Ref<ActualPackagesByTicketQueryVariables> | ReactiveFunction<ActualPackagesByTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActualPackagesByTicketQuery, ActualPackagesByTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActualPackagesByTicketQuery, ActualPackagesByTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActualPackagesByTicketQuery, ActualPackagesByTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActualPackagesByTicketQuery, ActualPackagesByTicketQueryVariables>(ActualPackagesByTicketDocument, variables, options);
}
export type ActualPackagesByTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActualPackagesByTicketQuery, ActualPackagesByTicketQueryVariables>;
export const AdvantagesAmountsByTicketCodeDocument = gql`
    query AdvantagesAmountsByTicketCode($code: String!) {
  advantagesAmountsByTicketCode(code: $code) {
    actual
    gap
    planned
  }
}
    `;
export function useAdvantagesAmountsByTicketCodeQuery(variables: AdvantagesAmountsByTicketCodeQueryVariables | VueCompositionApi.Ref<AdvantagesAmountsByTicketCodeQueryVariables> | ReactiveFunction<AdvantagesAmountsByTicketCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdvantagesAmountsByTicketCodeQuery, AdvantagesAmountsByTicketCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdvantagesAmountsByTicketCodeQuery, AdvantagesAmountsByTicketCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdvantagesAmountsByTicketCodeQuery, AdvantagesAmountsByTicketCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdvantagesAmountsByTicketCodeQuery, AdvantagesAmountsByTicketCodeQueryVariables>(AdvantagesAmountsByTicketCodeDocument, variables, options);
}
export function useAdvantagesAmountsByTicketCodeLazyQuery(variables?: AdvantagesAmountsByTicketCodeQueryVariables | VueCompositionApi.Ref<AdvantagesAmountsByTicketCodeQueryVariables> | ReactiveFunction<AdvantagesAmountsByTicketCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdvantagesAmountsByTicketCodeQuery, AdvantagesAmountsByTicketCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdvantagesAmountsByTicketCodeQuery, AdvantagesAmountsByTicketCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdvantagesAmountsByTicketCodeQuery, AdvantagesAmountsByTicketCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdvantagesAmountsByTicketCodeQuery, AdvantagesAmountsByTicketCodeQueryVariables>(AdvantagesAmountsByTicketCodeDocument, variables, options);
}
export type AdvantagesAmountsByTicketCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdvantagesAmountsByTicketCodeQuery, AdvantagesAmountsByTicketCodeQueryVariables>;
export const TicketsOnAdminManagementPageDocument = gql`
    query TicketsOnAdminManagementPage {
  tickets {
    id
    code
    name
    external_code
    status
    workflow_step
    is_archived
    is_declared
  }
}
    `;
export function useTicketsOnAdminManagementPageQuery(options: VueApolloComposable.UseQueryOptions<TicketsOnAdminManagementPageQuery, TicketsOnAdminManagementPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsOnAdminManagementPageQuery, TicketsOnAdminManagementPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsOnAdminManagementPageQuery, TicketsOnAdminManagementPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketsOnAdminManagementPageQuery, TicketsOnAdminManagementPageQueryVariables>(TicketsOnAdminManagementPageDocument, {}, options);
}
export function useTicketsOnAdminManagementPageLazyQuery(options: VueApolloComposable.UseQueryOptions<TicketsOnAdminManagementPageQuery, TicketsOnAdminManagementPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketsOnAdminManagementPageQuery, TicketsOnAdminManagementPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketsOnAdminManagementPageQuery, TicketsOnAdminManagementPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketsOnAdminManagementPageQuery, TicketsOnAdminManagementPageQueryVariables>(TicketsOnAdminManagementPageDocument, {}, options);
}
export type TicketsOnAdminManagementPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketsOnAdminManagementPageQuery, TicketsOnAdminManagementPageQueryVariables>;
export const SimpleEventsByDeclarationCodeDocument = gql`
    query SimpleEventsByDeclarationCode($declaration_code: String!, $ticket_badge: TicketBadge, $name: String, $orderBy: [TicketByDeclarationCodeOrderByInput!], $first: Int!, $page: Int!) {
  ticketsByDeclarationCode(
    declaration_code: $declaration_code
    ticket_badge: $ticket_badge
    event_type: SIMPLE_EVENT
    name: $name
    orderBy: $orderBy
    first: $first
    page: $page
  ) {
    data {
      ...CoreTicketFields
      ticketBadge
      doctors_count
      present_doctors_count
      doctor_list_status
      is_doctor_list_status_editable
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreTicketFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useSimpleEventsByDeclarationCodeQuery(variables: SimpleEventsByDeclarationCodeQueryVariables | VueCompositionApi.Ref<SimpleEventsByDeclarationCodeQueryVariables> | ReactiveFunction<SimpleEventsByDeclarationCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<SimpleEventsByDeclarationCodeQuery, SimpleEventsByDeclarationCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SimpleEventsByDeclarationCodeQuery, SimpleEventsByDeclarationCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SimpleEventsByDeclarationCodeQuery, SimpleEventsByDeclarationCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SimpleEventsByDeclarationCodeQuery, SimpleEventsByDeclarationCodeQueryVariables>(SimpleEventsByDeclarationCodeDocument, variables, options);
}
export function useSimpleEventsByDeclarationCodeLazyQuery(variables?: SimpleEventsByDeclarationCodeQueryVariables | VueCompositionApi.Ref<SimpleEventsByDeclarationCodeQueryVariables> | ReactiveFunction<SimpleEventsByDeclarationCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<SimpleEventsByDeclarationCodeQuery, SimpleEventsByDeclarationCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SimpleEventsByDeclarationCodeQuery, SimpleEventsByDeclarationCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SimpleEventsByDeclarationCodeQuery, SimpleEventsByDeclarationCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SimpleEventsByDeclarationCodeQuery, SimpleEventsByDeclarationCodeQueryVariables>(SimpleEventsByDeclarationCodeDocument, variables, options);
}
export type SimpleEventsByDeclarationCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SimpleEventsByDeclarationCodeQuery, SimpleEventsByDeclarationCodeQueryVariables>;
export const HasValidEmailsDocument = gql`
    query HasValidEmails($ticket_code: String!) {
  hasValidEmails(ticket_code: $ticket_code)
}
    `;
export function useHasValidEmailsQuery(variables: HasValidEmailsQueryVariables | VueCompositionApi.Ref<HasValidEmailsQueryVariables> | ReactiveFunction<HasValidEmailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<HasValidEmailsQuery, HasValidEmailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HasValidEmailsQuery, HasValidEmailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HasValidEmailsQuery, HasValidEmailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HasValidEmailsQuery, HasValidEmailsQueryVariables>(HasValidEmailsDocument, variables, options);
}
export function useHasValidEmailsLazyQuery(variables?: HasValidEmailsQueryVariables | VueCompositionApi.Ref<HasValidEmailsQueryVariables> | ReactiveFunction<HasValidEmailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<HasValidEmailsQuery, HasValidEmailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HasValidEmailsQuery, HasValidEmailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HasValidEmailsQuery, HasValidEmailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<HasValidEmailsQuery, HasValidEmailsQueryVariables>(HasValidEmailsDocument, variables, options);
}
export type HasValidEmailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HasValidEmailsQuery, HasValidEmailsQueryVariables>;
export const DepositsListDocument = gql`
    query DepositsList($first: Int!, $page: Int, $ticket_name: [String], $ticket_code: [String], $ticket_event_type: [String], $ticket_operation_name: [String], $ticket_initiator_id: [ID], $ticket_start_at: DateTimeUtc, $ticket_end_at: DateTimeUtc, $ticket_submission_regime: [String], $ticket_workflow_step_or_status: [String], $submission_reference: String, $status: [DepositStatus]) {
  deposits(
    first: $first
    page: $page
    ticket_name: $ticket_name
    ticket_code: $ticket_code
    ticket_event_type: $ticket_event_type
    ticket_operation_name: $ticket_operation_name
    ticket_initiator_id: $ticket_initiator_id
    ticket_start_at: $ticket_start_at
    ticket_end_at: $ticket_end_at
    ticket_submission_regime: $ticket_submission_regime
    ticket_workflow_step_or_status: $ticket_workflow_step_or_status
    submission_reference: $submission_reference
    status: $status
  ) {
    data {
      id
      reference
      status
      json_filters
      platform
      other_category
      ticket {
        id
        code
        name
        start_at
        end_at
        submission_regime
        workflow_step
        status
        remainingDays
        operation {
          id
          name
        }
      }
      submissions {
        id
        status
        url
      }
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useDepositsListQuery(variables: DepositsListQueryVariables | VueCompositionApi.Ref<DepositsListQueryVariables> | ReactiveFunction<DepositsListQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositsListQuery, DepositsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositsListQuery, DepositsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositsListQuery, DepositsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DepositsListQuery, DepositsListQueryVariables>(DepositsListDocument, variables, options);
}
export function useDepositsListLazyQuery(variables?: DepositsListQueryVariables | VueCompositionApi.Ref<DepositsListQueryVariables> | ReactiveFunction<DepositsListQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositsListQuery, DepositsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositsListQuery, DepositsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositsListQuery, DepositsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DepositsListQuery, DepositsListQueryVariables>(DepositsListDocument, variables, options);
}
export type DepositsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DepositsListQuery, DepositsListQueryVariables>;
export const FilterDepositOptionsDocument = gql`
    query FilterDepositOptions($ticket_name: [String], $ticket_code: [String]) {
  filterDepositOptions(ticket_code: $ticket_code, ticket_name: $ticket_name) {
    ticket_id
    ticket_name
    ticket_code
  }
}
    `;
export function useFilterDepositOptionsQuery(variables: FilterDepositOptionsQueryVariables | VueCompositionApi.Ref<FilterDepositOptionsQueryVariables> | ReactiveFunction<FilterDepositOptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FilterDepositOptionsQuery, FilterDepositOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterDepositOptionsQuery, FilterDepositOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterDepositOptionsQuery, FilterDepositOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilterDepositOptionsQuery, FilterDepositOptionsQueryVariables>(FilterDepositOptionsDocument, variables, options);
}
export function useFilterDepositOptionsLazyQuery(variables: FilterDepositOptionsQueryVariables | VueCompositionApi.Ref<FilterDepositOptionsQueryVariables> | ReactiveFunction<FilterDepositOptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FilterDepositOptionsQuery, FilterDepositOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilterDepositOptionsQuery, FilterDepositOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilterDepositOptionsQuery, FilterDepositOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilterDepositOptionsQuery, FilterDepositOptionsQueryVariables>(FilterDepositOptionsDocument, variables, options);
}
export type FilterDepositOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilterDepositOptionsQuery, FilterDepositOptionsQueryVariables>;
export const DepositNotValidatedDocument = gql`
    query DepositNotValidated($ticket_id: ID!) {
  depositNotValidated(ticket_id: $ticket_id) {
    deposit_count
    deposit_lines
    contract_count
    contract_lines
  }
}
    `;
export function useDepositNotValidatedQuery(variables: DepositNotValidatedQueryVariables | VueCompositionApi.Ref<DepositNotValidatedQueryVariables> | ReactiveFunction<DepositNotValidatedQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositNotValidatedQuery, DepositNotValidatedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositNotValidatedQuery, DepositNotValidatedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositNotValidatedQuery, DepositNotValidatedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DepositNotValidatedQuery, DepositNotValidatedQueryVariables>(DepositNotValidatedDocument, variables, options);
}
export function useDepositNotValidatedLazyQuery(variables?: DepositNotValidatedQueryVariables | VueCompositionApi.Ref<DepositNotValidatedQueryVariables> | ReactiveFunction<DepositNotValidatedQueryVariables>, options: VueApolloComposable.UseQueryOptions<DepositNotValidatedQuery, DepositNotValidatedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DepositNotValidatedQuery, DepositNotValidatedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DepositNotValidatedQuery, DepositNotValidatedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DepositNotValidatedQuery, DepositNotValidatedQueryVariables>(DepositNotValidatedDocument, variables, options);
}
export type DepositNotValidatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DepositNotValidatedQuery, DepositNotValidatedQueryVariables>;
export const TicketAttendeeImportDocument = gql`
    query TicketAttendeeImport($ticket_code: String!, $first: Int!, $page: Int) {
  ticketAttendeeImports(ticket_code: $ticket_code, first: $first, page: $page) {
    data {
      id
      status
      created_at
      document {
        ...CoreDocumentFields
      }
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useTicketAttendeeImportQuery(variables: TicketAttendeeImportQueryVariables | VueCompositionApi.Ref<TicketAttendeeImportQueryVariables> | ReactiveFunction<TicketAttendeeImportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketAttendeeImportQuery, TicketAttendeeImportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketAttendeeImportQuery, TicketAttendeeImportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketAttendeeImportQuery, TicketAttendeeImportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TicketAttendeeImportQuery, TicketAttendeeImportQueryVariables>(TicketAttendeeImportDocument, variables, options);
}
export function useTicketAttendeeImportLazyQuery(variables?: TicketAttendeeImportQueryVariables | VueCompositionApi.Ref<TicketAttendeeImportQueryVariables> | ReactiveFunction<TicketAttendeeImportQueryVariables>, options: VueApolloComposable.UseQueryOptions<TicketAttendeeImportQuery, TicketAttendeeImportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TicketAttendeeImportQuery, TicketAttendeeImportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TicketAttendeeImportQuery, TicketAttendeeImportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TicketAttendeeImportQuery, TicketAttendeeImportQueryVariables>(TicketAttendeeImportDocument, variables, options);
}
export type TicketAttendeeImportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TicketAttendeeImportQuery, TicketAttendeeImportQueryVariables>;
export const AuthTicketPermissionsDocument = gql`
    query AuthTicketPermissions {
  myTicketPermissions {
    lifecycle_key
    permissions
  }
}
    `;
export function useAuthTicketPermissionsQuery(options: VueApolloComposable.UseQueryOptions<AuthTicketPermissionsQuery, AuthTicketPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AuthTicketPermissionsQuery, AuthTicketPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AuthTicketPermissionsQuery, AuthTicketPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AuthTicketPermissionsQuery, AuthTicketPermissionsQueryVariables>(AuthTicketPermissionsDocument, {}, options);
}
export function useAuthTicketPermissionsLazyQuery(options: VueApolloComposable.UseQueryOptions<AuthTicketPermissionsQuery, AuthTicketPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AuthTicketPermissionsQuery, AuthTicketPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AuthTicketPermissionsQuery, AuthTicketPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AuthTicketPermissionsQuery, AuthTicketPermissionsQueryVariables>(AuthTicketPermissionsDocument, {}, options);
}
export type AuthTicketPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AuthTicketPermissionsQuery, AuthTicketPermissionsQueryVariables>;
export const UnitsDocument = gql`
    query Units($enabled: Boolean, $first: Int!, $page: Int) {
  units(enabled: $enabled, first: $first, page: $page) {
    data {
      id
      name
      enabled
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useUnitsQuery(variables: UnitsQueryVariables | VueCompositionApi.Ref<UnitsQueryVariables> | ReactiveFunction<UnitsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UnitsQuery, UnitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UnitsQuery, UnitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UnitsQuery, UnitsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UnitsQuery, UnitsQueryVariables>(UnitsDocument, variables, options);
}
export function useUnitsLazyQuery(variables?: UnitsQueryVariables | VueCompositionApi.Ref<UnitsQueryVariables> | ReactiveFunction<UnitsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UnitsQuery, UnitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UnitsQuery, UnitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UnitsQuery, UnitsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UnitsQuery, UnitsQueryVariables>(UnitsDocument, variables, options);
}
export type UnitsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UnitsQuery, UnitsQueryVariables>;
export const UnitDocument = gql`
    query Unit($id: ID!) {
  unit(id: $id) {
    id
    name
    enabled
  }
}
    `;
export function useUnitQuery(variables: UnitQueryVariables | VueCompositionApi.Ref<UnitQueryVariables> | ReactiveFunction<UnitQueryVariables>, options: VueApolloComposable.UseQueryOptions<UnitQuery, UnitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UnitQuery, UnitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UnitQuery, UnitQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UnitQuery, UnitQueryVariables>(UnitDocument, variables, options);
}
export function useUnitLazyQuery(variables?: UnitQueryVariables | VueCompositionApi.Ref<UnitQueryVariables> | ReactiveFunction<UnitQueryVariables>, options: VueApolloComposable.UseQueryOptions<UnitQuery, UnitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UnitQuery, UnitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UnitQuery, UnitQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UnitQuery, UnitQueryVariables>(UnitDocument, variables, options);
}
export type UnitQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UnitQuery, UnitQueryVariables>;
export const GetUserValidatorsDocument = gql`
    query GetUserValidators($id: ID!) {
  getValidatorsFromUser(id: $id) {
    first_validators
    second_validators
  }
}
    `;
export function useGetUserValidatorsQuery(variables: GetUserValidatorsQueryVariables | VueCompositionApi.Ref<GetUserValidatorsQueryVariables> | ReactiveFunction<GetUserValidatorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserValidatorsQuery, GetUserValidatorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserValidatorsQuery, GetUserValidatorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserValidatorsQuery, GetUserValidatorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserValidatorsQuery, GetUserValidatorsQueryVariables>(GetUserValidatorsDocument, variables, options);
}
export function useGetUserValidatorsLazyQuery(variables?: GetUserValidatorsQueryVariables | VueCompositionApi.Ref<GetUserValidatorsQueryVariables> | ReactiveFunction<GetUserValidatorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserValidatorsQuery, GetUserValidatorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserValidatorsQuery, GetUserValidatorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserValidatorsQuery, GetUserValidatorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserValidatorsQuery, GetUserValidatorsQueryVariables>(GetUserValidatorsDocument, variables, options);
}
export type GetUserValidatorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserValidatorsQuery, GetUserValidatorsQueryVariables>;
export const GetDynamicUsersByRoleListDocument = gql`
    query GetDynamicUsersByRoleList($search: String, $roles: [UserRoles!], $enabled: Boolean) {
  getDynamicUsersByRoleList(search: $search, roles: $roles, enabled: $enabled) {
    initiators {
      id
      keycloak_id
      first_name
      last_name
      full_name
      email
      enabled
    }
    validators_1 {
      id
      keycloak_id
      first_name
      last_name
      full_name
      email
      enabled
    }
    validators_2 {
      id
      keycloak_id
      first_name
      last_name
      full_name
      email
      enabled
    }
  }
}
    `;
export function useGetDynamicUsersByRoleListQuery(variables: GetDynamicUsersByRoleListQueryVariables | VueCompositionApi.Ref<GetDynamicUsersByRoleListQueryVariables> | ReactiveFunction<GetDynamicUsersByRoleListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetDynamicUsersByRoleListQuery, GetDynamicUsersByRoleListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDynamicUsersByRoleListQuery, GetDynamicUsersByRoleListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDynamicUsersByRoleListQuery, GetDynamicUsersByRoleListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetDynamicUsersByRoleListQuery, GetDynamicUsersByRoleListQueryVariables>(GetDynamicUsersByRoleListDocument, variables, options);
}
export function useGetDynamicUsersByRoleListLazyQuery(variables: GetDynamicUsersByRoleListQueryVariables | VueCompositionApi.Ref<GetDynamicUsersByRoleListQueryVariables> | ReactiveFunction<GetDynamicUsersByRoleListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetDynamicUsersByRoleListQuery, GetDynamicUsersByRoleListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDynamicUsersByRoleListQuery, GetDynamicUsersByRoleListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDynamicUsersByRoleListQuery, GetDynamicUsersByRoleListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetDynamicUsersByRoleListQuery, GetDynamicUsersByRoleListQueryVariables>(GetDynamicUsersByRoleListDocument, variables, options);
}
export type GetDynamicUsersByRoleListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetDynamicUsersByRoleListQuery, GetDynamicUsersByRoleListQueryVariables>;
export const GetAllUsersDocument = gql`
    query GetAllUsers {
  usersForTags {
    id
    email
    first_name
    last_name
    full_name
  }
}
    `;
export function useGetAllUsersQuery(options: VueApolloComposable.UseQueryOptions<GetAllUsersQuery, GetAllUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllUsersQuery, GetAllUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllUsersQuery, GetAllUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, {}, options);
}
export function useGetAllUsersLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAllUsersQuery, GetAllUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllUsersQuery, GetAllUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllUsersQuery, GetAllUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, {}, options);
}
export type GetAllUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const UserFindOneDocument = gql`
    query UserFindOne($id: ID!) {
  userFindOne(id: $id) {
    id
    firstName
    lastName
    staff_id
    email
    attributes {
      phone
      eps_login
      eps_password
      idahe_login
      idahe_password
    }
    allocations {
      ...CoreAllocationsFields
    }
    enabled
  }
}
    ${CoreAllocationsFieldsFragmentDoc}`;
export function useUserFindOneQuery(variables: UserFindOneQueryVariables | VueCompositionApi.Ref<UserFindOneQueryVariables> | ReactiveFunction<UserFindOneQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserFindOneQuery, UserFindOneQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserFindOneQuery, UserFindOneQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserFindOneQuery, UserFindOneQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserFindOneQuery, UserFindOneQueryVariables>(UserFindOneDocument, variables, options);
}
export function useUserFindOneLazyQuery(variables?: UserFindOneQueryVariables | VueCompositionApi.Ref<UserFindOneQueryVariables> | ReactiveFunction<UserFindOneQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserFindOneQuery, UserFindOneQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserFindOneQuery, UserFindOneQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserFindOneQuery, UserFindOneQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserFindOneQuery, UserFindOneQueryVariables>(UserFindOneDocument, variables, options);
}
export type UserFindOneQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserFindOneQuery, UserFindOneQueryVariables>;
export const GetUserCreatorByTicketCodeDocument = gql`
    query getUserCreatorByTicketCode($ticket_code: String!) {
  getUserCreatorByTicketCode(ticket_code: $ticket_code) {
    id
    full_name
  }
}
    `;
export function useGetUserCreatorByTicketCodeQuery(variables: GetUserCreatorByTicketCodeQueryVariables | VueCompositionApi.Ref<GetUserCreatorByTicketCodeQueryVariables> | ReactiveFunction<GetUserCreatorByTicketCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserCreatorByTicketCodeQuery, GetUserCreatorByTicketCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserCreatorByTicketCodeQuery, GetUserCreatorByTicketCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserCreatorByTicketCodeQuery, GetUserCreatorByTicketCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserCreatorByTicketCodeQuery, GetUserCreatorByTicketCodeQueryVariables>(GetUserCreatorByTicketCodeDocument, variables, options);
}
export function useGetUserCreatorByTicketCodeLazyQuery(variables?: GetUserCreatorByTicketCodeQueryVariables | VueCompositionApi.Ref<GetUserCreatorByTicketCodeQueryVariables> | ReactiveFunction<GetUserCreatorByTicketCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserCreatorByTicketCodeQuery, GetUserCreatorByTicketCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserCreatorByTicketCodeQuery, GetUserCreatorByTicketCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserCreatorByTicketCodeQuery, GetUserCreatorByTicketCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserCreatorByTicketCodeQuery, GetUserCreatorByTicketCodeQueryVariables>(GetUserCreatorByTicketCodeDocument, variables, options);
}
export type GetUserCreatorByTicketCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserCreatorByTicketCodeQuery, GetUserCreatorByTicketCodeQueryVariables>;
export const GetUserInviterByTicketCodeDocument = gql`
    query getUserInviterByTicketCode($ticket_code: String!) {
  getUserInviterByTicketCode(ticket_code: $ticket_code) {
    ...CoreAddedByFields
  }
}
    ${CoreAddedByFieldsFragmentDoc}`;
export function useGetUserInviterByTicketCodeQuery(variables: GetUserInviterByTicketCodeQueryVariables | VueCompositionApi.Ref<GetUserInviterByTicketCodeQueryVariables> | ReactiveFunction<GetUserInviterByTicketCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserInviterByTicketCodeQuery, GetUserInviterByTicketCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserInviterByTicketCodeQuery, GetUserInviterByTicketCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserInviterByTicketCodeQuery, GetUserInviterByTicketCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserInviterByTicketCodeQuery, GetUserInviterByTicketCodeQueryVariables>(GetUserInviterByTicketCodeDocument, variables, options);
}
export function useGetUserInviterByTicketCodeLazyQuery(variables?: GetUserInviterByTicketCodeQueryVariables | VueCompositionApi.Ref<GetUserInviterByTicketCodeQueryVariables> | ReactiveFunction<GetUserInviterByTicketCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserInviterByTicketCodeQuery, GetUserInviterByTicketCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserInviterByTicketCodeQuery, GetUserInviterByTicketCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserInviterByTicketCodeQuery, GetUserInviterByTicketCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserInviterByTicketCodeQuery, GetUserInviterByTicketCodeQueryVariables>(GetUserInviterByTicketCodeDocument, variables, options);
}
export type GetUserInviterByTicketCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserInviterByTicketCodeQuery, GetUserInviterByTicketCodeQueryVariables>;
export const UsersListAllDocument = gql`
    query UsersListAll($search: String, $enabled: Boolean, $first: Int!, $page: Int!) {
  usersListAll(search: $search, enabled: $enabled, first: $first, page: $page) {
    data {
      ...CoreUserKeycloakFields
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CoreUserKeycloakFieldsFragmentDoc}
${CorePaginationFieldsFragmentDoc}`;
export function useUsersListAllQuery(variables: UsersListAllQueryVariables | VueCompositionApi.Ref<UsersListAllQueryVariables> | ReactiveFunction<UsersListAllQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersListAllQuery, UsersListAllQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersListAllQuery, UsersListAllQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersListAllQuery, UsersListAllQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UsersListAllQuery, UsersListAllQueryVariables>(UsersListAllDocument, variables, options);
}
export function useUsersListAllLazyQuery(variables?: UsersListAllQueryVariables | VueCompositionApi.Ref<UsersListAllQueryVariables> | ReactiveFunction<UsersListAllQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersListAllQuery, UsersListAllQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersListAllQuery, UsersListAllQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersListAllQuery, UsersListAllQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UsersListAllQuery, UsersListAllQueryVariables>(UsersListAllDocument, variables, options);
}
export type UsersListAllQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UsersListAllQuery, UsersListAllQueryVariables>;
export const GetVeevaAttendeesDocument = gql`
    query GetVeevaAttendees($firstname: String, $lastname: String, $health_number: String, $category: String, $legal_title: String, $organization_type: String, $first: Int!, $page: Int) {
  veevaAttendees(
    firstname: $firstname
    lastname: $lastname
    health_number: $health_number
    category: $category
    legal_title: $legal_title
    organization_type: $organization_type
    first: $first
    page: $page
  ) {
    data {
      id
      civility
      firstname
      lastname
      title
      regime
      activity
      type_number
      health_number
      health_type
      healthSpecialties
      legal_title
      description
      organization_type
      category
      external_id
      email
      phone_number
      pharmacist_type
      address {
        street_name
        postcode
        city
        country
      }
    }
    paginatorInfo {
      ...CorePaginationFields
    }
  }
}
    ${CorePaginationFieldsFragmentDoc}`;
export function useGetVeevaAttendeesQuery(variables: GetVeevaAttendeesQueryVariables | VueCompositionApi.Ref<GetVeevaAttendeesQueryVariables> | ReactiveFunction<GetVeevaAttendeesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetVeevaAttendeesQuery, GetVeevaAttendeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetVeevaAttendeesQuery, GetVeevaAttendeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetVeevaAttendeesQuery, GetVeevaAttendeesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetVeevaAttendeesQuery, GetVeevaAttendeesQueryVariables>(GetVeevaAttendeesDocument, variables, options);
}
export function useGetVeevaAttendeesLazyQuery(variables?: GetVeevaAttendeesQueryVariables | VueCompositionApi.Ref<GetVeevaAttendeesQueryVariables> | ReactiveFunction<GetVeevaAttendeesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetVeevaAttendeesQuery, GetVeevaAttendeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetVeevaAttendeesQuery, GetVeevaAttendeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetVeevaAttendeesQuery, GetVeevaAttendeesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetVeevaAttendeesQuery, GetVeevaAttendeesQueryVariables>(GetVeevaAttendeesDocument, variables, options);
}
export type GetVeevaAttendeesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetVeevaAttendeesQuery, GetVeevaAttendeesQueryVariables>;
export const GetWatchdogsSettingsDocument = gql`
    query GetWatchdogsSettings($code: String!) {
  watchdogMessages(code: $code) {
    title
    type
    list
    count
  }
}
    `;
export function useGetWatchdogsSettingsQuery(variables: GetWatchdogsSettingsQueryVariables | VueCompositionApi.Ref<GetWatchdogsSettingsQueryVariables> | ReactiveFunction<GetWatchdogsSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWatchdogsSettingsQuery, GetWatchdogsSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWatchdogsSettingsQuery, GetWatchdogsSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWatchdogsSettingsQuery, GetWatchdogsSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetWatchdogsSettingsQuery, GetWatchdogsSettingsQueryVariables>(GetWatchdogsSettingsDocument, variables, options);
}
export function useGetWatchdogsSettingsLazyQuery(variables?: GetWatchdogsSettingsQueryVariables | VueCompositionApi.Ref<GetWatchdogsSettingsQueryVariables> | ReactiveFunction<GetWatchdogsSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWatchdogsSettingsQuery, GetWatchdogsSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWatchdogsSettingsQuery, GetWatchdogsSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWatchdogsSettingsQuery, GetWatchdogsSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetWatchdogsSettingsQuery, GetWatchdogsSettingsQueryVariables>(GetWatchdogsSettingsDocument, variables, options);
}
export type GetWatchdogsSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetWatchdogsSettingsQuery, GetWatchdogsSettingsQueryVariables>;
export const WorkflowByIdDocument = gql`
    query WorkflowById($id: ID!) {
  workflow(id: $id) {
    ...CoreWorkflowFields
  }
}
    ${CoreWorkflowFieldsFragmentDoc}`;
export function useWorkflowByIdQuery(variables: WorkflowByIdQueryVariables | VueCompositionApi.Ref<WorkflowByIdQueryVariables> | ReactiveFunction<WorkflowByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkflowByIdQuery, WorkflowByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkflowByIdQuery, WorkflowByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkflowByIdQuery, WorkflowByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WorkflowByIdQuery, WorkflowByIdQueryVariables>(WorkflowByIdDocument, variables, options);
}
export function useWorkflowByIdLazyQuery(variables?: WorkflowByIdQueryVariables | VueCompositionApi.Ref<WorkflowByIdQueryVariables> | ReactiveFunction<WorkflowByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkflowByIdQuery, WorkflowByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkflowByIdQuery, WorkflowByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkflowByIdQuery, WorkflowByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WorkflowByIdQuery, WorkflowByIdQueryVariables>(WorkflowByIdDocument, variables, options);
}
export type WorkflowByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WorkflowByIdQuery, WorkflowByIdQueryVariables>;
export const WorkflowsByEventTypeDocument = gql`
    query WorkflowsByEventType($eventType: EventType!) {
  workflowsByEventType(eventType: $eventType) {
    id
    name
  }
}
    `;
export function useWorkflowsByEventTypeQuery(variables: WorkflowsByEventTypeQueryVariables | VueCompositionApi.Ref<WorkflowsByEventTypeQueryVariables> | ReactiveFunction<WorkflowsByEventTypeQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkflowsByEventTypeQuery, WorkflowsByEventTypeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkflowsByEventTypeQuery, WorkflowsByEventTypeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkflowsByEventTypeQuery, WorkflowsByEventTypeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WorkflowsByEventTypeQuery, WorkflowsByEventTypeQueryVariables>(WorkflowsByEventTypeDocument, variables, options);
}
export function useWorkflowsByEventTypeLazyQuery(variables?: WorkflowsByEventTypeQueryVariables | VueCompositionApi.Ref<WorkflowsByEventTypeQueryVariables> | ReactiveFunction<WorkflowsByEventTypeQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkflowsByEventTypeQuery, WorkflowsByEventTypeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkflowsByEventTypeQuery, WorkflowsByEventTypeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkflowsByEventTypeQuery, WorkflowsByEventTypeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WorkflowsByEventTypeQuery, WorkflowsByEventTypeQueryVariables>(WorkflowsByEventTypeDocument, variables, options);
}
export type WorkflowsByEventTypeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WorkflowsByEventTypeQuery, WorkflowsByEventTypeQueryVariables>;
export const AvailableWorkflowsDocument = gql`
    query AvailableWorkflows {
  availableWorkflows {
    steps
  }
}
    `;
export function useAvailableWorkflowsQuery(options: VueApolloComposable.UseQueryOptions<AvailableWorkflowsQuery, AvailableWorkflowsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailableWorkflowsQuery, AvailableWorkflowsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailableWorkflowsQuery, AvailableWorkflowsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvailableWorkflowsQuery, AvailableWorkflowsQueryVariables>(AvailableWorkflowsDocument, {}, options);
}
export function useAvailableWorkflowsLazyQuery(options: VueApolloComposable.UseQueryOptions<AvailableWorkflowsQuery, AvailableWorkflowsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailableWorkflowsQuery, AvailableWorkflowsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailableWorkflowsQuery, AvailableWorkflowsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvailableWorkflowsQuery, AvailableWorkflowsQueryVariables>(AvailableWorkflowsDocument, {}, options);
}
export type AvailableWorkflowsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvailableWorkflowsQuery, AvailableWorkflowsQueryVariables>;
export const EpsDepositProgressDocument = gql`
    subscription EPSDepositProgress {
  epsDepositProgress {
    ...CoreBatchProgressFields
  }
}
    ${CoreBatchProgressFieldsFragmentDoc}`;
export function useEpsDepositProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<EpsDepositProgressSubscription, EpsDepositProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<EpsDepositProgressSubscription, EpsDepositProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<EpsDepositProgressSubscription, EpsDepositProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<EpsDepositProgressSubscription, EpsDepositProgressSubscriptionVariables>(EpsDepositProgressDocument, {}, options);
}
export type EpsDepositProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<EpsDepositProgressSubscription, EpsDepositProgressSubscriptionVariables>;
export const GenerateExpensesImportTemplateProgressDocument = gql`
    subscription GenerateExpensesImportTemplateProgress {
  generateExpensesImportTemplateProgress {
    status
    message
    expensesImportTemplate {
      id
      updated_at
      document {
        ...CoreDocumentFields
      }
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useGenerateExpensesImportTemplateProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<GenerateExpensesImportTemplateProgressSubscription, GenerateExpensesImportTemplateProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<GenerateExpensesImportTemplateProgressSubscription, GenerateExpensesImportTemplateProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<GenerateExpensesImportTemplateProgressSubscription, GenerateExpensesImportTemplateProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<GenerateExpensesImportTemplateProgressSubscription, GenerateExpensesImportTemplateProgressSubscriptionVariables>(GenerateExpensesImportTemplateProgressDocument, {}, options);
}
export type GenerateExpensesImportTemplateProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<GenerateExpensesImportTemplateProgressSubscription, GenerateExpensesImportTemplateProgressSubscriptionVariables>;
export const ProcessExpensesImportProgressDocument = gql`
    subscription ProcessExpensesImportProgress {
  processExpensesImportProgress {
    status
    message
    expensesImportTemplate {
      id
      updated_at
      document {
        ...CoreDocumentFields
      }
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useProcessExpensesImportProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<ProcessExpensesImportProgressSubscription, ProcessExpensesImportProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<ProcessExpensesImportProgressSubscription, ProcessExpensesImportProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<ProcessExpensesImportProgressSubscription, ProcessExpensesImportProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<ProcessExpensesImportProgressSubscription, ProcessExpensesImportProgressSubscriptionVariables>(ProcessExpensesImportProgressDocument, {}, options);
}
export type ProcessExpensesImportProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<ProcessExpensesImportProgressSubscription, ProcessExpensesImportProgressSubscriptionVariables>;
export const GenerateContractZipFileProgressDocument = gql`
    subscription GenerateContractZipFileProgress {
  generateContractZipFileProgress {
    status
    message
    attachment {
      id
      document {
        ...CoreDocumentFields
      }
      comment
      type
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useGenerateContractZipFileProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<GenerateContractZipFileProgressSubscription, GenerateContractZipFileProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<GenerateContractZipFileProgressSubscription, GenerateContractZipFileProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<GenerateContractZipFileProgressSubscription, GenerateContractZipFileProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<GenerateContractZipFileProgressSubscription, GenerateContractZipFileProgressSubscriptionVariables>(GenerateContractZipFileProgressDocument, {}, options);
}
export type GenerateContractZipFileProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<GenerateContractZipFileProgressSubscription, GenerateContractZipFileProgressSubscriptionVariables>;
export const GenerateAgencyExportProgressDocument = gql`
    subscription GenerateAgencyExportProgress {
  generateAgencyExportProgress {
    status
    message
    agencyExport {
      id
      updated_at
      document {
        ...CoreDocumentFields
      }
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useGenerateAgencyExportProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<GenerateAgencyExportProgressSubscription, GenerateAgencyExportProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<GenerateAgencyExportProgressSubscription, GenerateAgencyExportProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<GenerateAgencyExportProgressSubscription, GenerateAgencyExportProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<GenerateAgencyExportProgressSubscription, GenerateAgencyExportProgressSubscriptionVariables>(GenerateAgencyExportProgressDocument, {}, options);
}
export type GenerateAgencyExportProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<GenerateAgencyExportProgressSubscription, GenerateAgencyExportProgressSubscriptionVariables>;
export const GenerateDepositZipFileProgressDocument = gql`
    subscription GenerateDepositZipFileProgress {
  generateDepositZipFileProgress {
    status
    message
    params {
      ticket_id
      planned_package_id
      json_filter
      regime
    }
    depositZipFile {
      id
      document {
        ...CoreDocumentFields
      }
      updated_at
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useGenerateDepositZipFileProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<GenerateDepositZipFileProgressSubscription, GenerateDepositZipFileProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<GenerateDepositZipFileProgressSubscription, GenerateDepositZipFileProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<GenerateDepositZipFileProgressSubscription, GenerateDepositZipFileProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<GenerateDepositZipFileProgressSubscription, GenerateDepositZipFileProgressSubscriptionVariables>(GenerateDepositZipFileProgressDocument, {}, options);
}
export type GenerateDepositZipFileProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<GenerateDepositZipFileProgressSubscription, GenerateDepositZipFileProgressSubscriptionVariables>;
export const GenerateManualAttachmentsProgressDocument = gql`
    subscription GenerateManualAttachmentsProgress {
  generateManualAttachmentsProgress {
    status
    message
    params {
      deposit_id
    }
    submission {
      id
      ...CoreSubmissionFields
    }
  }
}
    ${CoreSubmissionFieldsFragmentDoc}`;
export function useGenerateManualAttachmentsProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<GenerateManualAttachmentsProgressSubscription, GenerateManualAttachmentsProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<GenerateManualAttachmentsProgressSubscription, GenerateManualAttachmentsProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<GenerateManualAttachmentsProgressSubscription, GenerateManualAttachmentsProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<GenerateManualAttachmentsProgressSubscription, GenerateManualAttachmentsProgressSubscriptionVariables>(GenerateManualAttachmentsProgressDocument, {}, options);
}
export type GenerateManualAttachmentsProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<GenerateManualAttachmentsProgressSubscription, GenerateManualAttachmentsProgressSubscriptionVariables>;
export const CreateAttendeesByImportProgressDocument = gql`
    subscription CreateAttendeesByImportProgress {
  createAttendeesByImportProgress {
    status
    message
    ticketAttendeeImport {
      id
      document {
        ...CoreDocumentFields
      }
      created_at
    }
  }
}
    ${CoreDocumentFieldsFragmentDoc}`;
export function useCreateAttendeesByImportProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<CreateAttendeesByImportProgressSubscription, CreateAttendeesByImportProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<CreateAttendeesByImportProgressSubscription, CreateAttendeesByImportProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<CreateAttendeesByImportProgressSubscription, CreateAttendeesByImportProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<CreateAttendeesByImportProgressSubscription, CreateAttendeesByImportProgressSubscriptionVariables>(CreateAttendeesByImportProgressDocument, {}, options);
}
export type CreateAttendeesByImportProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<CreateAttendeesByImportProgressSubscription, CreateAttendeesByImportProgressSubscriptionVariables>;
export const CreateSigningProcedureProgressDocument = gql`
    subscription CreateSigningProcedureProgress {
  createSigningProcedureProgress {
    ...CoreBatchProgressFields
  }
}
    ${CoreBatchProgressFieldsFragmentDoc}`;
export function useCreateSigningProcedureProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<CreateSigningProcedureProgressSubscription, CreateSigningProcedureProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<CreateSigningProcedureProgressSubscription, CreateSigningProcedureProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<CreateSigningProcedureProgressSubscription, CreateSigningProcedureProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<CreateSigningProcedureProgressSubscription, CreateSigningProcedureProgressSubscriptionVariables>(CreateSigningProcedureProgressDocument, {}, options);
}
export type CreateSigningProcedureProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<CreateSigningProcedureProgressSubscription, CreateSigningProcedureProgressSubscriptionVariables>;
export const CancelSigningProcedureProgressDocument = gql`
    subscription CancelSigningProcedureProgress {
  cancelSigningProcedureProgress {
    ...CoreBatchProgressFields
  }
}
    ${CoreBatchProgressFieldsFragmentDoc}`;
export function useCancelSigningProcedureProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<CancelSigningProcedureProgressSubscription, CancelSigningProcedureProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<CancelSigningProcedureProgressSubscription, CancelSigningProcedureProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<CancelSigningProcedureProgressSubscription, CancelSigningProcedureProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<CancelSigningProcedureProgressSubscription, CancelSigningProcedureProgressSubscriptionVariables>(CancelSigningProcedureProgressDocument, {}, options);
}
export type CancelSigningProcedureProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<CancelSigningProcedureProgressSubscription, CancelSigningProcedureProgressSubscriptionVariables>;
export const CloneTicketProgressDocument = gql`
    subscription CloneTicketProgress {
  cloneTicketProgress {
    status
    message
    ticket {
      id
      code
    }
  }
}
    `;
export function useCloneTicketProgressSubscription(options: VueApolloComposable.UseSubscriptionOptions<CloneTicketProgressSubscription, CloneTicketProgressSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<CloneTicketProgressSubscription, CloneTicketProgressSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<CloneTicketProgressSubscription, CloneTicketProgressSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<CloneTicketProgressSubscription, CloneTicketProgressSubscriptionVariables>(CloneTicketProgressDocument, {}, options);
}
export type CloneTicketProgressSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<CloneTicketProgressSubscription, CloneTicketProgressSubscriptionVariables>;